export default {
    nextTicket() {
        return {
            isChange: true,
            GenelBilgileri: {
                HesKodu: null,
                ArkmanUsers: '',
                SirketKodu: '',
                BiletNo: '',
                Formno: '',
                HavaYoluKodu: null,
                UcusTipi: '',
                SiparisNo: 0,
                MusteriKodu: {
                    Kod: '',
                    Uyari: '',
                    BilgiNotu: ''
                },
                KesenKisi: '',
                YolcuAdi: '',
                Parkurlar: {
                    Parkur1: '',
                    Parkur2: '',
                    Parkur3: '',
                    Parkur4: '',
                    Parkur5: '',
                },
                Classlar: {
                    Class1: '',
                    Class2: '',
                    Class3: '',
                    Class4: '',
                    Class5: '',
                },
                FiyatTur: 'AD', //enum deger
                Referans: {
                    Kod: ''
                },
                YolcuAdet: 1,
                Baglantili: false,
                PnrNo: '',
                RezervasyonVeren: '',
                RezervasyonAlan: '',
                Status: null, //enum
                Acente: '',
                AcenteKodu: '',
                ExBiletNo: '',
                ExBiletHY: '',
                ClassTip: 'E', //enum
                BiletYon: 'T', //enum
                DepartmanKod: '',
                Crs: 'Manuel', //enum
                Masraf: {
                    Code: ''
                },
                Email: '',
                BiletTel: '',
            },
            TarihBilgileri: {
                KesimTarihi: null,
                SatisTarihi: null,
                IptalTarihi: null,
                IadeTarihi: null,
                OdemeTarihi: null,
            },
            UcusBilgileri: {
                UcusTarihi: null,
                UcusNo1: null,
                UcusNo2: null,
                UcusDonusTarihi: null,
                UcusDonusNo1: null,
                UcusDonusNo2: null,
                UcusListesi: []
            },
            FaturaBilgileri: {
                FaturaTarihi: null,
                FaturaSeri: null,
                FaturaNo: 0,
                EfaturaBilgileri: {
                    FaturaNo: null,
                    Guid: null,
                    FaturaDurumu: null,
                    SanalFaturaNo: null,
                    GercekFaturaNo: null,
                    BasimTarihi: null,
                    Kullanici: null,
                    GonderimSekli: 0,
                    InternetSatis: 0,
                    WebAdresi: null,
                    OdemeSekli: 0,
                    OdemeSekliAciklama: null,
                    OdemeAraci: null,
                    OdemeTarihi: null
                },
                AlisFaturaNo: null,
                ProformaSeri: null,
                ProformaNo: 0,
                ProformaTarihi: null,
                SatisFaturaID: null,
                MaliyetFaturaID: null,
                AlisFaturaTarihi: null,
                AlisFatNo: null,
                FaturaOtomatik: 0,
                IstinaKod: null,
                KdvKod: null,
            },
            TutarBilgileri: {
                Doviz: {
                    DovizKod: ''
                },
                Kur: 1,
                NetTutar: {
                    NetTutar: 0,
                    NetTutarSatisDoviz: 0,
                    NetTutarAlisDoviz: 0,
                    NetTutarKdv: 0,
                },
                Tutar: {
                    Tutar: 0,
                    TutarSatisDoviz: 0,
                    TutarAlisDoviz: 0,
                    TutarKdv: 0,
                },
                PtaTutar: {
                    PtaTutar: 0,
                    PtaSatisDoviz: 0,
                    PtaAlisDoviz: 0,
                    PtaKdv: 0
                },
                AlanVergiTutar: {
                    AlanVergiTutar: 0,
                    AlanVergiSatisDoviz: 0,
                    AlanVergiAlisDoviz: 0,
                    AlanVergiKdv: 0,
                },
                CharterTutar: {
                    CharterTutar: 0,
                    CharterSatisDoviz: 0,
                    CharterAlisDoviz: 0,
                    CharterKdv: 0
                },
                YFFTutar: {
                    YFFTutar: 0,
                    YFFDoviz: 0,
                    YFFKdv: 0
                },
                ServisTutar: {
                    ServisTutar: 0,
                    ServisDoviz: 0,
                    ServisKdv: 0
                },
                DigerServisTutar: {
                    DigerServisTutar: 0,
                    DigerServisDoviz: 0,
                    DigerServisKdv: 0
                },
                IskontoTutar: {
                    IskontoYuzde: 0,
                    IskontoTutar: 0,
                    IskontoDoviz: 0,
                    IskontoKdv: 0
                },
                TaxTutar: {
                    TaxTutar: 0,
                    TaxSatisDoviz: 0,
                    TaxAlisDoviz: 0,
                    TaxKdv: 0
                },
                CezaTutar: {
                    CezaTutar: 0,
                    CezaSatisTutar: 0,
                    CezaAlisTutar: 0,
                    CezaKdv: 0
                },
                KaTutar: {
                    KaTutar: 0,
                    KaDoviz: 0,
                    KaKdv: 0
                },
                ReserveTutar: {
                    ReserveYuzde: 0,
                    ReserveTutar: 0,
                    ReserveDoviz: 0,
                    ReserveKdv: 0
                }
            },
            OdemeBilgileri: {
                SatisSekli: 'K', //enum
                KomisyonTip: '', //enum
                HYOran: 0,
                GSAOran: 0,
                KrediliTutar: 0,
                KrediliDoviz: 0,
                PesinTutar: 0,
                PesinDoviz: 0,
                KrediKartTutar: 0,
                KrediKartDoviz: 0,
                KrediKartBilgi: {
                    KrediKartNo: '',
                    KrediKartAy: '',
                    KrediKartYil: '',
                    KrediKartCins: '',
                    KrediKartTip: ''
                },
                AlisServisTutar: {
                    AlisServisTutar: 0,
                    AlisServisDoviz: 0,
                    AlisServisKdv: 0
                },
                HavaYoluTutar: 0,
                HavaYoluKdv: 0,
                Csc: false,
                BankaBilgileri: {
                    PosKod: {
                        BankaPosID: 0,
                        SirketKodu: 0,
                        PosKodu: '',
                        Aciklama: '',
                        MuhasebeKodlar: {
                            MuhasebeKodu: '',
                            CMuhasebeKodu: '',
                            FDisAktarimCariKodu: '',
                            FDisAktarimMuhKodu: '',
                            CDisAktarimCariKodu: '',
                            CDisAktarimMuhKodu: '',
                            ServisMuhasebeKodu: '',
                            ServisDisAktarimCariKodu: '',
                            ServisDisAktarimMuhKodu: ''
                        },
                        Parametreler: {
                            ID: 0,
                            Banka: {
                                BankaID: 0,
                                SirketKodu: 0,
                                BankaKod: '',
                                BankaAdi: '',
                                Cari: {
                                    Kod: ''
                                },
                                BankaKisaKod: '',
                                Tip: 0
                            },
                            PosMuhKodu: '',
                            PuanCariKodu: '',
                            SozlesmeBaslangic: null,
                            SozlesmeBitis: null,
                            Aktif: '',
                            VadeTip: '',
                            UyelikTutar: 0,
                            UyelikOran: 0,
                            Kota: 0,
                            KotaGun: 0,
                            KotaCezaTutar: 0,
                            KotaCezaOran: 0,
                            VadeSabitGun: 0,
                            VadeFarkSabit: 0,
                            KotaKod: '',
                            TerminalID: '',
                            UyeIsYeriID: '',
                            UserName: '',
                            UserPass: '',
                            PosType: 0,
                            StoreKey: '',
                        }
                        //public List<BankaPosTaksit> Taksitler { get; set; }
                    },
                    ServisPosKod: {
                        BankaPosID: 0,
                        SirketKodu: 0,
                        PosKodu: '',
                        Aciklama: '',
                        MuhasebeKodlar: {
                            MuhasebeKodu: '',
                            CMuhasebeKodu: '',
                            FDisAktarimCariKodu: '',
                            FDisAktarimMuhKodu: '',
                            CDisAktarimCariKodu: '',
                            CDisAktarimMuhKodu: '',
                            ServisMuhasebeKodu: '',
                            ServisDisAktarimCariKodu: '',
                            ServisDisAktarimMuhKodu: ''
                        },
                        Parametreler: {
                            ID: 0,
                            Banka: {
                                BankaID: 0,
                                SirketKodu: 0,
                                BankaKod: '',
                                BankaAdi: '',
                                Cari: {
                                    Kod: ''
                                },
                                BankaKisaKod: '',
                                Tip: 0
                            },
                            PosMuhKodu: '',
                            PuanCariKodu: '',
                            SozlesmeBaslangic: null,
                            SozlesmeBitis: null,
                            Aktif: '',
                            VadeTip: '',
                            UyelikTutar: 0,
                            UyelikOran: 0,
                            Kota: 0,
                            KotaGun: 0,
                            KotaCezaTutar: 0,
                            KotaCezaOran: 0,
                            VadeSabitGun: 0,
                            VadeFarkSabit: 0,
                            KotaKod: '',
                            TerminalID: '',
                            UyeIsYeriID: '',
                            UserName: '',
                            UserPass: '',
                            PosType: 0,
                            StoreKey: '',
                        },
                        Taksitler: []
                    },

                    ServisPosTutar: 0,
                    TaksitKod: '',
                    ServisTaksitKod: '',
                    TaksitKodLabel: '',
                    ServisTaksitKodLabel: '',
                    PuanTutar: 0
                },
                Slipkod: '',
                MakbuzNo: '',
            },
            DigerBilgileri: {
                SaveTime: null,
                Entegre: false,
                BiletTanim: '',
                eservedTutar1: 0,
                ExIcDis: '',
                EntegreTablo: '',
                GrossTutar: 0,
                CharterPtaKodu: '',
                pArkmanEntegre: '',
                PinKodu: '',
                RezervasyonID: '',
                SiparisID: '',
                CKLogID: 0,
                ParkurTip: '',
                DServisKod1: '',
                DServisKod2: '',
                KKEnt: '',
                SatisSapEntegre: '',
                MaliyetSapEntegre: '',
                KisiID: 0,
                // EntegrasyonID: guid değişkeni
                UserID: 0,
            },
            TanimBilgileri: {
                ServisKod: '',
                AnalizKod: {
                    SirketKodu: 0,
                    AnalizKod: '',
                    AnalizAdi: '',
                    AnalizTutar: 0,
                    AnalizOran: 0,
                },
                AnalizTutar: 0,
                AnalizDoviz: 0,
                AnalizKod1: {
                    SirketKodu: 0,
                    AnalizKod: '',
                    AnalizAdi: '',
                    AnalizTutar: 0,
                    AnalizOran: 0,
                },
                AnalizTutar1: 0,
                AnalizDoviz1: 0,
                TcKimlikNolar: {
                    TcNo1: '',
                    TcNo2: '',
                    TcNo3: '',
                    TcNo4: '',
                    TcNo5: ''
                },
                Aciklamalar: {
                    Aciklama1: '',
                    Aciklama2: '',
                    Aciklama3: '',
                    Aciklama4: '',
                    Aciklama5: '',
                    Aciklama6: '',
                    Aciklama7: '',
                },
                MilKodu: {
                    MilKoduOde: '',
                    MilKoduYolcu: '',
                    MilAdet: 0,
                    MilTutar: 0
                },
                MusteriPersonel: {
                    PersonelUcan: {
                        ID: 0,
                        SirketKodu: 0,
                        SirketAdi: '',
                        MasrafYeri: '',
                        SicilNo: '',
                        Adi: '',
                        Soyadi: '',
                        CalismaYeri: '',
                        Bolum: '',
                        IcSeyahat: '',
                        DisSeyahat: '',
                        IsAlani: '',
                        Siparis: '',
                        Cari: {
                            Kod: ''
                        },
                        KapatAc: false,
                        Email: '',
                        Tel: ''
                    },
                    PersonelSponsor: {
                        ID: 0,
                        SirketKodu: 0,
                        SirketAdi: '',
                        MasrafYeri: '',
                        SicilNo: '',
                        Adi: '',
                        Soyadi: '',
                        CalismaYeri: '',
                        Bolum: '',
                        IcSeyahat: '',
                        DisSeyahat: '',
                        IsAlani: '',
                        Siparis: '',
                        Cari: {
                            Kod: ''
                        },
                        KapatAc: false,
                        Email: '',
                        Tel: ''
                    }
                },
                YolcuCrm: {
                    CrmYolcu: {
                        Ref: 0,
                        Adi: '',
                        Soyadi: '',
                        Tel: '',
                        Gsm: '',
                        Email: '',
                        TCKimlikNo: '',
                        ID: 0
                    },
                    CrmRezervasyon: {
                        Ref: 0,
                        Adi: '',
                        Soyadi: '',
                        Tel: '',
                        Gsm: '',
                        Email: '',
                        TCKimlikNo: '',
                        ID: 0
                    }
                },
                ProfilID: 0,
                SablonID: 0,
                Bolum: '',
                EventID: '',
                ExAciklamalar: {
                    ID: 0,
                    SirketKodu: 0,
                    Biletno: '',
                    HavayoluKod: '',
                    EmployeeId: '',
                    DepartmentId: '',
                    CostCenter: '',
                    ClientId: '',
                    DkNumber: '',
                    WwId: '',
                    BusinessUnit: '',
                    CompanyCode: '',
                    SiteCode: '',
                    PurposeOt: '',
                    PcNumber: '',
                    NoHotelBc: '',
                    TripApprover: ''
                }
            },
            AyrintiOdemeBilgileri: [],
            NotlarBilgileri: {
                SirketKodu: 0,
                BiletNo: '',
                FormNo: '',
                Aciklama1: '',
                Aciklama2: '',
                Segment1: '',
                Segment2: '',
                Segment3: '',
                Segment4: '',
                Segment5: '',
                RefFare: 0,
                LowFare: 0,
                RealCode: '',
                DateofRes: null,
                MarketCode: '',
                TicketSuffix: '',
                VendorNumber: '',
                ReasonCode: '',
                CRSGDS: '',
                SubPruductCode: '',
                TicketTypeInd: false,
                TourCode: '',
                AlternatifTutar1: 0,
                AlternatifTutar2: 0,
                AlternatifTutar3: 0,
                Anlasmali: false,
                Esnek: false,
                KarbonSalinimi: 0,
                Mil1: 0,
                Mil2: 0,
                Mil3: 0,
                Mil4: 0
            },

            TaksitBilgileri: {
                ID: 0,
                SirketKodu: 0,
                BiletNo: '',
                HavaYoluKodu: '',
                MakbuzNo: '',
                CCNo1: '',
                Tip1: '',
                Ay1: 0,
                Yil1: 0,
                Tutar1: 0,
                Iade1: 0,
                Taksit1: 0,
                TVade1: null,
                PosKodu1: '',
                CCNo2: '',
                Tip2: '',
                Ay2: 0,
                Yil2: 0,
                Tutar2: 0,
                Iade2: 0,
                Taksit2: 0,
                TVade2: null,
                PosKodu2: '',
                CCNo3: '',
                Tip3: '',
                Ay3: 0,
                Yil3: 0,
                Tutar3: 0,
                Iade3: 0,
                Taksit3: 0,
                TVade3: null,
                PosKodu3: '',
                CCNo4: '',
                Tip4: '',
                Ay4: 0,
                Yil4: 0,
                Tutar4: 0,
                Iade4: 0,
                Taksit4: 0,
                TVade4: null,
                PosKodu4: '',
                PesinSatisTutari: 0,
                PesinIadeTutari: 0,
                SlipKod1: '',
                SlipKod2: '',
                SlipKod3: '',
                SlipKod4: '',
                OdemeFaturaId: '',
                OdemeSapEntegre: '',
            }
        }
    },

    makePayment() {
        return {
            Id: "",
            IpAddress: "",
            SessionHeader: {
                SessionId: "",
                SessionToken: ""
            },
            ShoppingCartId: "",
            Amount: 0,
            PaymentType: "CurrentPayment",
        }
    },
    billingInformation() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            BillingInformation: {
                IfCompany: true,
                IfCurrentCodeSet: true,
                BillingName: "",
                TaxOffice: "",
                TaxNo: "",
                City: "",
                District: "",
                ZipCode: "",
                CountryCode: "",
                Address: "",
                AutoBill: true,
                ServiceFee: 0
            }
        }
    },
    finalizeShopping() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            LinkUrl: "",
            SendInformationEmails: true,
        }
    },
    makePrebooking() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            LinkUrl: null,
            SelectedServiceFee: 0.0,
            ContinueWithoutReservation: false,
        }
    },
    updatePassengers() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            CorporatePin: "",
            Contact: {
                Name: null,
                LastName: null,
                Phone: null,
                Email: null
            },
            Passengers: [],
            EArchiveWebAddress: 0,
            Notes: null,
        }
    },
    contact() {
        return {
            Name: null,
            LastName: null,
            Phone: null,
            Email: null
        }
    },
    passenger() {
        return {
            FirstName: "",
            LastName: "",
            PaxType: "",
            Gender: "",
            BirthDate: null,
            Email: "",
            Phone: "",
            CitizenNo: "",
            PassportNo: "",
            PassportExpireDate: null,
            Nationality: "",
            HesCode: "",
            FrequentFlayerNo: "",
            WheelChairService: "",
            PaxReferanceId: "",
            ExtraPosAmount: "",
            HasTicket: false
        }
    },
    passengerType: function (val) {
        var passengerType = null;
        switch (val) {
            case "ADT":
                passengerType = "Yetiskin";
                break;
            case "CHD":
                passengerType = "Cocuk";
                break;
            case "INF":
                passengerType = "Bebek";
                break;
            case "SRC":
                passengerType = "+65 Yas";
                break;
            case "STD":
                passengerType = "Ogrenci";
                break;
            case "MIL":
                passengerType = "Asker";
                break;

            default:
                break;
        }
        return passengerType
    },

    wheelChairs() {
        return [{
            text: 'Tekerlekli sandalye istenmiyor',
            value: 0
        },
        {
            text: 'Kabinde koltuğua kadar',
            value: 1
        },
        {
            text: 'Aprondan uçağa kadar',
            value: 2
        },
        {
            text: 'Basamaklar için',
            value: 3
        }


        ]
    },

    allocateItems() {
        return {
            ProductId: null,
            FareCode: null,
            MarkupFare: 0,
            SetServiceFare: 0
        }
    },
    allocateParams() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            AllocateItems: [
            ],
            CreateShoppingCart: true,
            IncludeBags: false,
            IncludedBags: {
                ShoppingCartId: null,
                List: []
            }
        }
    },
    nextSearchParams() {
        return {
            Departure: null,
            Destination: null,
            DepartureDay: null,
            DestinationDay: null,
            OneWay: true,
            RoundTrip: false,
            Adult: 1,
            Child: 0,
            Baby: 0,
            Student: 0,
            Young: 0,
            Old: 0,
            Soldier: 0,
            Accouting: null,
            Cabin: "Economy",
            Markup: 0,
            FlightType: 'OW'
        }
    },
    bookingSearchParams() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null,
            },
            AirSearchOptions: {
                FlightType: null, //    NONE, OW(ONEWAY),RT,MULTI
                CabinType: null,
                CabinTypeOptions: [

                ],
                RefundableType: "AllFlights",
                Currency: "TRY",
                FareDisplayType: "Lowest",
                PreferedAirlines: [],
                MarkupFareList: 0,
                CompanyCode: null,
                DirectFlightsOnly: false,
                AvailableFlightsOnly: true,
                SelectableFaresOnly: true,
            },
            AirSearchPaxItems: [],
            AirSearchSegments: [],
        }
    },

    AirSearchSegments() {
        return {
            SequenceNo: 0,
            DepartureDay: null,
            Origin: {
                AirportCode: null,
                IsCity: false,
            },
            Destination: {
                AirportCode: null,
                IsCity: false,
            },
        }
    },

    CabinTypeOptions() {
        return {
            Airline: null,
            IncludeBusinessClass: true,
        }
    },

    AirSearchPaxItems() {
        return {
            PaxCode: null,
            PaxCount: 0,
        }
    },

    Genders() {
        return [
            {
                text: 'Bay',
                value: 'Male'
            },
            {
                text: 'Bayan',
                value: 'Female'
            }
        ]
    },

    headersFlightInfoSummary() {
        return [
            {
                text: "Tip",
                sortable: false,
                width: "1px",

            },
            {
                text: "Net",
                sortable: false,
                width: "1%"
            },
            {
                text: "Vergi",
                sortable: false,
                width: "1%"
            },
            {
                text: "Servis",
                sortable: false,
                width: "1%"
            },
            {
                text: "Vade",
                sortable: false,
                width: "1%"
            },
            {
                text: "Markup",
                sortable: false,
                width: "1%"
            },
            {
                text: "L.Markup",
                sortable: false,
                width: "1%"
            },
            {
                text: "Toplam",
                sortable: false,
                width: "1%"
            },
            {
                text: "Para Birimi",
                sortable: false,
                width: "1%"
            },
        ]
    },

    headersSummary() {
        return [
            {
                text: "Tip",
                sortable: false,
            },
            {
                text: "Net",
                sortable: false,
            },
            {
                text: "Vergi",
                sortable: false,
            },
            {
                text: "Sistem Servis Bedeli",
                sortable: false,
            },
            {
                text: "Yolcu",
                sortable: false,
            },
            {
                text: "Bagaj",
                sortable: false,
            },
            {
                text: "Toplam",
                sortable: false,
            },
        ]
    },

    countiries() {
        return [
            {
                name: "Peru",
                currency: "PEN",
                code: "PE",
                name_translations: {
                    en: "Peru"
                }
            },
            {
                name: "Belize",
                currency: "BZD",
                code: "BZ",
                name_translations: {
                    en: "Belize"
                }
            },
            {
                name: "Saint Pierre ve Miquelon",
                currency: "EUR",
                code: "PM",
                name_translations: {
                    en: "Saint Pierre and Miquelon"
                }
            },
            {
                name: "Somali",
                currency: "SOS",
                code: "SO",
                name_translations: {
                    en: "Somalia"
                }
            },
            {
                name: "Bouvet Island",
                currency: "NOK",
                code: "BV",
                name_translations: {
                    en: "Bouvet Island"
                }
            },
            {
                name: "Panama",
                currency: "PAB",
                code: "PA",
                name_translations: {
                    en: "Panama"
                }
            },
            {
                name: "Kongo - Brazavil",
                currency: "XAF",
                code: "CG",
                name_translations: {
                    en: "Republic of the Congo"
                }
            },
            {
                name: "Filipinler",
                currency: "PHP",
                code: "PH",
                name_translations: {
                    en: "Philippines"
                }
            },
            {
                name: "Gana",
                currency: "GHS",
                code: "GH",
                name_translations: {
                    en: "Ghana"
                }
            },
            {
                name: "İspanya",
                currency: "EUR",
                code: "ES",
                name_translations: {
                    en: "Spain"
                }
            },
            {
                name: "Grenada",
                currency: "XCD",
                code: "GD",
                name_translations: {
                    en: "Grenada"
                }
            },
            {
                name: "Mozambik",
                currency: "MZN",
                code: "MZ",
                name_translations: {
                    en: "Mozambique"
                }
            },
            {
                name: "Falkland Adaları",
                currency: "FKP",
                code: "FK",
                name_translations: {
                    en: "Falkland Islands"
                }
            },
            {
                name: "Samoa",
                currency: "WST",
                code: "WS",
                name_translations: {
                    en: "Samoa"
                }
            },
            {
                name: "Cocos (Keeling) Adaları",
                currency: "AUD",
                code: "CC",
                name_translations: {
                    en: "Cocos (Keeling) Islands"
                }
            },
            {
                name: "Yeni Kaledonya",
                currency: "XPF",
                code: "NC",
                name_translations: {
                    en: "New Caledonia"
                }
            },
            {
                name: "Güney Kore",
                currency: "KRW",
                code: "KR",
                name_translations: {
                    en: "South Korea"
                }
            },
            {
                name: "Fildişi Sahili",
                currency: "XOF",
                code: "CI",
                name_translations: {
                    en: "Ivory Coast"
                }
            },
            {
                name: "Curaçao",
                currency: "ANG",
                code: "CW",
                name_translations: {
                    en: "Curaçao"
                }
            },
            {
                name: "Paraguay",
                currency: "PYG",
                code: "PY",
                name_translations: {
                    en: "Paraguay"
                }
            },
            {
                name: "Komorlar",
                currency: "KMF",
                code: "KM",
                name_translations: {
                    en: "Comoros"
                }
            },
            {
                name: "Jamaika",
                currency: "JMD",
                code: "JM",
                name_translations: {
                    en: "Jamaica"
                }
            },
            {
                name: "Malta",
                currency: "EUR",
                code: "MT",
                name_translations: {
                    en: "Malta"
                }
            },
            {
                name: "Cayman Adaları",
                currency: "KYD",
                code: "KY",
                name_translations: {
                    en: "Cayman Islands"
                }
            },
            {
                name: "Antarktika",
                currency: null,
                code: "AQ",
                name_translations: {
                    en: "Antarctica"
                }
            },
            {
                name: "Saint Barthelemy",
                currency: "EUR",
                code: "BL",
                name_translations: {
                    en: "Saint Barthélemy"
                }
            },
            {
                name: "Andorra",
                currency: "EUR",
                code: "AD",
                name_translations: {
                    en: "Andorra"
                }
            },
            {
                name: "Birleşik Arap Emirlikleri",
                currency: "AED",
                code: "AE",
                name_translations: {
                    en: "United Arab Emirates"
                }
            },
            {
                name: "Guadalupe",
                currency: "EUR",
                code: "GP",
                name_translations: {
                    en: "Guadeloupe"
                }
            },
            {
                name: "Kuzey Mariana Adaları",
                currency: "USD",
                code: "MP",
                name_translations: {
                    en: "Northern Mariana Islands"
                }
            },
            {
                name: "Western Sahara",
                currency: "MAD",
                code: "EH",
                name_translations: {
                    en: "Western Sahara"
                }
            },
            {
                name: "Çek Cumhuriyeti",
                currency: "CZK",
                code: "CZ",
                name_translations: {
                    en: "Czech Republic"
                }
            },
            {
                name: "Nauru",
                currency: "AUD",
                code: "NR",
                name_translations: {
                    en: "Nauru"
                }
            },
            {
                name: "ABD Virjin Adaları",
                currency: "USD",
                code: "VI",
                name_translations: {
                    en: "U.S. Virgin Islands"
                }
            },
            {
                name: "Mali",
                currency: "XOF",
                code: "ML",
                name_translations: {
                    en: "Mali"
                }
            },
            {
                name: "Brezilya",
                currency: "BRL",
                code: "BR",
                name_translations: {
                    en: "Brazil"
                }
            },
            {
                name: "Cibuti",
                currency: "DJF",
                code: "DJ",
                name_translations: {
                    en: "Djibouti"
                }
            },
            {
                name: "Haiti",
                currency: "HTG",
                code: "HT",
                name_translations: {
                    en: "Haiti"
                }
            },
            {
                name: "Estonya",
                currency: "EUR",
                code: "EE",
                name_translations: {
                    en: "Estonia"
                }
            },
            {
                name: "Liechtenstein",
                currency: "CHF",
                code: "LI",
                name_translations: {
                    en: "Liechtenstein"
                }
            },
            {
                name: "Butan",
                currency: "BTN",
                code: "BT",
                name_translations: {
                    en: "Bhutan"
                }
            },
            {
                name: "Gine",
                currency: "GNF",
                code: "GN",
                name_translations: {
                    en: "Guinea"
                }
            },
            {
                name: "Etiyopya",
                currency: "ETB",
                code: "ET",
                name_translations: {
                    en: "Ethiopia"
                }
            },
            {
                name: "Guatemala",
                currency: "GTQ",
                code: "GT",
                name_translations: {
                    en: "Guatemala"
                }
            },
            {
                name: "Eritre",
                currency: "ERN",
                code: "ER",
                name_translations: {
                    en: "Eritrea"
                }
            },
            {
                name: "Lesoto",
                currency: "LSL",
                code: "LS",
                name_translations: {
                    en: "Lesotho"
                }
            },
            {
                name: "Porto Riko",
                currency: "USD",
                code: "PR",
                name_translations: {
                    en: "Puerto Rico"
                }
            },
            {
                name: "Lübnan",
                currency: "LBP",
                code: "LB",
                name_translations: {
                    en: "Lebanon"
                }
            },
            {
                name: "Lüksemburg",
                currency: "EUR",
                code: "LU",
                name_translations: {
                    en: "Luxembourg"
                }
            },
            {
                name: "Faroe Adaları",
                currency: "DKK",
                code: "FO",
                name_translations: {
                    en: "Faroe Islands"
                }
            },
            {
                name: "Saint Vincent ve Grenadinler",
                currency: "XCD",
                code: "VC",
                name_translations: {
                    en: "Saint Vincent and the Grenadines"
                }
            },
            {
                name: "Moldova",
                currency: "MDL",
                code: "MD",
                name_translations: {
                    en: "Moldova"
                }
            },
            {
                name: "Kıbrıs",
                currency: "EUR",
                code: "CY",
                name_translations: {
                    en: "Cyprus"
                }
            },
            {
                name: "Katar",
                currency: "QAR",
                code: "QA",
                name_translations: {
                    en: "Qatar"
                }
            },
            {
                name: "Norfolk Adası",
                currency: "AUD",
                code: "NF",
                name_translations: {
                    en: "Norfolk Island"
                }
            },
            {
                name: "Karadağ",
                currency: "EUR",
                code: "ME",
                name_translations: {
                    en: "Montenegro"
                }
            },
            {
                name: "Mauritius",
                currency: "MUR",
                code: "MU",
                name_translations: {
                    en: "Mauritius"
                }
            },
            {
                name: "Tunus",
                currency: "TND",
                code: "TN",
                name_translations: {
                    en: "Tunisia"
                }
            },
            {
                name: "Dominika",
                currency: "XCD",
                code: "DM",
                name_translations: {
                    en: "Dominica"
                }
            },
            {
                name: "Birleşik Krallık",
                currency: "GBP",
                code: "GB",
                name_translations: {
                    en: "United Kingdom"
                }
            },
            {
                name: "Şili",
                currency: "CLP",
                code: "CL",
                name_translations: {
                    en: "Chile"
                }
            },
            {
                name: "Sierra Leone",
                currency: "SLL",
                code: "SL",
                name_translations: {
                    en: "Sierra Leone"
                }
            },
            {
                name: "Fransız Polinezyası",
                currency: "XPF",
                code: "PF",
                name_translations: {
                    en: "French Polynesia"
                }
            },
            {
                name: "Cook Adaları",
                currency: "NZD",
                code: "CK",
                name_translations: {
                    en: "Cook Islands"
                }
            },
            {
                name: "Myanmar (Burma)",
                currency: "MMK",
                code: "MM",
                name_translations: {
                    en: "Myanmar"
                }
            },
            {
                name: "Ruanda",
                currency: "RWF",
                code: "RW",
                name_translations: {
                    en: "Rwanda"
                }
            },
            {
                name: "Singapur",
                currency: "SGD",
                code: "SG",
                name_translations: {
                    en: "Singapore"
                }
            },
            {
                name: "Pitcairn Islands",
                currency: "NZD",
                code: "PN",
                name_translations: {
                    en: "Pitcairn Islands"
                }
            },
            {
                name: "Monako",
                currency: "EUR",
                code: "MC",
                name_translations: {
                    en: "Monaco"
                }
            },
            {
                name: "Makedonya",
                currency: "MKD",
                code: "MK",
                name_translations: {
                    en: "North Macedonia"
                }
            },
            {
                name: "Suudi Arabistan",
                currency: "SAR",
                code: "SA",
                name_translations: {
                    en: "Saudi Arabia"
                }
            },
            {
                name: "Ermenistan",
                currency: "AMD",
                code: "AM",
                name_translations: {
                    en: "Armenia"
                }
            },
            {
                name: "İsveç",
                currency: "SEK",
                code: "SE",
                name_translations: {
                    en: "Sweden"
                }
            },
            {
                name: "Brunei",
                currency: "BND",
                code: "BN",
                name_translations: {
                    en: "Brunei"
                }
            },
            {
                name: "Tokelau",
                currency: "NZD",
                code: "TK",
                name_translations: {
                    en: "Tokelau"
                }
            },
            {
                name: "Réunion",
                currency: "EUR",
                code: "RE",
                name_translations: {
                    en: "Réunion"
                }
            },
            {
                name: "İrlanda",
                currency: "EUR",
                code: "IE",
                name_translations: {
                    en: "Ireland"
                }
            },
            {
                name: "Nijerya",
                currency: "NGN",
                code: "NG",
                name_translations: {
                    en: "Nigeria"
                }
            },
            {
                name: "Åland Adaları",
                currency: "EUR",
                code: "AX",
                name_translations: {
                    en: "Åland Islands"
                }
            },
            {
                name: "Svalbard ve Jan Mayen Adaları",
                currency: "NOK",
                code: "SJ",
                name_translations: {
                    en: "Svalbard and Jan Mayen"
                }
            },
            {
                name: "Slovenya",
                currency: "EUR",
                code: "SI",
                name_translations: {
                    en: "Slovenia"
                }
            },
            {
                name: "Montserrat",
                currency: "XCD",
                code: "MS",
                name_translations: {
                    en: "Montserrat"
                }
            },
            {
                name: "Mayotte",
                currency: "EUR",
                code: "YT",
                name_translations: {
                    en: "Mayotte"
                }
            },
            {
                name: "Turks ve Caicos Adaları",
                currency: "USD",
                code: "TC",
                name_translations: {
                    en: "Turks and Caicos Islands"
                }
            },
            {
                name: "Kongo - Kinşasa",
                currency: "CDF",
                code: "CD",
                name_translations: {
                    en: "Democratic Republic of the Congo"
                }
            },
            {
                name: "Macaristan",
                currency: "HUF",
                code: "HU",
                name_translations: {
                    en: "Hungary"
                }
            },
            {
                name: "Çin",
                currency: "CNY",
                code: "CN",
                name_translations: {
                    en: "China"
                }
            },
            {
                name: "Martinik",
                currency: "EUR",
                code: "MQ",
                name_translations: {
                    en: "Martinique"
                }
            },
            {
                name: "Amerikan Samoası",
                currency: "USD",
                code: "AS",
                name_translations: {
                    en: "American Samoa"
                }
            },
            {
                name: "Saint Kitts ve Nevis",
                currency: "XCD",
                code: "KN",
                name_translations: {
                    en: "Saint Kitts and Nevis"
                }
            },
            {
                name: "Saint Helena, Ascension and Tristan da Cunha",
                currency: "SHP",
                code: "SH",
                name_translations: {
                    en: "Saint Helena, Ascension and Tristan da Cunha"
                }
            },
            {
                name: "Beyaz Rusya",
                currency: "BYR",
                code: "BY",
                name_translations: {
                    en: "Belarus"
                }
            },
            {
                name: "Tuvalu",
                currency: "AUD",
                code: "TV",
                name_translations: {
                    en: "Tuvalu"
                }
            },
            {
                name: "Ekvador",
                currency: "USD",
                code: "EC",
                name_translations: {
                    en: "Ecuador"
                }
            },
            {
                name: "British Indian Ocean Territory",
                currency: "USD",
                code: "IO",
                name_translations: {
                    en: "British Indian Ocean Territory"
                }
            },
            {
                name: "Guyana",
                currency: "GYD",
                code: "GY",
                name_translations: {
                    en: "Guyana"
                }
            },
            {
                name: "Pakistan",
                currency: "PKR",
                code: "PK",
                name_translations: {
                    en: "Pakistan"
                }
            },
            {
                name: "Cebelitarık",
                currency: "GIP",
                code: "GI",
                name_translations: {
                    en: "Gibraltar"
                }
            },
            {
                name: "Antigua ve Barbuda",
                currency: "XCD",
                code: "AG",
                name_translations: {
                    en: "Antigua and Barbuda"
                }
            },
            {
                name: "Niue",
                currency: "NZD",
                code: "NU",
                name_translations: {
                    en: "Niue"
                }
            },
            {
                name: "Cape Verde",
                currency: "CVE",
                code: "CV",
                name_translations: {
                    en: "Cape Verde"
                }
            },
            {
                name: "Botsvana",
                currency: "BWP",
                code: "BW",
                name_translations: {
                    en: "Botswana"
                }
            },
            {
                name: "Grönland",
                currency: "DKK",
                code: "GL",
                name_translations: {
                    en: "Greenland"
                }
            },
            {
                name: "Kosta Rika",
                currency: "CRC",
                code: "CR",
                name_translations: {
                    en: "Costa Rica"
                }
            },
            {
                name: "Afganistan",
                currency: "AFN",
                code: "AF",
                name_translations: {
                    en: "Afghanistan"
                }
            },
            {
                name: "Hong Kong",
                currency: "HKD",
                code: "HK",
                name_translations: {
                    en: "Hong Kong"
                }
            },
            {
                name: "Azerbaycan",
                currency: "AZN",
                code: "AZ",
                name_translations: {
                    en: "Azerbaijan"
                }
            },
            {
                name: "Küba",
                currency: "CUP",
                code: "CU",
                name_translations: {
                    en: "Cuba"
                }
            },
            {
                name: "Sırbistan",
                currency: "RSD",
                code: "RS",
                name_translations: {
                    en: "Serbia"
                }
            },
            {
                name: "Finlandiya",
                currency: "EUR",
                code: "FI",
                name_translations: {
                    en: "Finland"
                }
            },
            {
                name: "Solomon Adaları",
                currency: "SBD",
                code: "SB",
                name_translations: {
                    en: "Solomon Islands"
                }
            },
            {
                name: "Vietnam",
                currency: "VND",
                code: "VN",
                name_translations: {
                    en: "Vietnam"
                }
            },
            {
                name: "Zimbabve",
                currency: "ZWD",
                code: "ZW",
                name_translations: {
                    en: "Zimbabwe"
                }
            },
            {
                name: "Jersey",
                currency: "GBP",
                code: "JE",
                name_translations: {
                    en: "Jersey"
                }
            },
            {
                name: "Heard Island and McDonald Islands",
                currency: "AUD",
                code: "HM",
                name_translations: {
                    en: "Heard Island and McDonald Islands"
                }
            },
            {
                name: "Barbados",
                currency: "BBD",
                code: "BB",
                name_translations: {
                    en: "Barbados"
                }
            },
            {
                name: "Gabon",
                currency: "XAF",
                code: "GA",
                name_translations: {
                    en: "Gabon"
                }
            },
            {
                name: "Rusya",
                currency: "RUB",
                code: "RU",
                name_translations: {
                    en: "Russia"
                }
            },
            {
                name: "Kolombiya",
                currency: "COP",
                code: "CO",
                name_translations: {
                    en: "Colombia"
                }
            },
            {
                name: "Dominik Cumhuriyeti",
                currency: "DOP",
                code: "DO",
                name_translations: {
                    en: "Dominican Republic"
                }
            },
            {
                name: "Guernsey",
                currency: "GBP",
                code: "GG",
                name_translations: {
                    en: "Guernsey"
                }
            },
            {
                name: "Saint Lucia",
                currency: "XCD",
                code: "LC",
                name_translations: {
                    en: "Saint Lucia"
                }
            },
            {
                name: "Palau",
                currency: "USD",
                code: "PW",
                name_translations: {
                    en: "Palau"
                }
            },
            {
                name: "Uganda",
                currency: "UGX",
                code: "UG",
                name_translations: {
                    en: "Uganda"
                }
            },
            {
                name: "Fransız Guyanası",
                currency: "EUR",
                code: "GF",
                name_translations: {
                    en: "French Guiana"
                }
            },
            {
                name: "Mikronezya",
                currency: "USD",
                code: "FM",
                name_translations: {
                    en: "Micronesia"
                }
            },
            {
                name: "Aruba",
                currency: "AWG",
                code: "AW",
                name_translations: {
                    en: "Aruba"
                }
            },
            {
                name: "Timor-Leste",
                currency: "USD",
                code: "TL",
                name_translations: {
                    en: "East Timor"
                }
            },
            {
                name: "San Marino",
                currency: "EUR",
                code: "SM",
                name_translations: {
                    en: "San Marino"
                }
            },
            {
                name: "Portekiz",
                currency: "EUR",
                code: "PT",
                name_translations: {
                    en: "Portugal"
                }
            },
            {
                name: "Britanya Virjin Adaları",
                currency: "USD",
                code: "VG",
                name_translations: {
                    en: "British Virgin Islands"
                }
            },
            {
                name: "Kuzey Kore",
                currency: "KPW",
                code: "KP",
                name_translations: {
                    en: "North Korea"
                }
            },
            {
                name: "Umman",
                currency: "OMR",
                code: "OM",
                name_translations: {
                    en: "Oman"
                }
            },
            {
                name: "Moritanya",
                currency: "MRO",
                code: "MR",
                name_translations: {
                    en: "Mauritania"
                }
            },
            {
                name: "Anguilla",
                currency: "XCD",
                code: "AI",
                name_translations: {
                    en: "Anguilla"
                }
            },
            {
                name: "Saint Martin",
                currency: "EUR",
                code: "MF",
                name_translations: {
                    en: "Saint Martin"
                }
            },
            {
                name: "Güney Afrika",
                currency: "ZAR",
                code: "ZA",
                name_translations: {
                    en: "South Africa"
                }
            },
            {
                name: "Kosova",
                currency: "EUR",
                code: "XK",
                name_translations: {
                    en: "Kosovo"
                }
            },
            {
                name: "Polonya",
                currency: "PLN",
                code: "PL",
                name_translations: {
                    en: "Poland"
                }
            },
            {
                name: "Bahreyn",
                currency: "BHD",
                code: "BH",
                name_translations: {
                    en: "Bahrain"
                }
            },
            {
                name: "Malezya",
                currency: "MYR",
                code: "MY",
                name_translations: {
                    en: "Malaysia"
                }
            },
            {
                name: "Marshall Adaları",
                currency: "USD",
                code: "MH",
                name_translations: {
                    en: "Marshall Islands"
                }
            },
            {
                name: "South Georgia and the South Sandwich Islands",
                currency: "GBP",
                code: "GS",
                name_translations: {
                    en: "South Georgia and the South Sandwich Islands"
                }
            },
            {
                name: "Gambiya",
                currency: "GMD",
                code: "GM",
                name_translations: {
                    en: "Gambia"
                }
            },
            {
                name: "Trinidad ve Tobago",
                currency: "TTD",
                code: "TT",
                name_translations: {
                    en: "Trinidad and Tobago"
                }
            },
            {
                name: "Nijer",
                currency: "XOF",
                code: "NE",
                name_translations: {
                    en: "Niger"
                }
            },
            {
                name: "French Southern Territories",
                currency: "EUR",
                code: "TF",
                name_translations: {
                    en: "French Southern Territories"
                }
            },
            {
                name: "Guam",
                currency: "USD",
                code: "GU",
                name_translations: {
                    en: "Guam"
                }
            },
            {
                name: "Christmas Adası",
                currency: "AUD",
                code: "CX",
                name_translations: {
                    en: "Christmas Island"
                }
            },
            {
                name: "Irak",
                currency: "IQD",
                code: "IQ",
                name_translations: {
                    en: "Iraq"
                }
            },
            {
                name: "Bolivya",
                currency: "BOB",
                code: "BO",
                name_translations: {
                    en: "Bolivia"
                }
            },
            {
                name: "Arjantin",
                currency: "ARS",
                code: "AR",
                name_translations: {
                    en: "Argentina"
                }
            },
            {
                name: "Hindistan",
                currency: "INR",
                code: "IN",
                name_translations: {
                    en: "India"
                }
            },
            {
                name: "Türkmenistan",
                currency: "TMT",
                code: "TM",
                name_translations: {
                    en: "Turkmenistan"
                }
            },
            {
                name: "Burundi",
                currency: "BIF",
                code: "BI",
                name_translations: {
                    en: "Burundi"
                }
            },
            {
                name: "Özbekistan",
                currency: "UZS",
                code: "UZ",
                name_translations: {
                    en: "Uzbekistan"
                }
            },
            {
                name: "Venezuela",
                currency: "VEF",
                code: "VE",
                name_translations: {
                    en: "Venezuela"
                }
            },
            {
                name: "Kamerun",
                currency: "XAF",
                code: "CM",
                name_translations: {
                    en: "Cameroon"
                }
            },
            {
                name: "Mısır",
                currency: "EGP",
                code: "EG",
                name_translations: {
                    en: "Egypt"
                }
            },
            {
                name: "Man Adası",
                currency: "GBP",
                code: "IM",
                name_translations: {
                    en: "Isle of Man"
                }
            },
            {
                name: "Sint Maarten",
                currency: "ANG",
                code: "SX",
                name_translations: {
                    en: "Sint Maarten"
                }
            },
            {
                name: "Slovakya",
                currency: "EUR",
                code: "SK",
                name_translations: {
                    en: "Slovakia"
                }
            },
            {
                name: "İzlanda",
                currency: "ISK",
                code: "IS",
                name_translations: {
                    en: "Iceland"
                }
            },
            {
                name: "Tayland",
                currency: "THB",
                code: "TH",
                name_translations: {
                    en: "Thailand"
                }
            },
            {
                name: "Uruguay",
                currency: "UYU",
                code: "UY",
                name_translations: {
                    en: "Uruguay"
                }
            },
            {
                name: "Suriye",
                currency: "SYP",
                code: "SY",
                name_translations: {
                    en: "Syria"
                }
            },
            {
                name: "Svaziland",
                currency: "SZL",
                code: "SZ",
                name_translations: {
                    en: "Eswatini"
                }
            },
            {
                name: "Avustralya",
                currency: "AUD",
                code: "AU",
                name_translations: {
                    en: "Australia"
                }
            },
            {
                name: "Senegal",
                currency: "XOF",
                code: "SN",
                name_translations: {
                    en: "Senegal"
                }
            },
            {
                name: "Papua Yeni Gine",
                currency: "PGK",
                code: "PG",
                name_translations: {
                    en: "Papua New Guinea"
                }
            },
            {
                name: "Wallis ve Futuna Adaları",
                currency: "XPF",
                code: "WF",
                name_translations: {
                    en: "Wallis and Futuna"
                }
            },
            {
                name: "Danimarka",
                currency: "DKK",
                code: "DK",
                name_translations: {
                    en: "Denmark"
                }
            },
            {
                name: "Malavi",
                currency: "MWK",
                code: "MW",
                name_translations: {
                    en: "Malawi"
                }
            },
            {
                name: "Sudan",
                currency: "SDG",
                code: "SD",
                name_translations: {
                    en: "Sudan"
                }
            },
            {
                name: "Norveç",
                currency: "NOK",
                code: "NO",
                name_translations: {
                    en: "Norway"
                }
            },
            {
                name: "Romanya",
                currency: "RON",
                code: "RO",
                name_translations: {
                    en: "Romania"
                }
            },
            {
                name: "İsrail",
                currency: "ILS",
                code: "IL",
                name_translations: {
                    en: "Israel"
                }
            },
            {
                name: "Kuveyt",
                currency: "KWD",
                code: "KW",
                name_translations: {
                    en: "Kuwait"
                }
            },
            {
                name: "Filistin",
                currency: "ILS",
                code: "PS",
                name_translations: {
                    en: "Palestine"
                }
            },
            {
                name: "Zambiya",
                currency: "ZMK",
                code: "ZM",
                name_translations: {
                    en: "Zambia"
                }
            },
            {
                name: "Arnavutluk",
                currency: "ALL",
                code: "AL",
                name_translations: {
                    en: "Albania"
                }
            },
            {
                name: "Ekvator Ginesi",
                currency: "XAF",
                code: "GQ",
                name_translations: {
                    en: "Equatorial Guinea"
                }
            },
            {
                name: "Hollanda",
                currency: "EUR",
                code: "NL",
                name_translations: {
                    en: "Netherlands"
                }
            },
            {
                name: "İtalya",
                currency: "EUR",
                code: "IT",
                name_translations: {
                    en: "Italy"
                }
            },
            {
                name: "El Salvador",
                currency: "USD",
                code: "SV",
                name_translations: {
                    en: "El Salvador"
                }
            },
            {
                name: "Litvanya",
                currency: "LTL",
                code: "LT",
                name_translations: {
                    en: "Lithuania"
                }
            },
            {
                name: "Orta Afrika Cumhuriyeti",
                currency: "XAF",
                code: "CF",
                name_translations: {
                    en: "Central African Republic"
                }
            },
            {
                name: "Moğolistan",
                currency: "MNT",
                code: "MN",
                name_translations: {
                    en: "Mongolia"
                }
            },
            {
                name: "Kanada",
                currency: "CAD",
                code: "CA",
                name_translations: {
                    en: "Canada"
                }
            },
            {
                name: "Kırgızistan",
                currency: "KGS",
                code: "KG",
                name_translations: {
                    en: "Kyrgyzstan"
                }
            },
            {
                name: "Madagaskar",
                currency: "MGA",
                code: "MG",
                name_translations: {
                    en: "Madagascar"
                }
            },
            {
                name: "Libya",
                currency: "LYD",
                code: "LY",
                name_translations: {
                    en: "Libya"
                }
            },
            {
                name: "Kazakistan",
                currency: "KZT",
                code: "KZ",
                name_translations: {
                    en: "Kazakhstan"
                }
            },
            {
                name: "Kamboçya",
                currency: "KHR",
                code: "KH",
                name_translations: {
                    en: "Cambodia"
                }
            },
            {
                name: "Çad",
                currency: "XAF",
                code: "TD",
                name_translations: {
                    en: "Chad"
                }
            },
            {
                name: "Kenya",
                currency: "KES",
                code: "KE",
                name_translations: {
                    en: "Kenya"
                }
            },
            {
                name: "Letonya",
                currency: "LVL",
                code: "LV",
                name_translations: {
                    en: "Latvia"
                }
            },
            {
                name: "Togo",
                currency: "XOF",
                code: "TG",
                name_translations: {
                    en: "Togo"
                }
            },
            {
                name: "Surinam",
                currency: "SRD",
                code: "SR",
                name_translations: {
                    en: "Suriname"
                }
            },
            {
                name: "Ürdün",
                currency: "JOD",
                code: "JO",
                name_translations: {
                    en: "Jordan"
                }
            },
            {
                name: "Gürcistan",
                currency: "GEL",
                code: "GE",
                name_translations: {
                    en: "Georgia"
                }
            },
            {
                name: "Bahamalar",
                currency: "BSD",
                code: "BS",
                name_translations: {
                    en: "Bahamas"
                }
            },
            {
                name: "Avusturya",
                currency: "EUR",
                code: "AT",
                name_translations: {
                    en: "Austria"
                }
            },
            {
                name: "Endonezya",
                currency: "IDR",
                code: "ID",
                name_translations: {
                    en: "Indonesia"
                }
            },
            {
                name: "İsviçre",
                currency: "CHF",
                code: "CH",
                name_translations: {
                    en: "Switzerland"
                }
            },
            {
                name: "Makao",
                currency: "MOP",
                code: "MO",
                name_translations: {
                    en: "Macau"
                }
            },
            {
                name: "Nikaragua",
                currency: "NIO",
                code: "NI",
                name_translations: {
                    en: "Nicaragua"
                }
            },
            {
                name: "Tanzanya",
                currency: "TZS",
                code: "TZ",
                name_translations: {
                    en: "Tanzania"
                }
            },
            {
                name: "Maldivler",
                currency: "MVR",
                code: "MV",
                name_translations: {
                    en: "Maldives"
                }
            },
            {
                name: "Fransa",
                currency: "EUR",
                code: "FR",
                name_translations: {
                    en: "France"
                }
            },
            {
                name: "Cezayir",
                currency: "DZD",
                code: "DZ",
                name_translations: {
                    en: "Algeria"
                }
            },
            {
                name: "Yunanistan",
                currency: "EUR",
                code: "GR",
                name_translations: {
                    en: "Greece"
                }
            },
            {
                name: "Bulgaristan",
                currency: "BGN",
                code: "BG",
                name_translations: {
                    en: "Bulgaria"
                }
            },
            {
                name: "Burkina Faso",
                currency: "XOF",
                code: "BF",
                name_translations: {
                    en: "Burkina Faso"
                }
            },
            {
                name: "Belçika",
                currency: "EUR",
                code: "BE",
                name_translations: {
                    en: "Belgium"
                }
            },
            {
                name: "Fas",
                currency: "MAD",
                code: "MA",
                name_translations: {
                    en: "Morocco"
                }
            },
            {
                name: "Almanya",
                currency: "EUR",
                code: "DE",
                name_translations: {
                    en: "Germany"
                }
            },
            {
                name: "Angola",
                currency: "AOA",
                code: "AO",
                name_translations: {
                    en: "Angola"
                }
            },
            {
                name: "Yemen",
                currency: "YER",
                code: "YE",
                name_translations: {
                    en: "Yemen"
                }
            },
            {
                name: "Bosna Hersek",
                currency: "BAM",
                code: "BA",
                name_translations: {
                    en: "Bosnia and Herzegovina"
                }
            },
            {
                name: "Bangladeş",
                currency: "BDT",
                code: "BD",
                name_translations: {
                    en: "Bangladesh"
                }
            },
            {
                name: "Seyşeller",
                currency: "SCR",
                code: "SC",
                name_translations: {
                    en: "Seychelles"
                }
            },
            {
                name: "Fiji",
                currency: "FJD",
                code: "FJ",
                name_translations: {
                    en: "Fiji"
                }
            },
            {
                name: "Crimea",
                currency: null,
                code: "KX",
                name_translations: {
                    en: "Crimea"
                }
            },
            {
                name: "Honduras",
                currency: "HNL",
                code: "HN",
                name_translations: {
                    en: "Honduras"
                }
            },
            {
                name: "Tayvan",
                currency: "TWD",
                code: "TW",
                name_translations: {
                    en: "Taiwan"
                }
            },
            {
                name: "Tonga",
                currency: "TOP",
                code: "TO",
                name_translations: {
                    en: "Tonga"
                }
            },
            {
                name: "İran",
                currency: "IRR",
                code: "IR",
                name_translations: {
                    en: "Iran"
                }
            },
            {
                name: "São Tomé ve Príncipe",
                currency: "STD",
                code: "ST",
                name_translations: {
                    en: "São Tomé and Príncipe"
                }
            },
            {
                name: "Bermuda",
                currency: "BMD",
                code: "BM",
                name_translations: {
                    en: "Bermuda"
                }
            },
            {
                name: "Vanuatu",
                currency: "VUV",
                code: "VU",
                name_translations: {
                    en: "Vanuatu"
                }
            },
            {
                name: "Kiribati",
                currency: "AUD",
                code: "KI",
                name_translations: {
                    en: "Kiribati"
                }
            },
            {
                name: "Namibya",
                currency: "NAD",
                code: "NA",
                name_translations: {
                    en: "Namibia"
                }
            },
            {
                name: "Japonya",
                currency: "JPY",
                code: "JP",
                name_translations: {
                    en: "Japan"
                }
            },
            {
                name: "ABD Küçük Dış Adaları",
                currency: "USD",
                code: "UM",
                name_translations: {
                    en: "United States Minor Outlying Islands"
                }
            },
            {
                name: "Laos",
                currency: "LAK",
                code: "LA",
                name_translations: {
                    en: "Laos"
                }
            },
            {
                name: "ABD",
                currency: "USD",
                code: "US",
                name_translations: {
                    en: "United States"
                }
            },
            {
                name: "Yeni Zelanda",
                currency: "NZD",
                code: "NZ",
                name_translations: {
                    en: "New Zealand"
                }
            },
            {
                name: "Güney Sudan",
                currency: null,
                code: "SS",
                name_translations: {
                    en: "South Sudan"
                }
            },
            {
                name: "Hırvatistan",
                currency: "HRK",
                code: "HR",
                name_translations: {
                    en: "Croatia"
                }
            },
            {
                name: "Türkiye",
                currency: "TRY",
                code: "TR",
                name_translations: {
                    en: "Turkey"
                }
            },
            {
                name: "Karayip Hollanda",
                currency: "USD",
                code: "BQ",
                name_translations: {
                    en: "Caribbean Netherlands"
                }
            },
            {
                name: "Ukraine",
                currency: "UAH",
                code: "UA",
                name_translations: {
                    en: "Ukraine"
                }
            },
            {
                name: "Liberya",
                currency: "LRD",
                code: "LR",
                name_translations: {
                    en: "Liberia"
                }
            },
            {
                name: "Benin",
                currency: "XOF",
                code: "BJ",
                name_translations: {
                    en: "Benin"
                }
            },
            {
                name: "Sri Lanka",
                currency: "LKR",
                code: "LK",
                name_translations: {
                    en: "Sri Lanka"
                }
            },
            {
                name: "Tacikistan",
                currency: "TJS",
                code: "TJ",
                name_translations: {
                    en: "Tajikistan"
                }
            },
            {
                name: "Nepal",
                currency: "NPR",
                code: "NP",
                name_translations: {
                    en: "Nepal"
                }
            },
            {
                name: "Meksika",
                currency: "MXN",
                code: "MX",
                name_translations: {
                    en: "Mexico"
                }
            },
            {
                name: "Gine-Bissau",
                currency: "XOF",
                code: "GW",
                name_translations: {
                    en: "Guinea-Bissau"
                }
            }
        ]
    },

    airports() {
        return [
            'Omsk Tsentralny Rusya - OMS',
            'Oktiabrsky  Rusya - OKT',
            'Orsk  Rusya - OSW',
            'Okhotsk  Rusya - OHO',
            'Okha  Rusya - OHH',
            'Vladikavkaz Beslan Rusya - OGZ',
            'Orel Yuzhny Rusya - OEL',
            'Nadym  Rusya - NYM',
            'Nyagan  Rusya - NYA',
            'Novy Urengoy  Rusya - NUX',
            'Novgorod  Rusya - NVR',
            'Norilsk Alykel Rusya - NSK',
            'Novorossiysk Krymska Rusya - NOI',
            'Noyabrsk  Rusya - NOJ',
            'Novokuznetsk Spichenkovo Rusya - NOZ',
            'Nizhnevartovsk  Rusya - NJC',
            'Naryan Mar  Rusya - NNM',
            'Neftekamsk  Rusya - NEF',
            'Nogliki  Rusya - NGK',
            'Neryungri  Rusya - NER',
            'Hatay  Türkiye - HTY',
            'Isparta Süleyman Demirel Türkiye (ısparta) - ISE',
            'İstanbul Tümü (istanbul) - ISTT',
            'İstanbul Havalimanı (istanbul) - IST',
            'İstanbul Sabiha Gökçen (istanbul) - SAW',
            'İzmir Adnan Menderes (izmir) - ADB',
            'Gaziantep Oğuzeli Türkiye - GZT',
            'Iğdır Şehit Bülent Aydın Türkiye ığdır - IGD',
            'Hakkari Yüksekova Selahaddin Eyyubi Turkey Türkiye - YKO',
            'Kars Türkiye - KSY',
            'Kahramanmaraş Türkiye - KCM',
            'Kastamonu Türkiye - KFS',
            'Konya  Türkiye - KYA',
            'Eskişehir Anadolu Türkiye - AOE',
            'Eskişehir  Türkiye - ESK',
            'Erzurum  Türkiye - ERZ',
            'Elazığ  Türkiye - EZS',
            'Erzincan  Türkiye - ERC',
            'Balıkesir Edremit Koca Seyit Türkiye Balikesir - EDO',
            'Diyarbakır  Türkiye - DIY',
            'Dalaman  Türkiye - DLM',
            'Denizli Çardak Türkiye - DNZ',
            'Çanakkale Türkiye - CKZ',
            'Canakkale Türkiye - CKZ',
            'Kocaeli Cengiz Topel Türkiye - KCO',
            'Kayseri Erkilet Türkiye - ASR',
            'Ankara Esenboğa Türkiye - ESB',
            'Ordu Giresun Türkiye - OGU',
            'Alanya Gazipaşa Türkiye - GZP',
            'Kütahya Afyon Zafer Türkiye - KZR',
            'Amasya Merzifon Türkiye - MZH',
            'Batman  Türkiye - BAL',
            'Antalya  Türkiye - AYT',
            'Adana Şakirpaşa Türkiye - ADA',
            'Adıyaman  Türkiye - ADF',
            'Adiyaman  Türkiye - ADF',
            'Ağrı  Türkiye - AJI',
            'Bandırma  Türkiye - BDM',
            'Bursa Yenişehir Türkiye - YEI',
            'Bodrum İmsik Türkiye - BXN',
            'Bingöl Türkiye Bıngol - BGG',
            'Bodrum Milas Türkiye - BJV',
            'Sivas  Türkiye - VAS',
            'Van Ferit Melen Türkiye - VAN',
            'Artvin Hopa Türkiye - XHQ',
            'Tekirdağ Çorlu Türkiye - TEQ',
            'Şerafettin Elçi Şırnak Türkiye - NKT',
            'Samsun Çarsamba Türkiye - SZF',
            'Samsun Türkiye - SSX',
            'Siirt Türkiye - SXZ',
            'Zonguldak, Türkiye - ONQ',
            'Sinop Türkiye - NOP',
            'Tokat Türkiye - TJK',
            'Trabzon Türkiye - TZX',
            'Uşak, Usak Türkiye - USQ',
            'Nevşehir, Nevsehir Kapodokya Türkiye - NAV',
            'Malatya Erhaç Türkiye - MLX',
            'Mardin  Türkiye - MQM',
            'Muş, Mus Türkiye - MSR',
            'Şanlıurfa, Sanliurfa Türkiye - SFQ',
            'Şanlıurfa, Sanliurfa Güney Anadolu Türkiye - GNY',
            'Provedenia  Rusya - PVX',
            'Pevek  Rusya - PWE',
            'Polyarnyj  Rusya - PYJ',
            'Provideniya Provideniya Bay Rusya - PVS',
            'Pskov  Rusya - PKV',
            'Sovetsky  Rusya - OVS',
            'Novosibirsk Tolmachevo Rusya - OVB',
            'Petropavlovsk Yelizovo Rusya - PKC',
            'Perm Bolshoye Savino Rusya - PEE',
            'Pechora  Rusya - PEX',
            'Penza Ternovka Rusya - PEZ',
            'Petrozavodsk Besovets Rusya - PES',
            'Syktyvkar  Rusya - SCW',
            'Surgut  Rusya - SGC',
            'Ryazan Turlatovo Rusya - RZN',
            'Rybinsk Staroselye Rusya - RYB',
            'Saratov Tsentralny Rusya - RTW',
            'Rostov  Rusya - ROV',
            'Raduzhny  Rusya - RAT',
            'Orenburg Tsentralny Rusya - REN',
            'Nefteyugansk  Rusya - NFG',
            'Nizhnekamsk Begishevo Rusya - NBC',
            'Nalchik  Rusya - NAL',
            'Magnitogorsk  Rusya - MQF',
            'Moskova Tüm Havalimanları Rusya - MOW',
            'Moskova Sheremetyevo Intl Rusya - SVO',
            'Moskova Domodedovo Rusya - DME',
            'Moskova Vnukovo Intl Rusya - VKO',
            'Moskova Bykovo Rusya - BKA',
            'Mineralnye Vody  Rusya - MRV',
            'Makhachkala Uytash Rusya - MCX',
            'Mirny  Rusya - MJZ',
            'Murmansk  Rusya - MMK',
            'Vologda  Rusya - VGD',
            'Velikiye Luki  Rusya - VLU',
            'Volgodonsk  Rusya - VLK',
            'Volgograd Gumrak Rusya - VOG',
            'Vorkuta  Rusya - VKT',
            'Veliky Ustyug  Rusya - VUS',
            'Voronezh Chertovitskoye Rusya - VOZ',
            'Vladivostok  Rusya - VVO',
            'Zonalnoe  Rusya - ZZO',
            'Yakutsk  Rusya - YKS',
            'Mys Kamenny  Rusya - YMK',
            'Tarko Sale  Rusya - TQL',
            'Tobolsk  Rusya - TOX',
            'Tomsk Bogashevo Rusya - TOF',
            'Taganrog  Rusya - TGK',
            'Plastun  Rusya - TLY',
            'Tyumen Roshchino Rusya - TJM',
            'Ufa  Rusya - UFA',
            'Urengoy  Rusya - UEN',
            'Ukhta  Rusya - UCT',
            'Tynda  Rusya - TYD',
            'Tula Klokovo Rusya - TYA',
            'Yuzhno Sakhalinsk  Rusya - UUS',
            'Bugulma  Rusya - UUA',
            'Ulan Ude Mukhino Rusya - UUD',
            'Ust Tsilma  Rusya - UTS',
            'Usinsk  Rusya - USK',
            'Kursk Vostochny Rusya - URS',
            'Uray  Rusya - URJ',
            'Ust Kut  Rusya - UKX',
            'Ust Ilimsk  Rusya - UIK',
            'Ulyanovsk Vostochny Rusya - ULY',
            'Stavropol Shpakovskoye Rusya - STW',
            'Strezhevoy  Rusya - SWT',
            'Yekaterinburg Koltsovo Rusya - SVX',
            'Tambov Donskoye Rusya - TBW',
            'Salekhard  Rusya - SLY',
            'Saransk  Rusya - SKX',
            'Beloretsk  Rusya - BCX',
            'Iturup Island Burevestnik Afb Rusya - BVV',
            'Balakovo  Rusya - BWO',
            'Bryansk  Rusya - BZK',
            'Blagoveshchensk Ignatyevo Rusya - BQS',
            'Bratsk  Rusya - BTK',
            'Arkhangelsk Talagi Rusya - ARH',
            'Astrakhan  Rusya - ASF',
            'Barnaul  Rusya - BAX',
            'Amderma  Rusya - AMV',
            'Abakan  Rusya - ABA',
            'Anapa Vityazevo Rusya - AAQ',
            'Achinsk  Rusya - ACS',
            'Sochi Sochi Intl Rusya - AER',
            'Aldan  Rusya - ADH',
            'Solovetsky Solovki Rusya - CSH',
            'Cheboksary  Rusya - CSY',
            'Cherskiy  Rusya - CYX',
            'Chkalovskiy Chkalovskiy Airport Rusya - CKL',
            'Chulman  Rusya - CNN',
            'Chokurdah  Rusya - CKH',
            'Cherepovets  Rusya - CEE',
            'Chelyabinsk Balandino Rusya - CEK',
            'Anadyr Ugolny Rusya - DYR',
            'Yuzhno Kurilsk Mendeleevoo Rusya - DEE',
            'Dikson  Rusya - DKS',
            'Belgorod  Rusya - EGO',
            'Yeniseysk  Rusya - EIE',
            'Yeysk  Rusya - EIK',
            'Shakhtersk  Rusya - EKS',
            'Elista  Rusya - ESL',
            'Berezovo  Rusya - EZV',
            'Beloyarsky  Rusya - EYK',
            'Inta  Rusya - INA',
            'Izhevsk  Rusya - IJK',
            'Tiksi  Rusya - IKS',
            'Irkutsk  Rusya - IKT',
            'Igrim  Rusya - IRM',
            'Ivanovo Yuzhny Rusya - IWA',
            'Yaroslavl Tunoshna Rusya - IAR',
            'Igarka  Rusya - IAA',
            'Chita Kadala Rusya - HTA',
            'Khatanga  Rusya - HTG',
            'Khanty Mansiysk Rusya - HMA',
            'Magadan Sokol Rusya - GDX',
            'Gelendzhik  Rusya - GDZ',
            'Magdagachi  Rusya - GDG',
            'Grozny  Rusya - GRV',
            'Nizhny Novgorodd Strigino Rusya - GOJ',
            'Sovetskaya Gavan Rusya - GVN',
            'Leshukonskoye  Rusya - LDG',
            'Saint Petersburg Pulkovo Rusya - LED',
            'Saint Petersburg Rzhevka Rusya - RVH',
            'Kyzyl Rusya - KYZ',
            'Kazan Rusya - KZN',
            'Komsomolsk Na Amure  Rusya - KXK',
            'Smolensk Rusya - LNX',
            'Lipetsk Rusya - LPK',
            'Samara Kurumoch Rusya - KUF',
            'Kotlas Rusya - KSZ',
            'Kirovsk Apatity Khibiny Rusya - KVK',
            'Kavalerovo Rusya - KVR',
            'Kirov Pobedilovo Rusya - KVX',
            'Kurgan Rusya - KRO',
            'Krasnodar Pashkovsky Rusya - KRR',
            'Krasnoselkup Rusya - KKQ',
            'Kaluga Grabtsevo Rusya - KLF',
            'Tver Migalovo Rusya - KLD',
            'Krasnoyarsk Yemelyanovo Rusya - KJA',
            'Kostroma  Rusya - KMW',
            'Khabarovsk Novyy Rusya - KHV',
            'Kaliningrad Khrabrovo Rusya - KGD',
            'Kogalym Rusya - KGP',
            'Kemerovo Rusya - KEJ',
            'Yoshkar Ola Rusya - JOK',
            'Kiev Borispol Ukraine - KBP',
            'Kiev Zhulhany Ukraine - IEV',
            'Ivano Frankovsk  Ukraine - IFO',
            'Kharkov  Ukraine - HRK',
            'Khmelnitskiy  Ukraine - HMJ',
            'Lviv Snilow Ukraine - LWO',
            'Kherson Ukraine - KHE',
            'Kerch Ukraine - KHC',
            'Kremenchug Ukraine - KHU',
            'Kirovograd Ukraine - KGO',
            'Kamenets Podolski  Ukraine - KCP',
            'Kramatorsk Ukraine - KRQ',
            'Krivoy Rog Ukraine - KWG',
            'Donetsk Ukraine - DOK',
            'Dnepropetrovsk Ukraine - DNK',
            'Berdyansk Ukraine - ERD',
            'Chernovtsy Ukraine - CWC',
            'Cherkassy Ukraine - CKC',
            'Chernigov Ukraine - CEJ',
            'Simferopol Ukraine - SIP',
            'Ternopol Ukraine - TNL',
            'Lutsk Ukraine - UCK',
            'Uzhgorod Ukraine - UDJ',
            'Sumy Ukraine - UMY',
            'Sevastopol Belbek Ukraine - UKS',
            'Zhitomir Ukraine - ZTR',
            'Vinnica Ukraine - VIN',
            'Luhansk Ukraine - VSG',
            'Severodoneck Ukraine - SEV',
            'Rovno Ukraine - RWN',
            'Poltava Ukraine - PLV',
            'Zaporozhye Ukraine - OZH',
            'Mirgorod Ukraine - MXR',
            'Mariupol Ukraine - MPW',
            'Nikolaev Ukraine - NLV',
            'Odessa Central Ukraine - ODS',
            'Pforzheim Germany - UPF',
            'Burg Feuerstein Germany - URD',
            'Spangdahlem Air Base Germany - SPM',
            'Schwerin Parchim Germany - SZW',
            'Stuttgart Stuttgart Airport Germany - STR',
            'Koblenz Germany - ZNV',
            'Kehl Germany - ZIW',
            'Fictitious Point Ge Germany - ZZG',
            'Lemwerder Germany - XLW',
            'Finkenwerder Germany - XFW',
            'Wilhelmshaven Mariensiel Germany - WVN',
            'Wildenrath Germany - WID',
            'Schleswig Jagel Germany - WBG',
            'Varrelbusch Germany - VAC',
            'Wiesbaden Aaf Germany - WIE',
            'Saint Peter Ording Germany - PSH',
            'Peenemuende Germany - PEF',
            'Boeblingen Baden Wurtemberg Germany - PHM',
            'Paderborn Lippstadt Paderborn Germany - PAD',
            'Egelsbach Germany - QEF',
            'Strausberg Germany - QPK',
            'Husum Schwesing Germany - QHU',
            'Straubing Wallmuehle Germany - RBM',
            'Rechlin Laerz Germany - REB',
            'Ramstein Air Base Germany - RMS',
            'Rostock Laage Germany - RLG',
            'Sembach  Germany - SEX',
            'Siegen Siegerland Germany - SGE',
            'Saarbruecken Zweibruecken Germany - ZQW',
            'Saarbruecken Saarbruecken Airport Germany - SCN',
            'Mannheim City Airport Germany - MHG',
            'Münih International Germany - MUC',
            'Münih Augsburg Germany - AGB',
            'Oberpfaffenhofen  Germany - OBF',
            'Wyk Auf Foehr  Germany - OHR',
            'Nuremberg Airport Germany - NUE',
            'Norderney  Germany - NRD',
            'Norden Norddeich Germany - NOD',
            'Norddeich  Germany - NOE',
            'Nordholz Spieka Cuxhaven Germany - NDZ',
            'Bremerhaven  Germany - BRV',
            'Bremen  Germany - BRE',
            'Braunschweig/Wolfsburg Braunschweig Germany - BWE',
            'Bayreuth Bindlacher Berg Germany - BYU',
            'Brueggen R A F Germany - BGN',
            'Bielefeld Windelsbleiche Germany - BFE',
            'Berlin Tegel Germany - TXL',
            'Berlin Tempelhof Germany - THF',
            'Berlin Schoenefeld Germany - SXF',
            'Baltrum  Germany - BMR',
            'Borkum  Germany - BMK',
            'Aachen Merzbrueck Germany - AAH',
            'Wangerooge  Germany - AGE',
            'Stralsund Barth Germany - BBH',
            'Bitburg Bitburg Air Base Germany - BBJ',
            'Altenburg Altenburg Nobitz Germany - AOC',
            'Erfurt  Germany - ERF',
            'Emden  Germany - EME',
            'Eisenach Kindel Airport Germany - EIB',
            'Essen Muelheim Germany - ESS',
            'Neumuenster  Germany - EUM',
            'Fuerstenfeldbruck  Germany - FEL',
            'Friedrichshafen  Germany - FDH',
            'Cuxhaven Nordholz Airport Germany - FCN',
            'Duesseldorf Moenchengladbach Apt Germany - MGL',
            'Duesseldorf International Airport Germany - DUS',
            'Duesseldorf Weeze Airport Germany - NRN',
            'Dresden  Germany - DRS',
            'Dortmund  Germany - DTM',
            'Köln / Bonn  - CGN',
            'Cottbus Drewitz Apt Germany - CBU',
            'Magdeburg Cochstedt Germany - CSO',
            'Guettin  Germany - GTI',
            'Westerland Sylt Germany - GWT',
            'Guetersloh  Germany - GUT',
            'Hamburg  Germany - HAM',
            'Hamburg Luebeck-Blankensee Germany - LBC',
            'Hannover  Germany - HAJ',
            'Heidelberg Aaf Airport Germany - HDB',
            'Heringsdorf  Germany - HDF',
            'Geilenkirchen Air Base Germany - GKE',
            'Rheindahlen  Germany - GMY',
            'Giebelstadt  Germany - GHF',
            'Neubrandenburg Trollenhagen Germany - FNB',
            'Memmingen Allgaeu Germany - FMM',
            'Muenster/Osnabrueck Muenster Germany - FMO',
            'Flensburg Schaeferhaus Airport Germany - FLF',
            'Karlsruhe/Baden Baden Baden Airpark Germany - FKB',
            'Fritzlar Fritzlar Apt Germany - FRZ',
            'Frankfurt Rhein Main Afb Germany - FRF',
            'Frankfurt Frankfurt Intl Germany - FRA',
            'Frankfurt Hahn Airport Germany - HHN',
            'Frankfurt Neu Isenburg Germany - QGV',
            'Hof Plauen Germany - HOQ',
            'Heide/Buesum Heide Germany - HEI',
            'Helgoland Duene Germany - HGL',
            'Ingolstadt Manching Germany - IGS',
            'Riesa Goehlis Germany - IES',
            'Illesheim  Germany - ILH',
            'Koethen De  Germany - KOQ',
            'Kassel Calden Germany - KSF',
            'Juist  Germany - JUI',
            'Kiel Holtenau Germany - KEL',
            'Kitzingen  Germany - KZG',
            'Leipzig/Halle Leipzig Germany - LEJ',
            'Lahr Black Forest Germany - LHA',
            'Langeoog  Germany - LGO',
            'Laarbruch R A F Germany - LRC',
            'Maastricht  Netherlands - MST',
            'Rotterdam  Netherlands - RTM',
            'Uden Volkel Ab Netherlands - UDE',
            'Utrecht Soesterberg Netherlands - UTC',
            'Bergen Op Zoom Woensdrecht Ab Netherlands - WOE',
            'Bergen Op Zoom Woensdrecht Netherlands - BZM',
            'Amsterdam Schiphol Airport Netherlands - AMS',
            'Enschede Twenthe Netherlands - ENS',
            'Eindhoven  Netherlands - EIN',
            'Den Helder De Kooy Netherlands - DHR',
            'Leeuwarden Air Base Netherlands - LWR',
            'Leiden Valkenburg Netherlands - LID',
            'Lelystad  Netherlands - LEY',
            'Breda Gilze Rijen Ab Netherlands - GLZ',
            'Groningen Eelde Netherlands - GRQ',
            'The Hague  Netherlands - HAG',
            'Haugesund Karmoy Norway - HAU',
            'Hasvik  Norway - HAA',
            'Gol Klanten Arpt Norway - GLL',
            'Floro  Norway - FRO',
            'Honningsvag Valan Norway - HVG',
            'Hamar Stafsberg Norway - HMR',
            'Orsta Volda Hovden Norway - HOV',
            'Hammerfest  Norway - HFT',
            'Lakselv Banak Norway - LKL',
            'Leknes Norway - LKN',
            'Longyearbyen Svalbard Norway - LYR',
            'Kirkenes Hoybuktmoen Norway - KKN',
            'Kristiansund Kvernberget Norway - KSU',
            'Kristiansand Kjevik Norway - KRS',
            'Geilo Dagali Airport Norway - DLD',
            'Harstad Narvik Evenes Apt Norway - EVE',
            'Forde Bringeland Norway - FDE',
            'Farsund Lista Norway - FAN',
            'Alta  Norway - ALF',
            'Alesund Vigra Norway - AES',
            'Andenes Andoya Norway - ANX',
            'Berlevag  Norway - BVG',
            'Bodo  Norway - BOO',
            'Bardufoss  Norway - BDU',
            'Bergen Flesland Norway - BGO',
            'Bronnoysund Bronnoy Norway - BNN',
            'Batsfjord  Norway - BJF',
            'Vardo Svartnes Norway - VAW',
            'Vadso  Norway - VDS',
            'Fagernes Leirin Norway - VDB',
            'Vaeroy Stolport Norway - VRY',
            'Tromso Langnes Norway - TOS',
            'Trondheim Vaernes Norway - TRD',
            'Skien Geiteryggen Norway - SKE',
            'Stokmarknes Skagen Norway - SKN',
            'Sorkjosen  Norway - SOJ',
            'Sogndal Haukasen Norway - SOG',
            'Stord Sorstokken Norway - SRP',
            'Sandnessjoen Stokka Norway - SSJ',
            'Svolvaer Helle Norway - SVJ',
            'Stavanger Sola Norway - SVG',
            'Rorvik Ryum Norway - RVK',
            'Sandane Anda Norway - SDN',
            'Roros  Norway - RRS',
            'Maloy Harbour  Norway - QFQ',
            'Selje Harbour  Norway - QFK',
            'Rost  Norway - RET',
            'Mo I Rana Rossvoll Norway - MQN',
            'Molde Aro Norway - MOL',
            'Mehamn  Norway - MEH',
            'Mosjoen Kjaerstad Norway - MJF',
            'Narvik Framnes Norway - NVK',
            'Orland  Norway - OLA',
            'Oslo Sandefjord Torp Norway - TRF',
            'Oslo Moss Rygge Norway - RYG',
            'Oslo Gardermoen Norway - OSL',
            'Namsos  Norway - OSY',
            'Notodden  Norway - NTB',
            'Evreux Fauville Fransa - EVX',
            'Metz Nancy Frescaty Fransa - MZM',
            'Metz Nancy Lorraine Fransa - ETZ',
            'Nancy Essey Fransa - ENC',
            'Epinal Mirecourt Fransa - EPL',
            'Bergerac Roumaniere Fransa - EGC',
            'La Roche Sur Yon Les Ajoncs Fransa - EDM',
            'Castres Mazamet Fransa - DCM',
            'Dijon Longvic Fransa - DIJ',
            'Dole Tavaux Fransa - DLE',
            'Dinard St Malo Pleurtuit Fransa - DNR',
            'Deauville Saint Gatien Fransa - DOL',
            'Dieppe Saint Aubin Fransa - DPE',
            'Basel Mulhouse Basel Euroairport Fransa - BSL',
            'Basel Mulhouse Mulhouse Euroairport Fransa - MLH',
            'Les Deux Alpes Deux Alpes Fransa - DXA',
            'Saint Etienne Boutheon Fransa - EBU',
            'Le Castellet  Fransa - CTT',
            'Creil  Fransa - CSF',
            'Calais Dunkerque  Fransa - CQF',
            'Courchevel  Fransa - CVF',
            'Chateauroux Deols Fransa - CHR',
            'Cognac Chateaubernard Fransa - CNG',
            'Chambery Aix Les Bains  Fransa - CMF',
            'Colmar Houssen Fransa - CMR',
            'Calvi Sainte Catherine Fransa - CLY',
            'Cannes Mandelieu Fransa - CEQ',
            'Cherbourg Maupertus Fransa - CER',
            'Cholet Le Pontreau Fransa - CET',
            'Clermont Ferrand Auvergne Fransa - CFE',
            'Caen Carpiquet Fransa - CFR',
            'Carcassonne Salvaza Fransa - CCF',
            'Brive La Gaillard La Roche Fransa - BVE',
            'Albert Bray Fransa - BYF',
            'Beziers Vias Fransa - BZR',
            'Bourges  Fransa - BOU',
            'Belfort Fontaine Fransa - BOR',
            'Bordeaux Merignac Fransa - BOD',
            'Brest Bretagne Fransa - BES',
            'Biarritz Bayonne Anglet Fransa - BIQ',
            'Bastia Poretta Fransa - BIA',
            'Angers Marce Fransa - ANE',
            'Barcelonnette Saint Pons Fransa - BAE',
            'Avoriaz  Fransa - AVF',
            'Avignon Caumont Fransa - AVN',
            'Auxerre Branches Fransa - AUF',
            'Aurillac  Fransa - AUR',
            'Agen La Garenne Fransa - AGF',
            'Angouleme Brie Champniers Fransa - ANG',
            'L alpe D huez  Fransa - AHZ',
            'Ajaccio Campo Dell Oro Fransa - AJA',
            'Juan Les Pins  Fransa - JLP',
            'Lannion  Fransa - LAI',
            'La Baule Escoublac  Fransa - LBY',
            'Albi Le Sequestre Fransa - LBI',
            'Lourdes Tarbes Pyrenees Fransa - LDE',
            'Landivisiau  Fransa - LDV',
            'Le Havre Octeville Fransa - LEH',
            'Limoges Bellegarde Fransa - LIG',
            'Lille Lesquin Fransa - LIL',
            'Le Mans Arnage Fransa - LME',
            'Le Touquet Paris Plage  Fransa - LTQ',
            'Saint Tropez La Mole Fransa - LTT',
            'La Rochelle Ile De Re Fransa - LRH',
            'Le Puy Loudes Fransa - LPY',
            'Les Sables Talmont Fransa - LSO',
            'Lorient Lann Bihoue Fransa - LRT',
            'Lyon Saint Exupery Fransa - LYS',
            'Lyon Bron Fransa - LYN',
            'Lyon Grenoble Saint Geoirs Fransa - GNB',
            'Laval Entrammes Fransa - LVA',
            'Hazebrouck Merville Colonne Fransa - HZB',
            'City Name Test  Fransa - III',
            'Ile D yeu  Fransa - IDY',
            'Gap Tallard Fransa - GAT',
            'Granville  Fransa - GFR',
            'Nimes Garons Fransa - FNI',
            'Figari Sud Corse Fransa - FSC',
            'Frejus  Fransa - FRJ',
            'Le Creusot Montceau Creusot Montceau Fransa - XCC',
            'Vittel Champ De Course Fransa - VTL',
            'City Name Test Three  Fransa - VVE',
            'Val D isere  Fransa - VAZ',
            'Valence Chabeuil Fransa - VAF',
            'Vichy Charmeil Fransa - VHY',
            'Vannes Meucon Fransa - VNE',
            'Cahors Lalbenque Fransa - ZAO',
            'Toulouse Blagnac Fransa - TLS',
            'Toulon Hyeres Fransa - TLN',
            'Tignes  Fransa - TGF',
            'Quimper Pluguffan Fransa - UIP',
            'Rouen Vallee De Seine Fransa - URO',
            'Tours Val De Loire Fransa - TUF',
            'Strasbourg Entzheim Fransa - SXB',
            'Sophia Antipolis  Fransa - SXD',
            'Saint Yan  Fransa - SYT',
            'Solenzara  Fransa - SOZ',
            'Saint Nazaire Montoir Fransa - SNR',
            'La Plagne  Fransa - PLG',
            'Propriano  Fransa - PRP',
            'Pau Pyrenees Fransa - PUF',
            'Perigueux Bassillac Fransa - PGX',
            'Poitiers Biard Fransa - PIS',
            'Perpignan Rivesaltes Fransa - PGF',
            'Paris Villacoublay Velizy Fransa - VIY',
            'Paris Toussus Le Noble Fransa - TNF',
            'Paris Pontoise Cormeilles Fransa - POX',
            'Paris Tüm Havalimanları Fransa - PAR',
            'Paris Charles De Gaulle Fransa - CDG',
            'Paris Beauvais Tille Fransa - BVA',
            'Paris Chalons Vatry Fransa - XCR',
            'Paris Orly Fransa - ORY',
            'Paris Le Bourget Fransa - LBG',
            'Rochefort Saint Agnant Fransa - RCO',
            'Rodez Marcillac Fransa - RDZ',
            'Offline Point  Fransa - QAF',
            'Reims Champagne Fransa - RHE',
            'Roanne Renaison Fransa - RNE',
            'Rennes Saint Jacques Fransa - RNS',
            'Royan Medis Fransa - RYN',
            'Saint Brieuc Armor Fransa - SBK',
            'Mont Dauphin Saint Crepin Fransa - SCP',
            'Serre Chevalier  Fransa - SEC',
            'Montpellier Mediterranee Fransa - MPL',
            'Masilya Provence Fransa - MRS',
            'Morlaix Ploujean Fransa - MXN',
            'Megeve  Fransa - MVV',
            'Meribel  Fransa - MFX',
            'Montlucon Gueret Fransa - MCU',
            'Mende Brenoux Fransa - MEN',
            'Orleans Saint Denis De L Hotel Fransa - ORE',
            'Aubenas Ardeche Meridionale Fransa - OBS',
            'Nevers Fourchambault Fransa - NVS',
            'Nantes Atlantique Fransa - NTE',
            'Niort Souche Fransa - NIT',
            'Nice Cote D Azur Fransa - NCE',
            'Annecy Meythet Fransa - NCY',
            'Al Ain  United Arab Emirates - AAN',
            'Abu Dhabi Abu Dhabi Intl United Arab Emirates - AUH',
            'Abu Dhabi Bateen United Arab Emirates - AZI',
            'Dubai Dubai Intl United Arab Emirates - DXB',
            'Dubai Al Maktoum Intl United Arab Emirates - DWC',
            'Dubai Dubai Bus Station United Arab Emirates - XNB',
            'Al Fujairah Fujairah Intl Arpt United Arab Emirates - FJR',
            'Minhad Ab Military Airport United Arab Emirates - NHD',
            'Umm Alquwain  United Arab Emirates - QIW',
            'Ras Al Khaimah  United Arab Emirates - RKT',
            'Sharjah  United Arab Emirates - SHJ',
            'Sheghnan  Afghanistan - SGA',
            'Sardeh Band  Afghanistan - SBF',
            'Mazar I Sharif  Afghanistan - MZR',
            'Bagram Air Field Afghanistan - OAI',
            'Maimana  Afghanistan - MMZ',
            'Tirinkot  Afghanistan - TII',
            'Taluqan  Afghanistan - TQN',
            'Kunduz  Afghanistan - UND',
            'Urgoon  Afghanistan - URN',
            'Uruzgan  Afghanistan - URZ',
            'Zaranj  Afghanistan - ZAJ',
            'Gardez  Afghanistan - GRG',
            'Ghazni  Afghanistan - GZI',
            'Herat  Afghanistan - HEA',
            'Nimroz  Afghanistan - IMZ',
            'Jalalabad  Afghanistan - JAA',
            'Kabul Khwaja Rawash Afghanistan - KBL',
            'Kandahar  Afghanistan - KDH',
            'Khost  Afghanistan - KHT',
            'Kuran O Munjan  Afghanistan - KUR',
            'Khwahan  Afghanistan - KWH',
            'Qala Nau  Afghanistan - LQN',
            'Farah  Afghanistan - FAH',
            'Faizabad  Afghanistan - FBD',
            'Chakcharan  Afghanistan - CCN',
            'Darwaz  Afghanistan - DAZ',
            'Bamiyan  Afghanistan - BIN',
            'Bost  Afghanistan - BST',
            'Barbuda  Antigua And Barbuda - BBQ',
            'Antigua Vc Bird Intl Antigua And Barbuda - ANU',
            'Anguilla Wallblake Anguilla - AXA',
            'Tirana Nene Tereza Intl Albania - TIA',
            'Erivan Zvartnots Intl Armenia - EVN',
            'Gyumri Shirak Armenia - LWN',
            'Saint Eustatius F D Roosevelt Netherlands Antilles - EUX',
            'Curacao Hato Apt Netherlands Antilles - CUR',
            'Bonaire Flamingo Intl Netherlands Antilles - BON',
            'Saint Maarten Princ. Juliana Netherlands Antilles - SXM',
            'Saba Island J Yrausquin Netherlands Antilles - SAB',
            'Lubango  Angola - SDD',
            'Porto Amboim  Angola - PBN',
            'Chitato  Angola - PGI',
            'Malange  Angola - MEG',
            'Namibe  Angola - MSZ',
            'Nzagi  Angola - NZA',
            'Ngiva  Angola - NGV',
            'Sumbe  Angola - NDD',
            'Ndalatandos  Angola - NDF',
            'Huambo  Angola - NOV',
            'N riquinha  Angola - NRQ',
            'Kuito  Angola - SVP',
            'M banza Congo  Angola - SSY',
            'Soyo  Angola - SZA',
            'Menongue  Angola - SPP',
            'Uige  Angola - UGO',
            'Luau  Angola - UAL',
            'Saurimo  Angola - VHC',
            'Ongiva  Angola - VPE',
            'Xangongo  Angola - XGN',
            'Benguela General V Deslandes Angola - BUG',
            'Cabinda  Angola - CAB',
            'Ambriz  Angola - AZZ',
            'Andulo  Angola - ANL',
            'N zeto  Angola - ARZ',
            'Cangamba  Angola - CNZ',
            'Cuito Cuanavale  Angola - CTI',
            'Cazombo  Angola - CAV',
            'Catumbela  Angola - CBT',
            'Waco Kungo  Angola - CEO',
            'Cafunfo  Angola - CFF',
            'Dundo  Angola - DUE',
            'Dirico  Angola - DRC',
            'Luena  Angola - LUO',
            'Luzamba  Angola - LZM',
            'Luanda 4 De Fevereiro Angola - LAD',
            'Lukapa  Angola - LBZ',
            'Capanda  Angola - KNP',
            'Jamba  Angola - JMB',
            'Negage  Angola - GXG',
            'Lumbala  Angola - GGC',
            'Teniente R  Marsh  Antartica - TNM',
            'San Juan  Argentina - UAQ',
            'Tartagal  Argentina - TTG',
            'Tucuman Benj Matienzo Argentina - TUC',
            'San Julian  Argentina - ULA',
            'Ushuaia Islas Malvinas Argentina - USH',
            'Salta Gen Martin M De Guemes Argentina - SLA',
            'Saenz Pena  Argentina - SZQ',
            'Tandil  Argentina - TDL',
            'Santa Teresita  Argentina - SST',
            'Pichanal  Argentina - XMV',
            'Ledesma  Argentina - XMX',
            'Mosconi  Argentina - XOS',
            'San Pedro  Argentina - XPD',
            'Villa Gesell  Argentina - VLG',
            'Villa Mercedes  Argentina - VME',
            'General Villegas  Argentina - VGS',
            'Valcheta  Argentina - VCF',
            'Viedma  Argentina - VDM',
            'Villa Dolores  Argentina - VDR',
            'Curuzu Cuatia  Argentina - UZU',
            'Embarcacion  Argentina - ZAI',
            'Neuquen  Argentina - NQN',
            'Necochea  Argentina - NEC',
            'San Antonio Oeste  Argentina - OES',
            'Colonia Sarmiento  Argentina - OLN',
            'Oran  Argentina - ORA',
            'Maquinchao  Argentina - MQD',
            'Monte Caseros  Argentina - MCS',
            'Mar Del Plata Astor Piazzola Argentina - MDQ',
            'Mercedes  Argentina - MDX',
            'Mendoza El Plumerillo Argentina - MDZ',
            'Miramar  Argentina - MJR',
            'Pehuajo  Argentina - PEH',
            'Olavarria  Argentina - OVR',
            'Goya  Argentina - OYA',
            'Tres Arroyos  Argentina - OYO',
            'Perito Moreno  Argentina - PMQ',
            'Puerto Madryn Tehuelche Argentina - PMY',
            'Parana  Argentina - PRA',
            'Pres  Roque Saenz  Argentina - PRQ',
            'Posadas  Argentina - PSS',
            'Puerto Deseado  Argentina - PUD',
            'Santiago Sgo Del Estero Argentina - SDE',
            'Santa Fe  Argentina - SFN',
            'Sierra Grande  Argentina - SGV',
            'Santa Rosa  Argentina - RSA',
            'Rio Turbio  Argentina - RYO',
            'Santa Cruz  Argentina - RZA',
            'Merlo Valle Del Conlara Argentina - RLO',
            'Rio Grande  Argentina - RGA',
            'Rio Gallegos Rio Gallegos Intl Argentina - RGL',
            'Rio Hondo  Argentina - RHD',
            'Rosario Fisherton Argentina - ROS',
            'Rio Mayo  Argentina - ROY',
            'Rafaela  Argentina - RAF',
            'Reconquista  Argentina - RCQ',
            'Rio Cuarto  Argentina - RCU',
            'Rincon De Los Sauces  Argentina - RDS',
            'Trelew  Argentina - REL',
            'Resistencia  Argentina - RES',
            'Gdor  Gregores  Argentina - GGS',
            'Gualeguaychu  Argentina - GHU',
            'Formosa El Pucu Argentina - FMA',
            'El Calafate  Argentina - FTE',
            'General Pico  Argentina - GPO',
            'General Roca  Argentina - GNR',
            'La Rioja  Argentina - IRJ',
            'Lago Argentino  Argentina - ING',
            'Ingeniero Jacobacci  Argentina - IGB',
            'Iguazu Cataratas Argentina - IGR',
            'Chos Malal Oscar Reguera Argentina - HOS',
            'Junin  Argentina - JNI',
            'Jose D San Martin  Argentina - JSM',
            'Jujuy El Cadillal Argentina - JUJ',
            'Loncopue  Argentina - LCP',
            'La Cumbre  Argentina - LCM',
            'Malargue  Argentina - LGS',
            'Las Heras  Argentina - LHS',
            'Las Lomitas  Argentina - LLS',
            'Los Menucos  Argentina - LMD',
            'San Luis  Argentina - LUQ',
            'La Plata  Argentina - LPG',
            'El Bolson  Argentina - EHL',
            'Eldorado  Argentina - ELO',
            'El Maiten  Argentina - EMX',
            'El Palomar  Argentina - EPA',
            'Esquel  Argentina - EQS',
            'Colonia Catriel  Argentina - CCT',
            'Clorinda  Argentina - CLX',
            'Coronel Suarez Brigadier Hector Ruiz Argentina - CSZ',
            'Catamarca  Argentina - CTC',
            'Ceres  Argentina - CRR',
            'Corrientes Camba Punta Argentina - CNQ',
            'Charata  Argentina - CNT',
            'Concordia  Argentina - COC',
            'Cordoba Pajas Blancas Argentina - COR',
            'San Martin De Los Andes Chapelco Argentina - CPC',
            'Carmen De Patagones  Argentina - CPG',
            'Comodoro Rivadavi  Argentina - CRD',
            'Cutral  Argentina - CUT',
            'Caviahue  Argentina - CVH',
            'Caleta Olivia  Argentina - CVI',
            'Alto Rio Senguerr  Argentina - ARR',
            'Paso De Los Libres  Argentina - AOL',
            'Zapala  Argentina - APZ',
            'San Rafael  Argentina - AFA',
            'Buenos Aires Pistarini Argentina - EZE',
            'Buenos Aires J. Newbery Argentina - AEP',
            'San Carlos De Bariloche Bariloche Intl Argentina - BRC',
            'Bahia Blanca Comandante Argentina - BHI',
            'Fitiuta  American Samoa - FTI',
            'Pago Pago Pago Pago Intl American Samoa - PPG',
            'Ofu  American Samoa - OFU',
            'Tau  American Samoa - TAV',
            'Salzburg Wolfgang A Mozart Austria - SZG',
            'Vienna Vienna Intl Austria - VIE',
            'Vienna Danubepier Hov Austria - VDD',
            'Lauterach  Austria - QLX',
            'Sightseeing Flight  Austria - FQQ',
            'Graz  Austria - GRZ',
            'Hohenems Dornbirn Airport Austria - HOH',
            'Innsbruck  Austria - INN',
            'Linz Blue Danube Austria - LNZ',
            'Klagenfurt  Austria - KLU',
            'Saint Anton  Austria - ANT',
            'Angus Downs  Australia - ANZ',
            'Armidale  Australia - ARM',
            'Ararat  Australia - ARY',
            'Alice Springs  Australia - ASP',
            'Alroy Downs  Australia - AYD',
            'Anthony Lagoon  Australia - AYL',
            'Ayers Rock Connellan Australia - AYQ',
            'Ayr  Australia - AYR',
            'Big Bell  Australia - BBE',
            'Alton Downs  Australia - AWN',
            'Austral Downs  Australia - AWP',
            'Aramac  Australia - AXC',
            'Alexandria  Australia - AXL',
            'Auvergne  Australia - AVG',
            'Augustus Downs  Australia - AUD',
            'Aurukun Mission  Australia - AUU',
            'Andamooka  Australia - ADO',
            'Adelaide  Australia - ADL',
            'Arrabury  Australia - AAB',
            'Abingdon  Australia - ABG',
            'Alpha  Australia - ABH',
            'Bamaga  Australia - ABM',
            'Albury  Australia - ABX',
            'Agnew  Australia - AGW',
            'Argyle Downs  Australia - AGY',
            'Albany  Australia - ALH',
            'Ammaroo  Australia - AMX',
            'Amata  Australia - AMT',
            'Broken Hill  Australia - BHQ',
            'Bathurst Raglan Australia - BHS',
            'Brighton Downs  Australia - BHT',
            'Bedourie  Australia - BEU',
            'Bloomfield  Australia - BFC',
            'Barcaldine  Australia - BCI',
            'Bolwarra  Australia - BCK',
            'Bickerton Island  Australia - BCZ',
            'Badu Island  Australia - BDD',
            'Bundaberg  Australia - BDB',
            'Bedford Downs  Australia - BDW',
            'Beagle Bay  Australia - BEE',
            'Bulimba  Australia - BIP',
            'Billiluna  Australia - BIW',
            'Barkly Downs  Australia - BKP',
            'Blackall  Australia - BKQ',
            'Benalla  Australia - BLN',
            'Bollon  Australia - BLS',
            'Blackwater  Australia - BLT',
            'Broome  Australia - BME',
            'Brampton Island  Australia - BMP',
            'Brisbane  Australia - BNE',
            'Ballina Ballina Byron Gateway Australia - BNK',
            'Bright  Australia - BRJ',
            'Bourke  Australia - BRK',
            'Balgo Hills  Australia - BQW',
            'Bussellton  Australia - BQB',
            'Boulia  Australia - BQL',
            'Borroloola  Australia - BOX',
            'Bairnsdale  Australia - BSJ',
            'Bathurst Island  Australia - BRT',
            'Brunette Downs  Australia - BTD',
            'Betoota  Australia - BTX',
            'Burketown  Australia - BUC',
            'Bunbury  Australia - BUY',
            'Birdsville  Australia - BVI',
            'Batavia Downs  Australia - BVW',
            'Beverley Springs  Australia - BVZ',
            'Barrow Island  Australia - BWB',
            'Brewarrina  Australia - BWQ',
            'Burnie Burnie Wyn Australia - BWT',
            'Bankstown  Australia - BWU',
            'Belburn  Australia - BXF',
            'Bendigo  Australia - BXG',
            'Balranald  Australia - BZD',
            'Bizant  Australia - BZP',
            'Baniyala  Australia - BYX',
            'Cue  Australia - CUY',
            'Coen  Australia - CUQ',
            'Cleve  Australia - CVC',
            'Caloundra  Australia - CUD',
            'Cudal  Australia - CUG',
            'Carnarvon  Australia - CVQ',
            'Cowarie  Australia - CWR',
            'Cowra  Australia - CWT',
            'Corowa  Australia - CWW',
            'Christmas Creek  Australia - CXQ',
            'Charters Towers  Australia - CXT',
            'Corryong  Australia - CYG',
            'Dubbo  Australia - DBO',
            'Dalby  Australia - DBY',
            'Dauan Island  Australia - DAJ',
            'Cluny  Australia - CZY',
            'Cherribah  Australia - CRH',
            'Collarenebri  Australia - CRB',
            'Cape Flattery  Australia - CQP',
            'Coober Pedy  Australia - CPD',
            'Coolawanyah  Australia - COY',
            'Coonabarabran  Australia - COJ',
            'Cairns  Australia - CNS',
            'Coolibah  Australia - COB',
            'Coorabie  Australia - CRJ',
            'Carlton Hill  Australia - CRY',
            'Cresswell Downs  Australia - CSD',
            'Casino  Australia - CSI',
            'Charleville  Australia - CTL',
            'Cooktown  Australia - CTN',
            'Cattle Creek  Australia - CTR',
            'Cunnamulla  Australia - CMA',
            'Cootamundra  Australia - CMD',
            'Coolah  Australia - CLH',
            'Camooweal  Australia - CML',
            'Clermont  Australia - CMQ',
            'Coonamble  Australia - CNB',
            'Coconut Island  Australia - CNC',
            'Cloncurry  Australia - CNJ',
            'Collie  Australia - CIE',
            'Croker Island  Australia - CKI',
            'Chinchilla  Australia - CCL',
            'Cowell  Australia - CCW',
            'Cooinda  Australia - CDA',
            'Croydon  Australia - CDQ',
            'Canberra  Australia - CBR',
            'Condobolin  Australia - CBX',
            'Canobie  Australia - CBY',
            'Cape Barren  Australia - CBI',
            'Cobar  Australia - CAZ',
            'Cherrabun  Australia - CBC',
            'Clifton Hills  Australia - CFH',
            'Camfield  Australia - CFI',
            'Carpentaria Downs  Australia - CFP',
            'Coffs Harbour  Australia - CFS',
            'Caiguna  Australia - CGV',
            'Cessnock  Australia - CES',
            'Camden  Australia - CDU',
            'Ceduna  Australia - CED',
            'Ernabella  Australia - ERB',
            'Esperance  Australia - EPR',
            'Eneabba West  Australia - ENB',
            'Emerald  Australia - EMD',
            'Elcho Island  Australia - ELC',
            'Einasleigh  Australia - EIH',
            'Elkedra  Australia - EKD',
            'Erldunda  Australia - EDD',
            'Edward River*Pompuraaw  Australia - EDR',
            'Eva Downs  Australia - EVD',
            'Evans Head  Australia - EVH',
            'Exmouth Gulf  Australia - EXM',
            'Etadunna  Australia - ETD',
            'Eucla  Australia - EUC',
            'Finke  Australia - FIK',
            'Dorunda Station  Australia - DRD',
            'Devonport  Australia - DPO',
            'Dongara  Australia - DOX',
            'Derby  Australia - DRB',
            'Derby Curtin Australia - DCN',
            'Dirranbandi  Australia - DRN',
            'Durrie  Australia - DRR',
            'Darwin  Australia - DRW',
            'Drysdale River Drysdale River Airport Australia - DRY',
            'Dixie  Australia - DXD',
            'Dysart  Australia - DYA',
            'Diamantina Lakes  Australia - DYM',
            'Davenport Downs  Australia - DVP',
            'Daly River  Australia - DVR',
            'Daly Waters  Australia - DYW',
            'Echuca  Australia - ECH',
            'Daydream Is  Australia - DDI',
            'Delta Downs  Australia - DDN',
            'Drumduff  Australia - DFP',
            'Dalgaranga  Australia - DGD',
            'Mudgee  Australia - DGE',
            'Durham Downs  Australia - DHD',
            'Dunk Island  Australia - DKI',
            'Docker River  Australia - DKV',
            'Dulkaninna  Australia - DLK',
            'Delissaville  Australia - DLV',
            'Doomadgee  Australia - DMD',
            'Dunbar  Australia - DNB',
            'Doogan Doogan Airport Australia - DNG',
            'Denham  Australia - DNM',
            'Deniliquin  Australia - DNQ',
            'Koolburra  Australia - KKP',
            'Katanning  Australia - KNI',
            'Kamileroi  Australia - KML',
            'King Island  Australia - KNS',
            'Kununurra  Australia - KNX',
            'Koolatah  Australia - KOH',
            'Kubin Island  Australia - KUG',
            'Karratha  Australia - KTA',
            'Katherine Tindal Australia - KTR',
            'Kempsey  Australia - KPS',
            'Kalpowar  Australia - KPP',
            'Koonibba  Australia - KQB',
            'Kerang  Australia - KRA',
            'Karumba  Australia - KRB',
            'Kurundi  Australia - KRD',
            'Springvale  Australia - KSV',
            'Jundah  Australia - JUN',
            'Jurien Bay  Australia - JUR',
            'Kalbarri  Australia - KAX',
            'Kirkimbie  Australia - KBB',
            'Kimberley Downs  Australia - KBD',
            'Kingaroy  Australia - KGY',
            'Kalkurung  Australia - KFG',
            'Kingscote  Australia - KGC',
            'Kalgoorlie  Australia - KGI',
            'Kulgera  Australia - KGR',
            'Kambalda  Australia - KDB',
            'Kamaran Downs  Australia - KDS',
            'Kings Canyon  Australia - KBJ',
            'Streaky Bay  Australia - KBY',
            'Collinsville  Australia - KCE',
            'Kings Creek Stati  Australia - KCS',
            'Lorraine  Australia - LOA',
            'Lock  Australia - LOC',
            'Leonora  Australia - LNO',
            'Lake Nash  Australia - LNH',
            'Longreach  Australia - LRE',
            'Launceston  Australia - LST',
            'Lismore  Australia - LSY',
            'Latrobe  Australia - LTB',
            'Lyndhurst  Australia - LTP',
            'Lotusvale  Australia - LTV',
            'Laura Station  Australia - LUT',
            'Laura  Australia - LUU',
            'Laverton  Australia - LVO',
            'Lawn Hill  Australia - LWH',
            'Lady Elliot Islan  Australia - LYT',
            'Lizard Island  Australia - LZR',
            'Marble Bar  Australia - MBB',
            'Mount Buffalo  Australia - MBF',
            'Maryborough  Australia - MBH',
            'Mount Barnett  Australia - MBN',
            'Moorabbin  Australia - MBW',
            'Linda Downs  Australia - LLP',
            'Chillagoe  Australia - LLG',
            'Lissadell  Australia - LLL',
            'Lakeland Downs  Australia - LKD',
            'Lightning Ridge  Australia - LHG',
            'Limbunya  Australia - LIB',
            'Leigh Creek  Australia - LGH',
            'Lake Gregory Lake Gregory Airport Australia - LGE',
            'Learmonth  Australia - LEA',
            'Lake Evella  Australia - LEL',
            'Leinster  Australia - LER',
            'Lakefield  Australia - LFP',
            'Balcanoona  Australia - LCN',
            'Lindeman Island  Australia - LDC',
            'Lord Howe Island  Australia - LDH',
            'Lansdowne  Australia - LDW',
            'Kowanyama  Australia - KWM',
            'Yangoonabie  Australia - KYB',
            'Yeelirrie  Australia - KYF',
            'Yalata Mission  Australia - KYI',
            'Innamincka  Australia - INM',
            'Injune  Australia - INJ',
            'Ingham  Australia - IGH',
            'Innisfail  Australia - IFL',
            'Iffley  Australia - IFF',
            'Indulkana  Australia - IDK',
            'Inkerman  Australia - IKP',
            'Mount Isa  Australia - ISA',
            'Lockhart River  Australia - IRG',
            'Isisford  Australia - ISI',
            'Inverell  Australia - IVR',
            'Inverway  Australia - IVW',
            'Jabiru  Australia - JAB',
            'Jandakot  Australia - JAD',
            'Julia Creek  Australia - JCK',
            'Hooker Creek  Australia - HOK',
            'Hillside  Australia - HLL',
            'Saint Helens  Australia - HLS',
            'Hamilton  Australia - HLT',
            'Helenvale  Australia - HLV',
            'Hermannsburg  Australia - HMG',
            'Hinchinbrook Isl  Australia - HNK',
            'Hughenden  Australia - HGD',
            'Horn Island  Australia - HID',
            'Highbury  Australia - HIG',
            'Hook Island  Australia - HIH',
            'Headingly  Australia - HIP',
            'Hayman Island  Australia - HIS',
            'Hope Vale  Australia - HPE',
            'Henbury  Australia - HRY',
            'Horsham  Australia - HSM',
            'Hamilton Island  Australia - HTI',
            'Hopetoun  Australia - HTU',
            'Humbert River  Australia - HUB',
            'Hervey Bay  Australia - HVB',
            'Hawker Wilpena Pound Australia - HWK',
            'Hay  Australia - HXX',
            'Gascoyne Junction  Australia - GSC',
            'Mount Gunson  Australia - GSN',
            'Garden Point  Australia - GPN',
            'Goondiwindi  Australia - GOO',
            'Gosford  Australia - GOS',
            'Gove Nhulunbuy Australia - GOV',
            'Gladstone  Australia - GLT',
            'Goldsworthy  Australia - GLY',
            'Great Keppel Isla  Australia - GKL',
            'Glengyle  Australia - GLG',
            'Glen Innes  Australia - GLI',
            'Glenormiston  Australia - GLM',
            'Argyle  Australia - GYL',
            'Greenvale  Australia - GVP',
            'Groote Eylandt Alyangula Australia - GTE',
            'Granites  Australia - GTS',
            'Georgetown  Australia - GTT',
            'Goulburn  Australia - GUL',
            'Gunnedah  Australia - GUH',
            'Halls Creek  Australia - HCQ',
            'Tazmanya  Australia - HBA',
            'Gympie  Australia - GYP',
            'Long Island  Australia - HAP',
            'Heathlands  Australia - HAT',
            'Forbes  Australia - FRB',
            'Fossil Downs  Australia - FSL',
            'Flora Valley  Australia - FVL',
            'Forrest River Forrest River Arpt Australia - FVR',
            'Flinders Island  Australia - FLS',
            'Finley  Australia - FLY',
            'Falls Creek  Australia - FLC',
            'Fitzroy Crossing  Australia - FIZ',
            'Forrest  Australia - FOS',
            'Forster  Australia - FOT',
            'Boigu Island  Australia - GIC',
            'Gregory Downs  Australia - GGD',
            'Geraldton  Australia - GET',
            'Grafton  Australia - GFN',
            'George Town  Australia - GEE',
            'Geelong  Australia - GEX',
            'Grenfell  Australia - GFE',
            'Griffith  Australia - GFF',
            'Gayndah  Australia - GAH',
            'Goulburn Island  Australia - GBL',
            'Gamboola  Australia - GBP',
            'Gibb River  Australia - GBV',
            'Gordon Downs  Australia - GDD',
            'Eden  Australia - QDN',
            'Ramingining  Australia - RAM',
            'Rockhampton Downs  Australia - RDA',
            'Richmond  Australia - RCM',
            'American River  Australia - RCN',
            'Orbost  Australia - RBS',
            'Roebourne  Australia - RBU',
            'Robinvale  Australia - RBC',
            'Rockhampton  Australia - ROK',
            'Roper Bar  Australia - RPB',
            'Ngukurr  Australia - RPM',
            'Roper Valley  Australia - RPV',
            'Marree  Australia - RRE',
            'Roma  Australia - RMA',
            'Renmark  Australia - RMK',
            'Robinhood  Australia - ROH',
            'Roy Hill  Australia - RHL',
            'Rosella Plains  Australia - RLP',
            'Rokeby  Australia - RKY',
            'Ravensthorpe  Australia - RVT',
            'Roseberth  Australia - RSB',
            'Robinson River  Australia - RRV',
            'Rutland Plains  Australia - RTP',
            'Rottnest Island  Australia - RTS',
            'Merty  Australia - RTY',
            'Saibai Island  Australia - SBR',
            'Saint George  Australia - SGO',
            'Shay Gap  Australia - SGP',
            'Surfers Paradise  Australia - SFP',
            'Spring Creek  Australia - SCG',
            'Port Pirie  Australia - PPI',
            'Proserpine Whitsunday Coast Australia - PPP',
            'Palm Island  Australia - PMK',
            'Port Keats  Australia - PKT',
            'Port Lincoln  Australia - PLO',
            'Port Augusta  Australia - PUG',
            'Prominent Hill Prominent Hill Apt Australia - PXH',
            'Port Stephens  Australia - PTE',
            'Portland  Australia - PTJ',
            'Pardoo  Australia - PRD',
            'Port Macquarie  Australia - PQQ',
            'Ouyen  Australia - OYN',
            'Orientos  Australia - OXO',
            'Morney  Australia - OXY',
            'Paraburdoo  Australia - PBO',
            'Peppers Palm Bay  Australia - PBY',
            'Peppimenarti  Australia - PEP',
            'Penneshaw  Australia - PEA',
            'Pandie Pandie  Australia - PDE',
            'Parndana  Australia - PDN',
            'Perth  Australia - PER',
            'Penong  Australia - PEY',
            'Port Hedland  Australia - PHE',
            'Port Hunter  Australia - PHJ',
            'Parkes  Australia - PKE',
            'Orange Springhill Spring Australia - OAG',
            'Oodnadatta  Australia - ODD',
            'Cordillo Downs  Australia - ODL',
            'Ord River  Australia - ODR',
            'Nyngan  Australia - NYN',
            'Oban  Australia - OBA',
            'Newcastle Williamtown Australia - NTL',
            'Newcastle Belmont Australia - BEO',
            'Numbulwar  Australia - NUB',
            'Nullarbor  Australia - NUR',
            'Yorketown  Australia - ORR',
            'Orpheus Island Waterport Australia - ORS',
            'Mount Isa Osbourne Mine Australia - OSO',
            'Mornington  Australia - ONG',
            'Monkira  Australia - ONR',
            'Onslow  Australia - ONS',
            'Gold Coast Coolangatta Australia - OOL',
            'Cooma  Australia - OOM',
            'Mooraberree  Australia - OOR',
            'Oenpelli  Australia - OPI',
            'Olympic Dam  Australia - OLP',
            'Orchid Beach Fraser Isl Australia - OKB',
            'Yorke Island  Australia - OKR',
            'Oakey  Australia - OKY',
            'Sandstone  Australia - NDS',
            'Young  Australia - NGA',
            'Narrabri  Australia - NAA',
            'Naracoorte  Australia - NAC',
            'Nambucca Heads  Australia - NBH',
            'Nambour  Australia - NBR',
            'Napperby  Australia - NPP',
            'Nowra  Australia - NOA',
            'Newry  Australia - NRY',
            'Noosa  Australia - NSA',
            'Narrandera  Australia - NRA',
            'Narrogin  Australia - NRG',
            'Norseman  Australia - NSM',
            'Scone  Australia - NSO',
            'Noosaville  Australia - NSV',
            'Normanton  Australia - NTN',
            'Nifty  Australia - NIF',
            'Noonkanbah  Australia - NKB',
            'Darnley Island  Australia - NLF',
            'Nullagine  Australia - NLL',
            'Nicholson  Australia - NLS',
            'New Moon  Australia - NMP',
            'Nappa Merry  Australia - NMR',
            'Meekatharra  Australia - MKR',
            'Mount Cavenagh  Australia - MKV',
            'Merimbula  Australia - MIM',
            'Minnipa  Australia - MIN',
            'Mittiebah  Australia - MIY',
            'Mainoru  Australia - MIZ',
            'Monkey Mia Shark Bay Australia - MJK',
            'Manjimup  Australia - MJP',
            'Middlemount  Australia - MMM',
            'Mungeranie  Australia - MNE',
            'Maningrida  Australia - MNG',
            'Monto  Australia - MNQ',
            'Mackay  Australia - MKY',
            'Millicent  Australia - MLR',
            'Merluna  Australia - MLV',
            'Mount Magnet  Australia - MMG',
            'Sunshine Coast Maroochydore Australia - MCY',
            'Mcarthur River  Australia - MCV',
            'Melbourne Tullamarine Australia - MEL',
            'Melbourne Essendon Australia - MEB',
            'Melbourne Avalon Australia - AVV',
            'Moreton  Australia - MET',
            'Mount Full Stop  Australia - MFL',
            'Manners Creek  Australia - MFP',
            'Mount Gambier  Australia - MGB',
            'Milingimbi  Australia - MGT',
            'Margaret River Station  Australia - MGV',
            'Macmahon Camp 4  Australia - MHC',
            'Mount House  Australia - MHO',
            'Mount Hotham  Australia - MHU',
            'Mitchell Plateau  Australia - MIH',
            'Marqua  Australia - MQE',
            'Mandora  Australia - MQA',
            'Mountain Valley  Australia - MNV',
            'Macdonald Downs  Australia - MNW',
            'Moranbah  Australia - MOV',
            'Moomba  Australia - MOO',
            'Moree  Australia - MRZ',
            'Moroak  Australia - MRT',
            'Mount Swan  Australia - MSF',
            'Mildura  Australia - MQL',
            'Margaret River  Australia - MQZ',
            'Mareeba  Australia - MRG',
            'Miners Lake  Australia - MRL',
            'Marla  Australia - MRP',
            'Mount Sandford  Australia - MTD',
            'Maitland  Australia - MTL',
            'Mitchell  Australia - MTQ',
            'Mulga Park  Australia - MUP',
            'Muccan  Australia - MUQ',
            'Macksville  Australia - MVH',
            'Mulka  Australia - MVK',
            'Musgrave  Australia - MVU',
            'Morawa  Australia - MWB',
            'Moolawatana  Australia - MWT',
            'Miranda Downs  Australia - MWY',
            'Marion Downs  Australia - MXD',
            'Mitchell River  Australia - MXQ',
            'Mullewa  Australia - MXU',
            'Moruya  Australia - MYA',
            'Murray Island  Australia - MYI',
            'Myroodah  Australia - MYO',
            'Vanrook  Australia - VNR',
            'Victoria River Do  Australia - VCD',
            'Waverney  Australia - WAN',
            'Wauchope  Australia - WAU',
            'Wave Hill Kalkgurung Australia - WAV',
            'Warwick  Australia - WAZ',
            'Wondai  Australia - WDI',
            'Weipa  Australia - WEI',
            'Wee Waa  Australia - WEW',
            'Wagga Wagga Forrest Hill Australia - WGA',
            'Walgett  Australia - WGE',
            'Wangaratta  Australia - WGT',
            'Welshpool  Australia - WHL',
            'Richmond Richmond Afb Australia - XRH',
            'Thargomindah  Australia - XTG',
            'Taroom  Australia - XTO',
            'Tara  Australia - XTR',
            'Yam Island  Australia - XMY',
            'Minlaton  Australia - XML',
            'Mallacoota  Australia - XMC',
            'Whyalla  Australia - WYA',
            'Wyndham  Australia - WYN',
            'Colac  Australia - XCO',
            'Winton  Australia - WIN',
            'Wilcannia  Australia - WIO',
            'Wittenoom  Australia - WIT',
            'Warracknabeal  Australia - WKB',
            'Wallal  Australia - WLA',
            'Walcha  Australia - WLC',
            'Wollogorang  Australia - WLL',
            'Waterloo  Australia - WLO',
            'Warrnambool  Australia - WMB',
            'Mount Keith  Australia - WME',
            'Windarra  Australia - WND',
            'Windorah  Australia - WNR',
            'Woodgreen  Australia - WOG',
            'Wollongong  Australia - WOL',
            'Wondoola  Australia - WON',
            'Warrawagine  Australia - WRW',
            'Wrotham Park  Australia - WPK',
            'Airlie Beach Whitsunday Australia - WSY',
            'Wudinna  Australia - WUD',
            'Wiluna  Australia - WUN',
            'Woodie Woodie  Australia - WWI',
            'West Wyalong  Australia - WWY',
            'Yuendumu  Australia - YUE',
            'Yandicoogina Yandi Airport Australia - YNN',
            'Yalgoo  Australia - YLG',
            'Biloela  Australia - ZBL',
            'Bowen  Australia - ZBO',
            'South Galway  Australia - ZGL',
            'Newman  Australia - ZNE',
            'Springvale  Australia - ZVG',
            'Day Trip Mystery  Australia - ZZW',
            'Sue Island Warraber Australia - SYU',
            'Tarcoola  Australia - TAQ',
            'Tangalooma  Australia - TAN',
            'Timber Creek  Australia - TBK',
            'Tableland  Australia - TBL',
            'Theda Theda Station Australia - TDN',
            'Theodore  Australia - TDR',
            'Telfer  Australia - TEF',
            'Temora  Australia - TEM',
            'Tennant Creek  Australia - TCA',
            'Tocumwal  Australia - TCW',
            'Stephen Island  Australia - STF',
            'Strathmore  Australia - STH',
            'Saint Paul s Mission  Australia - SVM',
            'Shaw River  Australia - SWB',
            'Stawell  Australia - SWC',
            'Swan Hill  Australia - SWH',
            'Sale  Australia - SXE',
            'Sydney Au Rose Bay Australia - RSE',
            'Sydney Kingsford Smith Australia - SYD',
            'Sydney Sydney West Australia - SWZ',
            'Sydney Palm Beach Spb Australia - LBH',
            'Southport  Australia - SHQ',
            'Shepparton  Australia - SHT',
            'Smith Point  Australia - SHU',
            'Smithton  Australia - SIO',
            'Singleton  Australia - SIX',
            'Snake Bay  Australia - SNB',
            'Stanthorpe  Australia - SNH',
            'South Molle Islan  Australia - SOI',
            'Southern Cross  Australia - SQC',
            'Starcke  Australia - SQP',
            'Sandringham  Australia - SRM',
            'Strahan  Australia - SRN',
            'Stradbroke Isl Dunwich Australia - SRR',
            'Sturt Creek  Australia - SSK',
            'Silver Plains  Australia - SSP',
            'Useless Loop  Australia - USL',
            'Muttaburra  Australia - UTB',
            'Nutwood Downs  Australia - UTD',
            'Quirindi  Australia - UIR',
            'Woomera  Australia - UMR',
            'Quilpie  Australia - ULP',
            'Tumut  Australia - TUM',
            'Toowoomba  Australia - TWB',
            'Tewantin  Australia - TWN',
            'Torwood  Australia - TWP',
            'Tanbar  Australia - TXR',
            'Mabuiag Island  Australia - UBB',
            'Tibooburra  Australia - TYB',
            'Thylungra  Australia - TYG',
            'Tobermorey  Australia - TYP',
            'Kalumburu  Australia - UBU',
            'Undarra  Australia - UDA',
            'Queenstown  Australia - UEE',
            'Tamworth  Australia - TMW',
            'Tom Price  Australia - TPR',
            'Taree  Australia - TRO',
            'Townsville  Australia - TSV',
            'Thursday Island  Australia - TIS',
            'Thangool  Australia - THG',
            'Traralgon La Trobe Traralgon Australia - TGN',
            'Türkiye Creek  Australia - TKY',
            'Aruba Reina Beatrix Aruba - AUA',
            'Bakü Heydar Aliyev Intl Azerbaijan - GYD',
            'Bakü Zabrat Airport Azerbaijan - ZXT',
            'Lankaran  Azerbaijan - LLK',
            'Ganja  Azerbaijan - KVD',
            'Zaqatala  Azerbaijan - ZTU',
            'Nakchivan  Azerbaijan - NAJ',
            'Mostar International Bosnia Herzegovina - OMO',
            'Tuzla International Bosnia Herzegovina - TZL',
            'Sarajevo International Bosnia Herzegovina - SJJ',
            'Banja Luka International Bosnia Herzegovina - BNX',
            'Bridgetown Grantley Adams Barbados - BGI',
            'Barisal  Bangladesh - BZL',
            'Chittagong Patenga Bangladesh - CGP',
            'Comilla  Bangladesh - CLA',
            'Dhaka Hazrat Shahjalal Intl Bangladesh - DAC',
            'Cox s Bazar  Bangladesh - CXB',
            'Khulna  Bangladesh - KHL',
            'Jessore  Bangladesh - JSR',
            'Ishurdi  Bangladesh - IRD',
            'Saidpur  Bangladesh - SPD',
            'Thakurgaon  Bangladesh - TKR',
            'Sylhet Civil Bangladesh - ZYL',
            'Shamshernagar  Bangladesh - ZHM',
            'Sandwip  Bangladesh - SDW',
            'Sirajganj  Bangladesh - SAJ',
            'Rajshahi  Bangladesh - RJH',
            'Rangpur  Bangladesh - RAU',
            'Oostende Brugge Airport Belgium - OST',
            'Zoersel Oostmalle Belgium - OBL',
            'Mouscron  Belgium - MWW',
            'Gent Ghent Belgium - GNE',
            'Knokke Het Zoute  Belgium - KNO',
            'Kortrijk Wevelgem Belgium - KJK',
            'Liege Airport Belgium - LGG',
            'Brussels National Belgium - BRU',
            'Brussels Brussels S Charleroi Belgium - CRL',
            'Brussels Antwerp Brussels North Belgium - ANR',
            'Brüksel - BRU',
            'Bobo Dioulasso Borgo Burkina Faso - BOY',
            'Banfora  Burkina Faso - BNR',
            'Arly  Burkina Faso - ARL',
            'Diapaga  Burkina Faso - DIP',
            'Dedougou  Burkina Faso - DGU',
            'Dori  Burkina Faso - DOR',
            'Fada Ngourma  Burkina Faso - FNG',
            'Ouagadougou  Burkina Faso - OUA',
            'Ouahigouya  Burkina Faso - OUG',
            'Diebougou  Burkina Faso - XDE',
            'Djibo  Burkina Faso - XDJ',
            'Aribinda  Burkina Faso - XAR',
            'Bogande  Burkina Faso - XBG',
            'Boulsa  Burkina Faso - XBO',
            'Leo  Burkina Faso - XLU',
            'Gaoua  Burkina Faso - XGA',
            'Gorom Gorom  Burkina Faso - XGG',
            'Kantchari  Burkina Faso - XKA',
            'Kaya  Burkina Faso - XKY',
            'Sebba  Burkina Faso - XSE',
            'Pama  Burkina Faso - XPA',
            'Nouna  Burkina Faso - XNU',
            'Zabre  Burkina Faso - XZA',
            'Tambao  Burkina Faso - TMQ',
            'Tougan  Burkina Faso - TUQ',
            'Tenkodogo  Burkina Faso - TEG',
            'Stara Zagora Kolyu Ganchevo Bulgaria - SZR',
            'Sofia  Bulgaria - SOF',
            'Silistra Polkovnik Lambrinovo Bulgaria - SLS',
            'Targovishte Bukhovtsi Bulgaria - TGV',
            'Varna  Bulgaria - VAR',
            'Vidin  Bulgaria - VID',
            'Plovdiv Krumovo Bulgaria - PDV',
            'Pleven  Bulgaria - PVN',
            'Ruse Shtruklevo Bulgaria - ROU',
            'Gorna Oryahovitsa  Bulgaria - GOZ',
            'Jambol Bezmer Bulgaria - JAM',
            'Haskovo Malevo Bulgaria - HKV',
            'Kardjali  Bulgaria - KDG',
            'Burgas  Bulgaria - BOJ',
            'Bahrain Bahrain Intl Bahrain - BAH',
            'Muharraq  Bahrain - GBQ',
            'Gitega  Burundi - GID',
            'Kirundo  Burundi - KRE',
            'Bujumbura Bujumbura Intl Burundi - BJM',
            'Djougou  Benin - DJA',
            'Cotonou  Benin - COO',
            'Kandi  Benin - KDC',
            'Parakou  Benin - PKO',
            'Natitingou  Benin - NAE',
            'Save  Benin - SVF',
            'Bermuda Bermuda Intl Bermuda - BDA',
            'Bermuda Nas Bermuda - NWU',
            'Bandar Seri Begawan Brunei Intl Brunei Darussalam - BWN',
            'Kuala Belait  Brunei Darussalam - KUB',
            'La Paz El Alto Bolivia - LPB',
            'Guayaramerin  Bolivia - GYA',
            'Huacaraje  Bolivia - BVK',
            'Baures  Bolivia - BVL',
            'Camiri  Bolivia - CAM',
            'Yacuiba  Bolivia - BYC',
            'Bermejo  Bolivia - BJO',
            'Ascension  Bolivia - ASC',
            'Apolo  Bolivia - APB',
            'Cobija East Beltram Bolivia - CIJ',
            'Concepcion  Bolivia - CEP',
            'Cochabamba J Wilsterman Bolivia - CBB',
            'Trinidad  Bolivia - TDD',
            'San Joaquin  Bolivia - SJB',
            'San Jose  Bolivia - SJS',
            'San Javier  Bolivia - SJV',
            'San Ignacio De M  Bolivia - SNM',
            'San Ignacio De Ve  Bolivia - SNG',
            'Santa Cruz Viru Viru Intl Bolivia - VVI',
            'Santa Cruz El Trompillo Bolivia - SRZ',
            'San Borja Cap G Q Guardia Bolivia - SRJ',
            'Santa Rosa  Bolivia - SRB',
            'San Ramon  Bolivia - SRD',
            'Sucre  Bolivia - SRE',
            'Tarija  Bolivia - TJA',
            'Villamontes  Bolivia - VLM',
            'Uyuni  Bolivia - UYU',
            'Vallegrande  Bolivia - VAH',
            'Oruro  Bolivia - ORU',
            'San Matias  Bolivia - MQK',
            'Monteagudo  Bolivia - MHW',
            'Magdalena  Bolivia - MGD',
            'Potosi  Bolivia - POI',
            'Puerto Rico  Bolivia - PUR',
            'Puerto Suarez  Bolivia - PSZ',
            'Riberalta General Buech Bolivia - RIB',
            'Reyes  Bolivia - REY',
            'Robore  Bolivia - RBO',
            'Rurrenabaque  Bolivia - RBQ',
            'Santa Ana Yacuma Bolivia - SBL',
            'Sao Mateus  Brazil - SBJ',
            'Sao Paulo Guarulhos Intl Brazil - GRU',
            'Sao Paulo Viracopos Brazil - VCP',
            'Sao Paulo Congonhas Brazil - CGH',
            'Serra Pelada  Brazil - RSG',
            'Sumare  Brazil - RWS',
            'Rio Verde  Brazil - RVD',
            'Senhor Do Bonfim  Brazil - SEI',
            'Santa Fe Do Sul  Brazil - SFV',
            'Soure  Brazil - SFK',
            'Rio Branco Pres Medici Brazil - RBR',
            'Borba  Brazil - RBB',
            'Redencao  Brazil - RDC',
            'Recife Guararapes Intl Brazil - REC',
            'Ribeirao Preto Leite Lop Brazil - RAO',
            'Atibaia  Brazil - QTA',
            'Santa Cruz Rio Pardo  Brazil - QNR',
            'Resende  Brazil - REZ',
            'Santa Maria Base Aerea Brazil - RIA',
            'Rio Grande  Brazil - RIG',
            'Rio De Janeiro Santos Dumont Brazil - SDU',
            'Rio De Janeiro Rio De Janeiro Intl Brazil - GIG',
            'Rondonopolis  Brazil - ROO',
            'Serra Norte  Brazil - RRN',
            'Passos  Brazil - PSW',
            'Pato Branco Pato Branco Mnpl Brazil - PTO',
            'Porto De Moz  Brazil - PTQ',
            'Porto Velho Belmonte Brazil - PVH',
            'Paranavai  Brazil - PVI',
            'Patos De Minas  Brazil - POJ',
            'Pocos De Caldas  Brazil - POO',
            'Petrolina Petrolina Intl Brazil - PNZ',
            'Porto Alegre Salgado Fil Brazil - POA',
            'Paranagua Paranagua Mnpl Brazil - PNG',
            'Pouso Alegre  Brazil - PPY',
            'Presidente Pruden Barros Brazil - PPB',
            'Ponta Pelada  Brazil - PLL',
            'Ponta Pora Ponta Pora Intl Brazil - PMG',
            'Palmas  Brazil - PMW',
            'Porto Nacional  Brazil - PNB',
            'Presidente Dutra  Brazil - PDR',
            'Prado  Brazil - PDF',
            'Pelotas Federal Brazil - PET',
            'Passo Fundo  Brazil - PFB',
            'Progresso  Brazil - PGG',
            'Pirapora  Brazil - PIV',
            'Pitinga  Brazil - PIG',
            'Parintins  Brazil - PIN',
            'Parnaiba Santos Dumont Brazil - PHB',
            'Ponta Grossa Sant ana Brazil - PGZ',
            'Pinheiro  Brazil - PHI',
            'Ourinhos  Brazil - OUS',
            'Cotriguacu Andre Maggi Brazil - OTT',
            'Oiapoque  Brazil - OYK',
            'Porto Alegre Do Norte  Brazil - PBX',
            'Portos Dos Gauchos  Brazil - PBV',
            'Pimenta Bueno  Brazil - PBQ',
            'Picos  Brazil - PCS',
            'Paulo Afonso  Brazil - PAV',
            'Paranaiba  Brazil - PBB',
            'Maringa Regional De Maringa Brazil - MGF',
            'Marilia Dr G Vidigal Brazil - MII',
            'Monte Dourado  Brazil - MEU',
            'Maceio Palmares Brazil - MCZ',
            'Macae  Brazil - MEA',
            'Minacu  Brazil - MQH',
            'Manicore  Brazil - MNX',
            'Montes Claros  Brazil - MOC',
            'Mucuri  Brazil - MVS',
            'Mossoro Dixsept Rosado Brazil - MVF',
            'Monte Alegre  Brazil - MTE',
            'Mato Grosso  Brazil - MTG',
            'Oriximina  Brazil - ORX',
            'Sinop  Brazil - OPS',
            'Ourilandia  Brazil - OIA',
            'Obidos  Brazil - OBI',
            'Novo Aripuana  Brazil - NVP',
            'Navegantes  Brazil - NVT',
            'Miracema Do Norte  Brazil - NTM',
            'Cacoal  Brazil - OAL',
            'Natal Augusto Severo Brazil - NAT',
            'Cana Brava  Brazil - NBV',
            'Niquelandia  Brazil - NQL',
            'Nova Xavantina  Brazil - NOK',
            'Nanuque  Brazil - NNU',
            'Novo Progresso Municipal Brazil - NPR',
            'Valenca  Brazil - VAL',
            'Varginha Maj Brig Brazil - VAG',
            'Vitoria Da Conquista  Brazil - VDC',
            'Vila Rica Mncpl Brazil - VLP',
            'Videira  Brazil - VIA',
            'Vitoria Eurico Sales Brazil - VIX',
            'Votuporanga  Brazil - VOT',
            'Xinguera  Brazil - XIG',
            'Chapeco  Brazil - XAP',
            'Sena Madureira  Brazil - ZMD',
            'Atibaia  Brazil - ZBW',
            'Catalao  Brazil - TLZ',
            'Teresina  Brazil - THE',
            'Tangara Da Serra Tangara Brazil - TGQ',
            'Tefe  Brazil - TFF',
            'Teofilo Otoni  Brazil - TFL',
            'Trombetas  Brazil - TMT',
            'Toledo  Brazil - TOW',
            'Torres  Brazil - TSQ',
            'Tarauaca  Brazil - TRQ',
            'Tucurui  Brazil - TUR',
            'Tucuma  Brazil - TUZ',
            'Teixeira Freitas  Brazil - TXF',
            'Uberaba  Brazil - UBA',
            'Uberlandia Eduardo Gomes Brazil - UDI',
            'Ubatuba  Brazil - UBT',
            'Umuarama Ernesto Geisel Brazil - UMU',
            'Ilha Comandatuba/Una Ilha Comandatuba Brazil - UNA',
            'Uruguaiana Ruben Berta Brazil - URG',
            'Urubupunga East Pochler Brazil - URB',
            'Sao Lourenco Do Sul  Brazil - SQY',
            'Santa Rosa  Brazil - SRA',
            'Sao Miguel Araguaia  Brazil - SQM',
            'Salvador D.L.E.Magalhaes Brazil - SSA',
            'Sorocaba  Brazil - SOD',
            'Santa Cruz  Brazil - SNZ',
            'Sao Jose Do Rio Preto  Brazil - SJP',
            'Sao Jose Dos Campos  Brazil - SJK',
            'Sao Gabriel Da Cachoeira Brazil - SJL',
            'Sao Luiz Mal Cunha Macha Brazil - SLZ',
            'Telemaco Borba  Brazil - TEC',
            'Tabatinga Tabatinga Intl Brazil - TBT',
            'Santa Terezinha Confresa Brazil - STZ',
            'Santarem Eduardo Gomes Brazil - STM',
            'Santos  Brazil - SSZ',
            'Sao Lourenco  Brazil - SSO',
            'Sao Felix Do Xing  Brazil - SXX',
            'Sao Felix Do Arag  Brazil - SXO',
            'Suia Missu  Brazil - SWM',
            'Caruaru  Brazil - CAU',
            'Campos Bartolomeu Lisand Brazil - CAW',
            'Cachoeiro De Itapemirim Cachoeiro Brazil - CDI',
            'Conceicao Do Arag  Brazil - CDJ',
            'Caceres  Brazil - CCX',
            'Criciuma  Brazil - CCM',
            'Cachoeira  Brazil - CCQ',
            'Campo Mourao  Brazil - CBW',
            'Concordia  Brazil - CCI',
            'Cabo Frio Cabo Frio Airport Brazil - CFB',
            'Cacador  Brazil - CFC',
            'Campo Grande Campo Grande Intl Brazil - CGR',
            'Cuiaba M Rondon Brazil - CGB',
            'Confreza  Brazil - CFO',
            'Coari  Brazil - CIZ',
            'Cornelio Procopio  Brazil - CKO',
            'Carajas  Brazil - CKS',
            'Caldas Novas  Brazil - CLV',
            'Carolina  Brazil - CLN',
            'Cameta  Brazil - CMT',
            'Santana Do Aragua Campo Brazil - CMP',
            'Corumba Corumba Intl Brazil - CMG',
            'Camocim  Brazil - CMC',
            'Canavieiras  Brazil - CNV',
            'Campinas Campinas Intl Brazil - CPQ',
            'Costa Marques  Brazil - CQS',
            'Cururupu  Brazil - CPU',
            'Campina Grande Joao Suas Brazil - CPV',
            'Canarana  Brazil - CQA',
            'Carutapera  Brazil - CTP',
            'Santa Vitoria Do Palmar Brazil - CTQ',
            'Santa Cruz Do Sul  Brazil - CSU',
            'Cassilandia  Brazil - CSS',
            'Colorado Do Oeste  Brazil - CSW',
            'Caravelas  Brazil - CRQ',
            'Caxias Do Sul Campo Dos Brazil - CXJ',
            'Curitiba Afonso Pena Brazil - CWB',
            'Curitiba Bacacheri Brazil - BFH',
            'Cruzeiro Do Sul Campo Brazil - CZS',
            'Cruz Alta Carlos Ruhl Brazil - CZB',
            'Divinopolis  Brazil - DIQ',
            'Dianopolis  Brazil - DNO',
            'Diamantino  Brazil - DMT',
            'Dourados  Brazil - DOU',
            'Feira De Santana  Brazil - FEC',
            'Feijo  Brazil - FEJ',
            'Fernando De Noron  Brazil - FEN',
            'Francisco Beltrao  Brazil - FBE',
            'Espinosa  Brazil - ESI',
            'Erechim Comandante K Brazil - ERM',
            'Eirunepe  Brazil - ERN',
            'Araraquara  Brazil - AQA',
            'Anapolis  Brazil - APS',
            'Arapongas  Brazil - APX',
            'Alto Parnaiba  Brazil - APY',
            'Ariquemes  Brazil - AQM',
            'Arapiraca  Brazil - APQ',
            'Apucarana  Brazil - APU',
            'Aragarcas  Brazil - ARS',
            'Aracatuba  Brazil - ARU',
            'Altamira  Brazil - ATM',
            'Barretos  Brazil - BAT',
            'Bauru  Brazil - BAU',
            'Barbelos  Brazil - BAZ',
            'Sapezal Fazenda Tucunare Brazil - AZL',
            'Itauba  Brazil - AUB',
            'Araguaina  Brazil - AUX',
            'Xanxere  Brazil - AXE',
            'Almenara  Brazil - AMJ',
            'Alegrete Federal Brazil - ALQ',
            'Alenquer  Brazil - ALT',
            'Assis  Brazil - AIF',
            'Aripuana  Brazil - AIR',
            'Aracaju  Brazil - AJU',
            'Araxa  Brazil - AAX',
            'Arapoti  Brazil - AAG',
            'Arraias  Brazil - AAI',
            'Alta Floresta  Brazil - AFL',
            'Braganca Paulista  Brazil - BJP',
            'Belo Horizonte Pampulha Brazil - PLU',
            'Belo Horizonte Tancredo Brazil - CNF',
            'Brumado  Brazil - BMS',
            'Boca Do Acre  Brazil - BCR',
            'Belem Val De Cans Brazil - BEL',
            'Barra Do Corda  Brazil - BDC',
            'Bento Goncalves  Brazil - BGV',
            'Bage  Brazil - BGX',
            'Bonito  Brazil - BYO',
            'Cascavel  Brazil - CAC',
            'Carauari  Brazil - CAF',
            'Buzios  Brazil - BZC',
            'Belmonte  Brazil - BVM',
            'Vilhena  Brazil - BVH',
            'Boa Vista  Brazil - BVB',
            'Breves  Brazil - BVS',
            'Blumenau  Brazil - BNU',
            'Porto Seguro  Brazil - BPS',
            'Barra Do Garcas  Brazil - BPG',
            'Barreiras  Brazil - BRA',
            'Barreirinhas  Brazil - BRB',
            'Barra  Brazil - BQQ',
            'Brasilia Brasilia Intl Brazil - BSB',
            'Balsas  Brazil - BSS',
            'Governador Valada  Brazil - GVR',
            'Guarapari  Brazil - GUZ',
            'Guaratingueta  Brazil - GUJ',
            'Goiania Santa Genoveva Brazil - GYN',
            'Guarapuava Tancredo Brazil - GPB',
            'Gurupi  Brazil - GRP',
            'Guanambi  Brazil - GNM',
            'Guimaraes  Brazil - GMS',
            'Guajara Mirim  Brazil - GJM',
            'Santo Angelo Sepe Tiara Brazil - GEL',
            'Guadalupe  Brazil - GDP',
            'Gravatai  Brazil - GCV',
            'Floriano Cangapara Brazil - FLB',
            'Florianopolis Hercilio L Brazil - FLN',
            'Franca  Brazil - FRC',
            'Fortaleza Pinto Martins Brazil - FOR',
            'Horizontina  Brazil - HRZ',
            'Jacobina  Brazil - JCM',
            'Jacareacanga  Brazil - JCR',
            'Joacaba  Brazil - JCB',
            'Juiz De Fora F De Assis Brazil - JDF',
            'Juazeiro Do Norte Regional Do Cariri Brazil - JDO',
            'Sao Joao Del Rei  Brazil - JDR',
            'Jequie  Brazil - JEQ',
            'Irece  Brazil - IRE',
            'Itacoatiara  Brazil - ITA',
            'Itaituba  Brazil - ITB',
            'Itubera  Brazil - ITE',
            'Itambacuri  Brazil - ITI',
            'Itabuna  Brazil - ITN',
            'Itaperuna  Brazil - ITP',
            'Itaqui  Brazil - ITQ',
            'Itumbiara  Brazil - ITR',
            'Ilha Solteira  Brazil - ILB',
            'Iguassu Falls Cataratas Brazil - IGU',
            'Ijui J Batista Bos Filho Brazil - IJU',
            'Santa Isabel Do M  Brazil - IDO',
            'Imperatriz  Brazil - IMP',
            'Ilheus Apt De Ilheus Brazil - IOS',
            'Ipiranga  Brazil - IPG',
            'Ipatinga Usiminas Brazil - IPN',
            'Ipiau  Brazil - IPU',
            'Maues  Brazil - MBZ',
            'Macapa Macapa Intl Brazil - MCP',
            'Matupa  Brazil - MBK',
            'Maraba  Brazil - MAB',
            'Manaus Eduardo Gomes Brazil - MAO',
            'Lucas Do Rio Verde Mun. Do Bom Futuro Brazil - LVR',
            'Livramento Dos Galpoes Brazil - LVB',
            'Leopoldina  Brazil - LEP',
            'Lins  Brazil - LIP',
            'Lages  Brazil - LAJ',
            'Lencois Chapada Diamantina Brazil - LEC',
            'Londrina  Brazil - LDB',
            'Pontes E Lacerda  Brazil - LCB',
            'Labrea  Brazil - LBR',
            'Bom Jesus Da Lapa  Brazil - LAZ',
            'Bauru Arealva Brazil - JTC',
            'Jatai  Brazil - JTI',
            'Juara  Brazil - JUA',
            'Joinville Cubatao Brazil - JOI',
            'Januaria  Brazil - JNA',
            'Joao Pessoa Castro Pinto Brazil - JPA',
            'Ji Parana  Brazil - JPR',
            'Juruena  Brazil - JRN',
            'Jales  Brazil - JLS',
            'Juina  Brazil - JIA',
            'Deadmans Cay  Bahamas - LGI',
            'Mangrove Cay  Bahamas - MAY',
            'Inagua  Bahamas - IGA',
            'Freeport Grand Bahama Intl Bahamas - FPO',
            'Grand Bahama Aux Ab Bahamas - GBI',
            'Governors Harbour  Bahamas - GHB',
            'Great Harbour  Bahamas - GHC',
            'George Town Exuma Int Bahamas - GGT',
            'Harbour Island  Bahamas - HBI',
            'Green Turtle  Bahamas - GTC',
            'Bimini North Spb Bahamas - NSB',
            'Bimini Bimini Intl Bahamas - BIM',
            'Spring Point Springpoint Bahamas - AXP',
            'Arthur s Town  Bahamas - ATC',
            'Bahamalar - ASD',
            'North Eleuthera North Eleuthera Intl Bahamas - ELH',
            'Duncan Town  Bahamas - DCT',
            'Cat Cays  Bahamas - CXY',
            'Crooked Island  Bahamas - CRI',
            'Congo Town  Bahamas - COX',
            'Cape Eleuthera  Bahamas - CEL',
            'Chub Cay  Bahamas - CCZ',
            'Cat Island  Bahamas - CAT',
            'Spanish Wells  Bahamas - SWL',
            'Treasure Cay  Bahamas - TCB',
            'The Bight  Bahamas - TBI',
            'Stella Maris Estate Air Bahamas - SML',
            'South Andros  Bahamas - TZN',
            'Staniel Cay  Bahamas - TYM',
            'San Salvador  Bahamas - ZSA',
            'West End  Bahamas - WTD',
            'Walker s Cay  Bahamas - WKR',
            'Norman s Cay Normans Cay Bahamas - NMC',
            'Nassau International Bahamas - NAS',
            'Nassau Seaplane Base Bahamas - WZY',
            'Nassau Paradise Island Bahamas - PID',
            'Mayaguana  Bahamas - MYG',
            'Mastic Point  Bahamas - MSK',
            'Marsh Harbour Marsh Harbour Intl Bahamas - MHH',
            'Powell Point  Bahamas - PPO',
            'Pitts Town  Bahamas - PWN',
            'Rum Cay  Bahamas - RCY',
            'Rock Sound South Eleuthera Bahamas - RSD',
            'San Andros  Bahamas - SAQ',
            'Paro  Bhutan - PBH',
            'Selebi Phikwe  Botswana - PKW',
            'Maun  Botswana - MUB',
            'Orapa  Botswana - ORP',
            'Tuli Block Limpopo Valley Botswana - TLD',
            'Tsabong  Botswana - TBY',
            'Shakawe  Botswana - SWX',
            'Savuti  Botswana - SVT',
            'Suapan  Botswana - SXN',
            'Kasane  Botswana - BBK',
            'Ghanzi  Botswana - GNZ',
            'Gaborone Gaborone Intl Botswana - GBE',
            'Francistown  Botswana - FRW',
            'Hukuntsi  Botswana - HUK',
            'Lobatse  Botswana - LOQ',
            'Jwaneng  Botswana - JWA',
            'Khwai River Lodge  Botswana - KHW',
            'Grodno  Belarus - GNA',
            'Gomel  Belarus - GME',
            'Brest  Belarus - BQT',
            'Vitebsk  Belarus - VTB',
            'Mogilev  Belarus - MVQ',
            'Minsk Minsk 1 Belarus - MHP',
            'Minsk Minsk 2 International Belarus - MSQ',
            'Melinda  Belize - MDB',
            'Orange Walk  Belize - ORZ',
            'Manatee  Belize - MZE',
            'Placencia  Belize - PLJ',
            'Punta Gorda  Belize - PND',
            'Silver Creek  Belize - SVK',
            'Santa Cruz  Belize - STU',
            'Sartaneja  Belize - SJX',
            'San Pedro  Belize - SPR',
            'San Ignacia Matthew Spain Belize - SQS',
            'Belize City P.S.W. Goldson Intl Belize - BZE',
            'Belize City Belize City Mnpl Belize - TZA',
            'Big Creek  Belize - BGK',
            'Belmopan  Belize - BCV',
            'Caye Chapel  Belize - CYC',
            'Caye Caulker  Belize - CUK',
            'Corozal  Belize - CZH',
            'Dangriga  Belize - DGA',
            'Independence  Belize - INB',
            'Ilford  Canada - ILF',
            'Summit Lake  Canada - IUM',
            'Fort Mackay Horizon Canada - HZP',
            'Fort Mackay Firebag Canada - YFI',
            'Taltheilei  Canada - GSL',
            'Kingfisher Lake  Canada - KIF',
            'Kelsey  Canada - KES',
            'Keewaywin  Canada - KEW',
            'Fort Mackay Albian Canada - JHL',
            'Knights Inlet  Canada - KNV',
            'Kinoosao  Canada - KNY',
            'Laurie River  Canada - LRQ',
            'Aklavik  Canada - LAK',
            'Douglas Lake  Canada - DGF',
            'Diavik  Canada - DVK',
            'Duncan Quam  Canada - DUQ',
            'Great Bear Lake  Canada - DAS',
            'Creston  Canada - CFQ',
            'Chilko Lake  Canada - CJH',
            'Akulivik  Canada - AKV',
            'La Sarre  Canada - SSQ',
            'Summer Beaver  Canada - SUR',
            'Silva Bay  Canada - SYF',
            'Inverlake  Canada - TIL',
            'Tungsten  Canada - TNS',
            'Tumbler Ridge  Canada - TUX',
            'Hope Bay  Canada - UZM',
            'Pincher Creek  Canada - WPC',
            'Wunnummin Lake  Canada - WNN',
            'Powell Lake  Canada - WPL',
            'Cluff Lake  Canada - XCL',
            'Chatham  Canada - XCM',
            'Grande Riviere Railway Station Canada - XDO',
            'Brockville  Canada - XBR',
            'Killineq  Canada - XBW',
            'Blubber Bay  Canada - XBB',
            'Bearskin Lake  Canada - XBE',
            'Granville Lake  Canada - XGL',
            'Kangiqsualujjuaq  Canada - XGR',
            'Lac Brochet  Canada - XLB',
            'Leaf Bay  Canada - XLF',
            'Kemano  Canada - XKO',
            'Kasabonika  Canada - XKS',
            'Anahim Lake  Canada - YAA',
            'Arctic Bay  Canada - YAB',
            'Cat Lake  Canada - YAC',
            'Moose Lake  Canada - YAD',
            'Alta Lake  Canada - YAE',
            'Asbestos Hill  Canada - YAF',
            'Fort Fransas Municipal Canada - YAG',
            'Lagrande 4  Canada - YAH',
            'Alert Bay  Canada - YAL',
            'Sault Ste Marie  Canada - YAM',
            'Lyall Harbour  Canada - YAJ',
            'Maple Bay  Canada - YAQ',
            'Lagrande 3  Canada - YAR',
            'Attawapiskat  Canada - YAT',
            'Kattiniq Donaldson Lake Canada - YAU',
            'Miners Bay  Canada - YAV',
            'Angling Lake  Canada - YAX',
            'Saint Anthony  Canada - YAY',
            'Tofino Tofino Airport Canada - YAZ',
            'Tofino Sea Plane Base Canada - YTP',
            'Banff  Canada - YBA',
            'Pelly Bay Kugaaruk Canada - YBB',
            'Baie Comeau  Canada - YBC',
            'New Westminster  Canada - YBD',
            'Uranium City  Canada - YBE',
            'Bamfield  Canada - YBF',
            'Bagotville  Canada - YBG',
            'Bull Harbour  Canada - YBH',
            'Black Tickle  Canada - YBI',
            'Baie Johan Beetz  Canada - YBJ',
            'Baker Lake  Canada - YBK',
            'Campbell River Harbor Spb Canada - YHH',
            'Campbell River  Canada - YBL',
            'Bronson Creek  Canada - YBM',
            'Borden  Canada - YBN',
            'Bobquinn Lake  Canada - YBO',
            'Macmillan Pass  Canada - XMP',
            'Ross River  Canada - XRR',
            'Pukatawagan  Canada - XPK',
            'Poplar River  Canada - XPP',
            'South Indian Lake  Canada - XSI',
            'Qualicum  Canada - XQU',
            'Tadoule Lake  Canada - XTL',
            'Round Lake  Canada - ZRJ',
            'Pine House  Canada - ZPO',
            'Queen Charlotte Is  Canada - ZQS',
            'Sandy Lake  Canada - ZSJ',
            'Saint Paul  Canada - ZSP',
            'Stewart  Canada - ZST',
            'Tete A La Baleine  Canada - ZTB',
            'Shamattawa  Canada - ZTM',
            'Ignace  Canada - ZUC',
            'Tahsis  Canada - ZTS',
            'Churchill Falls  Canada - ZUM',
            'Wollaston Lake  Canada - ZWL',
            'Bella Bella  Canada - ZEL',
            'East Main  Canada - ZEM',
            'Faro  Canada - ZFA',
            'Old Fort Bay  Canada - ZFB',
            'Fond Du Lac  Canada - ZFD',
            'South Trout Lake  Canada - ZFL',
            'Fort Mcpherson  Canada - ZFM',
            'Tulita Fort Norman Tulita Canada - ZFN',
            'Fairview  Canada - ZFW',
            'Grand Forks  Canada - ZGF',
            'Gods River  Canada - ZGI',
            'Bromont  Canada - ZBM',
            'Bathurst  Canada - ZBF',
            'Mile Ranch 108  Canada - ZMH',
            'Masset  Canada - ZMT',
            'La Tabatiere  Canada - ZLT',
            'Negginan  Canada - ZNG',
            'Namu  Canada - ZNU',
            'Ocean Falls  Canada - ZOF',
            'Sachigo Lake  Canada - ZPB',
            'High Prairie  Canada - ZHP',
            'Little Grand Rapids  Canada - ZGR',
            'Gethsemani  Canada - ZGS',
            'Jenpeg  Canada - ZJG',
            'Swan River  Canada - ZJN',
            'Kaschechewan  Canada - ZKE',
            'Kegaska  Canada - ZKG',
            'Lansdowne House  Canada - YLH',
            'Waskaganish  Canada - YKQ',
            'Jasper Hinton Canada - YJA',
            'Fort Liard  Canada - YJF',
            'Saint Jean  Canada - YJN',
            'Johnny Mountain  Canada - YJO',
            'Jasper Hinton  Canada - YJP',
            'Murray Bay Charlevoix Canada - YML',
            'Fort Mcmurray  Canada - YMM',
            'Makkovik  Canada - YMN',
            'Moosonee  Canada - YMO',
            'Port Mcneil  Canada - YMP',
            'Montreal Saint Hubert Canada - YHU',
            'Montreal Mirabel Canada - YMX',
            'Montreal P Trudeau Intl Canada - YUL',
            'Merry Island  Canada - YMR',
            'Meadow Lake  Canada - YLJ',
            'Oro Station Lake Simcoe Regional Canada - YLK',
            'Lloydminster  Canada - YLL',
            'Clinton Creek  Canada - YLM',
            'Chibougamau  Canada - YMT',
            'Mansons Landing Spb Canada - YMU',
            'Mary River  Canada - YMV',
            'Maniwaki  Canada - YMW',
            'Natashquan  Canada - YNA',
            'Wemindji  Canada - YNC',
            'Norway House  Canada - YNE',
            'Corner Brook Deer Lake Canada - YNF',
            'Hudson s Hope Hudson Hope Canada - YNH',
            'Nitchequon  Canada - YNI',
            'Nootka Sound  Canada - YNK',
            'Points North Land  Canada - YNL',
            'Matagami  Canada - YNM',
            'North Spirit Lake  Canada - YNO',
            'Natuashish  Canada - YNP',
            'Arnes  Canada - YNR',
            'Nemiscau  Canada - YNS',
            'Snap Lake  Canada - YNX',
            'Ekati Ekati Airport Canada - YOA',
            'Old Crow  Canada - YOC',
            'Cold Lake  Canada - YOD',
            'Falher  Canada - YOE',
            'Ogoki  Canada - YOG',
            'Oxford House  Canada - YOH',
            'Opinaca  Canada - YOI',
            'High Level Footner Lake Canada - YOJ',
            'Tuktoyaktuk  Canada - YUB',
            'Umiujaq  Canada - YUD',
            'Oshawa  Canada - YOO',
            'Rainbow Lake  Canada - YOP',
            'Owen Sound  Canada - YOS',
            'Bonaventure  Canada - YVB',
            'La Ronge  Canada - YVC',
            'Repulse Bay  Canada - YUT',
            'Hall Beach  Canada - YUX',
            'Rouyn  Canada - YUY',
            'Telegraph Harbour  Canada - YBQ',
            'Brandon  Canada - YBR',
            'Opapamiska Lake Musselwhite Canada - YBS',
            'Brochet  Canada - YBT',
            'Berens River  Canada - YBV',
            'Bedwell Harbor  Canada - YBW',
            'Blanc Sablon  Canada - YBX',
            'Bonnyville  Canada - YBY',
            'Courtenay  Canada - YCA',
            'Cambridge Bay  Canada - YCB',
            'Cornwall Regional Canada - YCC',
            'Nanaimo Nanaimo Airport Canada - YCD',
            'Nanaimo Harbour Canada - ZNA',
            'Centralia  Canada - YCE',
            'Cortes Bay  Canada - YCF',
            'Castlegar  Canada - YCG',
            'Miramichi  Canada - YCH',
            'Caribou Island  Canada - YCI',
            'Cape St James  Canada - YCJ',
            'Colville Lake  Canada - YCK',
            'Charlo  Canada - YCL',
            'Saint Catharines  Canada - YCM',
            'Cochrane  Canada - YCN',
            'Kugluktuk Coppermine Kugluktuk Canada - YCO',
            'Co Op Point  Canada - YCP',
            'Chetwynd  Canada - YCQ',
            'Cross Lake  Canada - YCR',
            'Chesterfield Inlet  Canada - YCS',
            'Coronation  Canada - YCT',
            'Cartierville  Canada - YCV',
            'Chilliwack  Canada - YCW',
            'Gagetown  Canada - YCX',
            'Clyde River  Canada - YCY',
            'Fairmount Springs  Canada - YCZ',
            'Dawson City  Canada - YDA',
            'Burwash Landings  Canada - YDB',
            'Drayton Valley Ind Apt Canada - YDC',
            'Paradise River  Canada - YDE',
            'Deer Lake  Canada - YDF',
            'Digby  Canada - YDG',
            'Daniels Harbour  Canada - YDH',
            'Davis Inlet  Canada - YDI',
            'Hatchet Lake  Canada - YDJ',
            'Main Duck Island  Canada - YDK',
            'Dease Lake  Canada - YDL',
            'Dauphin  Canada - YDN',
            'Dolbeau Saint Methode Canada - YDO',
            'Nain  Canada - YDP',
            'Dawson Creek  Canada - YDQ',
            'Broadview  Canada - YDR',
            'Desolation Sound  Canada - YDS',
            'Kasba Lake  Canada - YDU',
            'Bloodvein  Canada - YDV',
            'Obre Lake  Canada - YDW',
            'Doc Creek  Canada - YDX',
            'Edmonton Edmonton Mnpl Canada - YXD',
            'Edmonton Namao Fld Canada - YED',
            'Edmonton Edmonton Intl Canada - YEG',
            'Bar River  Canada - YEB',
            'Kingston  Canada - YGK',
            'La Grande  Canada - YGL',
            'Gimli  Canada - YGM',
            'Greenway Sound  Canada - YGN',
            'Gods Narrows  Canada - YGO',
            'Gaspe  Canada - YGP',
            'Geraldton  Canada - YGQ',
            'Iles De La Madele  Canada - YGR',
            'Germansen  Canada - YGS',
            'Igloolik  Canada - YGT',
            'Havre St Pierre  Canada - YGV',
            'Kuujjuarapik  Canada - YGW',
            'Gillam  Canada - YGX',
            'Deception  Canada - YGY',
            'Grise Fiord  Canada - YGZ',
            'Port Hope Simpson  Canada - YHA',
            'Hudson Bay  Canada - YHB',
            'Hakai Pass  Canada - YHC',
            'Dryden Dryden Mnpl Canada - YHD',
            'Hope  Canada - YHE',
            'Hearst  Canada - YHF',
            'Charlottetown  Canada - YHG',
            'Ulukhaktok  Canada - YHI',
            'Gjoa Haven  Canada - YHK',
            'Hornepayne  Canada - YHN',
            'Hopedale  Canada - YHO',
            'Poplar Hill  Canada - YHP',
            'Chevery  Canada - YHR',
            'Sechelt  Canada - YHS',
            'Haines Junction  Canada - YHT',
            'Hay River  Canada - YHY',
            'Halifax Shearwater Canada - YAW',
            'Halifax Stanfield Intl Canada - YHZ',
            'Atikokan  Canada - YIB',
            'Edson  Canada - YET',
            'Eureka  Canada - YEU',
            'Inuvik Inuvik Mike Zubko Canada - YEV',
            'Amos  Canada - YEY',
            'Fort Albany  Canada - YFA',
            'Iqaluit  Canada - YFB',
            'Fredericton Fredericton Intl Apt Canada - YFC',
            'Forestville  Canada - YFE',
            'Fontanges  Canada - YFG',
            'Fort Hope  Canada - YFH',
            'Snare Lake  Canada - YFJ',
            'Fort Reliance  Canada - YFL',
            'Flin Flon  Canada - YFO',
            'Fort Resolution  Canada - YFR',
            'Fort Simpson  Canada - YFS',
            'Fox Harbour  Canada - YFX',
            'Gagnon  Canada - YGA',
            'Gillies Bay  Canada - YGB',
            'Grande Cache  Canada - YGC',
            'Gorge Harbor  Canada - YGE',
            'Ganges Harbour  Canada - YGG',
            'Fort Good Hope  Canada - YGH',
            'Arviat  Canada - YEK',
            'Elliot Lake  Canada - YEL',
            'Manitowaning Manitoulin Canada - YEM',
            'Estevan  Canada - YEN',
            'Estevan Point  Canada - YEP',
            'Fort Severn  Canada - YER',
            'Pakuashipi  Canada - YIF',
            'Big Bay Marina  Canada - YIG',
            'Ivujivik  Canada - YIK',
            'Pond Inlet  Canada - YIO',
            'Island Lk Garden Hill  Canada - YIV',
            'Stephenville  Canada - YJT',
            'Kamloops  Canada - YKA',
            'Collins Bay  Canada - YKC',
            'Kincardine Township Canada - YKD',
            'Knee Lake  Canada - YKE',
            'Kitchener  Canada - YKF',
            'Kangirsuk  Canada - YKG',
            'Kennosao Lake  Canada - YKI',
            'Key Lake  Canada - YKJ',
            'Kitkatla  Canada - YKK',
            'Schefferville  Canada - YKL',
            'Klemtu  Canada - YKT',
            'Chisasibi  Canada - YKU',
            'Kirkland Lake  Canada - YKX',
            'Kindersley  Canada - YKY',
            'Langara  Canada - YLA',
            'Lac Biche  Canada - YLB',
            'Kimmirut Lake Harbour  Canada - YLC',
            'Chapleau  Canada - YLD',
            'Wha Ti Lac La Martre Wha Ti Canada - YLE',
            'Laforges  Canada - YLF',
            'Shilo  Canada - YLO',
            'Mingan  Canada - YLP',
            'La Tuque  Canada - YLQ',
            'Leaf Rapids  Canada - YLR',
            'Lebel Sur Quevillon  Canada - YLS',
            'Alert  Canada - YLT',
            'Kelowna  Canada - YLW',
            'Long Point  Canada - YLX',
            'Langley Langley Regional Canada - YLY',
            'Mayo  Canada - YMA',
            'Merritt  Canada - YMB',
            'Maricourt Airstrip  Canada - YMC',
            'Mould Bay  Canada - YMD',
            'Matane  Canada - YME',
            'Montagne Harbor  Canada - YMF',
            'Manitouwadge  Canada - YMG',
            'Mary s Harbour  Canada - YMH',
            'Minaki  Canada - YMI',
            'Moose Jaw  Canada - YMJ',
            'Ottawa Gatineau Canada - YND',
            'Ottawa Ottawa Intl Canada - YOW',
            'Ottawa Rockcliffe St Canada - YRO',
            'Valcartier  Canada - YOY',
            'Prince Albert  Canada - YPA',
            'Port Alberni  Canada - YPB',
            'Paulatuk  Canada - YPC',
            'Parry Sound  Canada - YPD',
            'Peace River  Canada - YPE',
            'Esquimalt  Canada - YPF',
            'Portage La Prairie  Canada - YPG',
            'Inukjuak  Canada - YPH',
            'Port Simpson  Canada - YPI',
            'Aupaluk  Canada - YPJ',
            'Pickle Lake  Canada - YPL',
            'Pikangikum  Canada - YPM',
            'Port Menier  Canada - YPN',
            'Peawanuck  Canada - YPO',
            'Pine Point  Canada - YPP',
            'Peterborough  Canada - YPQ',
            'Prince Rupert Digby Isl Canada - YPR',
            'Prince Rupert Seal Cove Canada - ZSW',
            'Port Hawkesbury  Canada - YPS',
            'Pender Harbour  Canada - YPT',
            'Powell River  Canada - YPW',
            'Povungnituk Puvimitug Canada - YPX',
            'Fort Chipewyan  Canada - YPY',
            'Burns Lake  Canada - YPZ',
            'Muskoka  Canada - YQA',
            'Quebec  Canada - YQB',
            'Quaqtaq  Canada - YQC',
            'The Pas  Canada - YQD',
            'Kimberley  Canada - YQE',
            'Red Deer  Canada - YQF',
            'Windsor  Canada - YQG',
            'Watson Lake  Canada - YQH',
            'Yarmouth  Canada - YQI',
            'Quadra Island April Point Spb Canada - YQJ',
            'Kenora  Canada - YQK',
            'Lethbridge  Canada - YQL',
            'Moncton Greater Moncton Canada - YQM',
            'Nakina  Canada - YQN',
            'Comox  Canada - YQQ',
            'Regina  Canada - YQR',
            'Saint Thomas Pembroke Area Canada - YQS',
            'Thunder Bay  Canada - YQT',
            'Grande Prairie  Canada - YQU',
            'Yorkton  Canada - YQV',
            'North Battleford  Canada - YQW',
            'Gander  Canada - YQX',
            'Sydney  Canada - YQY',
            'Quesnel  Canada - YQZ',
            'Rae Lakes  Canada - YRA',
            'Resolute  Canada - YRB',
            'Refuge Cove Spb Canada - YRC',
            'Dean River  Canada - YRD',
            'Resolution Island  Canada - YRE',
            'Cartwright  Canada - YRF',
            'Rigolet  Canada - YRG',
            'Riviere Du Loup  Canada - YRI',
            'Roberval  Canada - YRJ',
            'Red Lake  Canada - YRL',
            'Rocky Mountain Ho  Canada - YRM',
            'Rivers Inlet  Canada - YRN',
            'Trois Rivieres  Canada - YRQ',
            'Stuart Island  Canada - YRR',
            'Red Sucker Lake  Canada - YRS',
            'Rankin Inlet  Canada - YRT',
            'Revelstoke  Canada - YRV',
            'Sable Island  Canada - YSA',
            'Sudbury  Canada - YSB',
            'Sherbrooke  Canada - YSC',
            'Suffield  Canada - YSD',
            'Squamish  Canada - YSE',
            'Stony Rapids  Canada - YSF',
            'Lutselke Snowdrift Lutselke Canada - YSG',
            'Smith Falls  Canada - YSH',
            'Sans Souci  Canada - YSI',
            'Saint John  Canada - YSJ',
            'Sanikiluaq  Canada - YSK',
            'Saint Leonard Edmunston Canada - YSL',
            'Fort Smith  Canada - YSM',
            'Salmon Arm  Canada - YSN',
            'Postville  Canada - YSO',
            'Marathon  Canada - YSP',
            'Spring Island  Canada - YSQ',
            'Nanisivik  Canada - YSR',
            'Slate Island  Canada - YSS',
            'Sainte Therese Point  Canada - YST',
            'Summerside  Canada - YSU',
            'Saglek  Canada - YSV',
            'Shearwater  Canada - YSX',
            'Sachs Harbour  Canada - YSY',
            'Squirrel Cove  Canada - YSZ',
            'Pembroke Pembroke Apt Canada - YTA',
            'Hartley Bay  Canada - YTB',
            'Sturdee  Canada - YTC',
            'Thicket Portage  Canada - YTD',
            'Cape Dorset  Canada - YTE',
            'Alma  Canada - YTF',
            'Sullivan Bay  Canada - YTG',
            'Thompson  Canada - YTH',
            'Triple Island  Canada - YTI',
            'Terrace Bay  Canada - YTJ',
            'Tulugak  Canada - YTK',
            'Big Trout  Canada - YTL',
            'Mont Tremblant International Canada - YTM',
            'Riviere Au Tonner  Canada - YTN',
            'Toronto Pearson Intl Canada - YYZ',
            'Toronto Hamilton Jc Munro Intl Canada - YHM',
            'Toronto Buttonville Canada - YKZ',
            'Toronto City Centre Apt Canada - YTZ',
            'Tasiujuaq  Canada - YTQ',
            'Trenton  Canada - YTR',
            'Timmins  Canada - YTS',
            'Tisdale  Canada - YTT',
            'Tasu  Canada - YTU',
            'Telegraph Creek  Canada - YTX',
            'Vernon  Canada - YVE',
            'Vermilion  Canada - YVG',
            'Qikiqtarjuaq  Canada - YVM',
            'Cape Dyer  Canada - YVN',
            'Val D or  Canada - YVO',
            'Kuujjuaq  Canada - YVP',
            'Norman Wells  Canada - YVQ',
            'Vancouver Coal Harbour Canada - CXH',
            'Vancouver Vancouver Intl Canada - YVR',
            'Vancouver Boundary Bay Canada - YDT',
            'Buffalo Narrows  Canada - YVT',
            'Wiarton  Canada - YVV',
            'Deer Lake  Canada - YVZ',
            'Petawawa  Canada - YWA',
            'Kangiqsujuaq  Canada - YWB',
            'Winnipeg J A Richardson Intl Canada - YWG',
            'Deline  Canada - YWJ',
            'Wabush  Canada - YWK',
            'Williams Lake  Canada - YWL',
            'Williams Harbour  Canada - YWM',
            'Winisk  Canada - YWN',
            'Lupin  Canada - YWO',
            'Webequie  Canada - YWP',
            'Chute Des Passes  Canada - YWQ',
            'White River  Canada - YWR',
            'Whistler  Canada - YWS',
            'Wrigley  Canada - YWY',
            'Cranbrook  Canada - YXC',
            'Saskatoon J Diefenbaker Int Apt Canada - YXE',
            'Snake River  Canada - YXF',
            'Medicine Hat  Canada - YXH',
            'Killaloe  Canada - YXI',
            'Fort St John  Canada - YXJ',
            'Rimouski  Canada - YXK',
            'Sioux Lookout  Canada - YXL',
            'Whale Cove  Canada - YXN',
            'Pangnirtung  Canada - YXP',
            'Beaver Creek  Canada - YXQ',
            'Earlton  Canada - YXR',
            'Prince George  Canada - YXS',
            'Terrace  Canada - YXT',
            'London  Canada - YXU',
            'Abbotsford  Canada - YXX',
            'Whitehorse  Canada - YXY',
            'Wawa  Canada - YXZ',
            'Big Bay Yacht Clu  Canada - YYA',
            'North Bay  Canada - YYB',
            'Calgary Calgary Intl Canada - YYC',
            'Smithers  Canada - YYD',
            'Fort Nelson  Canada - YYE',
            'Penticton  Canada - YYF',
            'Charlottetown  Canada - YYG',
            'Taloyoak  Canada - YYH',
            'Rivers  Canada - YYI',
            'Victoria Victoria Intl Canada - YYJ',
            'Victoria Inner Harbor Canada - YWH',
            'Lynn Lake  Canada - YYL',
            'Cowley  Canada - YYM',
            'Swift Current  Canada - YYN',
            'Churchill  Canada - YYQ',
            'Goose Bay  Canada - YYR',
            'Saint Johns  Canada - YYT',
            'Kapuskasing  Canada - YYU',
            'Armstrong  Canada - YYW',
            'Mont Joli  Canada - YYY',
            'Ashcroft  Canada - YZA',
            'Beatton River  Canada - YZC',
            'Gore Bay  Canada - YZE',
            'Yellowknife  Canada - YZF',
            'Salluit  Canada - YZG',
            'Slave Lake  Canada - YZH',
            'Liard River  Canada - YZL',
            'Buchans  Canada - YZM',
            'Sandspit  Canada - YZP',
            'Sarnia  Canada - YZR',
            'Coral Harbour  Canada - YZS',
            'Port Hardy  Canada - YZT',
            'Whitecourt  Canada - YZU',
            'Sept Iles  Canada - YZV',
            'Teslin  Canada - YZW',
            'Greenwood  Canada - YZX',
            'Trail  Canada - YZZ',
            'Alice Arm  Canada - ZAA',
            'York Landing  Canada - ZAC',
            'Pikwitonei  Canada - PIW',
            'Bella Coola  Canada - QBC',
            'Mildred Lake  Canada - NML',
            'Argentia Naval Station Canada - NWP',
            'Muskrat Dam  Canada - MSA',
            'Cocos Islands  Cocos Islands - CCK',
            'Dili  Congo The Democratic Rep Of - DIC',
            'Lubumbashi Luano Congo The Democratic Rep Of - FBM',
            'Bandundu  Congo The Democratic Rep Of - FDU',
            'Kinshasa N djili Congo The Democratic Rep Of - FIH',
            'Kinshasa N dolo Congo The Democratic Rep Of - NLO',
            'Basongo  Congo The Democratic Rep Of - BAN',
            'Gbadolite  Congo The Democratic Rep Of - BDT',
            'Moba  Congo The Democratic Rep Of - BDV',
            'Boende  Congo The Democratic Rep Of - BNB',
            'Beni  Congo The Democratic Rep Of - BNC',
            'Bumba  Congo The Democratic Rep Of - BMB',
            'Bukavu Kamenbe Congo The Democratic Rep Of - BKY',
            'Buta  Congo The Democratic Rep Of - BZU',
            'Bunia  Congo The Democratic Rep Of - BUX',
            'Boma  Congo The Democratic Rep Of - BOA',
            'Basankusu  Congo The Democratic Rep Of - BSU',
            'Kolwezi  Congo The Democratic Rep Of - KWZ',
            'Lusambo  Congo The Democratic Rep Of - LBO',
            'Lisala  Congo The Democratic Rep Of - LIQ',
            'Libenge  Congo The Democratic Rep Of - LIE',
            'Lodja  Congo The Democratic Rep Of - LJA',
            'Matadi  Congo The Democratic Rep Of - MAT',
            'Luozi  Congo The Democratic Rep Of - LZI',
            'Lusanga  Congo The Democratic Rep Of - LUS',
            'Luiza  Congo The Democratic Rep Of - LZA',
            'Kongolo  Congo The Democratic Rep Of - KOO',
            'Kaniama  Congo The Democratic Rep Of - KNM',
            'Kindu  Congo The Democratic Rep Of - KND',
            'Kamina  Congo The Democratic Rep Of - KMN',
            'Kikwit  Congo The Democratic Rep Of - KKW',
            'Kota Koli  Congo The Democratic Rep Of - KLI',
            'Kalima  Congo The Democratic Rep Of - KLY',
            'Kiri  Congo The Democratic Rep Of - KRZ',
            'Kapanga  Congo The Democratic Rep Of - KAP',
            'Kananga  Congo The Democratic Rep Of - KGA',
            'Kasongo Lunda  Congo The Democratic Rep Of - KGN',
            'Kilwa  Congo The Democratic Rep Of - KIL',
            'Kasenga  Congo The Democratic Rep Of - KEC',
            'Kabinda  Congo The Democratic Rep Of - KBN',
            'Kabalo  Congo The Democratic Rep Of - KBO',
            'Goma  Congo The Democratic Rep Of - GOM',
            'Gemena  Congo The Democratic Rep Of - GMA',
            'Kisangani  Congo The Democratic Rep Of - FKI',
            'Kalemie  Congo The Democratic Rep Of - FMI',
            'Gandajika  Congo The Democratic Rep Of - GDJ',
            'Isiro Matari Congo The Democratic Rep Of - IRP',
            'Ikela  Congo The Democratic Rep Of - IKL',
            'Idiofa  Congo The Democratic Rep Of - IDF',
            'Inongo  Congo The Democratic Rep Of - INO',
            'Masi Manimba  Congo The Democratic Rep Of - MSM',
            'Mbandaka  Congo The Democratic Rep Of - MDK',
            'Mweka  Congo The Democratic Rep Of - MEW',
            'Manono  Congo The Democratic Rep Of - MNO',
            'Moanda  Congo The Democratic Rep Of - MNB',
            'Mbuji Mayi  Congo The Democratic Rep Of - MJM',
            'Nkolo  Congo The Democratic Rep Of - NKL',
            'Nioki  Congo The Democratic Rep Of - NIO',
            'Butembo Rughenda Congo The Democratic Rep Of - RUE',
            'Ilebo  Congo The Democratic Rep Of - PFR',
            'Pweto  Congo The Democratic Rep Of - PWO',
            'Punia  Congo The Democratic Rep Of - PUN',
            'Yangambi  Congo The Democratic Rep Of - YAN',
            'Tshikapa  Congo The Democratic Rep Of - TSH',
            'Rafai  Central African Republic - RFA',
            'Ndele  Central African Republic - NDL',
            'Ouanda Djalle  Central African Republic - ODJ',
            'Ouadda  Central African Republic - ODA',
            'M boki  Central African Republic - MKI',
            'Zemio  Central African Republic - IMO',
            'Birao  Central African Republic - IRO',
            'Gordil  Central African Republic - GDI',
            'Gounda  Central African Republic - GDA',
            'Kawadjia  Central African Republic - KWD',
            'Koumala  Central African Republic - KOL',
            'Bossangoa  Central African Republic - BSN',
            'Batangafo  Central African Republic - BTG',
            'Bozoum  Central African Republic - BOZ',
            'Bouar  Central African Republic - BOP',
            'Bakouma  Central African Republic - BMF',
            'Bria  Central African Republic - BIV',
            'Bossembele  Central African Republic - BEM',
            'Bouca  Central African Republic - BCF',
            'Berberati  Central African Republic - BBT',
            'Bambari  Central African Republic - BBY',
            'Bangassou  Central African Republic - BGU',
            'Bangui  Central African Republic - BGF',
            'Yalinga  Central African Republic - AIG',
            'Carnot  Central African Republic - CRF',
            'Ewo  Congo Brazzaville - EWO',
            'Epena  Congo Brazzaville - EPN',
            'Loubomo  Congo Brazzaville - DIS',
            'Djambala  Congo Brazzaville - DJM',
            'Zanaga  Congo Brazzaville - ANJ',
            'Boundji  Congo Brazzaville - BOE',
            'Betou  Congo Brazzaville - BTB',
            'Brazzaville Maya Maya Congo Brazzaville - BZV',
            'Makabana  Congo Brazzaville - KMK',
            'Kindamba  Congo Brazzaville - KNJ',
            'Kelle  Congo Brazzaville - KEE',
            'Lekana  Congo Brazzaville - LKC',
            'Lague  Congo Brazzaville - LCO',
            'Owando  Congo Brazzaville - FTX',
            'Gamboma  Congo Brazzaville - GMM',
            'Impfondo  Congo Brazzaville - ION',
            'Makoua  Congo Brazzaville - MKJ',
            'Mossendjo  Congo Brazzaville - MSX',
            'Mouyondzi  Congo Brazzaville - MUY',
            'Okoyo  Congo Brazzaville - OKG',
            'Nkayi  Congo Brazzaville - NKY',
            'Pointe Noire  Congo Brazzaville - PNR',
            'Ouesso  Congo Brazzaville - OUE',
            'Souanke  Congo Brazzaville - SOE',
            'Sibiti  Congo Brazzaville - SIB',
            'Sion  Switzerland - SIR',
            'Saint Moritz Engadin Switzerland - SMV',
            'Villars Bvb  Switzerland - ZLA',
            'Zurich Zurich Airport Switzerland - ZRH',
            'Cenevre International Switzerland - GVA',
            'Lugano Agno Switzerland - LUG',
            'Buochs  Switzerland - BXO',
            'Bern Belp Switzerland - BRN',
            'Altenrhein Saint Gallen-Altenrhein Switzerland - ACH',
            'Ascona  Switzerland - ACO',
            'Emmen  Switzerland - EML',
            'Ferkessedougou  Cote D Ivoire - FEK',
            'Daloa  Cote D Ivoire - DJO',
            'Divo  Cote D Ivoire - DIV',
            'Danane  Cote D Ivoire - DNC',
            'Dimbokro  Cote D Ivoire - DIM',
            'Abidjan F Houphouet Boigny Cote D Ivoire - ABJ',
            'Aboisso  Cote D Ivoire - ABO',
            'Yamoussoukro  Cote D Ivoire - ASK',
            'Borotou  Cote D Ivoire - BRZ',
            'Bouna  Cote D Ivoire - BQO',
            'Bouake  Cote D Ivoire - BYK',
            'Buyo  Cote D Ivoire - BUU',
            'Boundiali  Cote D Ivoire - BXI',
            'Bereby  Cote D Ivoire - BBV',
            'Bondoukou  Cote D Ivoire - BDK',
            'Lakota  Cote D Ivoire - LKT',
            'Odienne  Cote D Ivoire - KEO',
            'Katiola  Cote D Ivoire - KTC',
            'Gagnoa  Cote D Ivoire - GGN',
            'Guiglo  Cote D Ivoire - GGO',
            'Korhogo  Cote D Ivoire - HGO',
            'Sassandra  Cote D Ivoire - ZSS',
            'Zuenoula  Cote D Ivoire - ZUE',
            'M bahiakro  Cote D Ivoire - XMB',
            'San Pedro  Cote D Ivoire - SPY',
            'Taabo  Cote D Ivoire - TBX',
            'Touba  Cote D Ivoire - TOZ',
            'Tingrela  Cote D Ivoire - TGX',
            'Tabou  Cote D Ivoire - TXU',
            'Seguela  Cote D Ivoire - SEO',
            'Ouango Fitini  Cote D Ivoire - OFI',
            'Abengourou  Cote D Ivoire - OGO',
            'Mankono  Cote D Ivoire - MOK',
            'Man  Cote D Ivoire - MJC',
            'Mangaia Island  Cook Islands - MGS',
            'Manihiki Island  Cook Islands - MHX',
            'Mitiaro Island  Cook Islands - MOI',
            'Mauke Island  Cook Islands - MUK',
            'Puka Puka Isld  Cook Islands - PZK',
            'Rarotonga  Cook Islands - RAR',
            'Penrhyn Island  Cook Islands - PYE',
            'Aitutaki  Cook Islands - AIT',
            'Atiu Island  Cook Islands - AIU',
            'Antofagasta Cerro Moreno Chile - ANF',
            'Arica Chacalluta Chile - ARI',
            'Balmaceda  Chile - BBA',
            'Futaleufu  Chile - FFU',
            'El Salvador Salvador Bajo Chile - ESR',
            'Copiapo Desierto De Atacama Chile - CPO',
            'Coquimbo  Chile - COW',
            'Chanaral  Chile - CNR',
            'Chile Chico  Chile - CCH',
            'Concepcion Carriel Sur Chile - CCP',
            'Calama El Loa Chile - CJC',
            'Easter Island Mataveri Intl Chile - IPC',
            'Iquique Diego Aracena Chile - IQQ',
            'Frutillar  Chile - FRT',
            'Coyhaique Ten Vidal Chile - GXQ',
            'Vina Del Mar  Chile - KNA',
            'Cochrane  Chile - LGR',
            'La Serena La Florida Chile - LSC',
            'Los Angeles Maria Dolores Chile - LSQ',
            'Los Andes  Chile - LOB',
            'Punta Arenas Pres Ibanez Chile - PUQ',
            'Puerto Varas  Chile - PUX',
            'Puerto Natales Teniente Chile - PNT',
            'Puerto Montt Tepual Chile - PMC',
            'Ovalle  Chile - OVL',
            'Santiago Los Cerrillos Chile - ULC',
            'Santiago A Merino Benitez Chile - SCL',
            'Taltal  Chile - TTC',
            'Talca  Chile - TLX',
            'Tocopilla Barriles Chile - TOQ',
            'Cerro Sombrero  Chile - SMB',
            'Chillan  Chile - YAI',
            'Porvenir  Chile - WPR',
            'Puerto Williams  Chile - WPU',
            'Puerto Aisen  Chile - WPA',
            'Valparaiso  Chile - VAP',
            'Vallenar  Chile - VLR',
            'Alto Palena  Chile - WAP',
            'Castro Gamboa Chile - WCA',
            'Chaiten  Chile - WCH',
            'Ancud  Chile - ZUD',
            'Pucon  Chile - ZPC',
            'Osorno Canal Bajo Chile - ZOS',
            'Victoria  Chile - ZIC',
            'Valdivia Pichoy Chile - ZAL',
            'Temuco Maquehue Chile - ZCO',
            'Limbe  Cameroon - VCC',
            'Yaounde Yaounde Airport Cameroon - YAO',
            'Yaounde Nsimalen Cameroon - NSI',
            'Tiko  Cameroon - TKC',
            'Batouri  Cameroon - OUR',
            'Maroua Salam Cameroon - MVR',
            'Mamfe  Cameroon - MMF',
            'Nkongsamba  Cameroon - NKS',
            'Ngaoundere  Cameroon - NGE',
            'Koutaba  Cameroon - KOB',
            'Kaele  Cameroon - KLE',
            'Kribi  Cameroon - KBI',
            'Yagoua  Cameroon - GXX',
            'Garoua  Cameroon - GOU',
            'Foumban  Cameroon - FOM',
            'Douala  Cameroon - DLA',
            'Ebolowa  Cameroon - EBW',
            'Dschang  Cameroon - DSC',
            'Bafoussam  Cameroon - BFX',
            'Bali  Cameroon - BLC',
            'Bamenda  Cameroon - BPC',
            'Bertoua  Cameroon - BTA',
            'Baoshan  China Çin - BSD',
            'Bole  China Çin - BPL',
            'Bangda Bangda Airport China Çin - BPX',
            'Guangzhou Baiyun China Çin - CAN',
            'Beihai  China Çin - BHY',
            'Beijing Capital Apt Pekin China Çin - PEK',
            'Beijing Nanyuan Apt China Çin - NAY',
            'Bengbu  China Çin - BFU',
            'Baotou  China Çin - BAV',
            'Anyang  China Çin - AYN',
            'An Shun  China Çin - AVA',
            'Anshan  China Çin - AOG',
            'Anqing  China Çin - AQG',
            'Aksu  China Çin - AKU',
            'Ankang  China Çin - AKA',
            'Altay  China Çin - AAT',
            'Baise  China Çin - AEB',
            'Xingyi  China Çin - ACX',
            'Dongsheng  China Çin - DSN',
            'Dongying  China Çin - DOY',
            'Daqing Shi Saertu China Çin - DQA',
            'Dazu  China Çin - DZU',
            'Dayong  China Çin - DYG',
            'Dalian  China Çin - DLC',
            'Dali  China Çin - DLU',
            'Dunhuang  China Çin - DNH',
            'Diqing  China Çin - DIG',
            'Dandong  China Çin - DDG',
            'Dongguan  China Çin - DGM',
            'Erenhot Shi Saiwusu China Çin - ERL',
            'Enshi  China Çin - ENH',
            'Yan an  China Çin - ENY',
            'Chongqing  China Çin - CKG',
            'Changzhi  China Çin - CIH',
            'Chifeng  China Çin - CIF',
            'Jiuquan  China Çin - CHW',
            'Chaoyang Chaoyang Airport China Çin - CHG',
            'Zhengzhou  China Çin - CGO',
            'Changchun  China Çin - CGQ',
            'Changde  China Çin - CGD',
            'Changhai  China Çin - CNI',
            'Changsha Changsha Airport China Çin - CSX',
            'Changsha Changsha Huanghua China Çin - HHA',
            'Chengdu  China Çin - CTU',
            'Datong  China Çin - DAT',
            'Daxian  China Çin - DAX',
            'Changzhou  China Çin - CZX',
            'Fuzhou  China Çin - FOC',
            'Sui Fen He  China Çin - FUD',
            'Fuyun  China Çin - FYN',
            'Fuyang  China Çin - FUG',
            'Foshan  China Çin - FUO',
            'Guanghan  China Çin - GHN',
            'Golmud  China Çin - GOQ',
            'Handan Hebei Handan China Çin - HDG',
            'Guang Yuan Guang Yuan Airport China Çin - GYS',
            'Guyuan Shi Liu Pan Shan China Çin - GYU',
            'Haikou  China Çin - HAK',
            'Jiayuguan  China Çin - JGN',
            'Ji An  China Çin - JGS',
            'Jingdezhen  China Çin - JDZ',
            'Qiemo  China Çin - IQM',
            'Qingyang  China Çin - IQN',
            'Yinchuan  China Çin - INC',
            'Hangzhou  China Çin - HGH',
            'Hefei  China Çin - HFE',
            'Heihe  China Çin - HEK',
            'Hohhot  China Çin - HET',
            'Huai Hua Zhi Jiang China Çin - HJJ',
            'Huai an Lianshui China Çin - HIA',
            'Hami  China Çin - HMI',
            'Ulanhot  China Çin - HLH',
            'Hailar  China Çin - HLD',
            'Hengyang  China Çin - HNY',
            'Huangyan  China Çin - HYN',
            'Hanzhong  China Çin - HZG',
            'Liping City Liping China Çin - HZH',
            'Huizhou  China Çin - HUZ',
            'Hotan  China Çin - HTN',
            'Zhoushan  China Çin - HSN',
            'Harbin  China Çin - HRB',
            'Shaoguan  China Çin - HSC',
            'Jixi Shi Xingkaihu China Çin - JXA',
            'Song Pan Jiu Zhai Huang Long China Çin - JZH',
            'Juzhou  China Çin - JUZ',
            'Jinghong Gasa China Çin - JHG',
            'Jilin  China Çin - JIL',
            'Qianjiang Shi Zhoubai China Çin - JIQ',
            'Jiujiang  China Çin - JIU',
            'Jinjiang Quanzhou China Çin - JJN',
            'Jiamusi  China Çin - JMU',
            'Jining  China Çin - JNG',
            'Jinzhou  China Çin - JNZ',
            'Kuqa  China Çin - KCA',
            'Nanchang  China Çin - KHN',
            'Kashi  China Çin - KHG',
            'Kangding  China Çin - KGT',
            'Kunming  China Çin - KMG',
            'Buerjin City Kanasi China Çin - KJI',
            'Ganzhou  China Çin - KOW',
            'Ji an  China Çin - KNC',
            'Guiyang  China Çin - KWE',
            'Karamay  China Çin - KRY',
            'Korla  China Çin - KRL',
            'Lincang Lincang Airport China Çin - LNJ',
            'Liuzhou  China Çin - LZH',
            'Lianyungang  China Çin - LYG',
            'Linyi  China Çin - LYI',
            'Lhasa  China Çin - LXA',
            'Linxi  China Çin - LXI',
            'Luoyang  China Çin - LYA',
            'Luxi Mangshi China Çin - LUM',
            'Lushan  China Çin - LUZ',
            'Lin Zhi  China Çin - LZY',
            'Nangan  China Çin - LZN',
            'Luzhou  China Çin - LZO',
            'Guanghua  China Çin - LHK',
            'Lanzhou Lanzhou Arpt China Çin - LHW',
            'Lanzhou Zhongchuan China Çin - ZGC',
            'Lanzhou Lanzhoudong China Çin - LZD',
            'Liangping  China Çin - LIA',
            'Ling Ling Ling Ling Airport China Çin - LLF',
            'Libo City Libo Airport China Çin - LLB',
            'Lijiang City Lijiang China Çin - LJG',
            'Longyan Liancheng Apt China Çin - LCX',
            'Yichun Shi Lindu China Çin - LDS',
            'Guilin  China Çin - KWL',
            'Ningbo  China Çin - NGB',
            'Shi Quan He Ali China Çin - NGQ',
            'Qiqihar  China Çin - NDG',
            'Nanchong  China Çin - NAO',
            'Baishan Changbaishan China Çin - NBS',
            'Nanjing Nanking Nanjing China Çin - NKG',
            'Nanning  China Çin - NNG',
            'Xinyuan City Nalati China Çin - NLT',
            'Nanyang  China Çin - NNY',
            'Nantong Nantong Airport China Çin - NTG',
            'Mohe County Gu-Lian China Çin - OHE',
            'Manzhouli  China Çin - NZH',
            'Mian Yang Mian Yang Airport China Çin - MIG',
            'Mudanjiang  China Çin - MDG',
            'Meixian  China Çin - MXZ',
            'Peng Lai Sha He Kou China Çin - PNJ',
            'Shenyang  China Çin - SHE',
            'Shanhaiguan  China Çin - SHF',
            'Şangay Hongqiao Intl China Çin - SHA',
            'Şangay Pudong Intl China Çin - PVG',
            'Rugao  China Çin - RUG',
            'Pan Zhi Hua Pan Zhi Hua Bao An Apt China Çin - PZI',
            'Tongliao  China Çin - TGO',
            'Tianshui Tianshui Airport China Çin - THQ',
            'Jinan  China Çin - TNA',
            'Tonghua Tonghua Liuhe China Çin - TNH',
            'Tianjin  China Çin - TSN',
            'Tunxi  China Çin - TXN',
            'Tangshan Sannuhe China Çin - TVS',
            'Taiyuan  China Çin - TYN',
            'Urumqi  China Çin - URC',
            'Qinhuangdao  China Çin - SHP',
            'Shashi  China Çin - SHS',
            'Xi An Xiguan China Çin - SIA',
            'Xi An Xianyang China Çin - XIY',
            'Shijiazhuang Daguocun China Çin - SJW',
            'Tacheng  China Çin - TCG',
            'Tengchong Hump Airport China Çin - TCZ',
            'Tongren  China Çin - TEN',
            'Qingdao  China Çin - TAO',
            'Shanzhou  China Çin - SZO',
            'Suzhou  China Çin - SZV',
            'Shenzhen  China Çin - SZX',
            'Sanya  China Çin - SYX',
            'Simao  China Çin - SYM',
            'Shanshan  China Çin - SXJ',
            'Shantou  China Çin - SWA',
            'Yibin  China Çin - YBP',
            'Xining  China Çin - XNN',
            'Xingtai  China Çin - XNT',
            'Xuzhou  China Çin - XUZ',
            'Xiamen  China Çin - XMN',
            'Xichang  China Çin - XIC',
            'Xilinhot  China Çin - XIL',
            'Xingning  China Çin - XIN',
            'Xingcheng  China Çin - XEN',
            'Xiangfan  China Çin - XFN',
            'Wenzhou  China Çin - WNZ',
            'Wenshan Wenshan Puzhehei China Çin - WNH',
            'Wanxian  China Çin - WXN',
            'Wuxi Wuxi Airport China Çin - WUX',
            'Wuzhou Changzhoudao China Çin - WUZ',
            'Wuyishan  China Çin - WUS',
            'Wuhan  China Çin - WUH',
            'Wu Hai Wu Hai Apt China Çin - WUA',
            'Yulin  China Çin - UYN',
            'Wuhu  China Çin - WHU',
            'Weifang  China Çin - WEF',
            'Weihai  China Çin - WEH',
            'Shunde Ferry Port China Çin - ZAS',
            'Zhaotong  China Çin - ZAT',
            'Jiang Men Ferry Port China Çin - ZBD',
            'Zhongwei  China Çin - ZHY',
            'Zhanjiang  China Çin - ZHA',
            'Yushu Xian Yushu Batang China Çin - YUS',
            'Yancheng  China Çin - YNZ',
            'Yantai Laishan China Çin - YNT',
            'Yanji  China Çin - YNJ',
            'Yilan  China Çin - YLN',
            'Zhuhai Zhuhai Airport China Çin - ZUH',
            'Zunyi  China Çin - ZYI',
            'Yuanmou  China Çin - YUA',
            'Yiwu  China Çin - YIW',
            'Yining  China Çin - YIN',
            'Yichang  China Çin - YIH',
            'Yun Cheng  China Çin - YCU',
            'Villavicencio La Vanguardia Colombia - VVC',
            'Valledupar Alfonso L Michelsen Colombia - VUP',
            'Yavarate  Colombia - VAB',
            'Villagarzon  Colombia - VGZ',
            'San Vicente  Colombia - SVI',
            'Tauramena  Colombia - TAU',
            'Timbiqui  Colombia - TBD',
            'Trinidad  Colombia - TDA',
            'Tumaco La Florida Colombia - TCO',
            'Tarapaca  Colombia - TCD',
            'San Juan D Ur  Colombia - SJR',
            'San Pedro Jagua  Colombia - SJG',
            'San Juan Del Cesa  Colombia - SJH',
            'San Jose Del Gua  Colombia - SJE',
            'Santa Maria  Colombia - SMC',
            'Santa Marta Simon Bolivar Colombia - SMR',
            'San Luis De Pale  Colombia - SQE',
            'Solano  Colombia - SQF',
            'Santa Ana  Colombia - SQB',
            'Santa Rosalia  Colombia - SSL',
            'San Felipe  Colombia - SSD',
            'Santana Ramos  Colombia - SRO',
            'San Marcos  Colombia - SRS',
            'Solita  Colombia - SOH',
            'Sabana De Torres  Colombia - SNT',
            'Sogamoso  Colombia - SOX',
            'Uribe  Colombia - URI',
            'Urrao  Colombia - URR',
            'Unguia  Colombia - UNC',
            'Tulua Farfan Colombia - ULQ',
            'Mulatos  Colombia - ULS',
            'Quibdo  Colombia - UIB',
            'Tablon De Tamara  Colombia - TTM',
            'Tres Esquinas  Colombia - TQS',
            'Turbo Gonzalo Colombia - TRB',
            'Tame  Colombia - TME',
            'Tibu  Colombia - TIB',
            'Tolu  Colombia - TLU',
            'Paz De Ariporo Casanare Colombia - PZA',
            'Cravo Norte  Colombia - RAV',
            'Riohacha  Colombia - RCH',
            'Rondon  Colombia - RON',
            'Saravena  Colombia - RVE',
            'Santa Catalina  Colombia - SCA',
            'Popayan Guillermoleon Valencia Colombia - PPN',
            'Plato  Colombia - PLT',
            'Planeta Rica  Colombia - PLC',
            'Planadas  Colombia - PLA',
            'Puerto Asis  Colombia - PUU',
            'Providencia  Colombia - PVA',
            'Pitalito  Colombia - PTX',
            'Puerto Boyaca  Colombia - PYA',
            'Payan  Colombia - PYN',
            'Pasto Cano Colombia - PSO',
            'Pore  Colombia - PRE',
            'Otu  Colombia - OTU',
            'Puerto Berrio  Colombia - PBE',
            'Palanquero  Colombia - PAL',
            'Puerto Rico  Colombia - PCC',
            'Puerto Carreno  Colombia - PCR',
            'Puerto Inirida  Colombia - PDA',
            'Pereira Matecana Colombia - PEI',
            'Mitu  Colombia - MVP',
            'Monteria Los Garzones Colombia - MTR',
            'Monterrey  Colombia - MOY',
            'Monte Libano  Colombia - MTB',
            'Mosquera  Colombia - MQR',
            'Mariquita  Colombia - MQU',
            'Medellin J M Cordova Colombia - MDE',
            'Medellin Olaya Herrera Colombia - EOH',
            'Monfort  Colombia - MFB',
            'Morichal  Colombia - MHF',
            'Magangue Baracoa Colombia - MGN',
            'Miraflores  Colombia - MFS',
            'Miriti  Colombia - MIX',
            'Mompos  Colombia - MMP',
            'Medina  Colombia - MND',
            'Nunchia  Colombia - NUH',
            'Neiva La Marguita Colombia - NVA',
            'Ocana Aguasclaras Colombia - OCV',
            'Orocue  Colombia - ORC',
            'Nuqui  Colombia - NQU',
            'San Pedro Uraba  Colombia - NPU',
            'Necocli  Colombia - NCI',
            'Barrancominas  Colombia - NBB',
            'Nare  Colombia - NAR',
            'Manizales La Nubia Colombia - MZL',
            'Macanal  Colombia - NAD',
            'La Chorrera  Colombia - LCR',
            'La Uribe  Colombia - LAT',
            'Las Gaviotas  Colombia - LGT',
            'Leguizamo  Colombia - LGZ',
            'Leticia General A V Cobo Colombia - LET',
            'Maicao  Colombia - MCJ',
            'Lopez De Micay  Colombia - LMX',
            'Lamacarena  Colombia - LMC',
            'La Pedrera  Colombia - LPD',
            'La Primavera  Colombia - LPE',
            'Puerto Leguizamo  Colombia - LQM',
            'Lorica  Colombia - LRI',
            'Jurado  Colombia - JUO',
            'Herrera  Colombia - HRR',
            'Hato Corozal  Colombia - HTZ',
            'Ibague  Colombia - IBE',
            'Ipiales San Luis Colombia - IPI',
            'Chigorodo  Colombia - IGO',
            'Chivolo  Colombia - IVO',
            'Iscuande  Colombia - ISD',
            'Gamarra  Colombia - GRA',
            'Guapi  Colombia - GPI',
            'Guerima  Colombia - GMC',
            'Girardot  Colombia - GIR',
            'Gilgal  Colombia - GGL',
            'Guacamaya  Colombia - GCA',
            'Guamal  Colombia - GAA',
            'Florencia Capitolio Colombia - FLA',
            'Corozal  Colombia - CZU',
            'Cucuta Camilo Dazo Colombia - CUC',
            'Caruru  Colombia - CUO',
            'Currillo  Colombia - CUI',
            'Covenas  Colombia - CVE',
            'Cartagena Rafael Nunez Colombia - CTG',
            'Casuarito  Colombia - CSR',
            'Condoto Mandinga Colombia - COG',
            'Capurgana  Colombia - CPB',
            'Chaparral  Colombia - CPL',
            'Cartago  Colombia - CRC',
            'Caquetania  Colombia - CQT',
            'Carimagua  Colombia - CCO',
            'Cimitarra  Colombia - CIM',
            'Candilejas  Colombia - CJD',
            'Cali Alfonso B Aragon Colombia - CLO',
            'El Recreo  Colombia - ELJ',
            'El Banco San Bernado Colombia - ELB',
            'Barrancabermeja Variguies Colombia - EJA',
            'El Yopal  Colombia - EYP',
            'Paratebueno  Colombia - EUO',
            'Codazzi  Colombia - DZI',
            'El Encanto  Colombia - ECO',
            'El Charco  Colombia - ECR',
            'El Bagre  Colombia - EBG',
            'San Andres Island  Colombia - ADZ',
            'Andes  Colombia - ADN',
            'Amalfi  Colombia - AFI',
            'Aguaclara  Colombia - ACL',
            'Arica  Colombia - ACM',
            'Araracuara  Colombia - ACR',
            'Acandi  Colombia - ACD',
            'Apartado  Colombia - APO',
            'Apiay  Colombia - API',
            'Acaricuara  Colombia - ARF',
            'Arboletas  Colombia - ARO',
            'Arauquita  Colombia - ARQ',
            'Arauca  Colombia - AUC',
            'Armenia El Eden Colombia - AXM',
            'Yaguara  Colombia - AYG',
            'Yari  Colombia - AYI',
            'Ayapel  Colombia - AYA',
            'Ayacucho  Colombia - AYC',
            'Baltık Sahili - BAC',
            'Zapatoca  Colombia - AZT',
            'Barranquilla Ernesto Cortissoz Colombia - BAQ',
            'Bucaramanga Palo Negro Colombia - BGA',
            'Bahia Cupica  Colombia - BHF',
            'Caucasia  Colombia - CAQ',
            'Buenaventura  Colombia - BUN',
            'Bogota Eldorado Colombia - BOG',
            'Bahia Solano  Colombia - BSC',
            'Barra Colorado  Costa Rica - BCL',
            'Buenos Aires  Costa Rica - BAI',
            'Drake Bay  Costa Rica - DRK',
            'Canas  Costa Rica - CSC',
            'Flamingo  Costa Rica - FMG',
            'Fortuna Fortuna Airport Costa Rica - FON',
            'Golfito  Costa Rica - GLF',
            'Guapiles  Costa Rica - GPL',
            'Punta Renes  Costa Rica - JAP',
            'Los Chiles  Costa Rica - LSL',
            'Limon  Costa Rica - LIO',
            'Liberia  Costa Rica - LIR',
            'Las Canas  Costa Rica - LCS',
            'Nicoya Guanacaste Costa Rica - NCT',
            'Nosara Beach  Costa Rica - NOB',
            'Puerto Jimenez  Costa Rica - PJM',
            'Punta Islita  Costa Rica - PBP',
            'Coto 47  Costa Rica - OTR',
            'Playa Samara  Costa Rica - PLD',
            'Palmar Palmar Sur Costa Rica - PMZ',
            'Rio Frio  Costa Rica - RFR',
            'Carillo  Costa Rica - RIK',
            'Tambor  Costa Rica - TMU',
            'San Vito San Vito Airport Costa Rica - TOO',
            'Tamarindo  Costa Rica - TNO',
            'Tortuquero  Costa Rica - TTQ',
            'Upala  Costa Rica - UPL',
            'San Jose Tobias Bolanos Costa Rica - SYQ',
            'San Jose Juan Santamaria Costa Rica - SJO',
            'Santa Cruz Guanacaste Costa Rica - SZC',
            'Quepos  Costa Rica - XQP',
            'Las Tunas  Cuba - VTU',
            'Varadero Juan Gualberto G Cuba - VRA',
            'Matanzas Kawama Airport Cuba - VRO',
            'Siguanea Siguanea Airport Cuba - SZJ',
            'Santa Clara  Cuba - SNU',
            'San Julian  Cuba - SNJ',
            'Punta Alegre  Cuba - UPA',
            'Havana Playa Baracoa Cuba - UPB',
            'Sancti Spiritus  Cuba - USS',
            'Punta De Maisi  Cuba - UMA',
            'Trinidad  Cuba - TND',
            'Santiago Antonio Maceo Cuba - SCU',
            'Preston  Cuba - PST',
            'Manzanillo Sierra Maestra Cuba - MZO',
            'Mayajigua  Cuba - MJG',
            'Moa Orestes Acosta Cuba - MOA',
            'La Coloma  Cuba - LCL',
            'Nicaro  Cuba - ICR',
            'Holguin Frank Pais Cuba - HOG',
            'Havana Jose Marti Intl Cuba - HAV',
            'Guantanamo Los Canos Cuba - GAO',
            'Guantanamo Guantanamo Nas Cuba - NBW',
            'Nueva Gerona Rafael Cabre Cuba - GER',
            'Cayo Largo Del Sur  Cuba - CYO',
            'Camaguey Ign Agramonte Intl Cuba - CMW',
            'Cayo Coco  Cuba - CCC',
            'Cienfuegos  Cuba - CFG',
            'Ciego De Avila Maximo Gomez Cuba - AVI',
            'Baracoa  Cuba - BCA',
            'Cayo Las Brujas Las Brujas Cuba - BWW',
            'Bayamo C M De Cespedes Cuba - BYM',
            'Brava Esperadinha Cape Verde Republic Of - BVR',
            'Boa Vista Rabil Cape Verde Republic Of - BVC',
            'Mosteiros  Cape Verde Republic Of - MTI',
            'Maio Vila Do Maio Cape Verde Republic Of - MMO',
            'Santo Antao  Cape Verde Republic Of - NTO',
            'Sao Filipe  Cape Verde Republic Of - SFL',
            'Praia F Mendes Cape Verde Republic Of - RAI',
            'Sao Nicolau Preguica Cape Verde Republic Of - SNE',
            'Sal Amilcar Cabral Intl Cape Verde Republic Of - SID',
            'Sao Vicente San Pedro Cape Verde Republic Of - VXE',
            'Christmas Island  Christmas Island - XCH',
            'Paphos Paphos Intl Cyprus - PFO',
            'Lefkoşa  Cyprus - NIC',
            'Akrotiri Raf Station Cyprus - AKT',
            'Ercan  Cyprus - ECN',
            'Episkopi  Cyprus - EPK',
            'Gecitkale  Cyprus - GEC',
            'Larnaca  Cyprus - LCA',
            'Karlovy Vary International Czech Republic - KLV',
            'Zlin Holesov Czech Republic - GTW',
            'Brno Turany Czech Republic - BRQ',
            'Ostrava Leos Janacek Czech Republic - OSR',
            'Olomouc Neredin Czech Republic - OLO',
            'Marianske Lazne  Czech Republic - MKA',
            'Pardubice Airport Czech Republic - PED',
            'Prag Ruzyne Czech Republic - PRG',
            'Prerov  Czech Republic - PRV',
            'Zabreh Dolni Benesov Czech Republic - ZBE',
            'Uherske Hradiste Kunovice Czech Republic - UHE',
            'Djibouti Ambouli Djibouti - JIB',
            'Alisabieh  Djibouti - AII',
            'Obock  Djibouti - OBC',
            'Musha  Djibouti - MHI',
            'Tadjoura  Djibouti - TDJ',
            'Thisted  Denmark - TED',
            'Stauning  Denmark - STA',
            'Skive Airport Denmark - SQW',
            'Vojens Skrydstrup Denmark - SKS',
            'Vejle  Denmark - VEJ',
            'Aarhus Limousine Denmark - ZBU',
            'Maribo Lolland Falster Denmark - MRW',
            'Odense Airport Denmark - ODE',
            'Sonderborg Airport Denmark - SGD',
            'Bornholm Ronne Denmark - RNN',
            'Aarhus Airport Denmark - AAR',
            'Aalborg  Denmark - AAL',
            'Billund  Denmark - BLL',
            'Laeso  Denmark - BYR',
            'Copenhagen Roskilde Denmark - RKE',
            'Copenhagen Kastrup Denmark - CPH',
            'Sindal  Denmark - CNL',
            'Esbjerg Airport Denmark - EBJ',
            'Karup  Denmark - KRP',
            'Dominica Cane Field Dominica - DCF',
            'Dominica Melville Hall Dominica - DOM',
            'El Portillo/Samana El Portillo Airport Dominican Republic - EPS',
            'Cabo Rojo  Dominican Republic - CBJ',
            'Constanza  Dominican Republic - COZ',
            'Barahona  Dominican Republic - BRX',
            'Samana International Dominican Republic - AZS',
            'La Romana  Dominican Republic - LRM',
            'Higuero Dr Joaquin Balaguer Dominican Republic - JBQ',
            'Santo Domingo Las Americas Dominican Republic - SDQ',
            'Santo Domingo Herrera Dominican Republic - HEX',
            'Punta Cana  Dominican Republic - PUJ',
            'Puerto Plata La Union Dominican Republic - POP',
            'San Juan  Dominican Republic - SJM',
            'Sabana De Mar  Dominican Republic - SNX',
            'Santiago Santiago Mnpl Dominican Republic - STI',
            'Tebessa Tbessa Algeria - TEE',
            'Skikda  Algeria - SKI',
            'Timimoun  Algeria - TMX',
            'Tamanrasset Aguenar Algeria - TMR',
            'Tlemcen Zenata Messali El Hadj Algeria - TLM',
            'Tiaret Bou Chekif Algeria - TID',
            'Tindouf  Algeria - TIN',
            'Touggourt Sidi Mahdi Algeria - TGR',
            'Illizi Takhamalt Algeria - VVZ',
            'Setif 8 Mai 45 Algeria - QSF',
            'Ouargla Ain El Beida Algeria - OGX',
            'Oran Es Senia Algeria - ORN',
            'Oran Tafaraoui Algeria - TAF',
            'Mecheria  Algeria - MZW',
            'Mostaganem  Algeria - MQV',
            'Mascara Ghriss Algeria - MUW',
            'In Salah  Algeria - INZ',
            'In Guezzam  Algeria - INF',
            'Hassi Messaoud Oued Irara Algeria - HME',
            'In Amenas Zarzaitine Algeria - IAM',
            'Hassi R mel Tilrempt Algeria - HRM',
            'Ghardaia Noumerat Algeria - GHA',
            'Gara Djebilet  Algeria - GBB',
            'Jijel Ferhat Abbas Algeria - GJL',
            'Laghouat L mekrareg Algeria - LOO',
            'Kouba  Algeria - KDF',
            'Adrar Touat Algeria - AZR',
            'Annaba Rabah Bitat Algeria - AAE',
            'Algiers Houari Boumediene Algeria - ALG',
            'Biskra Mohamed Khider Algeria - BSK',
            'Bou Saada  Algeria - BUJ',
            'Batna Mostepha Ben Boulaid Algeria - BLJ',
            'Bordj Mokhtar  Algeria - BMW',
            'Bejaia Soummam Abane Ramdane Algeria - BJA',
            'Sidi Belabbes  Algeria - BFW',
            'Constantine Mohamed Boudiaf Algeria - CZL',
            'Bechar Boudghene B Ali Lotfi Algeria - CBH',
            'Chlef Aboubakr Belkaid Algeria - CFK',
            'El Oued Guemar Algeria - ELU',
            'El Golea  Algeria - ELG',
            'El Bayadh  Algeria - EBH',
            'Djanet Tiska Algeria - DJG',
            'Esmeraldas  Ecuador - ESM',
            'Cuenca  Ecuador - CUE',
            'Bahia De Caraquez  Ecuador - BHA',
            'Ambato Chachoan Ecuador - ATF',
            'Jipijapa  Ecuador - JIP',
            'Loja  Ecuador - LOH',
            'Latacunga Cotapaxi Intl Ecuador - LTX',
            'Machala  Ecuador - MCH',
            'Lago Agrio  Ecuador - LGQ',
            'Galapagos Is Baltra Ecuador - GPS',
            'Guayaquil Jose Joaquin De Olmedo Ecuador - GYE',
            'Macara  Ecuador - MRR',
            'Manta  Ecuador - MEC',
            'Mendez  Ecuador - MZD',
            'Coca  Ecuador - OCC',
            'San Cristobal  Ecuador - SCY',
            'Pastaza  Ecuador - PTZ',
            'Portoviejo  Ecuador - PVO',
            'Putumayo  Ecuador - PYO',
            'Macas  Ecuador - XMS',
            'Tarapoa  Ecuador - TPC',
            'Tiputini  Ecuador - TPN',
            'Taisha  Ecuador - TSC',
            'Quito Mariscal Sucr Ecuador - UIO',
            'Tulcan  Ecuador - TUA',
            'Salinas  Ecuador - SNC',
            'Sucua  Ecuador - SUQ',
            'Tartu Ulenurme Estonia - TAY',
            'Kuressaare  Estonia - URE',
            'Tallinn Pirita Harbor Estonia - QUF',
            'Tallinn Lennart Meri Estonia - TLL',
            'Kardla  Estonia - KDL',
            'Parnu  Estonia - EPU',
            'Tour Sinai City  Egypt - ELT',
            'El Minya  Egypt - EMY',
            'Dakhla Oasis Dakhla Egypt - DAK',
            'Dabaa City Alalamain Intl Egypt - DBB',
            'Aswan  Egypt - ASW',
            'Assiut  Egypt - ATZ',
            'Abu Rudeis  Egypt - AUE',
            'Alexandria El Nohza Egypt - ALY',
            'Alexandria Borg El Arab Egypt - HBE',
            'Al Arish  Egypt - AAC',
            'Abu Simbel  Egypt - ABS',
            'Kahire - CAI',
            'Luxor  Egypt - LXR',
            'Shark Alowainat  Egypt - GSQ',
            'Hurghada  Egypt - HRG',
            'Ramadan  Egypt - TFR',
            'Kharga  Egypt - UVL',
            'Taba Taba International Egypt - TCP',
            'Sidi Barani  Egypt - SQK',
            'Sharm El Sheikh Sharm El Sheikh Intl Egypt - SSH',
            'Santa Katarina Mount Sinai Egypt - SKV',
            'Port Said  Egypt - PSD',
            'Siwa  Egypt - SEW',
            'Marsa Alam  Egypt - RMF',
            'Mersa Matruh  Egypt - MUH',
            'Massawa  Eritrea - MSW',
            'Tessenei  Eritrea - TES',
            'Assab  Eritrea - ASA',
            'Asmara Asmara International Eritrea - ASM',
            'Lanzarote  Spain - ACE',
            'Albacete Airport Spain - ABC',
            'Malaga  Spain - AGP',
            'Algeciras  Spain - AEI',
            'Alicante  Spain - ALC',
            'Barselona - BCN',
            'Bilbao  Spain - BIO',
            'Badajoz  Spain - BJZ',
            'Ciudad Real Central Spain - CQM',
            'Cadiz  Spain - CDZ',
            'Ciudad Real  Spain - CJI',
            'San Fernando  Spain - FES',
            'Fuengirola  Spain - FGR',
            'San Sebastian  Spain - EAS',
            'Huesca Pirineos Spain - HSK',
            'Ibiza  Spain - IBZ',
            'Huelva  Spain - HEV',
            'Lleida Alguaire Spain - ILD',
            'Granada Federico Garcia Lorca Spain - GRX',
            'Girona Costa Brava Spain - GRO',
            'San Sebastian Gomera La Gomera Spain - GMZ',
            'Puente Genil  Spain - GEN',
            'Fuerteventura  Spain - FUE',
            'Madrid Barajas Spain - MAD',
            'Madrid Torrejon Spain - TOJ',
            'Menorca  Spain - MAH',
            'Las Palmas Gran Canaria Spain - LPA',
            'Almeria  Spain - LEI',
            'Leon  Spain - LEN',
            'Seo De Urgel  Spain - LEU',
            'La Coruna  Spain - LCG',
            'Tenerife Tenerife Norte Spain - TFN',
            'Tenerife Tenerife Sur Spain - TFS',
            'Sevilla Sevilla Airport Spain - SVQ',
            'Salamanca Matacan Spain - SLM',
            'San Pablo  Spain - SPO',
            'Santa Cruz De La Palma La Palma Spain - SPC',
            'Torremolinos  Spain - UTL',
            'Puerto De La Cruz Puerto La Cruz Spain - UPC',
            'Puertollano  Spain - UER',
            'Jerez La Parra Spain - XRY',
            'Valverde El Hierro Spain - VDE',
            'Valladolid Airport Spain - VLL',
            'Vitoria  Spain - VIT',
            'Valencia  Spain - VLC',
            'Vigo  Spain - VGO',
            'Zaragoza  Spain - ZAZ',
            'Murcia San Javier Spain - MJV',
            'Melilla  Spain - MLN',
            'Cordoba Cordoba Airport Spain - ODB',
            'La Palma Del Condado  Spain - NDO',
            'Rota Us Naval Station Spain - ROZ',
            'Ronda  Spain - RRA',
            'Logrono Agoncillo Spain - RJL',
            'Burgos  Spain - RGS',
            'Reus  Spain - REU',
            'Santander  Spain - SDR',
            'Santiago De Compostela  Spain - SCQ',
            'Puerto De Santa Maria  Spain - PXS',
            'Pamplona  Spain - PNA',
            'Palma Mallorca  Spain - PMI',
            'Oviedo Asturias Spain - OVD',
            'Montilla  Spain - OZU',
            'Bobadilla  Spain - OZI',
            'Moron Air Base Spain - OZP',
            'Mota  Ethiopia - OTA',
            'Pawi Beles Ethiopia - PWI',
            'Indaselassie  Ethiopia - SHC',
            'Mendi  Ethiopia - NDM',
            'Nejjo  Ethiopia - NEJ',
            'Nekemt  Ethiopia - NEK',
            'Mena  Ethiopia - MZX',
            'Chagni  Ethiopia - MKD',
            'Mekane Selam  Ethiopia - MKS',
            'Misrak Gashamo  Ethiopia - MHJ',
            'Mizan Teferi  Ethiopia - MTF',
            'Mui  Ethiopia - MUJ',
            'Moyale  Ethiopia - MYS',
            'Makale  Ethiopia - MQX',
            'Waca  Ethiopia - WAC',
            'Buno Bedelle  Ethiopia - XBL',
            'Warder  Ethiopia - WRA',
            'Tum  Ethiopia - TUJ',
            'Tippi  Ethiopia - TIE',
            'Shehdi  Ethiopia - SQJ',
            'Shakiso  Ethiopia - SKR',
            'Soddu  Ethiopia - SXU',
            'Semera  Ethiopia - SZE',
            'Kelafo Callaf Kelafo Ethiopia - LFO',
            'Lalibela  Ethiopia - LLI',
            'Jijiga  Ethiopia - JIJ',
            'Jimma  Ethiopia - JIM',
            'Fincha  Ethiopia - FNH',
            'Gondar  Ethiopia - GDQ',
            'Ghimbi  Ethiopia - GHD',
            'Gode Iddidole  Ethiopia - GDE',
            'Ghinnir  Ethiopia - GNN',
            'Goba  Ethiopia - GOB',
            'Gambela  Ethiopia - GMB',
            'Geladi  Ethiopia - GLC',
            'Gore  Ethiopia - GOR',
            'Shilavo  Ethiopia - HIL',
            'Humera  Ethiopia - HUE',
            'Dessie Combolcha Ethiopia - DSE',
            'Dire Dawa Aba Tenna D Yilma Ethiopia - DIR',
            'Degahbur  Ethiopia - DGC',
            'Dembidollo  Ethiopia - DEM',
            'Genda Wuha  Ethiopia - ETE',
            'Neghelli  Ethiopia - EGL',
            'Debra Marcos  Ethiopia - DBM',
            'Debra Tabor  Ethiopia - DBT',
            'Bahar Dar  Ethiopia - BJR',
            'Jinka  Ethiopia - BCO',
            'Bulchi  Ethiopia - BCY',
            'Beica  Ethiopia - BEI',
            'Asela  Ethiopia - ALK',
            'Arba Mintch  Ethiopia - AMH',
            'Addis Ababa Bole Ethiopia - ADD',
            'Kabri Dar  Ethiopia - ABK',
            'Asosa  Ethiopia - ASO',
            'Awassa  Ethiopia - AWA',
            'Awareh  Ethiopia - AWH',
            'Axum  Ethiopia - AXU',
            'Enontekio  Finland - ENF',
            'Helsinki Helsinki Vantaa Finland - HEL',
            'Helsinki Helsinki Malmi Finland - HEM',
            'Ivalo  Finland - IVL',
            'Joensuu  Finland - JOE',
            'Kauhava  Finland - KAU',
            'Kuusamo  Finland - KAO',
            'Jyvaskyla  Finland - JYV',
            'Kajaani  Finland - KAJ',
            'Kemi Tornio  Finland - KEM',
            'Halli  Finland - KEV',
            'Kauhajoki  Finland - KHJ',
            'Kuopio  Finland - KUO',
            'Kitee  Finland - KTQ',
            'Kittila  Finland - KTT',
            'Kokkola Pietarsaa Kruunupyy Finland - KOK',
            'Lappeenranta  Finland - LPP',
            'Savonlinna  Finland - SVL',
            'Seinajoki  Finland - SJY',
            'Sodankyla  Finland - SOT',
            'Turku  Finland - TKU',
            'Tampere Tampere Pirkkala Finland - TMP',
            'Utti  Finland - UTI',
            'Varkaus  Finland - VRK',
            'Vaasa  Finland - VAA',
            'Ylivieska  Finland - YLI',
            'Mariehamn  Finland - MHQ',
            'Mikkeli  Finland - MIK',
            'Rovaniemi  Finland - RVN',
            'Pori  Finland - POR',
            'Oulu  Finland - OUL',
            'Pacific Harbor  Fiji - PHR',
            'Malololailai  Fiji - PTF',
            'Rotuma Island  Fiji - RTA',
            'Rabi  Fiji - RBI',
            'Mana Island Airstrip Fiji - MNF',
            'Moala  Fiji - MFJ',
            'Nadi Nadi Intl Fiji - NAN',
            'Ngau Island  Fiji - NGI',
            'Natadola  Fiji - NTA',
            'Ono I Lau  Fiji - ONU',
            'Vanuabalavu  Fiji - VBV',
            'Vatukoula  Fiji - VAU',
            'Vatulele  Fiji - VTF',
            'Yasawa  Fiji - YAS',
            'Turtle Island  Fiji - TTL',
            'Taveuni Matei Fiji - TVU',
            'Savusavu  Fiji - SVU',
            'Suva Nausori Fiji - SUV',
            'Laucala Is  Fiji - LUC',
            'Lakeba  Fiji - LKB',
            'Bureta Levuka Airfield Fiji - LEV',
            'Labasa  Fiji - LBS',
            'Koro Island  Fiji - KXF',
            'Korolevu  Fiji - KVU',
            'Kadavu  Fiji - KDV',
            'Wakaya Island  Fiji - KAY',
            'Cicia  Fiji - ICI',
            'Castaway  Fiji - CST',
            'Saqani  Fiji - AQS',
            'Ba  Fiji - BFJ',
            'Blue Lagoon  Fiji - BXL',
            'Bua Dama Fiji - BVF',
            'Mount Pleasant  Falkland Islands - MPN',
            'Port Stanley  Falkland Islands - PSY',
            'Pohnpei  Micronesia - PNI',
            'Ulithi  Micronesia - ULI',
            'Truk  Micronesia - TKK',
            'Yap  Micronesia - YAP',
            'Kosrae  Micronesia - KSA',
            'Faroe Islands Vagar Faroe Islands - FAE',
            'Mitzic  Gabon - MZC',
            'Nkan  Gabon - NKA',
            'Omboue  Gabon - OMB',
            'Okondja  Gabon - OKN',
            'Medouneu  Gabon - MDV',
            'Moanda  Gabon - MFF',
            'Manega  Gabon - MGO',
            'Moabi  Gabon - MGX',
            'Makokou  Gabon - MKU',
            'Mouila  Gabon - MJL',
            'Mekambo  Gabon - MKB',
            'Minvoul  Gabon - MVX',
            'Mevang  Gabon - MVG',
            'Fransaville  Gabon - MVB',
            'Mayoumba  Gabon - MYB',
            'Ouanga  Gabon - OUU',
            'Oyem  Gabon - OYE',
            'Owendo  Gabon - OWE',
            'Port Gentil  Gabon - POG',
            'Tchibanga  Gabon - TCH',
            'Sette Cama  Gabon - ZKM',
            'Wagny  Gabon - WGY',
            'Wora Na Ye  Gabon - WNE',
            'Fougamou  Gabon - FOU',
            'Miele Mimbale  Gabon - GIM',
            'Gamba  Gabon - GAX',
            'Kongoboumba  Gabon - GKO',
            'Iguela  Gabon - IGE',
            'Mbigou  Gabon - MBC',
            'Lastourville  Gabon - LTL',
            'Leconi  Gabon - LEO',
            'Libreville Libreville Leon M Ba Gabon - LBV',
            'Lambarene  Gabon - LBQ',
            'Ndende  Gabon - KDN',
            'N djole  Gabon - KDJ',
            'Koulamoutou  Gabon - KOU',
            'Mandji  Gabon - KMD',
            'Akieni  Gabon - AKE',
            'Alowe  Gabon - AWE',
            'Biawonque  Gabon - BAW',
            'Bitam  Gabon - BMM',
            'Booue  Gabon - BGB',
            'Bongo  Gabon - BGP',
            'Belfast Belfast City İngiltere - BHD',
            'Belfast International İngiltere - BFS',
            'Benson Raf Station İngiltere - BEX',
            'Benbecula  İngiltere - BEB',
            'Bury St Edmunds Honington İngiltere - BEQ',
            'Blackbush  İngiltere - BBS',
            'Blackpool  İngiltere - BLK',
            'Birmingham Birmingham Intl İngiltere - BHX',
            'Bournemouth Bournemouth Intl İngiltere - BOH',
            'Bally Kelly  İngiltere - BOL',
            'Bradford  İngiltere - BRF',
            'Brighton  İngiltere - BSH',
            'Barra North Bay İngiltere - BRR',
            'Bristol Bristol Intl İngiltere - BRS',
            'Brize Norton Raf Station İngiltere - BZZ',
            'Campbeltown Machrihanish İngiltere - CAL',
            'Burtonwood  İngiltere - BUT',
            'Barrow In Furness  İngiltere - BWF',
            'Woodbridge Bentwaters St İngiltere - BWY',
            'Bembridge  İngiltere - BBP',
            'Alconbury Raf Station İngiltere - AYH',
            'Andover  İngiltere - ADV',
            'Saint Andrews Leuchars İngiltere - ADX',
            'Aberdeen Dyce İngiltere - ABZ',
            'Alderney The Blaye İngiltere - ACI',
            'Abingdon Raf Station İngiltere - ABB',
            'Cambridge  İngiltere - CBG',
            'Carlisle  İngiltere - CAX',
            'Chester  İngiltere - CEG',
            'Coventry West Midlands İngiltere - CVT',
            'Cardiff  İngiltere - CWL',
            'Coll Island  İngiltere - COL',
            'Colonsay Is  İngiltere - CSA',
            'Cromarty  İngiltere - CRN',
            'Dornoch  İngiltere - DOC',
            'Doncaster Sheffield İngiltere - DSA',
            'Dundee  İngiltere - DND',
            'Edinburg  İngiltere - EDI',
            'Eday  İngiltere - EOI',
            'Enniskillen Saint Angelo İngiltere - ENK',
            'Shoreham By Sea Shoreham İngiltere - ESH',
            'Farnborough  İngiltere - FAB',
            'Newbury Greenham Raf İngiltere - EWY',
            'Exeter  İngiltere - EXT',
            'Fairford Raf Station İngiltere - FFD',
            'Fair Isle  İngiltere - FIE',
            'Fetlar  İngiltere - FEA',
            'Kirkwall  İngiltere - KOI',
            'Kings Lynn Marham Raf İngiltere - KNF',
            'Leeds Leeds Bradford İngiltere - LBA',
            'Londonderry Eglinton İngiltere - LDY',
            'Milton Keynes  İngiltere - KYN',
            'Lands End  İngiltere - LEQ',
            'Lossiemouth Raf Station İngiltere - LMO',
            'Brandon Lakenheath Raf İngiltere - LKZ',
            'Liverpool Liverpool John Lennon İngiltere - LPL',
            'Londra Tüm Havalimanları İngiltere - LON',
            'Londra Heathrow İngiltere - LHR',
            'Londra Luton İngiltere - LTN',
            'Londra London City İngiltere - LCY',
            'Londra Stansted İngiltere - STN',
            'Londra Biggin Hill İngiltere - BQH',
            'Londra Gatwick İngiltere - LGW',
            'Manchester Manchester Intl İngiltere - MAN',
            'Lydd London Ashford İngiltere - LYX',
            'Lyneham Raf Station İngiltere - LYE',
            'Islay Glenegedale İngiltere - ILY',
            'Isle Of Man Ronaldsway İngiltere - IOM',
            'Inverness  İngiltere - INV',
            'Ipswich  İngiltere - IPW',
            'Isles Of Scilly Saint Marys İngiltere - ISC',
            'Isles Of Scilly Tresco İngiltere - TSO',
            'Jersey States İngiltere - JER',
            'High Wycombe Wycombe Air Park İngiltere - HYC',
            'Humberside  İngiltere - HUY',
            'Harrogate Linton On Ouse İngiltere - HRT',
            'Hatfield  İngiltere - HTF',
            'Hoy Island  İngiltere - HOY',
            'Hendon  İngiltere - HEN',
            'Holyhead  İngiltere - HLY',
            'Glasgow Glasgow Intl İngiltere - GLA',
            'Glasgow Prestwick İngiltere - PIK',
            'Gloucester Gloucestershire İngiltere - GLO',
            'Machrihanish Raf Station İngiltere - GQJ',
            'Grimsby Binbrook İngiltere - GSY',
            'Haverfordwest  İngiltere - HAW',
            'Filton  İngiltere - FZO',
            'Guernsey  İngiltere - GCI',
            'Foula  İngiltere - FOA',
            'Fakenham Sculthorp Raf İngiltere - FKH',
            'Flotta  İngiltere - FLH',
            'Forres Kinloss İngiltere - FSS',
            'Suttonheath Woodbridge İngiltere - WOB',
            'Wick  İngiltere - WIC',
            'Westray  İngiltere - WRY',
            'Braintree Wether Fld Raf İngiltere - WXF',
            'Waddington Raf Station İngiltere - WTN',
            'Whalsay  İngiltere - WHS',
            'West Malling  İngiltere - WEM',
            'Woodford  İngiltere - WFD',
            'Newcastle Under Lyme  İngiltere - VLF',
            'Anglesey  İngiltere - VLY',
            'Yeovilton  İngiltere - YEO',
            'Stornoway  İngiltere - SYY',
            'Sheffield  İngiltere - SZD',
            'Swansea Fairwood Comm İngiltere - SWS',
            'Stronsay  İngiltere - SOY',
            'Southampton Eastleigh İngiltere - SOU',
            'Scampton Raf Station İngiltere - SQZ',
            'Isle Of Skye Broadford İngiltere - SKL',
            'Unst Shetland Is Baltasound İngiltere - UNT',
            'Upavon  İngiltere - UPV',
            'Upper Heyford Raf Station İngiltere - UHF',
            'Mull  İngiltere - ULL',
            'Tiree  İngiltere - TRE',
            'Papa Westray  İngiltere - PPW',
            'Plymouth  İngiltere - PLH',
            'Portsmouth  İngiltere - PME',
            'Perth  İngiltere - PSL',
            'Papa Stour  İngiltere - PSV',
            'Oxford London Oxford İngiltere - OXF',
            'Outer Skerries  İngiltere - OUK',
            'Shetland Islands Scatsta İngiltere - SCS',
            'Shetland Islands Sumburgh İngiltere - LSI',
            'Shetland Islands Lerwick İngiltere - LWK',
            'Southend Southend Mnpl İngiltere - SEN',
            'Penzance  İngiltere - PZE',
            'Rochester  İngiltere - RCS',
            'Manston Kent Intl Kent Intl İngiltere - MSE',
            'Durham Tees Valley  İngiltere - MME',
            'Mildenhall Naf İngiltere - GXH',
            'Mildenhall  İngiltere - MHZ',
            'Oakham Cottesmor Raf İngiltere - OKH',
            'Northampton  İngiltere - ORM',
            'Norwich  İngiltere - NWI',
            'Oban Connel İngiltere - OBN',
            'Odiham Raf Station İngiltere - ODH',
            'Newquay Saint Mawgan İngiltere - NQY',
            'North Ronaldsay  İngiltere - NRL',
            'Nottingham  İngiltere - NQT',
            'East Midlands Havaalanı İngiltere - EMA',
            'Newcastle  İngiltere - NCL',
            'Sanday  İngiltere - NDY',
            'Northolt  İngiltere - NHT',
            'Grenada Maurice Bishop Intl Grenada - GND',
            'Carriacou Is  Grenada - CRU',
            'Batumi  Georgia - BUS',
            'Kutaisi Kopitnari Georgia - KUT',
            'Sokhumi Dranda Georgia - SUI',
            'Tbilisi International Georgia - TBS',
            'Saul  French Guiana - XAU',
            'Maripasoula  French Guiana - MPY',
            'Regina  French Guiana - REI',
            'Saint Georges De Loy  French Guiana - OYP',
            'Saint Laurent Du Maroni  French Guiana - LDX',
            'Cayenne Rochambeau French Guiana - CAY',
            'Accra Kotoka Ghana - ACC',
            'Kumasi  Ghana - KMS',
            'Sunyani  Ghana - NYI',
            'Tamale  Ghana - TML',
            'Takoradi  Ghana - TKD',
            'Cebelitarık - GIB',
            'Nuuk  Greenland - GOH',
            'Paamiut  Greenland - JFR',
            'Qeqertarsuaq  Greenland - JGO',
            'Aasiaat  Greenland - JEG',
            'Ilulissat  Greenland - JAV',
            'Qasigiannguit  Greenland - JCH',
            'Kulusuk  Greenland - KUS',
            'Sisimiut  Greenland - JHS',
            'Nanortalik  Greenland - JNN',
            'Arsuk  Greenland - JRK',
            'Qaarsut  Greenland - JQA',
            'Alluitsup Paa  Greenland - LLU',
            'Tasiilaq  Greenland - AGM',
            'Neerlerit Inaat  Greenland - CNP',
            'Dundas  Greenland - DUN',
            'Thule  Greenland - THU',
            'Uummannaq  Greenland - UMD',
            'Narsarsuaq  Greenland - UAK',
            'Oqatsut Harbour  Greenland - XEO',
            'Tasiuasaq Harbour  Greenland - XEQ',
            'Ilimanaq Harbour  Greenland - XIQ',
            'Ittoqqortoormiit  Greenland - OBY',
            'Qaanaaq  Greenland - NAQ',
            'Qeqertarsuatsiaat  Greenland - QEY',
            'Alluitsup  Greenland - QFJ',
            'Narsaq Kujalleq  Greenland - QFN',
            'Qassimiut  Greenland - QJH',
            'Kangaamiut  Greenland - QKT',
            'Saarloq  Greenland - QOQ',
            'Qullissat  Greenland - QUE',
            'Aappilattoq  Greenland - QUV',
            'Kangerlussuaq  Greenland - SFJ',
            'Banjul Yundum Intl Gambia - BJL',
            'Boke  Guinea - BKJ',
            'Fria  Guinea - FIG',
            'Faranah  Guinea - FAA',
            'Conakry  Guinea - CKY',
            'Labe  Guinea - LEK',
            'Macenta  Guinea - MCA',
            'Kissidougou  Guinea - KSI',
            'Kankan  Guinea - KNN',
            'Siguiri  Guinea - GII',
            'Koundara Sambailo Guinea - SBI',
            'Nzerekore  Guinea - NZE',
            'Saint Barthelemy  Guadeloupe - SBH',
            'Saint Martin Grand Case Guadeloupe - CCE',
            'Saint Martin Esperance Guadeloupe - SFG',
            'Saint Martin Marigot Spb Guadeloupe - MSB',
            'Saint Francois  Guadeloupe - SFC',
            'Pointe A Pitre Pole Caraibes Guadeloupe - PTP',
            'Marie Galante Les Bases Guadeloupe - GBJ',
            'Terre De Bas  Guadeloupe - HTB',
            'Terre De Haut  Guadeloupe - LSS',
            'La Desirade  Guadeloupe - DSD',
            'Basse Terre Baillif Guadeloupe - BBR',
            'Bata  Equatorial Guinea - BSG',
            'Malabo Santa Isabel Equatorial Guinea - SSG',
            'Sparta  Greece - SPJ',
            'Thessaloniki Makedonia Apt Greece - SKG',
            'Skyros  Greece - SKU',
            'Samos Aristarchos Of Samos Greece - SMI',
            'Volos Nea Anchialos Greece - VOL',
            'Zakinthos Island Dionisios Salomos Greece - ZTH',
            'Preveza Lefkada Aktion Greece - PVK',
            'Pyrgos Andravida Ab Greece - PYR',
            'Portochelion Kanaris Greece - PKH',
            'Paros  Greece - PAS',
            'Rodos Diagoras Airport Greece - RHO',
            'Milos  Greece - MLO',
            'Mytilini Odysseas Elytis Greece - MJT',
            'Agrinion G.Karaiskakis Greece - AGQ',
            'Alexandroupolis Dimokritos Greece - AXD',
            'Karpathos  Greece - AOK',
            'Athens Hellinikon Greece - HEW',
            'Atina - ATH',
            'Drama  Greece - DRM',
            'Kefallinia Airport Greece - EFL',
            'Chania I Daskalogiannis Greece - CHQ',
            'Korfu - CFU',
            'Leros  Greece - LRS',
            'Larisa Thessalia Greece - LRA',
            'Limnos  Greece - LXS',
            'Kozani Filippos Airport Greece - KZI',
            'Kastelorizo Megisti Greece - KZS',
            'Kalamata  Greece - KLX',
            'Kithira  Greece - KIT',
            'Kasos Island  Greece - KSJ',
            'Kastoria Aristotelis Apt Greece - KSO',
            'Kavala Megas Alexandros Apt Greece - KVA',
            'Naxos Apt Greece - JNX',
            'Mykonos  Greece - JMK',
            'Ikaria Island Ikaria Greece - JIK',
            'Chios Omiros Greece - JKH',
            'Kalymnos Island Kalymnos Greece - JKL',
            'Syros Island Dimitrios Vikelas Greece - JSY',
            'Siteia  Greece - JSH',
            'Skiathos Alex Papadiamantis Greece - JSI',
            'Thira Santorini Greece - JTR',
            'Astypalea Island  Greece - JTY',
            'Spetsai Island  Greece - JSS',
            'Kos Ippokratis Greece - KGS',
            'Heraklion Nikos Kazantzakis Greece - HER',
            'Ioannina King Pyrros Greece - IOA',
            'Patrai Araxos Airport Greece - GPA',
            'Guatemala City La Aurora Guatemala - GUA',
            'Flores Santa Elena Guatemala - FRS',
            'Huehuetenango  Guatemala - HUG',
            'Rio Dulce Las Vegas Airport Guatemala - LCF',
            'Los Tablones  Guatemala - LOX',
            'Coban  Guatemala - CBV',
            'Chiquimula  Guatemala - CIQ',
            'Carmelita  Guatemala - CMM',
            'Coatepeque  Guatemala - CTF',
            'El Naranjo  Guatemala - ENJ',
            'Dos Lagunas  Guatemala - DON',
            'Quiche  Guatemala - AQB',
            'Quetzaltenango  Guatemala - AAZ',
            'Melchor De Menco  Guatemala - MCR',
            'Retalhuleu Base Aerea Del Sur Apt Guatemala - RER',
            'Rubelsanto  Guatemala - RUV',
            'Puerto Barrios  Guatemala - PBR',
            'Paso Caballos  Guatemala - PCG',
            'Playa Grande Playa Grand Airport Guatemala - PKJ',
            'Poptun  Guatemala - PON',
            'Uaxactun  Guatemala - UAX',
            'Tikal El Peten Guatemala - TKM',
            'Guam A.B Won Pat Intl Guam - GUM',
            'Guam Agana Nas Guam - NGM',
            'Guam Anderson Afb Guam - UAM',
            'Guam Uscg Shore Station Guam - NRV',
            'Bubaque  Guinea Bissau - BQE',
            'Bissau O Vieira Guinea Bissau - OXB',
            'Pipillipai  Guyana - PIQ',
            'Port Kaituma  Guyana - PKM',
            'Paramakotoi  Guyana - PMT',
            'Paruima  Guyana - PRR',
            'Sandcreek  Guyana - SDC',
            'Mahdia  Guyana - MHA',
            'Monkey Mountain  Guyana - MYM',
            'Matthews Ridge  Guyana - MWJ',
            'Ogle  Guyana - OGL',
            'Orinduik  Guyana - ORJ',
            'Annai  Guyana - NAI',
            'Mabaruma  Guyana - USI',
            'Skeldon  Guyana - SKM',
            'Maikwak  Guyana - VEG',
            'Bemichi  Guyana - BCG',
            'Baramita  Guyana - BMJ',
            'Aishalton  Guyana - AHL',
            'Ekereku  Guyana - EKE',
            'Bartica  Guyana - GFO',
            'Georgetown Cheddi Jagan Int Guyana - GEO',
            'Imbaimadai  Guyana - IMB',
            'Lethem  Guyana - LTM',
            'Lumid Pau  Guyana - LUB',
            'Kamarang  Guyana - KAR',
            'Kaieteur  Guyana - KAI',
            'Kato  Guyana - KTO',
            'Karanambo  Guyana - KRM',
            'Karasabai  Guyana - KRG',
            'Kurupung  Guyana - KPG',
            'Konawaruk  Guyana - KKG',
            'Kwun Tong China Çin - KTZ',
            'Hong Kong Hong Kong Intl China Çin - HKG',
            'Shek Mum  Hong Kong China Çin - QDM',
            'Santa Rosa Copan  Honduras - SDH',
            'Sulaco  Honduras - SCD',
            'San Esteban  Honduras - SET',
            'Copan  Honduras - RUY',
            'Roatan  Honduras - RTB',
            'San Pedro Sula Ramon V Morales Honduras - SAP',
            'Puerto Lempira  Honduras - PEU',
            'Palacios  Honduras - PCH',
            'Yoro  Honduras - ORO',
            'Olanchito  Honduras - OAN',
            'Marcala  Honduras - MRJ',
            'Victoria  Honduras - VTA',
            'Comayagua Palmerola Base Honduras - XPL',
            'Tocoa  Honduras - TCF',
            'Tela  Honduras - TEA',
            'Utila  Honduras - UII',
            'Trujillo Capiro Honduras - TJI',
            'Tegucigalpa Toncontin Honduras - TGU',
            'Iriona  Honduras - IRN',
            'Gracias  Honduras - GAC',
            'Gualaco  Honduras - GUO',
            'Guanaja  Honduras - GJA',
            'Juticalpa  Honduras - JUT',
            'La Union  Honduras - LUI',
            'La Ceiba Goloson Intl Honduras - LCE',
            'La Esperanza  Honduras - LEZ',
            'Limon  Honduras - LMH',
            'Las Limas  Honduras - LLH',
            'Erandique  Honduras - EDQ',
            'Coronel E Soto A  Honduras - ENQ',
            'Coyoles  Honduras - CYL',
            'Cauquira Cauquira Airport Honduras - CDD',
            'Ahuas  Honduras - AHS',
            'Brus Laguna  Honduras - BHG',
            'Catacamas  Honduras - CAA',
            'Brac Bol Croatia - BWK',
            'Dubrovnik  Croatia - DBV',
            'Mali Losinj  Croatia - LSZ',
            'Split  Croatia - SPU',
            'Zadar  Croatia - ZAD',
            'Zagreb Pleso Croatia - ZAG',
            'Osijek  Croatia - OSI',
            'Pula  Croatia - PUY',
            'Rijeka  Croatia - RJK',
            'Port Au Prince Toussaint Louverture Haiti - PAP',
            'Port De Paix  Haiti - PAX',
            'Jeremie  Haiti - JEE',
            'Jacmel  Haiti - JAK',
            'Les Cayes  Haiti - CYA',
            'Cap Haitien  Haiti - CAP',
            'Debrecen  Hungary - DEB',
            'Budapeşte - BUD',
            'Miskolc  Hungary - MCQ',
            'Pecs Pogany Hungary - PEV',
            'Balaton Sarmellek Hungary - SOB',
            'Solo City Adi Sumarmo Indonesia - SOC',
            'Sorong Jefman Indonesia - SOQ',
            'Sintang  Indonesia - SQG',
            'Sanana  Indonesia - SQN',
            'Soroako  Indonesia - SQR',
            'Samarinda  Indonesia - SRI',
            'Semarang Achmad Uani Indonesia - SRG',
            'Sampit  Indonesia - SMQ',
            'Sibisa  Indonesia - SIW',
            'Singkep Dabo Indonesia - SIQ',
            'Senipah  Indonesia - SZH',
            'Tumbang Samba  Indonesia - TBM',
            'Taliabu  Indonesia - TAX',
            'Surabaya Juanda Indonesia - SUB',
            'Sumenep Trunojoyo Indonesia - SUP',
            'Sumbawa Brang Bidji Indonesia - SWQ',
            'Saumlaki  Indonesia - SXK',
            'Tembagapura Timika Indonesia - TIM',
            'Tanjung Warukin  Indonesia - TJG',
            'Tanjung Pendan Bulutumbang Indonesia - TJQ',
            'Tanjung Selor  Indonesia - TJS',
            'Tanjung Balai  Indonesia - TJB',
            'Bandar Lampung Branti Indonesia - TKG',
            'Tolitoli  Indonesia - TLI',
            'Tambolaka  Indonesia - TMC',
            'Tanahmerah  Indonesia - TMH',
            'Tiom  Indonesia - TMY',
            'Tanah Grogot  Indonesia - TNB',
            'Tanjung Pinang Kidjang Indonesia - TNJ',
            'Tapaktuan  Indonesia - TPK',
            'Tarakan  Indonesia - TRK',
            'Tanjung Santan  Indonesia - TSX',
            'Tasikmalaya  Indonesia - TSY',
            'Zugapa Indonesia  Indonesia - UGU',
            'Buol  Indonesia - UOL',
            'Ujung Pandang Hasanudin Indonesia - UPG',
            'Ubrub  Indonesia - UBR',
            'Tana Toraja  Indonesia - TTR',
            'Ternate Babullah Indonesia - TTE',
            'Teminabuan  Indonesia - TXM',
            'Serui  Indonesia - ZRI',
            'Sarmi  Indonesia - ZRM',
            'Steenkool  Indonesia - ZKL',
            'Senggo  Indonesia - ZEG',
            'Wasior  Indonesia - WSR',
            'Wamena  Indonesia - WMX',
            'Waris  Indonesia - WAR',
            'Wagethe  Indonesia - WET',
            'Waingapu  Indonesia - WGP',
            'Wahai Maluku  Indonesia - WBA',
            'Pangkalpinang  Indonesia - PGK',
            'Padang Tabing Indonesia - PDG',
            'Pendopo  Indonesia - PDO',
            'Pondok Cabe  Indonesia - PCB',
            'Palibelo  Indonesia - PBW',
            'Morotai Island  Indonesia - OTI',
            'Pomala  Indonesia - PUM',
            'Purwokerto  Indonesia - PWL',
            'Putussibau  Indonesia - PSU',
            'Poso  Indonesia - PSJ',
            'Palu Mutiara Indonesia - PLW',
            'Pangkalanbuun  Indonesia - PKN',
            'Palangkaraya  Indonesia - PKY',
            'Pekanbaru Simpang Tiga Indonesia - PKU',
            'Palembang M Badaruddin Li Indonesia - PLM',
            'Pasir Pangarayan  Indonesia - PPR',
            'Pulau Panjang  Indonesia - PPJ',
            'Pontianak Supadio Indonesia - PNK',
            'Rokot  Indonesia - RKI',
            'Sipora  Indonesia - RKO',
            'Rengat Japura Indonesia - RGT',
            'Merdey  Indonesia - RDE',
            'Raha Sugimanuru Indonesia - RAQ',
            'Sawu  Indonesia - SAU',
            'Sabang  Indonesia - SBG',
            'Sangir  Indonesia - SAE',
            'Ruteng  Indonesia - RTG',
            'Roti  Indonesia - RTI',
            'Yuruf  Indonesia - RUF',
            'Ransiki  Indonesia - RSK',
            'Sungai Pakning  Indonesia - SEQ',
            'Senggeh  Indonesia - SEH',
            'Sanggata  Indonesia - SGQ',
            'Moanamani  Indonesia - ONI',
            'Oksibil  Indonesia - OKL',
            'Okaba  Indonesia - OKQ',
            'Obano  Indonesia - OBD',
            'Natuna Ranai  Indonesia - NTX',
            'Namlea  Indonesia - NAM',
            'Nabire  Indonesia - NBX',
            'Banaina  Indonesia - NAF',
            'Naha  Indonesia - NAH',
            'Bandanaira  Indonesia - NDA',
            'Nangapinoh  Indonesia - NPO',
            'Nunukan  Indonesia - NNX',
            'Namrole  Indonesia - NRE',
            'Bintuni  Indonesia - NTI',
            'Sinak  Indonesia - NKD',
            'Masalembo  Indonesia - MSI',
            'Muko Muko  Indonesia - MPC',
            'Maumere Waioti Indonesia - MOF',
            'Matak  Indonesia - MWK',
            'Masamba  Indonesia - MXB',
            'Muting  Indonesia - MUF',
            'Manado Samratulangi Indonesia - MDC',
            'Mindiptana  Indonesia - MDP',
            'Meulaboh Seunagan Indonesia - MEQ',
            'Medan Polania Indonesia - MES',
            'Mamuju  Indonesia - MJU',
            'Mangunjaya  Indonesia - MJY',
            'Manokwari Rendani Indonesia - MKW',
            'Merauke Mopah Indonesia - MKQ',
            'Malang  Indonesia - MLG',
            'Melangguane  Indonesia - MNA',
            'Mangole  Indonesia - MAL',
            'Langgur  Indonesia - LUV',
            'Luwuk  Indonesia - LUW',
            'Lewoleba  Indonesia - LWE',
            'Lunyuk  Indonesia - LYK',
            'Lhoksumawe  Indonesia - LSW',
            'Lhok Sukon  Indonesia - LSX',
            'Long Apung  Indonesia - LPU',
            'Kelila  Indonesia - LLN',
            'Mulia  Indonesia - LII',
            'Larantuka  Indonesia - LKA',
            'Lereh  Indonesia - LHI',
            'Labuan Bajo Mutiara Indonesia - LBJ',
            'Long Bawan  Indonesia - LBW',
            'Labuha  Indonesia - LAH',
            'Kau  Indonesia - KAZ',
            'Karubaga  Indonesia - KBF',
            'Jakarta Soekarno Hatta Intl Indonesia - CGK',
            'Jakarta Halim Perdana Indonesia - HLP',
            'Yogyakarta Adisutjipto Indonesia - JOG',
            'Kebar  Indonesia - KEQ',
            'Kendari Wolter Monginsidi Indonesia - KDI',
            'Keisah  Indonesia - KEA',
            'Kepi  Indonesia - KEI',
            'Kotabaru  Indonesia - KBU',
            'Kambuaya  Indonesia - KBX',
            'Kamur  Indonesia - KCD',
            'Kon  Indonesia - KCI',
            'Ketapang  Indonesia - KTG',
            'Karimunjawa  Indonesia - KWB',
            'Kerinci  Indonesia - KRC',
            'Keluang  Indonesia - KLQ',
            'Kaimana  Indonesia - KNG',
            'Kimam  Indonesia - KMM',
            'Kotabangun  Indonesia - KOD',
            'Kupang Eltari Indonesia - KOE',
            'Kokonao  Indonesia - KOX',
            'Ilu  Indonesia - IUL',
            'Illaga  Indonesia - ILA',
            'Inanwatan  Indonesia - INX',
            'Gunungsitoli  Indonesia - GNS',
            'Galela  Indonesia - GLX',
            'Gorontalo Tolotio Indonesia - GTO',
            'Gag Island  Indonesia - GAV',
            'Gebe  Indonesia - GEB',
            'Fak Fak  Indonesia - FKQ',
            'Numfoor  Indonesia - FOO',
            'Batu Licin  Indonesia - BTW',
            'Batu Besar Hang Nadim Indonesia - BTH',
            'Banda Aceh Blang Bintang Indonesia - BTJ',
            'Balikpapan Sepingan Indonesia - BPN',
            'Babo  Indonesia - BXB',
            'Bade  Indonesia - BXD',
            'Bokondini  Indonesia - BUI',
            'Baubau  Indonesia - BUW',
            'Bunyu  Indonesia - BYQ',
            'Batom  Indonesia - BXM',
            'Bontang  Indonesia - BXT',
            'Berau  Indonesia - BEJ',
            'Banjarmasin Sjamsudin Noor Indonesia - BDJ',
            'Bandung Husein Sastranegara Indonesia - BDO',
            'Bima  Indonesia - BMU',
            'Bengkulu Padangkemiling Indonesia - BKS',
            'Bajawa  Indonesia - BJW',
            'Benjina  Indonesia - BJK',
            'Bolaang  Indonesia - BJG',
            'Biak Mokmer Indonesia - BIK',
            'Amahai  Indonesia - AHI',
            'Mataram Selaparang Indonesia - AMI',
            'Ambon Pattimura Indonesia - AMQ',
            'Astraksetra Gunung Batin Indonesia - AKQ',
            'Apalapsili  Indonesia - AAS',
            'Atambua  Indonesia - ABU',
            'Anggi  Indonesia - AGD',
            'Aek Godang  Indonesia - AEG',
            'Alor Island  Indonesia - ARD',
            'Arso  Indonesia - ARJ',
            'Atauro  Indonesia - AUT',
            'Ayawasi  Indonesia - AYW',
            'Dobo  Indonesia - DOB',
            'Jambi Sultan Taha Syarifudn Indonesia - DJB',
            'Jayapura Sentani Indonesia - DJJ',
            'Denpasar Bali Ngurah Rai Indonesia - DPS',
            'Dabra  Indonesia - DRH',
            'Datadawai  Indonesia - DTD',
            'Dumai Pinang Kampai Indonesia - DUM',
            'Ende  Indonesia - ENE',
            'Elelim  Indonesia - ELR',
            'Ewer  Indonesia - EWE',
            'Enarotali  Indonesia - EWI',
            'Cirebon Penggung Indonesia - CBN',
            'Cilacap Tunggul Wulung Indonesia - CXP',
            'Cepu  Indonesia - CPF',
            'Donegal  Ireland - CFN',
            'Castlebar  Ireland - CLB',
            'Caherciveen Reenroe Ireland - CHE',
            'Dublin Dublin International Ireland - DUB',
            'Belmullet  Ireland - BLY',
            'Bantry  Ireland - BYT',
            'Galway  Ireland - GWY',
            'Inishmore Kilronan Ireland - IOR',
            'Inisheer  Ireland - INQ',
            'Inishmaan  Ireland - IIA',
            'Kilkenny  Ireland - KKY',
            'Kerry County  Ireland - KIR',
            'Letterkenny  Ireland - LTR',
            'Spiddal Connemara Ireland - NNR',
            'Knock Ireland West Ireland - NOC',
            'Cork Cork International Ireland - ORK',
            'Waterford  Ireland - WAT',
            'Wexford Castlebridge Ireland - WEX',
            'Sligo  Ireland - SXL',
            'Shannon  Ireland - SNN',
            'Tel Aviv Yafo Sde Dov Israel - SDV',
            'Tel Aviv Yafo Ben Gurion Intl Israel - TLV',
            'Yotvata  Israel - YOT',
            'Mitspeh Ramon  Israel - MIP',
            'Masada  Israel - MTZ',
            'Sedom Min hat Hashnayim Israel - SED',
            'Rosh Pina  Israel - RPN',
            'Kiryat Shmona  Israel - KSW',
            'Jerusalem  Israel - JRS',
            'Haifa Bölgesi Israel - HFA',
            'Gush Katif  Israel - GHK',
            'Beer Sheba  Israel - BEV',
            'Elat Ovda Israel - VDA',
            'Elat  Israel - ETH',
            'Ein Yahav  Israel - EIY',
            'Diu  India - DIU',
            'Dimapur  India - DMU',
            'Dehra Dun Jolly Grant Airport India - DED',
            'Deparizo  India - DEP',
            'Dibrugarh Chabua India - DIB',
            'Dharamsala Gaggal Airport India - DHM',
            'Delhi Indira Gandhi Intl India - DEL',
            'Coimbatore Peelamedu India - CJB',
            'Cuddapah  India - CDP',
            'Car Nicobar  India - CBD',
            'Kozhikode  India - CCJ',
            'Kalküta - CCU',
            'Cooch Behar  India - COH',
            'Kochi  India - COK',
            'Dhanbad  India - DBD',
            'Darjeeling  India - DAI',
            'Daparizo  India - DAE',
            'Bhuj Rudra Mata India - BHJ',
            'Bhavnagar  India - BHU',
            'Bhopal Raja Bhoj India - BHO',
            'Vadodara  India - BDQ',
            'Bareli  India - BEK',
            'Bellary  India - BEP',
            'Bengaluru Bengaluru Intl India - BLR',
            'Bikaner  India - BKB',
            'Bhatinda  India - BUP',
            'Hyderabad Begumpet India - BPM',
            'Mumbai Chhatrapati Shivaji India - BOM',
            'Bhubaneswar Biju Patnaik Airport India - BBI',
            'Amritsar Raja Sansi India - ATQ',
            'Agra Kheria India - AGR',
            'Ahmedabad  India - AMD',
            'Agatti Island  India - AGX',
            'Akola  India - AKD',
            'Aizawl  India - AJL',
            'Gaya  India - GAY',
            'Guwahati Borjhar India - GAU',
            'Gwalior  India - GWL',
            'Guna  India - GUX',
            'Hubli  India - HBX',
            'Goa Dabolim India - GOI',
            'Gorakhpur  India - GOP',
            'Khajuraho  India - HJR',
            'Hissar  India - HSS',
            'Shamshabad Rajiv Gandhi Intl India - HYD',
            'Indore Devi Ahilya Bai Holkar India - IDR',
            'Imphal Imphal Mnpl India - IMF',
            'Nasik Gandhinagar Apt India - ISK',
            'Agartala Singerbhil India - IXA',
            'Bagdogra  India - IXB',
            'Chandigarh  India - IXC',
            'Allahabad Bamrauli India - IXD',
            'Mangalore Bajpe India - IXE',
            'Belgaum Sambre India - IXG',
            'Kailashahar  India - IXH',
            'Lilabari  India - IXI',
            'Jammu Satwari India - IXJ',
            'Keshod  India - IXK',
            'Leh  India - IXL',
            'Madurai  India - IXM',
            'Khowai  India - IXN',
            'Pathankot  India - IXP',
            'Kamalpur  India - IXQ',
            'Ranchi Birsa Munda India - IXR',
            'Silchar Kumbhirgram India - IXS',
            'Pasighat  India - IXT',
            'Aurangabad Chikkalthana India - IXU',
            'Along  India - IXV',
            'Jamshedpur Sonari India - IXW',
            'Kandla  India - IXY',
            'Port Blair Veer Savarkar India - IXZ',
            'Jamnagar Govardhanpur India - JGA',
            'Jagdalpur  India - JGB',
            'Jodhpur  India - JDH',
            'Jaisalmer  India - JSA',
            'Jorhat Rowriah India - JRH',
            'Jabalpur  India - JLR',
            'Jaipur Sanganeer India - JAI',
            'Kulu Bhuntar India - KUU',
            'Kota  India - KTU',
            'Kolhapur  India - KLH',
            'Kanpur  India - KNU',
            'Latur  India - LTU',
            'Ludhiana  India - LUH',
            'Chennai  India - MAA',
            'Malda  India - LDA',
            'Lucknow Amausi India - LKO',
            'Raipur  India - RPR',
            'Rourkela  India - RRK',
            'Ramagundam  India - RMD',
            'Balurghat  India - RGH',
            'Rajouri  India - RJI',
            'Rajahmundry  India - RJA',
            'Rewa  India - REW',
            'Rajkot Civil India - RAJ',
            'Shillong  India - SHL',
            'Ratnagiri  India - RTC',
            'Rupsi  India - RUP',
            'Pune Lohegaon India - PNQ',
            'Pondicherry  India - PNY',
            'Jeypore  India - PYB',
            'Puttaparthi Puttaprathe India - PUT',
            'Bilaspur  India - PAB',
            'Porbandar  India - PBD',
            'Patna Jai Prakash Narayan India - PAT',
            'Pantnagar  India - PGH',
            'Mysore  India - MYQ',
            'Mohanbari  India - MOH',
            'Osmanabad  India - OMN',
            'Neyveli  India - NVY',
            'Daman  India - NMB',
            'Nanded  India - NDC',
            'Nagpur Dr.Ambedkar Intl India - NAG',
            'Muzaffarpur  India - MZU',
            'Muzaffarnagar  India - MZA',
            'Zero  India - ZER',
            'Warangal  India - WGC',
            'Nilgris India  India - VWY',
            'Vishakhapatnam  India - VTZ',
            'Vijayawada  India - VGA',
            'Vidyanagar Jindal Vidyanagar India - VDY',
            'Varanasi Lal Bahadur Shastri India - VNS',
            'Thanjavur  India - TJV',
            'Tirupati  India - TIR',
            'Tiruchirapally Civil India - TRZ',
            'Thiruvananthapuram  India - TRV',
            'Satna  India - TNI',
            'Udaipur Maharana Pratap India - UDR',
            'Sholapur  India - SSE',
            'Simla  India - SLV',
            'Salem  India - SXV',
            'Srinagar  India - SXR',
            'Surat  India - STV',
            'Tezpur Salonibari India - TEZ',
            'Tezu  India - TEI',
            'Tuticorin  India - TCR',
            'Al Fallujah Al Taqaddum Ab Iraq - TQD',
            'Najaf Najaf Intl Iraq - NJF',
            'Mosul  Iraq - OSM',
            'Qayyarah West Iraq - RQW',
            'Kirkuk  Iraq - KIK',
            'Sulaymaniyah International Iraq - ISU',
            'Al Asad Al Asad Ab Iraq - IQA',
            'Basra Basra Intl Iraq - BSR',
            'Bamerny  Iraq - BMN',
            'Baghdad Baghdad Intl Iraq - BGW',
            'Baghdad Baghdad Intl Iraq - SDA',
            'Erbil International Iraq - EBL',
            'Dezful  Iran - DEF',
            'Fasa Fasa Airport Iran - FAZ',
            'Shahre-Kord  Iran - CQD',
            'Sarakhs  Iran - CKT',
            'Bandar Lengeh  Iran - BDH',
            'Bandar Abbas  Iran - BND',
            'Bojnord  Iran - BJB',
            'Bishe-Kola  Iran - BSM',
            'Bushehr  Iran - BUZ',
            'Bam  Iran - BXR',
            'Araak  Iran - AJK',
            'Aghajari  Iran - AKW',
            'Sabzevar  Iran - AFZ',
            'Abu Musa Abu Musa Airport Iran - AEU',
            'Ardabil  Iran - ADU',
            'Zabol Zabol Airport Iran - ACZ',
            'Sahand Sahand Airport Iran - ACP',
            'Abadan  Iran - ABD',
            'Babolsar  Iran - BBL',
            'Yazd  Iran - AZD',
            'Ahwaz  Iran - AWZ',
            'Hesa  Iran - IFH',
            'Isfahan  Iran - IFN',
            'Iran Shahr Iran Shahr Airport Iran - IHR',
            'Ilaam Ilaam Airport Iran - IIL',
            'Jahrom Jahrom Airport Iran - JAR',
            'Bahregan  Iran - IAQ',
            'Havadarya  Iran - HDR',
            'Gheshm  Iran - GSM',
            'Hamadan  Iran - HDM',
            'Ghazvin  Iran - GZW',
            'Gorgan Gorgan Airport Iran - GBT',
            'Gachsaran  Iran - GCH',
            'Kalaleh  Iran - KLM',
            'Kangan Jam Iran - KNR',
            'Kermanshah  Iran - KSH',
            'Jiroft  Iran - JYR',
            'Zanjan  Iran - JWN',
            'Kerman  Iran - KER',
            'Khark Island  Iran - KHK',
            'Khorramabad  Iran - KHD',
            'Khaneh  Iran - KHA',
            'Kish Island  Iran - KIH',
            'Khoy  Iran - KHY',
            'Lamerd Lamerd Airport Iran - LFM',
            'Lavan  Iran - LVP',
            'Lar  Iran - LRR',
            'Rafsanjan  Iran - RJN',
            'Rasht  Iran - RAS',
            'Shahrood  Iran - RUD',
            'Ramsar  Iran - RZR',
            'Sanandaj  Iran - SDG',
            'Parsabad Parsabad Airport Iran - PFQ',
            'Karaj Payam Intl Iran - PYK',
            'Urmieh  Iran - OMH',
            'Omidieh  Iran - OMI',
            'Nojeh  Iran - NUJ',
            'Now Shahr  Iran - NSH',
            'Bandar Mahshahr  Iran - MRX',
            'Mashad  Iran - MHD',
            'Tehran Imam Khomeini Intl Iran - IKA',
            'Tehran Mehrabad Intl Iran - THR',
            'Tabas  Iran - TCX',
            'Tabriz  Iran - TBZ',
            'Tohid Tohid Airport Iran - TEW',
            'Shiraz  Iran - SYZ',
            'Sirri Island  Iran - SXI',
            'Sirjan  Iran - SYJ',
            'Sary Dashte Naz Iran - SRY',
            'Birjand  Iran - XBJ',
            'Chah Bahar  Iran - ZBR',
            'Zahedan  Iran - ZAH',
            'Asaloyeh Persian Gulf Intl Iran - PGU',
            'Asaloyeh  Iran - YEH',
            'Yasouj  Iran - YES',
            'Vopnafjordur  Iceland - VPN',
            'Vestmannaeyjar  Iceland - VEY',
            'Siglufjordur  Iceland - SIJ',
            'Stykkisholmur  Iceland - SYK',
            'Sudureyri  Iceland - SUY',
            'Thingeyri Selardalur Iceland - TEY',
            'Thorshofn  Iceland - THO',
            'Talknafjordur  Iceland - TLK',
            'Myvatn Reykjahlid Iceland - MVA',
            'Nordfjordur  Iceland - NOR',
            'Olafsfjordur  Iceland - OFJ',
            'Olafsvik Rif Iceland - OLI',
            'Kopasker  Iceland - OPA',
            'Patreksfjordur  Iceland - PFJ',
            'Seydisfjordur  Iceland - SEJ',
            'Saudarkrokur  Iceland - SAK',
            'Reykjavik Reykjavik Dom Iceland - RKV',
            'Reykjavik Keflavik Intl Iceland - KEF',
            'Reykholar  Iceland - RHA',
            'Raufarhofn  Iceland - RFN',
            'Flateyri Holt Iceland - FLI',
            'Grundarfjordur  Iceland - GUU',
            'Grimsey  Iceland - GRY',
            'Gjogur  Iceland - GJR',
            'Hornafjordur Hofn Iceland - HFN',
            'Husavik  Iceland - HZK',
            'Holmavik  Iceland - HVK',
            'Hvammstangi  Iceland - HVM',
            'Isafjordur  Iceland - IFJ',
            'Akureyri  Iceland - AEY',
            'Breiddalsvik  Iceland - BXV',
            'Bakkafjordur  Iceland - BJD',
            'Bildudalur  Iceland - BIU',
            'Blonduos  Iceland - BLO',
            'Borgarfjordur Eystri  Iceland - BGJ',
            'Fagurholsmyri  Iceland - FAG',
            'Faskrudsfjordur  Iceland - FAS',
            'Egilsstadir  Iceland - EGS',
            'Djupivogur  Iceland - DJU',
            'Elba Island Marina Di Campo Italy - EBA',
            'Comiso Vincenzo Magliocco Italy - CIY',
            'Cortina D ampezzo Fiames Italy - CDF',
            'Crotone  Italy - CRV',
            'Catania Fontanarossa Italy - CTA',
            'Catania Sigonella Nas Italy - NSY',
            'Decimomannu Air Base Italy - DCI',
            'Cuneo Levaldigi Italy - CUF',
            'Brindisi Casale Italy - BDS',
            'Bologna Guglielmo Marconi Italy - BLQ',
            'Belluno  Italy - BLX',
            'Bolzano Bozen Dolomiti Italy - BZO',
            'Cagliari Elmas Italy - CAG',
            'Bari Palese Italy - BRI',
            'Albenga  Italy - ALL',
            'Alghero Fertilia Italy - AHO',
            'Aviano Air Base Italy - AVB',
            'Aosta Corrado Gex Airport Italy - AOT',
            'Ancona Falconara Italy - AOI',
            'Ischia Harbour Italy - ISH',
            'Genoa Cristoforo Colombo Italy - GOA',
            'Grosseto Corrado Baccarini Italy - GRS',
            'Floransa Peretola Italy - FLR',
            'Oristano Fenosu Italy - FNU',
            'Forli Luigi Ridolfi Italy - FRL',
            'Foggia Gino Lisa Italy - FOG',
            'San Giovanni Rotondo  Italy - GBN',
            'Lampedusa  Italy - LMP',
            'Lucca Tassignano Italy - LCV',
            'Lecce Galatina Italy - LCC',
            'Jesolo  Italy - JLO',
            'Sorrento Harbour Italy - RRO',
            'Roma Ciampino Italy - CIA',
            'Roma Fiumicino Italy - FCO',
            'Rimini Miramare Italy - RMI',
            'Reggio Di Calabria  Italy - REG',
            'Ravenna  Italy - RAN',
            'Salerno Pontecagnano Italy - QSR',
            'Marina Di Massa  Italy - QMM',
            'Siena Ampugnano Italy - SAY',
            'Perugia Sant Egidio Italy - PEG',
            'Peschiei  Italy - PEJ',
            'Pescara Abruzzo Italy - PSR',
            'Pisa Galileo Galilei Italy - PSA',
            'Capri Harbour Italy - PRJ',
            'Pantelleria  Italy - PNL',
            'Palermo Punta Raisi Italy - PMO',
            'Olbia Costa Smeralda Italy - OLB',
            'Napoli Capodichino Airport Italy - NAP',
            'Milan Parma Italy - PMF',
            'Milan Bergamo Orio Al Serio Italy - BGY',
            'Milan Malpensa Italy - MXP',
            'Milan Linate Italy - LIN',
            'Milan Segrate Italy - SWK',
            'San Domino  Tremiti Isla San Domino Island Italy - TQR',
            'Trapani Birgi Italy - TPS',
            'Turin Caselle Italy - TRN',
            'Trieste Ronchi Dei Legionari Italy - TRS',
            'Udine Campoformido Italy - UDN',
            'Tortoli Arbatax Italy - TTB',
            'Taranto Grottaglie Italy - TAR',
            'Lamezia Terme  Italy - SUF',
            'Venice Marco Polo Italy - VCE',
            'Venice Treviso Sant Angelo Italy - TSF',
            'Vicenza  Italy - VIC',
            'Vieste  Italy - VIF',
            'Merano Italy  Italy - VKB',
            'Verona Brescia Montechiari Italy - VBS',
            'Verona Villafranca Italy - VRN',
            'Mandeville Marlboro Jamaica - MVJ',
            'Negril  Jamaica - NEG',
            'Ocho Rios Boscobel Jamaica - OCJ',
            'Port Antonio Ken Jones Jamaica - POT',
            'Kingston Norman Manley Jamaica - KIN',
            'Kingston Tinson Jamaica - KTP',
            'Montego Bay Sangster Intl Jamaica - MBJ',
            'Aqaba King Hussein Intl Jordan - AQJ',
            'Amman Queen Alia Jordan - AMM',
            'Amman Civil Marka Airport Jordan - ADJ',
            'Mafraq King Hussein Jordan - OMF',
            'Maan  Jordan - MPQ',
            'Misawa  Japan - MSJ',
            'Marcus Island  Japan - MUS',
            'Matsuyama  Japan - MYJ',
            'Matsumoto  Japan - MMJ',
            'Miyako Jima Hirara Japan - MMY',
            'Minami Daito Maridor Japan - MMD',
            'Memanbetsu  Japan - MMB',
            'Omura  Japan - OMJ',
            'Oki Island  Japan - OKI',
            'Okayama  Japan - OKJ',
            'Okino Erabu  Japan - OKE',
            'Oshima  Japan - OIM',
            'Okushiri  Japan - OIR',
            'Oita  Japan - OIT',
            'Okinawa Naha Japan - OKA',
            'Okinawa Naha Afb Japan - AHA',
            'Okinawa Kadena Afb Japan - DNA',
            'Odate Noshiro  Japan - ONJ',
            'Osaka Kobe Japan - UKB',
            'Osaka Kansai Intl Japan - KIX',
            'Osaka Itami Japan - ITM',
            'Obihiro  Japan - OBO',
            'Yonaguni Jima  Japan - OGN',
            'Nagasaki  Japan - NGS',
            'Nagoya Chubu Centrair Japan - NGO',
            'Nagoya Komaki Afb Japan - NKM',
            'Miyake Jima  Japan - MYE',
            'Wajima Noto Airport Japan - NTQ',
            'Atsugi Nas Japan - NJA',
            'Sado Shima  Japan - SDS',
            'Ryotsu Sado Is  Japan - SDO',
            'Sendai  Japan - SDJ',
            'Shirahama  Japan - SHM',
            'Nakashibetsu  Japan - SHB',
            'Sakai  Japan - QKV',
            'Fukuyama  Japan - QFY',
            'Rebun  Japan - RBJ',
            'Yoronjima  Japan - RNJ',
            'Rishiri  Japan - RIS',
            'Wakkanai Hokkaido Japan - WKJ',
            'Yonago Miho Japan - YGJ',
            'Yokohama  Japan - YOK',
            'Shonai  Japan - SYO',
            'Takamatsu  Japan - TAK',
            'Shimojishima  Japan - SHI',
            'Sapporo Chitose Japan - CTS',
            'Sapporo Okadama Japan - OKD',
            'Tottori  Japan - TTJ',
            'Kumejima  Japan - UEO',
            'Ube  Japan - UBJ',
            'Tokyo Yokota Afb Japan - OKO',
            'Tokyo Haneda Japan - HND',
            'Tokyo Narita Japan - NRT',
            'Kyoto  Japan - UKY',
            'Tsushima  Japan - TSJ',
            'Taramajima Tarama Japan - TRA',
            'Tanegashima  Japan - TNE',
            'Toyama  Japan - TOY',
            'Toyooka Tajima Japan - TJH',
            'Tokunoshima  Japan - TKN',
            'Tokushima  Japan - TKS',
            'Asahikawa  Japan - AKJ',
            'Aguni  Japan - AGJ',
            'Aomori  Japan - AOJ',
            'Amami O Shima  Japan - ASJ',
            'Akita  Japan - AXT',
            'Beppu  Japan - BPU',
            'Monbetsu  Japan - MBE',
            'Kita Kyushu Kokura Japan - KKJ',
            'Kerama  Japan - KJP',
            'Kikaiga Shima  Japan - KKX',
            'Kagoshima  Japan - KOJ',
            'Miyazaki  Japan - KMI',
            'Kumamoto  Japan - KMJ',
            'Komatsu  Japan - KMQ',
            'Kitadaito  Japan - KTD',
            'Kushiro  Japan - KUH',
            'Kushimoto  Japan - KUJ',
            'Yakushima  Japan - KUM',
            'Niigata  Japan - KIJ',
            'Kochi  Japan - KCZ',
            'Yamagata Junmachi Japan - GAJ',
            'Shizuoka Mount Fuji Japan - FSZ',
            'Fukue  Japan - FUJ',
            'Fukuoka  Japan - FUK',
            'Fukushima  Japan - FKS',
            'Fukui  Japan - FKJ',
            'Hachijo Jima  Japan - HAC',
            'Iwami Iwami Aiport Japan - IWJ',
            'Iwo Jima Vol Iwo Jima Base Japan - IWO',
            'Ishigaki  Japan - ISG',
            'Izumo  Japan - IZO',
            'Iejima  Japan - IEJ',
            'Nishinoomote  Japan - IIN',
            'Iki  Japan - IKI',
            'Niihama  Japan - IHA',
            'Ibaraki  Japan - IBR',
            'Saga Saga Airport Japan - HSG',
            'Hateruma  Japan - HTR',
            'Hachinohe  Japan - HHE',
            'Hiroshima West Airport Japan - HIW',
            'Hiroshima Hiroshima Intl Japan - HIJ',
            'Hakodate  Japan - HKD',
            'Morioka Hanamaki Japan - HNA',
            'Hola  Kenya - HOA',
            'Kilaguni  Kenya - ILU',
            'Fergusons Gulf  Kenya - FER',
            'Garissa  Kenya - GAS',
            'Kericho  Kenya - KEY',
            'Kitale  Kenya - KTL',
            'Kerio Valley  Kenya - KRV',
            'Kalokol  Kenya - KLK',
            'Kiunga  Kenya - KIU',
            'Kisumu  Kenya - KIS',
            'Mombasa Moi Intl Kenya - MBA',
            'Loyangalani  Kenya - LOY',
            'Lodwar  Kenya - LOK',
            'Lake Baringo  Kenya - LBN',
            'Liboi  Kenya - LBK',
            'Lamu  Kenya - LAU',
            'Kiwayu  Kenya - KWY',
            'Lake Rudolf  Kenya - LKU',
            'Lokichoggio  Kenya - LKG',
            'Bamburi  Kenya - BMQ',
            'Amboseli  Kenya - ASV',
            'Eldoret  Kenya - EDL',
            'Eliye Springs  Kenya - EYS',
            'Ukunda  Kenya - UKA',
            'Samburu  Kenya - UAS',
            'Wajir  Kenya - WJR',
            'Marsabit  Kenya - RBT',
            'Moyale  Kenya - OYL',
            'Nayrobi Jomo Kenyatta Kenya - NBO',
            'Nayrobi Wilson Kenya - WIL',
            'Mandera  Kenya - NDE',
            'Nakuru  Kenya - NUU',
            'Nzoia  Kenya - NZO',
            'Nanyuki  Kenya - NYK',
            'Nyeri  Kenya - NYE',
            'Malindi  Kenya - MYD',
            'Mumias  Kenya - MUM',
            'Mara Lodges  Kenya - MRE',
            'Osh  Kyrgyzstan - OSS',
            'Bishkek  Kyrgyzstan - FRU',
            'Poipet  Cambodia - HPP',
            'Kompong Thom  Cambodia - KZK',
            'Kompong Chhnang  Cambodia - KZC',
            'Krakor  Cambodia - KZD',
            'Koh Kong  Cambodia - KKZ',
            'Kampot  Cambodia - KMT',
            'Sihanoukville  Cambodia - KOS',
            'Kratie  Cambodia - KTI',
            'Battambang  Cambodia - BBM',
            'Oddor Meanche  Cambodia - OMY',
            'Mundulkiri  Cambodia - MWV',
            'Pailin  Cambodia - PAI',
            'Phnom Penh Pochentong Cambodia - PNH',
            'Ratanakiri  Cambodia - RBE',
            'Siem Reap  Cambodia - REP',
            'Stung Treng  Cambodia - TNX',
            'Svay Rieng  Cambodia - SVR',
            'Tabiteuea North  Kiribati - TBF',
            'Teraina  Kiribati - TNQ',
            'Tabuaeran  Kiribati - TNV',
            'Tamana Island  Kiribati - TMN',
            'Tarawa Bonriki Kiribati - TRW',
            'Tabiteuea South  Kiribati - TSU',
            'Makin Island  Kiribati - MTK',
            'Maiana  Kiribati - MNK',
            'Onotoa  Kiribati - OOT',
            'Marakei  Kiribati - MZK',
            'Nikunau  Kiribati - NIG',
            'Nonouti  Kiribati - NON',
            'Butaritari  Kiribati - BBG',
            'Abemama Atoll  Kiribati - AEA',
            'Aranuka  Kiribati - AAK',
            'Abaiang  Kiribati - ABF',
            'Arorae Island  Kiribati - AIS',
            'Beru  Kiribati - BEZ',
            'Christmas Island  Kiribati - CXI',
            'Canton Island  Kiribati - CIS',
            'Kuria  Kiribati - KUC',
            'Anjouan Ouani Comoros - AJN',
            'Moroni Iconi Comoros - YVA',
            'Moroni Moroni Intl Comoros - HAH',
            'Saint Kitts Robert L Bradshaw St. Kitts - SKB',
            'Nevis Newcastle St. Kitts - NEV',
            'Samjiyon  Korea Dem Peoples Rep Of - YJS',
            'Wonson  Korea Dem Peoples Rep Of - WOS',
            'Sondok  Korea Dem Peoples Rep Of - DSO',
            'Pyongyang Sunan Korea Dem Peoples Rep Of - FNJ',
            'Jinju Sacheon Korea Republic Of - HIN',
            'Gunsan  Korea Republic Of - KUV',
            'Gunsan Airbase Korea Republic Of - KUZ',
            'Pohang  Korea Republic Of - KPO',
            'Gangneung  Korea Republic Of - KAG',
            'Gwangju  Korea Republic Of - KWJ',
            'Cheongju Cheongju Airport Korea Republic Of - CJJ',
            'Jeju Jeju  Apt Korea Republic Of - CJU',
            'Jinhae  Korea Republic Of - CHF',
            'Jeonju  Korea Republic Of - CHN',
            'Won Ju  Korea Republic Of - WJU',
            'Won Ju  Korea Republic Of - WBJ',
            'Yangyang  Korea Republic Of - YNY',
            'Yecheon  Korea Republic Of - YEC',
            'Sokcho Seolak Airport Korea Republic Of - SHO',
            'Suncheon Yeosu Apt Korea Republic Of - SYS',
            'Daegu  Korea Republic Of - TAE',
            'Suwon Suwon Airport Korea Republic Of - SWU',
            'Samcheok  Korea Republic Of - SUK',
            'Ulsan  Korea Republic Of - USN',
            'Osan Ab Korea Republic Of - OSN',
            'Muan  Korea Republic Of - MWX',
            'Mokpo  Korea Republic Of - MPK',
            'Seul Incheon International Korea Republic Of - ICN',
            'Seul Gimpo International Korea Republic Of - GMP',
            'Seul Seoul Ab Korea Republic Of - SSN',
            'Yeosu  Korea Republic Of - RSU',
            'Busan Gimhae Airport Korea Republic Of - PUS',
            'Kuwait Kuwait Intl Kuwait - KWI',
            'Little Cayman  Cayman Islands - LYB',
            'Grand Cayman Is Owen Robert Cayman Islands - GCM',
            'Cayman Brac Is Gerrard Cayman Islands - CYB',
            'Shimkent  Kazakhstan - CIT',
            'Zhezkazgan  Kazakhstan - DZN',
            'Zhambyl  Kazakhstan - DMB',
            'Ekibastuz  Kazakhstan - EKB',
            'Aktyubinsk  Kazakhstan - AKX',
            'Almaty  Kazakhstan - ALA',
            'Arkalyk  Kazakhstan - AYK',
            'Atbasar  Kazakhstan - ATX',
            'Burundai  Kazakhstan - BXJ',
            'Balhash  Kazakhstan - BXH',
            'Atyrau  Kazakhstan - GUW',
            'Zhairem  Kazakhstan - HRC',
            'Kzyl Orda  Kazakhstan - KZO',
            'Karaganda  Kazakhstan - KGF',
            'Kostanay  Kazakhstan - KSN',
            'Kokshetau  Kazakhstan - KOV',
            'Pavlodar  Kazakhstan - PWQ',
            'Petropavlovsk  Kazakhstan - PPK',
            'Semipalatinsk  Kazakhstan - PLX',
            'Aktau  Kazakhstan - SCO',
            'Uralsk  Kazakhstan - URA',
            'Ust Kamenogorsk  Kazakhstan - UKK',
            'Astana  Kazakhstan - TSE',
            'Zaisan  Kazakhstan - SZI',
            'Taldy Kurgan  Kazakhstan - TDK',
            'Seno  Lao People s Dem Republic - SND',
            'Thakhek  Lao People s Dem Republic - THK',
            'Muong Sai  Lao People s Dem Republic - UON',
            'Udomxay  Lao People s Dem Republic - UDO',
            'Sayaboury  Lao People s Dem Republic - ZBY',
            'Savannakhet  Lao People s Dem Republic - ZVK',
            'Vientiane Wattay Lao People s Dem Republic - VTE',
            'Viengxay  Lao People s Dem Republic - VNG',
            'Saravane  Lao People s Dem Republic - VNA',
            'Vangrieng  Lao People s Dem Republic - VGG',
            'Xayabury  Lao People s Dem Republic - XAY',
            'Xienglom  Lao People s Dem Republic - XIE',
            'Xieng Khouang  Lao People s Dem Republic - XKH',
            'Pakse  Lao People s Dem Republic - PKZ',
            'Paksane  Lao People s Dem Republic - PKS',
            'Phongsaly Bounneua Lao People s Dem Republic - PCQ',
            'Ban Houei  Lao People s Dem Republic - OUI',
            'Oudomxay  Lao People s Dem Republic - ODY',
            'Sam Neua  Lao People s Dem Republic - NEU',
            'Khong  Lao People s Dem Republic - KOG',
            'Luang Namtha  Lao People s Dem Republic - LXG',
            'Luang Prabang  Lao People s Dem Republic - LPQ',
            'Houeisay  Lao People s Dem Republic - HOE',
            'Attopeu  Lao People s Dem Republic - AOU',
            'Beyrut - BEY',
            'Tripoli Kleyate Lebanon - KYE',
            'Saint Lucia George F.L.Charles St. Lucia - SLU',
            'Saint Lucia Hewanorra St. Lucia - UVF',
            'Tissa Tank  Sri Lanka - TTW',
            'Trincomalee China Bay Sri Lanka - TRR',
            'Weerawila  Sri Lanka - WRZ',
            'Hatton Castlereigh Reservoir Sri Lanka - NUF',
            'Nuwara Eliya Gregorys Lake Sri Lanka - NUA',
            'Minneriya  Sri Lanka - MNH',
            'Katukurunda Katukurunda Slaf Base Sri Lanka - KTY',
            'Kelaniya Kelaniya River Sri Lanka - KEZ',
            'Koggala  Sri Lanka - KCT',
            'Kandy Victoria Reservoir Sri Lanka - KDW',
            'Mahaweli  Sri Lanka - KDY',
            'Katugastota Polgolla Reservoir Sri Lanka - KDZ',
            'Hingurakgoda  Sri Lanka - HIM',
            'Jaffna Kankesanturai Sri Lanka - JAF',
            'Gal Oya Amparai Sri Lanka - GOY',
            'Sigiriya Sigiriya Slaf Base Sri Lanka - GIU',
            'Bentota Bentota River Sri Lanka - BJT',
            'Batticaloa  Sri Lanka - BTC',
            'Anuradhapura  Sri Lanka - ACJ',
            'Ampara Kondavattavan Tank Sri Lanka - AFK',
            'Ampara  Sri Lanka - ADP',
            'Dickwella Mawella Lagoon Sri Lanka - DIW',
            'Colombo Bandaranayike Intl Sri Lanka - CMB',
            'Colombo Ratmalana Sri Lanka - RML',
            'Dambula Dambula Oya Tank Sri Lanka - DBU',
            'Cape Palmas A Tubman Liberia - CPA',
            'Bella Yella  Liberia - BYL',
            'Grand Cess  Liberia - GRC',
            'Foya  Liberia - FOY',
            'Monrovia Roberts Intl Liberia - ROB',
            'Monrovia Sprigg Payne Liberia - MLW',
            'Nimba  Liberia - NIA',
            'Rivercess  Liberia - RVC',
            'Sasstown  Liberia - SAZ',
            'Wologissi  Liberia - WOI',
            'Voinjama  Liberia - VOI',
            'Weasua  Liberia - WES',
            'Tapeta  Liberia - TPT',
            'Tchien  Liberia - THC',
            'Buchanan  Liberia - UCN',
            'Sinoe R E Murray Liberia - SNI',
            'Sinoe Afc Liberia - XSA',
            'Semongkong  Lesotho - SOK',
            'Sekakes  Lesotho - SKQ',
            'Seshutes  Lesotho - SHZ',
            'Qachas Nek  Lesotho - UNE',
            'Quthing  Lesotho - UTG',
            'Thaba Tseka  Lesotho - THB',
            'Tlokoeng  Lesotho - TKO',
            'Sehonghong  Lesotho - SHK',
            'Pelaneng  Lesotho - PEL',
            'Nkaus  Lesotho - NKU',
            'Mokhotlong  Lesotho - MKH',
            'Mafeteng  Lesotho - MFC',
            'Matsaile  Lesotho - MSG',
            'Maseru Moshoeshoe Lesotho - MSU',
            'Lebakeng  Lesotho - LEF',
            'Lesobeng  Lesotho - LES',
            'Leribe  Lesotho - LRB',
            'Kaunas Kaunas Intl Lithuania - KUN',
            'Klaipeda/Palanga Palanga International Lithuania - PLQ',
            'Panevezys Pajuostis Lithuania - PNV',
            'Siauliai Siauliai Intl Lithuania - SQQ',
            'Vilnius Vilnius Intl Lithuania - VNO',
            'Luxembourg  Luxembourg - LUX',
            'Liepaja Liepaja Intl Latvia - LPX',
            'Daugavpils Daugavpils Intl Latvia - DGP',
            'Ventspils  Latvia - VNT',
            'Riga Skulte Latvia - RSC',
            'Riga Riga Intl Latvia - RIX',
            'Ubari  Libyan Arab Jamahiriya - QUB',
            'Sebha  Libyan Arab Jamahiriya - SEB',
            'Misurata  Libyan Arab Jamahiriya - MRA',
            'Mitiga  Libyan Arab Jamahiriya - MJI',
            'Nafoora  Libyan Arab Jamahiriya - NFR',
            'Zwara  Libyan Arab Jamahiriya - WAX',
            'Sert  Libyan Arab Jamahiriya - SRX',
            'Tripoli Tripoli Intl Libyan Arab Jamahiriya - TIP',
            'Tobruk  Libyan Arab Jamahiriya - TOB',
            'Derna Martuba Libyan Arab Jamahiriya - DNF',
            'Benghazi Benina Intl Libyan Arab Jamahiriya - BEN',
            'Brack  Libyan Arab Jamahiriya - BCQ',
            'Kufrah  Libyan Arab Jamahiriya - AKF',
            'Ghadames  Libyan Arab Jamahiriya - LTD',
            'Marsa Brega  Libyan Arab Jamahiriya - LMQ',
            'Beida La Braq Libyan Arab Jamahiriya - LAQ',
            'Ghat  Libyan Arab Jamahiriya - GHT',
            'Houn  Libyan Arab Jamahiriya - HUQ',
            'Guelmime  Morocco - GLN',
            'Al Hoceima Cherif Al Idriss Morocco - AHU',
            'Agadir Al Massira Morocco - AGA',
            'Errachidia Moulay Ali Cherif Morocco - ERH',
            'Essaouira Mogador Morocco - ESU',
            'Laayoune Hassan I Morocco - EUN',
            'Fes Saiss Morocco - FEZ',
            'Casablanca Anfa Morocco - CAS',
            'Casablanca Mohammed V Morocco - CMN',
            'Tangier Ibn Batouta Morocco - TNG',
            'Tarfaya  Morocco - TFY',
            'Tetouan Saniat R Mel Morocco - TTU',
            'Tan Tan Plage Blanche Morocco - TTA',
            'Sidi Ifni Sania Ramel Morocco - SII',
            'Smara  Morocco - SMW',
            'Dakhla  Morocco - VIL',
            'Nador El Aroui Morocco - NDR',
            'Kenitra Royal Afb Morocco - NNA',
            'Meknes Royal Afb Morocco - MEK',
            'Ksar Es Souk  Morocco - SEK',
            'Safi  Morocco - SFI',
            'Marrakech Menara Morocco - RAK',
            'Rabat Sale Morocco - RBA',
            'Oujda Angads Morocco - OUD',
            'Ouarzazate  Morocco - OZZ',
            'Balti International Moldova - BZY',
            'Chisinau International Moldova - KIV',
            'Herceg Novi Hercegnovi Montenegro - HNO',
            'Berane Dolac Montenegro - IVG',
            'Zabljak  Montenegro - ZBK',
            'Podgorica  Montenegro - TGD',
            'Tivat  Montenegro - TIV',
            'Tulear  Madagascar Island - TLE',
            'Tamatave  Madagascar Island - TMM',
            'Antananarivo  Madagascar Island - TNR',
            'Tsaratanana  Madagascar Island - TTS',
            'Morafenobe  Madagascar Island - TVA',
            'Sainte Marie  Madagascar Island - SMS',
            'Tanandava  Madagascar Island - TDV',
            'Sambava  Madagascar Island - SVB',
            'Andapa  Madagascar Island - ZWA',
            'Miandrivazo  Madagascar Island - ZVA',
            'Vangaindrano  Madagascar Island - VND',
            'Vohemar  Madagascar Island - VOH',
            'Vatomandry  Madagascar Island - VAT',
            'Ambatondrazaka  Madagascar Island - WAM',
            'Befandriana  Madagascar Island - WBD',
            'Bealanana  Madagascar Island - WBE',
            'Beroroha  Madagascar Island - WBO',
            'Fianarantsoa  Madagascar Island - WFI',
            'Mahanoro  Madagascar Island - VVB',
            'Andriamena  Madagascar Island - WAD',
            'Antsalova  Madagascar Island - WAQ',
            'Antsohihy  Madagascar Island - WAI',
            'Ankazoabo  Madagascar Island - WAK',
            'Port Berge  Madagascar Island - WPB',
            'Ankorefo Moramba Airport Madagascar Island - WOR',
            'Mampikony Mampikony Airport Madagascar Island - WMP',
            'Mananara  Madagascar Island - WMR',
            'Madirovalo  Madagascar Island - WMV',
            'Malaimbandy  Madagascar Island - WML',
            'Maroantsetra  Madagascar Island - WMN',
            'Mandabe  Madagascar Island - WMD',
            'Mandritsara  Madagascar Island - WMA',
            'Tambohorano  Madagascar Island - WTA',
            'Tsiroanomandidy  Madagascar Island - WTS',
            'Manakara  Madagascar Island - WVK',
            'Bekily  Madagascar Island - OVA',
            'Farafangana  Madagascar Island - RVA',
            'Majunga Amborovy Madagascar Island - MJN',
            'Manja  Madagascar Island - MJA',
            'Mananjary  Madagascar Island - MNJ',
            'Morondava  Madagascar Island - MOQ',
            'Morombe  Madagascar Island - MXM',
            'Maintirano  Madagascar Island - MXT',
            'Ankokoambo  Madagascar Island - NKO',
            'Nossi Be Fascene Madagascar Island - NOS',
            'Moramanga Ambohibary Madagascar Island - OHB',
            'Ambanja  Madagascar Island - IVA',
            'Ihosy  Madagascar Island - IHO',
            'Ilaka  Madagascar Island - ILK',
            'Analalava  Madagascar Island - HVA',
            'Fort Dauphin Marillac Madagascar Island - FTU',
            'Ankavandra  Madagascar Island - JVA',
            'Besakoa  Madagascar Island - BSV',
            'Besalampy  Madagascar Island - BPY',
            'Belo  Madagascar Island - BMD',
            'Betioky  Madagascar Island - BKU',
            'Ambatolahy  Madagascar Island - AHY',
            'Ambilobe  Madagascar Island - AMB',
            'Ambatomainty  Madagascar Island - AMY',
            'Ampanihy  Madagascar Island - AMP',
            'Antalaha Antsirabato Madagascar Island - ANM',
            'Antsirabe  Madagascar Island - ATJ',
            'Doany  Madagascar Island - DOA',
            'Antsiranana  Madagascar Island - DIE',
            'Soalala  Madagascar Island - DWB',
            'Kwajelein Atoll Elenak Airport Marshall Islands - EAL',
            'Ebadon  Marshall Islands - EBN',
            'Ebon Ebon Apt Marshall Islands - EBO',
            'Enewetak Island Enewetak Marshall Islands - ENT',
            'Mili Atoll Enijet Airport Marshall Islands - EJT',
            'Aur Island  Marshall Islands - AUL',
            'Arno  Marshall Islands - AMR',
            'Airok  Marshall Islands - AIC',
            'Ailinglapalap Isl  Marshall Islands - AIP',
            'Ailuk Island  Marshall Islands - AIM',
            'Bikini Atoll Enyu Airfield Marshall Islands - BII',
            'Kaben  Marshall Islands - KBT',
            'Kili Island  Marshall Islands - KIO',
            'Kwajalein  Marshall Islands - KWA',
            'Likiep Island  Marshall Islands - LIK',
            'Loen  Marshall Islands - LOF',
            'Lae Island  Marshall Islands - LML',
            'Maloelap Island  Marshall Islands - MAV',
            'Majuro Amata Kabua Intl Marshall Islands - MAJ',
            'Ine Island  Marshall Islands - IMI',
            'Jabot  Marshall Islands - JAT',
            'Jeh  Marshall Islands - JEJ',
            'Namu  Marshall Islands - NMU',
            'Namdrik Island Namdrik Marshall Islands - NDK',
            'Mejit Island  Marshall Islands - MJB',
            'Majkin  Marshall Islands - MJE',
            'Mili Island  Marshall Islands - MIJ',
            'Rongelap Island  Marshall Islands - RNP',
            'Wotho Island  Marshall Islands - WTO',
            'Wotje Island  Marshall Islands - WTE',
            'Woja  Marshall Islands - WJA',
            'Tabal  Marshall Islands - TBV',
            'Utirik Island  Marshall Islands - UTK',
            'Ujae Island  Marshall Islands - UJE',
            'Jaluit Island  Marshall Islands - UIT',
            'Tinak Island  Marshall Islands - TIC',
            'Skopje Alexander The Great Macedonia - SKP',
            'Ohrid Saint Paul The Apostle Macedonia - OHD',
            'Mopti  Mali - MZI',
            'Nioro  Mali - NIX',
            'Nara  Mali - NRM',
            'Segou  Mali - SZU',
            'Tombouctou  Mali - TOM',
            'Gao  Mali - GAQ',
            'Goundam  Mali - GUD',
            'Kayes  Mali - KYS',
            'Koutiala  Mali - KTX',
            'Sikasso  Mali - KSS',
            'Kenieba  Mali - KNZ',
            'Bamako  Mali - BKO',
            'Yelimane  Mali - EYL',
            'Bhamo  Myanmar - BMO',
            'Bagan  Myanmar - BPE',
            'Bassein  Myanmar - BSX',
            'Sittwe Civil Myanmar - AKY',
            'Kalemyo  Myanmar - KMV',
            'Keng Tung  Myanmar - KET',
            'Khamti  Myanmar - KHM',
            'Kawthaung  Myanmar - KAW',
            'Kyauktaw  Myanmar - KYT',
            'Kyaukpyu  Myanmar - KYP',
            'Loikaw  Myanmar - LIW',
            'Lashio  Myanmar - LSH',
            'Gwa  Myanmar - GWA',
            'Henzada  Myanmar - HEB',
            'Gangaw  Myanmar - GAW',
            'Homalin  Myanmar - HOX',
            'Heho  Myanmar - HEH',
            'Tilin  Myanmar - TIO',
            'Tachilek  Myanmar - THL',
            'Dawe  Myanmar - TVY',
            'Thandwe  Myanmar - SNW',
            'Ye  Myanmar - XYE',
            'Namsang  Myanmar - NMS',
            'Namtu  Myanmar - NMT',
            'Nyaung U  Myanmar - NYU',
            'Myeik  Myanmar - MGZ',
            'Manaung  Myanmar - MGU',
            'Mong Ton  Myanmar - MGK',
            'Mandalay Annisaton Myanmar - MDL',
            'Myitkyina  Myanmar - MYT',
            'Magwe  Myanmar - MWQ',
            'Mong Hsat  Myanmar - MOG',
            'Maulmyine  Myanmar - MNU',
            'Momeik  Myanmar - MOE',
            'Yangon Mingaladon Myanmar - RGN',
            'Pa An  Myanmar - PAA',
            'Putao  Myanmar - PBU',
            'Pauk  Myanmar - PAU',
            'Papun  Myanmar - PPU',
            'Pakokku  Myanmar - PKK',
            'Prome  Myanmar - PRU',
            'Moron  Mongolia - MXV',
            'Mandalgobi  Mongolia - MXW',
            'Aershan Yiershi Airport Mongolia - YIE',
            'Bulgan  Mongolia - UGA',
            'Umnugobitour  Mongolia - UGT',
            'Ulgit  Mongolia - ULG',
            'Uliastai  Mongolia - ULZ',
            'Ulaanbaatar Buyant Uhaa Mongolia - ULN',
            'Ulaangom  Mongolia - ULO',
            'Baruun Urt  Mongolia - UUN',
            'Underkhaan  Mongolia - UNR',
            'Tosontsengel  Mongolia - TNZ',
            'Tsetserleg  Mongolia - TSZ',
            'Khujirt  Mongolia - HJT',
            'Khatgal  Mongolia - HTM',
            'Khovd  Mongolia - HVD',
            'Altai  Mongolia - LTI',
            'Kharkhorin  Mongolia - KHR',
            'Arvaikheer  Mongolia - AVK',
            'Bayankhongor  Mongolia - BYN',
            'Erdenet  Mongolia - ERT',
            'Dalanzadgad  Mongolia - DLZ',
            'Choibalsan  Mongolia - COQ',
            'Macau International Macao -Sar Of China Çin- - MFM',
            'Rota  Northern Mariana Islands - ROP',
            'Tinian  Northern Mariana Islands - TIQ',
            'Saipan Saipan Intl Northern Mariana Islands - SPN',
            'Martinik - FDF',
            'Fderik  Mauritania - FGD',
            'Nema  Mauritania - EMN',
            'Chinguitti  Mauritania - CGT',
            'Boghe Abbaye Mauritania - BGH',
            'Atar Mouakchott Mauritania - ATR',
            'Akjoujt  Mauritania - AJJ',
            'Aioun El Atrouss  Mauritania - AEO',
            'Kiffa  Mauritania - KFA',
            'Kaedi  Mauritania - KED',
            'Mbout  Mauritania - MBR',
            'Aleg  Mauritania - LEG',
            'Tichitt  Mauritania - THI',
            'Tamchakett  Mauritania - THT',
            'Tidjikja  Mauritania - TIY',
            'Timbedra  Mauritania - TMD',
            'El Gouera  Mauritania - ZLG',
            'Selibaby  Mauritania - SEY',
            'Zouerate  Mauritania - OUZ',
            'Boutilimit  Mauritania - OTL',
            'Moudjeria  Mauritania - MOM',
            'Nouakchott  Mauritania - NKC',
            'Nouadhibou  Mauritania - NDB',
            'Montserrat Geralds Airport Montserrat - MNI',
            'Malta Luqa International Malta - MLA',
            'Gozo  Malta - GZM',
            'Mauritius Adaları - MRU',
            'Rodrigues Is  Mauritius Island - RRG',
            'Male Male Intl Maldives Island - MLE',
            'Hanimaadhoo  Maldives Island - HAQ',
            'Pasifik Kuzey Kıyısı - GAN',
            'Kadhdhoo  Maldives Island - KDO',
            'Kaadedhdhoo  Maldives Island - KDM',
            'Kasungu  Malawi - KBQ',
            'Karonga  Malawi - KGJ',
            'Likoma Island Likoma Malawi - LIX',
            'Salima  Malawi - LMB',
            'Lilongwe Lilongwe Intl Malawi - LLW',
            'Mangochi  Malawi - MAI',
            'Blantyre Chileka Malawi - BLZ',
            'Blantyre Mvuu Camp Malawi - VUU',
            'Chelinda  Malawi - CEH',
            'Club Makokola  Malawi - CMK',
            'Dwangwa  Malawi - DWA',
            'Monkey Bay  Malawi - MYZ',
            'Mzuzu  Malawi - ZZU',
            'Manzanillo  Mexico - ZLO',
            'Zamora  Mexico - ZMM',
            'Ixtapa Zihuatanej Ixtapa Zihuatanej Intl Mexico - ZIH',
            'Zacatecas La Calera Mexico - ZCL',
            'Alamos  Mexico - XAL',
            'Villahermosa Cap C Perez Mexico - VSA',
            'Veracruz Heriberto Jara Mexico - VER',
            'Villa Constitucion  Mexico - VIB',
            'Tamuin  Mexico - TSL',
            'Torreon  Mexico - TRC',
            'Tepic  Mexico - TPQ',
            'Tijuana Rodriguez Mexico - TIJ',
            'Tuxtla Gutierrez Llano San Juan Mexico - TGZ',
            'Uruapan  Mexico - UPN',
            'San Luis Rio Colorado  Mexico - UAC',
            'Tizimin  Mexico - TZM',
            'Tulum  Mexico - TUY',
            'San Quintin  Mexico - SNQ',
            'Santa Rosalia  Mexico - SRL',
            'Saltillo  Mexico - SLW',
            'San Luis Potosi  Mexico - SLP',
            'San Jose Cabo Los Cabos Mexico - SJD',
            'Tapachula Tapachula Intl Mexico - TAP',
            'Tampico General F Javier Mina Mexico - TAM',
            'San Cristobal De Las Cas San Cristobal Airport Mexico - SZT',
            'Tehuacan  Mexico - TCN',
            'Mazatlan General Rafael Buelna Mexico - MZT',
            'Nueva Casas Grandes  Mexico - NCG',
            'Nuevo Laredo Nuevo Laredo Intl Mexico - NLD',
            'Nogales  Mexico - NOG',
            'Oaxaca Xoxocotlan Mexico - OAX',
            'Morelia  Mexico - MLM',
            'Ciudad Mante  Mexico - MMC',
            'Merida Rejon Mexico - MID',
            'Mexico City Toluca Mexico - TLC',
            'Mexico City Santa Lucia Mexico - NLU',
            'Mexico City Juarez Intl Mexico - MEX',
            'Mexico City Atizapan Mexico - AZP',
            'Mexicali  Mexico - MXL',
            'Minatitlan  Mexico - MTT',
            'Mulege  Mexico - MUG',
            'Monterrey General M Escobedo Mexico - MTY',
            'Monterrey Apt Del Norte Mexico - NTR',
            'Reynosa General Lucio Blanco Mexico - REX',
            'Queretaro  Mexico - QRO',
            'San Felipe  Mexico - SFH',
            'San Ignacio  Mexico - SGM',
            'Salina Cruz  Mexico - SCX',
            'Poza Rica Tajin Mexico - PAZ',
            'Puebla Huejotsingo Mexico - PBC',
            'Playa Del Carmen  Mexico - PCM',
            'Punta Colorada  Mexico - PCO',
            'Piedras Negras  Mexico - PDS',
            'Punta Chivato  Mexico - PCV',
            'Puerto Juarez  Mexico - PJZ',
            'Palenque  Mexico - PQM',
            'Puerto Escondido  Mexico - PXM',
            'Puerto Vallarta Ordaz Mexico - PVR',
            'Pochutla  Mexico - PUH',
            'Puerto Penasco  Mexico - PPE',
            'Pinotepa Nacional  Mexico - PNO',
            'Durango Guadalupe Victoria Mexico - DGO',
            'Ensenada  Mexico - ESE',
            'Cananea  Mexico - CNA',
            'Ciudad Del Carmen  Mexico - CME',
            'Colima  Mexico - CLQ',
            'Ciudad Juarez Ciudad Juarez Intl Mexico - CJS',
            'Comitan Copalar Mexico - CJT',
            'Ciudad Obregon  Mexico - CEN',
            'Campeche Campeche Intl Mexico - CPE',
            'Chetumal  Mexico - CTM',
            'Cozumel  Mexico - CZM',
            'Celaya  Mexico - CYW',
            'Chichen Itza  Mexico - CZA',
            'Ciudad Constitucion  Mexico - CUA',
            'Cancun  Mexico - CUN',
            'Culiacan Fedl De Bachiguala Mexico - CUL',
            'Chihuahua General Fierro Villa Mexico - CUU',
            'Ciudad Victoria  Mexico - CVM',
            'Cuernavaca  Mexico - CVJ',
            'Leon Guanajuato Del Bajio Mexico - BJX',
            'Bahia Angeles  Mexico - BHL',
            'Ciudad Acuna Ciudad Acuna Intl Mexico - ACN',
            'Acapulco Alvarez Intl Mexico - ACA',
            'Abreojos  Mexico - AJS',
            'Aguascalientes  Mexico - AGU',
            'Apatzingan  Mexico - AZG',
            'Matamoros  Mexico - MAM',
            'Lazaro Cardenas  Mexico - LZC',
            'Loreto  Mexico - LTO',
            'Los Mochis Federal Mexico - LMM',
            'Lagos De Moreno Francisco Mexico - LOM',
            'Monclova  Mexico - LOV',
            'La Paz Leon Mexico - LAP',
            'Guadalajara Miguel Hidalgo Mexico - GDL',
            'Guaymas General Jose M Yanez Mexico - GYM',
            'Guerrero Negro  Mexico - GUB',
            'Huatulco  Mexico - HUX',
            'Hermosillo General Pesqueir Mexico - HMO',
            'Ixtepec  Mexico - IZT',
            'Jalapa  Mexico - JAL',
            'Isla Mujeres  Mexico - ISJ',
            'Johor Bahru Sultan Ismail Malaysia - JHB',
            'Ipoh  Malaysia - IPH',
            'Sungei Tekai  Malaysia - GTK',
            'Genting  Malaysia - GTB',
            'Long Pasia  Malaysia - GSA',
            'Long Banga Airfield Malaysia - LBP',
            'Labuan  Malaysia - LBU',
            'Lahad Datu  Malaysia - LDU',
            'Pulau Layang  Malaysia - LAC',
            'Long Lama  Malaysia - LLM',
            'Long Akah  Malaysia - LKH',
            'Langkawi  Malaysia - LGK',
            'Long Lellang  Malaysia - LGL',
            'Limbang  Malaysia - LMN',
            'Long Sukang  Malaysia - LSU',
            'Long Semado Lawas Malaysia - LSM',
            'Lawas  Malaysia - LWY',
            'Keningau  Malaysia - KGU',
            'Kota Bharu Pengkalan Chepa Malaysia - KBR',
            'Kuching  Malaysia - KCH',
            'Kapit  Malaysia - KPI',
            'Kuantan  Malaysia - KUA',
            'Kudat  Malaysia - KUD',
            'Kerteh  Malaysia - KTE',
            'Kuala Lumpur Klia Malaysia - KUL',
            'Kuala Lumpur Sultan Abdul Aziz Shah Malaysia - SZB',
            'Bario  Malaysia - BBN',
            'Alor Setar  Malaysia - AOR',
            'Kota Kinabalu  Malaysia - BKI',
            'Bakalalan  Malaysia - BKM',
            'Belaga  Malaysia - BLG',
            'Bintulu  Malaysia - BTU',
            'Sematan  Malaysia - BSE',
            'Pangkor Perak  Malaysia - PKG',
            'Penang Butterworth Malaysia - BWH',
            'Penang Penang Intl Malaysia - PEN',
            'Pamol  Malaysia - PAY',
            'Sandakan  Malaysia - SDK',
            'Simanggang  Malaysia - SGG',
            'Sibu  Malaysia - SBW',
            'Redang Lts Pulau Redang Malaysia - RDN',
            'Ranau  Malaysia - RNU',
            'Marudi  Malaysia - MUR',
            'Mersing  Malaysia - MEP',
            'Malacca Batu Berendum Malaysia - MKZ',
            'Mukah  Malaysia - MKM',
            'Long Seridan  Malaysia - ODN',
            'Mulu  Malaysia - MZV',
            'Mostyn  Malaysia - MZS',
            'Miri  Malaysia - MYY',
            'Telupid  Malaysia - TEL',
            'Sitiawan  Malaysia - SWY',
            'Sahabat 16  Malaysia - SXS',
            'Taman Negara  Malaysia - SXT',
            'Semporna  Malaysia - SMM',
            'Sipitang  Malaysia - SPT',
            'Sepulot  Malaysia - SPE',
            'Tawau  Malaysia - TWU',
            'Kuala Terengganu Sultan Mahmud Malaysia - TGG',
            'Tanjung Manis Tanjung Manis Apt Malaysia - TGC',
            'Taiping  Malaysia - TPG',
            'Tomanggong  Malaysia - TMG',
            'Tioman  Malaysia - TOD',
            'Chokwe  Mozambique - TGS',
            'Quelimane  Mozambique - UEL',
            'Tete Tete Airport Mozambique - TCV',
            'Tete Matunda Mozambique - TET',
            'Xai Xai  Mozambique - VJB',
            'Gurue  Mozambique - VJQ',
            'Vilanculos  Mozambique - VNX',
            'Chimoio  Mozambique - VPY',
            'Lichinga  Mozambique - VXC',
            'Mocimboa Praia  Mozambique - MZB',
            'Santa Carolina  Mozambique - NTC',
            'Nangade  Mozambique - NND',
            'Maganja Da Costa  Mozambique - MJS',
            'Nacala  Mozambique - MNC',
            'Moma  Mozambique - MMW',
            'Magaruque  Mozambique - MFW',
            'Mueda  Mozambique - MUD',
            'Montepuez  Mozambique - MTU',
            'Maputo Maputo Intl Mozambique - MPM',
            'Marromeu  Mozambique - RRM',
            'Pebane  Mozambique - PEB',
            'Ponta De Ouro  Mozambique - PDD',
            'Pemba  Mozambique - POL',
            'Bazaruto Island  Mozambique - BZB',
            'Bajone  Mozambique - BJN',
            'Beira  Mozambique - BEW',
            'Benguera Island  Mozambique - BCW',
            'Angoche  Mozambique - ANO',
            'Nampula  Mozambique - APL',
            'Alto Molocue  Mozambique - AME',
            'Caia  Mozambique - CMZ',
            'Dugong  Mozambique - DGK',
            'Palma  Mozambique - LMZ',
            'Lumbo Lumbo Apt Mozambique - LFB',
            'Luabo  Mozambique - LBM',
            'Cuamba  Mozambique - FXO',
            'Inhaminga  Mozambique - IMG',
            'Chinde  Mozambique - INE',
            'Inhambane  Mozambique - INH',
            'Inhaca  Mozambique - IHC',
            'Ila Da Chilonzuene  Mozambique - IDC',
            'Indigo Bay Lodge  Mozambique - IBL',
            'Ibo  Mozambique - IBO',
            'Grootfontein  Namibia - GFY',
            'Gobabis  Namibia - GOG',
            'Halali  Namibia - HAL',
            'Caprivi Lianshulu Airport Namibia - LHU',
            'Luderitz  Namibia - LUD',
            'Keetmanshoop Van Der Wath Namibia - KMP',
            'Karasburg  Namibia - KAS',
            'Ai Ais  Namibia - AIW',
            'Arandis  Namibia - ADI',
            'Bagani  Namibia - BQI',
            'Otjiwarongo  Namibia - OTJ',
            'Rosh Pina Rosh Pina Airport Namibia - RHN',
            'Mpacha  Namibia - MPA',
            'Midgard  Namibia - MQG',
            'Mount Etjo Lodge  Namibia - MJO',
            'Namutoni  Namibia - NNI',
            'Rundu  Namibia - NDU',
            'Oshakati  Namibia - OHI',
            'Ongava Game Rsv  Namibia - OGV',
            'Opuwa  Namibia - OPW',
            'Ondangwa  Namibia - OND',
            'Omega  Namibia - OMG',
            'Mokuti Lodge  Namibia - OKU',
            'Oranjemund  Namibia - OMD',
            'Okaukuejo  Namibia - OKF',
            'Windhoek Hosea Kutako Int l Namibia - WDH',
            'Windhoek Eros Namibia - ERS',
            'Walvis Bay Rooikop Namibia - WVB',
            'Terrace Bay  Namibia - TCY',
            'Sesriem  Namibia - SZM',
            'Swakopmund  Namibia - SWP',
            'Tsumeb  Namibia - TSB',
            'Touho  New Caledonia - TOU',
            'Tiga  New Caledonia - TGJ',
            'Ouvea  New Caledonia - UVE',
            'Noumea Magenta New Caledonia - GEA',
            'Noumea Tontouta New Caledonia - NOU',
            'Mare  New Caledonia - MEE',
            'Mueo  New Caledonia - PDC',
            'Poum  New Caledonia - PUV',
            'Belep Island  New Caledonia - BMY',
            'Kone  New Caledonia - KNQ',
            'Koumac  New Caledonia - KOC',
            'Lifou  New Caledonia - LIF',
            'Hienghene  New Caledonia - HNG',
            'Houailou  New Caledonia - HLU',
            'Ile Des Pins  New Caledonia - ILP',
            'Ile Ouen  New Caledonia - IOU',
            'Birni Nkoni  Niger - BKN',
            'Agades  Niger - AJY',
            'Arlit  Niger - RLT',
            'Maradi  Niger - MFQ',
            'Niamey  Niger - NIM',
            'Zinder  Niger - ZND',
            'Tahoua  Niger - THZ',
            'Norfolk Island  Norfolk Island - NLK',
            'Makurdi  Nigeria - MDI',
            'Maiduguri  Nigeria - MIU',
            'Minna  Nigeria - MXJ',
            'Warri  Nigeria - QRW',
            'Owerri Sam Mbakwe Nigeria - QOW',
            'Port Harcourt City Port Harcourt City Apt Nigeria - PHG',
            'Port Harcourt  Nigeria - PHC',
            'Sokoto  Nigeria - SKO',
            'Zaria  Nigeria - ZAR',
            'Yola  Nigeria - YOL',
            'Akure  Nigeria - AKR',
            'Abuja Abuja Intl Nigeria - ABV',
            'Benin City  Nigeria - BNI',
            'Bauchi  Nigeria - BCU',
            'Katsina  Nigeria - DKA',
            'Enugu  Nigeria - ENU',
            'Calabar  Nigeria - CBQ',
            'Ilorin  Nigeria - ILR',
            'Ibadan  Nigeria - IBA',
            'Gombe  Nigeria - GMO',
            'Lagos Murtala Muhammed Nigeria - LOS',
            'Kano Aminu Kano Intl Nigeria - KAN',
            'Kaduna  Nigeria - KAD',
            'Jos  Nigeria - JOS',
            'Bluefields  Nicaragua - BEF',
            'Bonanza San Pedro Nicaragua - BZA',
            'Waspam  Nicaragua - WSP',
            'Siuna  Nicaragua - SIU',
            'Puerto Cabezas  Nicaragua - PUZ',
            'Rosita  Nicaragua - RFS',
            'Corn Island  Nicaragua - RNI',
            'Managua Augusto C Sandino Nicaragua - MGA',
            'San Carlos  Nicaragua - NCR',
            'Nueva Guinea  Nicaragua - NVG',
            'Manang  Nepal - NGX',
            'Meghauli  Nepal - MEY',
            'Mountain  Nepal - MWP',
            'Rolpa  Nepal - RPA',
            'Ramechhap  Nepal - RHP',
            'Rajbiraj  Nepal - RJB',
            'Rukumkot  Nepal - RUK',
            'Rumjatar  Nepal - RUM',
            'Phaplu  Nepal - PPL',
            'Pokhara  Nepal - PKR',
            'Syangboche  Nepal - SYH',
            'Surkhet  Nepal - SKH',
            'Simara  Nepal - SIF',
            'Silgadi Doti  Nepal - SIH',
            'Tikapur  Nepal - TPU',
            'Taplejung  Nepal - TPJ',
            'Tumling Tar  Nepal - TMI',
            'Mahendranagar  Nepal - XMG',
            'Bajhang  Nepal - BJH',
            'Bajura Bajura Arpt Nepal - BJU',
            'Baitadi  Nepal - BIT',
            'Biratnagar  Nepal - BIR',
            'Baglung  Nepal - BGL',
            'Bhojpur  Nepal - BHP',
            'Bharatpur  Nepal - BHR',
            'Bhadrapur  Nepal - BDP',
            'Bhairawa  Nepal - BWA',
            'Sanfebagar  Nepal - FEB',
            'Dang  Nepal - DNP',
            'Dhangarhi  Nepal - DHI',
            'Dolpa  Nepal - DOP',
            'Darchula  Nepal - DAP',
            'Kathmandu Tribhuvan Nepal - KTM',
            'Jomsom  Nepal - JMO',
            'Janakpur  Nepal - JKR',
            'Jiri  Nepal - JIR',
            'Jumla  Nepal - JUM',
            'Nepalganj  Nepal - KEP',
            'Lukla  Nepal - LUA',
            'Langtang  Nepal - LTG',
            'Lamidanda  Nepal - LDN',
            'Chaurjhari  Nepal - HRJ',
            'Simikot  Nepal - IMK',
            'Gorkha  Nepal - GKH',
            'Nauru Island Nauru Island Intl Nauru - INU',
            'Niue Island Hanan Niue - IUE',
            'Invercargill  New Zealand - IVC',
            'Hokitika  New Zealand - HKK',
            'Hamilton  New Zealand - HLZ',
            'Gisborne  New Zealand - GIS',
            'Greymouth  New Zealand - GMN',
            'Port Fitzroy  New Zealand - GBS',
            'Great Barrier Isl  New Zealand - GBZ',
            'Mansion House  New Zealand - KWU',
            'Kaikoura  New Zealand - KBZ',
            'Kaitaia  New Zealand - KAT',
            'Takaka  New Zealand - KTF',
            'Kawau Island  New Zealand - KUI',
            'Kaikohe  New Zealand - KKO',
            'Kerikeri  New Zealand - KKE',
            'Coromandel  New Zealand - CMV',
            'Chatham Island Karewa New Zealand - CHT',
            'Christchurch  New Zealand - CHC',
            'Dunedin  New Zealand - DUD',
            'Dargaville  New Zealand - DGR',
            'Fox Glacier  New Zealand - FGL',
            'Mystery Break  New Zealand - ENZ',
            'Blenheim  New Zealand - BHE',
            'Ashburton  New Zealand - ASG',
            'Alexandra  New Zealand - ALR',
            'Ardmore  New Zealand - AMZ',
            'Auckland Mechanics Bay New Zealand - MHB',
            'Auckland  New Zealand - AKL',
            'Helicopter Scenic  New Zealand - XXH',
            'Wanaka  New Zealand - WKA',
            'Wairoa  New Zealand - WIR',
            'Wellington  New Zealand - WLG',
            'Whitianga  New Zealand - WTZ',
            'Westport  New Zealand - WSZ',
            'Whangarei  New Zealand - WRE',
            'Wanganui  New Zealand - WAG',
            'Waitangi  New Zealand - WGN',
            'Whakatane  New Zealand - WHK',
            'Franz Josef  New Zealand - WHO',
            'Surfdale  New Zealand - WIK',
            'Mystery Explorer  New Zealand - ZUF',
            'Queenstown Frankton New Zealand - ZQN',
            'Thames  New Zealand - TMZ',
            'Tauranga  New Zealand - TRG',
            'Taharoa  New Zealand - THH',
            'Timaru  New Zealand - TIU',
            'Tokoroa  New Zealand - TKZ',
            'Taupo  New Zealand - TUO',
            'Stewart Island  New Zealand - SZS',
            'Te Anau Manapouri New Zealand - TEU',
            'Pakatoa Island  New Zealand - PKL',
            'Palmerston North  New Zealand - PMR',
            'Paraparaumu  New Zealand - PPQ',
            'Picton Koromiko New Zealand - PCN',
            'Rotorua  New Zealand - ROT',
            'Raglan  New Zealand - RAG',
            'Mount Cook Glentanner New Zealand - GTN',
            'Mount Cook Pukaki Twizel New Zealand - TWZ',
            'Mount Cook  New Zealand - MON',
            'Masterton  New Zealand - MRO',
            'Matamata  New Zealand - MTA',
            'Milford Sound  New Zealand - MFN',
            'Motueka  New Zealand - MZP',
            'Nelson  New Zealand - NSN',
            'Napier Hawkes Bay New Zealand - NPE',
            'New Plymouth  New Zealand - NPL',
            'Oamaru  New Zealand - OAM',
            'Ohakea Raf Base New Zealand - OHA',
            'Marmul  Oman - OMM',
            'Muscat Muscat International Oman - MCT',
            'Masirah  Oman - MSH',
            'Qarn Alam  Oman - RNM',
            'Buraimi  Oman - RMB',
            'Sur  Oman - SUH',
            'Salalah  Oman - SLL',
            'Thumrait  Oman - TTH',
            'Mukhaizna  Oman - UKH',
            'Saihrawl  Oman - AHW',
            'Adam  Oman - AOM',
            'Bahja  Oman - BJQ',
            'Dibaa  Oman - BYB',
            'Fahud  Oman - FAU',
            'Khasab  Oman - KHS',
            'Lekhawair  Oman - LKW',
            'Jaque  Panama - JQE',
            'Garachine  Panama - GHE',
            'Fort Kobbe Howard Afb Panama - HOW',
            'Isla Viveros  Panama - IVI',
            'El Real  Panama - ELE',
            'Changuinola  Panama - CHX',
            'Caledonia  Panama - CDE',
            'David Enrique Malek Panama - DAV',
            'Corazon De Jesus  Panama - CZJ',
            'Chitre  Panama - CTD',
            'Carti  Panama - CTE',
            'Bocas Del Toro  Panama - BOC',
            'Balboa  Panama - BLB',
            'Bahia Pinas  Panama - BFQ',
            'Ailigandi  Panama - AIL',
            'Puerto Armuellas  Panama - AML',
            'Achutupo  Panama - ACU',
            'Ustupo  Panama - UTU',
            'Tupile  Panama - TUE',
            'Tubala  Panama - TUW',
            'Ticantiki Ticantiki Airport Panama - TJC',
            'Santiago  Panama - SYP',
            'Rio Alzucar  Panama - RIZ',
            'Rio Tigre  Panama - RIT',
            'Rio Sidra  Panama - RSI',
            'Sambu  Panama - SAX',
            'Santa Fe  Panama - SFW',
            'Contadora  Panama - OTD',
            'La Palma  Panama - PLP',
            'El Porvenir  Panama - PVE',
            'Panama City Paitilla Panama - PAC',
            'Panama City Tocumen Intl Panama - PTY',
            'Puerto Obaldia  Panama - PUE',
            'Yaviza  Panama - PYV',
            'Playon Chico  Panama - PYC',
            'Mamitupo  Panama - MPI',
            'Mulatupo  Panama - MPP',
            'Colon  Panama - ONX',
            'San Miguel  Panama - NMG',
            'San Blas  Panama - NBL',
            'Nargana  Panama - NGN',
            'Machu Picchu  Peru - MFT',
            'Pucallpa Capitan Rolden Peru - PCL',
            'Piura  Peru - PIU',
            'Pisco  Peru - PIO',
            'Puerto Maldonado  Peru - PEM',
            'Rodriguez De Men  Peru - RIM',
            'Rioja  Peru - RIJ',
            'Tacna  Peru - TCQ',
            'Tumbes  Peru - TBP',
            'Shiringayoc  Peru - SYC',
            'Santa Maria  Peru - SMG',
            'San Juan  Peru - SJA',
            'Saposoa  Peru - SQU',
            'Tingo Maria  Peru - TGI',
            'Tarapoto  Peru - TPP',
            'Trujillo  Peru - TRU',
            'Talara  Peru - TYL',
            'Quincemil  Peru - UMI',
            'Yurimaguas  Peru - YMS',
            'Alerta  Peru - ALD',
            'Andahuaylas  Peru - ANS',
            'San Juan Aposento  Peru - APE',
            'Arequipa Rodriguez Ballon Peru - AQP',
            'Anta  Peru - ATA',
            'Ayacucho Yanamilla Peru - AYP',
            'Bellavista  Peru - BLP',
            'Cuzco Velazco Astete Peru - CUZ',
            'Chimbote  Peru - CHM',
            'Chachapoyas  Peru - CHH',
            'Cajamarca  Peru - CJA',
            'Chiclayo Cornel Ruiz Peru - CIX',
            'Iquitos C F Secada Peru - IQT',
            'Jauja  Peru - JAU',
            'Ilo  Peru - ILQ',
            'Huanuco  Peru - HUU',
            'Iberia  Peru - IBP',
            'Juanjui  Peru - JJI',
            'Juliaca  Peru - JUL',
            'Lima J Chavez Intl Peru - LIM',
            'Moyobamba  Peru - MBP',
            'Maupiti  French Polynesia - MAU',
            'Katiu  French Polynesia - KXU',
            'Kauehi  French Polynesia - KHZ',
            'Kaukura Atoll  French Polynesia - KKR',
            'Huahine  French Polynesia - HUH',
            'Hao Island  French Polynesia - HOI',
            'Hiva Oa  French Polynesia - HIX',
            'Hikueru  French Polynesia - HHZ',
            'Gambier Is  French Polynesia - GMR',
            'Fakarava  French Polynesia - FAV',
            'Fangatau  French Polynesia - FGU',
            'Fakahina  French Polynesia - FHZ',
            'Faaite  French Polynesia - FAC',
            'Bora Bora Motu-Mute French Polynesia - BOB',
            'Arutua  French Polynesia - AXR',
            'Atuona  French Polynesia - AUQ',
            'Apataki  French Polynesia - APK',
            'Ahe  French Polynesia - AHE',
            'Anaa  French Polynesia - AAA',
            'Tureia  French Polynesia - ZTA',
            'Vahitahi  French Polynesia - VHZ',
            'Manihi  French Polynesia - XMH',
            'Ua Huka  French Polynesia - UAH',
            'Ua Pou  French Polynesia - UAP',
            'Tetiaroa Is  French Polynesia - TTI',
            'Tubuai  French Polynesia - TUB',
            'Tupai  French Polynesia - TPX',
            'Tikehau Atoll  French Polynesia - TIH',
            'Takapoto  French Polynesia - TKP',
            'Takume  French Polynesia - TJN',
            'Tatakoto  French Polynesia - TKV',
            'Takaroa  French Polynesia - TKX',
            'Raiatea  French Polynesia - RFP',
            'Rangiroa  French Polynesia - RGI',
            'Aratika  French Polynesia - RKA',
            'Rimatara  French Polynesia - RMT',
            'Raroia  French Polynesia - RRR',
            'Reao  French Polynesia - REA',
            'Rurutu  French Polynesia - RUR',
            'Rairua Raivavae Airport French Polynesia - RVV',
            'Pukarua  French Polynesia - PUK',
            'Papeete Faaa French Polynesia - PPT',
            'Puka Puka  French Polynesia - PKP',
            'Makemo  French Polynesia - MKP',
            'Moorea Temae French Polynesia - MOZ',
            'Mataiva  French Polynesia - MVT',
            'Nuku Hiva  French Polynesia - NHV',
            'Napuka Island  French Polynesia - NAU',
            'Niau  French Polynesia - NIU',
            'Nukutavake  French Polynesia - NUK',
            'Nuguria  Papua New Guinea - NUG',
            'Nutuve  Papua New Guinea - NUT',
            'Nowata  Papua New Guinea - NWT',
            'Ogeranang  Papua New Guinea - OGE',
            'Obo  Papua New Guinea - OBX',
            'Morobe  Papua New Guinea - OBM',
            'Open Bay  Papua New Guinea - OPB',
            'Balimo  Papua New Guinea - OPU',
            'Ononge  Papua New Guinea - ONB',
            'Omora  Papua New Guinea - OSE',
            'Ossima  Papua New Guinea - OSG',
            'Omkalai  Papua New Guinea - OML',
            'Olsobip  Papua New Guinea - OLQ',
            'Oksapmin  Papua New Guinea - OKP',
            'Simberi Island Simberi Airport Papua New Guinea - NIS',
            'Nankina  Papua New Guinea - NKN',
            'Nomane  Papua New Guinea - NMN',
            'Nipa  Papua New Guinea - NPG',
            'Naoro  Papua New Guinea - NOO',
            'Nomad River  Papua New Guinea - NOM',
            'Nambaiyufa  Papua New Guinea - NBA',
            'Menyamya  Papua New Guinea - MYX',
            'Minj  Papua New Guinea - MZN',
            'Ningerum  Papua New Guinea - NGR',
            'Namudi  Papua New Guinea - NDI',
            'Nadunumu  Papua New Guinea - NDN',
            'Manetai  Papua New Guinea - MVI',
            'Mussau  Papua New Guinea - MWU',
            'Mindik  Papua New Guinea - MXK',
            'Moro  Papua New Guinea - MXH',
            'Marawaka  Papua New Guinea - MWG',
            'Maramuni  Papua New Guinea - MWI',
            'Mapoda  Papua New Guinea - MPF',
            'Makini  Papua New Guinea - MPG',
            'Mapua  Papua New Guinea - MPU',
            'Miyanmin  Papua New Guinea - MPX',
            'Manare  Papua New Guinea - MRM',
            'May River  Papua New Guinea - MRH',
            'Malekolon  Papua New Guinea - MKN',
            'Moki  Papua New Guinea - MJJ',
            'Misima Island  Papua New Guinea - MIS',
            'Mal  Papua New Guinea - MMV',
            'Maron  Papua New Guinea - MNP',
            'Malalaua  Papua New Guinea - MLQ',
            'Meselia  Papua New Guinea - MFZ',
            'Manguna  Papua New Guinea - MFO',
            'Manga  Papua New Guinea - MGP',
            'Margarima  Papua New Guinea - MGG',
            'Morehead  Papua New Guinea - MHY',
            'Munduku  Papua New Guinea - MDM',
            'Mendi  Papua New Guinea - MDU',
            'Paiela  Papua New Guinea - PLE',
            'Pimaga  Papua New Guinea - PMP',
            'Param  Papua New Guinea - PPX',
            'Port Moresby Jackson Fld Papua New Guinea - POM',
            'Popondetta Girua Papua New Guinea - PNP',
            'Pumani  Papua New Guinea - PMN',
            'Pureni  Papua New Guinea - PUI',
            'Puas  Papua New Guinea - PUA',
            'Pindiu  Papua New Guinea - PDI',
            'Yegepa  Papua New Guinea - PGE',
            'Pangoa  Papua New Guinea - PGB',
            'Pangia  Papua New Guinea - PGN',
            'Pambwa  Papua New Guinea - PAW',
            'Oria  Papua New Guinea - OTY',
            'Ruti  Papua New Guinea - RUU',
            'Selbang  Papua New Guinea - SBC',
            'Suabi  Papua New Guinea - SBE',
            'Salamo  Papua New Guinea - SAM',
            'Singaua  Papua New Guinea - SGB',
            'Safia  Papua New Guinea - SFU',
            'Sagarai  Papua New Guinea - SGJ',
            'Sangapi  Papua New Guinea - SGK',
            'Saidor  Papua New Guinea - SDI',
            'Sabah  Papua New Guinea - SBV',
            'Rabaraba  Papua New Guinea - RBP',
            'Arawa  Papua New Guinea - RAW',
            'Oram  Papua New Guinea - RAX',
            'Rakanda  Papua New Guinea - RAA',
            'Rabaul Tokua Papua New Guinea - RAB',
            'Rumginae  Papua New Guinea - RMN',
            'Robinson River  Papua New Guinea - RNR',
            'Yule Island Kairuku Papua New Guinea - RKU',
            'Porgera  Papua New Guinea - RGE',
            'Tekin  Papua New Guinea - TKW',
            'Talasea  Papua New Guinea - TLW',
            'Tol  Papua New Guinea - TLO',
            'Tumolbil  Papua New Guinea - TLP',
            'Tekadu  Papua New Guinea - TKB',
            'Tari  Papua New Guinea - TIZ',
            'Tingwon  Papua New Guinea - TIG',
            'Telefomin  Papua New Guinea - TFM',
            'Tufi  Papua New Guinea - TFI',
            'Tagula  Papua New Guinea - TGL',
            'Tapini  Papua New Guinea - TPI',
            'Tarakbits  Papua New Guinea - TRJ',
            'Taskul  Papua New Guinea - TSK',
            'Tsili Tsili  Papua New Guinea - TSI',
            'Tsewi  Papua New Guinea - TSW',
            'Tonu  Papua New Guinea - TON',
            'Torokina  Papua New Guinea - TOK',
            'Tauta  Papua New Guinea - TUT',
            'Tawa  Papua New Guinea - TWY',
            'Buin  Papua New Guinea - UBI',
            'Mount Aue  Papua New Guinea - UAE',
            'Umba  Papua New Guinea - UMC',
            'Sule  Papua New Guinea - ULE',
            'Kiunga  Papua New Guinea - UNG',
            'Nuku  Papua New Guinea - UKU',
            'Uvol  Papua New Guinea - UVO',
            'Manumu  Papua New Guinea - UUU',
            'Usino  Papua New Guinea - USO',
            'Upiara  Papua New Guinea - UPR',
            'Uroubi  Papua New Guinea - URU',
            'Samarai Isl China Strait Papua New Guinea - SQT',
            'Sepik Plains  Papua New Guinea - SPV',
            'Sopu  Papua New Guinea - SPH',
            'Sissano  Papua New Guinea - SIZ',
            'Sila  Papua New Guinea - SIL',
            'Simbai  Papua New Guinea - SIM',
            'Sapmanga  Papua New Guinea - SMH',
            'Stockholm  Papua New Guinea - SMP',
            'Sim  Papua New Guinea - SMJ',
            'Suki  Papua New Guinea - SKC',
            'Tadji  Papua New Guinea - TAJ',
            'Tabubil  Papua New Guinea - TBG',
            'Timbunke  Papua New Guinea - TBE',
            'Tabibuga  Papua New Guinea - TBA',
            'Tarabo  Papua New Guinea - TBQ',
            'Torembi Torembi Airport Papua New Guinea - TCJ',
            'Tinboli  Papua New Guinea - TCK',
            'Tetabedi  Papua New Guinea - TDB',
            'Terapo  Papua New Guinea - TEO',
            'Teptep  Papua New Guinea - TEP',
            'Sauren  Papua New Guinea - SXW',
            'Sehulea  Papua New Guinea - SXH',
            'Satwag  Papua New Guinea - SWG',
            'Sialum  Papua New Guinea - SXA',
            'Silur  Papua New Guinea - SWR',
            'Siwea  Papua New Guinea - SWE',
            'Suria  Papua New Guinea - SUZ',
            'Siassi  Papua New Guinea - SSS',
            'Biniguni  Papua New Guinea - XBN',
            'Yellow River  Papua New Guinea - XYR',
            'Wasua  Papua New Guinea - WSA',
            'Wasu  Papua New Guinea - WSU',
            'Wipim  Papua New Guinea - WPM',
            'Wau  Papua New Guinea - WUG',
            'Wasum  Papua New Guinea - WUM',
            'Wantoat  Papua New Guinea - WTT',
            'Woitape  Papua New Guinea - WTP',
            'Wuvulu Is  Papua New Guinea - WUV',
            'Wewak Boram Papua New Guinea - WWK',
            'Witu  Papua New Guinea - WIU',
            'Wakunai  Papua New Guinea - WKN',
            'Wanuma  Papua New Guinea - WNU',
            'Wonenara  Papua New Guinea - WOA',
            'Vanimo  Papua New Guinea - VAI',
            'Baimuru  Papua New Guinea - VMU',
            'Vivigani  Papua New Guinea - VIV',
            'Wagau  Papua New Guinea - WGU',
            'Weam  Papua New Guinea - WEP',
            'Wapolu  Papua New Guinea - WBC',
            'Wedau  Papua New Guinea - WED',
            'Wapenamanda  Papua New Guinea - WBM',
            'Wabag  Papua New Guinea - WAB',
            'Wawoi Falls  Papua New Guinea - WAJ',
            'Wabo  Papua New Guinea - WAO',
            'Yeva  Papua New Guinea - YVD',
            'Zenag  Papua New Guinea - ZEN',
            'Yenkis  Papua New Guinea - YEQ',
            'Abau  Papua New Guinea - ABW',
            'Atkamba  Papua New Guinea - ABP',
            'Aseki  Papua New Guinea - AEK',
            'Afore  Papua New Guinea - AFR',
            'Angoram  Papua New Guinea - AGG',
            'Kagua  Papua New Guinea - AGK',
            'Wanigela  Papua New Guinea - AGL',
            'Aiome  Papua New Guinea - AIE',
            'Anguganak  Papua New Guinea - AKG',
            'Ama  Papua New Guinea - AMF',
            'Amboin  Papua New Guinea - AMG',
            'Amanab  Papua New Guinea - AMU',
            'Asapa  Papua New Guinea - APP',
            'April River  Papua New Guinea - APR',
            'Aroa  Papua New Guinea - AOA',
            'Annanberg  Papua New Guinea - AOB',
            'Arona  Papua New Guinea - AON',
            'Namatanai  Papua New Guinea - ATN',
            'Asirim  Papua New Guinea - ASZ',
            'Aitape Airstrip Papua New Guinea - ATP',
            'Aragip  Papua New Guinea - ARP',
            'Agaun  Papua New Guinea - AUP',
            'Aumo  Papua New Guinea - AUV',
            'Aua Island  Papua New Guinea - AUI',
            'Ambunti  Papua New Guinea - AUJ',
            'Awar  Papua New Guinea - AWR',
            'Awaba  Papua New Guinea - AWB',
            'Aiyura  Papua New Guinea - AYU',
            'Amazon Bay  Papua New Guinea - AZB',
            'Bialla  Papua New Guinea - BAA',
            'Baibara  Papua New Guinea - BAP',
            'Bali  Papua New Guinea - BAJ',
            'Banz  Papua New Guinea - BNZ',
            'Boana  Papua New Guinea - BNV',
            'Boku  Papua New Guinea - BOQ',
            'Boset  Papua New Guinea - BOT',
            'Boang  Papua New Guinea - BOV',
            'Bapi  Papua New Guinea - BPD',
            'Boridi  Papua New Guinea - BPB',
            'Biaru  Papua New Guinea - BRP',
            'Bensbach  Papua New Guinea - BSP',
            'Brahman  Papua New Guinea - BRH',
            'Buka  Papua New Guinea - BUA',
            'Bewani  Papua New Guinea - BWP',
            'Bunsil  Papua New Guinea - BXZ',
            'Bolovip  Papua New Guinea - BVP',
            'Bawan  Papua New Guinea - BWJ',
            'Bulolo  Papua New Guinea - BUL',
            'Bodinumu  Papua New Guinea - BNM',
            'Bundi  Papua New Guinea - BNT',
            'Bamu  Papua New Guinea - BMZ',
            'Bomai  Papua New Guinea - BMH',
            'Bimin  Papua New Guinea - BIZ',
            'Biliau  Papua New Guinea - BIJ',
            'Baindoung  Papua New Guinea - BDZ',
            'Bereina  Papua New Guinea - BEA',
            'Bambu  Papua New Guinea - BCP',
            'Esa ala  Papua New Guinea - ESA',
            'Erume  Papua New Guinea - ERU',
            'Freida River  Papua New Guinea - FAQ',
            'Eia Popondetta Papua New Guinea - EIA',
            'Efogi  Papua New Guinea - EFG',
            'Engati  Papua New Guinea - EGA',
            'Erave  Papua New Guinea - ERE',
            'Eliptamin  Papua New Guinea - EPT',
            'Emo  Papua New Guinea - EMO',
            'Embessa  Papua New Guinea - EMS',
            'Emirau  Papua New Guinea - EMI',
            'Daugo  Papua New Guinea - DGG',
            'Dodoima  Papua New Guinea - DDM',
            'Derim  Papua New Guinea - DER',
            'Dinangat  Papua New Guinea - DNU',
            'Dalbertis  Papua New Guinea - DLB',
            'Dumpu  Papua New Guinea - DPU',
            'Dorobisoro  Papua New Guinea - DOO',
            'Dios  Papua New Guinea - DOS',
            'Doini  Papua New Guinea - DOI',
            'Kundiawa Chimbu Papua New Guinea - CMU',
            'Cape Gloucester  Papua New Guinea - CGC',
            'Chungribu  Papua New Guinea - CVB',
            'Cape Vogel  Papua New Guinea - CVL',
            'Daup  Papua New Guinea - DAF',
            'Debepare  Papua New Guinea - DBP',
            'Daru  Papua New Guinea - DAU',
            'Cape Orford  Papua New Guinea - CPI',
            'Cape Rodney  Papua New Guinea - CPN',
            'Gasmata Island  Papua New Guinea - GMI',
            'Gora  Papua New Guinea - GOC',
            'Gonalia  Papua New Guinea - GOE',
            'Goroka  Papua New Guinea - GKA',
            'Gulgubip  Papua New Guinea - GLP',
            'Garasa  Papua New Guinea - GRL',
            'Garuahi  Papua New Guinea - GRH',
            'Hatzfeldthaven  Papua New Guinea - HAZ',
            'Guriaso  Papua New Guinea - GUE',
            'Guari  Papua New Guinea - GUG',
            'Alotau Gurney Papua New Guinea - GUR',
            'Gnarowein  Papua New Guinea - GWN',
            'Mougulu  Papua New Guinea - GUV',
            'Green River  Papua New Guinea - GVI',
            'Gewoia  Papua New Guinea - GEW',
            'Green Islands  Papua New Guinea - GEI',
            'Negarbo  Papua New Guinea - GBF',
            'Garaina  Papua New Guinea - GAR',
            'Gusap  Papua New Guinea - GAP',
            'Gasuke  Papua New Guinea - GBC',
            'Guasopa  Papua New Guinea - GAZ',
            'Feramin  Papua New Guinea - FRQ',
            'Fuma  Papua New Guinea - FUM',
            'Fulleborn  Papua New Guinea - FUB',
            'Fane  Papua New Guinea - FNE',
            'Finschhafen  Papua New Guinea - FIN',
            'Hoskins  Papua New Guinea - HKN',
            'Hivaro  Papua New Guinea - HIT',
            'Mount Hagen Kagamuga Papua New Guinea - HGU',
            'Haelogo  Papua New Guinea - HEO',
            'Honinabi  Papua New Guinea - HNN',
            'Komako  Papua New Guinea - HOC',
            'Heiweni  Papua New Guinea - HNI',
            'Iboki  Papua New Guinea - IBI',
            'Iaura  Papua New Guinea - IAU',
            'Hawabango  Papua New Guinea - HWA',
            'Hayfields  Papua New Guinea - HYF',
            'Ileg  Papua New Guinea - ILX',
            'Iamalele  Papua New Guinea - IMA',
            'Imonda  Papua New Guinea - IMD',
            'Imane  Papua New Guinea - IMN',
            'Ioma  Papua New Guinea - IOP',
            'Iokea  Papua New Guinea - IOK',
            'Indagen  Papua New Guinea - IDN',
            'Ihu  Papua New Guinea - IHU',
            'Nissan Island  Papua New Guinea - IIS',
            'Jacquinot Bay  Papua New Guinea - JAQ',
            'Inus  Papua New Guinea - IUS',
            'Itokama  Papua New Guinea - ITK',
            'Kerema  Papua New Guinea - KMA',
            'Koinambe  Papua New Guinea - KMB',
            'Kamiraba  Papua New Guinea - KJU',
            'Kokoda  Papua New Guinea - KKD',
            'Kira  Papua New Guinea - KIQ',
            'Kikinonda  Papua New Guinea - KIZ',
            'Komo Manda  Papua New Guinea - KOM',
            'Kokoro  Papua New Guinea - KOR',
            'Kelanoa  Papua New Guinea - KNL',
            'Kanainj  Papua New Guinea - KNE',
            'Karimui  Papua New Guinea - KMR',
            'Kamina  Papua New Guinea - KMF',
            'Kupiano  Papua New Guinea - KUP',
            'Kuri  Papua New Guinea - KUQ',
            'Kamusi  Papua New Guinea - KUY',
            'Kitava  Papua New Guinea - KVE',
            'Kavieng  Papua New Guinea - KVG',
            'Kanua  Papua New Guinea - KTK',
            'Kerau  Papua New Guinea - KRU',
            'Kar Kar  Papua New Guinea - KRX',
            'Kasanombe  Papua New Guinea - KSB',
            'Kisengan  Papua New Guinea - KSG',
            'Yasuru  Papua New Guinea - KSX',
            'Kosipe  Papua New Guinea - KSP',
            'Kopiago  Papua New Guinea - KPA',
            'Yapsiei  Papua New Guinea - KPE',
            'Kompiam  Papua New Guinea - KPM',
            'Kol  Papua New Guinea - KQL',
            'Kikori  Papua New Guinea - KRI',
            'Karawari  Papua New Guinea - KRJ',
            'Kaiapit  Papua New Guinea - KIA',
            'Kieta Aropa Papua New Guinea - KIE',
            'Kagi  Papua New Guinea - KGW',
            'Kungum  Papua New Guinea - KGM',
            'Yongai  Papua New Guinea - KGH',
            'Konge  Papua New Guinea - KGB',
            'Kanabea  Papua New Guinea - KEX',
            'Kabwum  Papua New Guinea - KBM',
            'Komaio  Papua New Guinea - KCJ',
            'Keglsugl  Papua New Guinea - KEG',
            'Kandep  Papua New Guinea - KDP',
            'Kamberatoro  Papua New Guinea - KDQ',
            'Kandrian  Papua New Guinea - KDR',
            'Koroba  Papua New Guinea - KDE',
            'Kamulai  Papua New Guinea - KAQ',
            'Karato  Papua New Guinea - KAF',
            'Kar  Papua New Guinea - KAK',
            'Josephstaal  Papua New Guinea - JOP',
            'Karoola  Papua New Guinea - KXR',
            'Kurwina  Papua New Guinea - KWV',
            'Kiwai Island  Papua New Guinea - KWX',
            'Kawito  Papua New Guinea - KWO',
            'Lablab  Papua New Guinea - LAB',
            'Lae Nadzab Papua New Guinea - LAE',
            'Kaintiba  Papua New Guinea - KZF',
            'Yalumet  Papua New Guinea - KYX',
            'Lumi  Papua New Guinea - LMI',
            'Lamassa  Papua New Guinea - LMG',
            'Lehu  Papua New Guinea - LHP',
            'Laiagam  Papua New Guinea - LGM',
            'Linga Linga  Papua New Guinea - LGN',
            'Manus Island Momote Papua New Guinea - MAS',
            'Mamai  Papua New Guinea - MAP',
            'Madang  Papua New Guinea - MAG',
            'Masa  Papua New Guinea - MBV',
            'Lowai  Papua New Guinea - LWI',
            'Leitre  Papua New Guinea - LTF',
            'Long Island  Papua New Guinea - LSJ',
            'Losuia  Papua New Guinea - LSA',
            'Leron Plains  Papua New Guinea - LPN',
            'Lake Murray  Papua New Guinea - LMY',
            'Lengbati  Papua New Guinea - LNC',
            'Munbil  Papua New Guinea - LNF',
            'Lese  Papua New Guinea - LNG',
            'Langimar  Papua New Guinea - LNM',
            'Loani  Papua New Guinea - LNQ',
            'Lihir Island  Papua New Guinea - LNV',
            'Lwbak  Philippines - LWA',
            'Masbate  Philippines - MBT',
            'Mamburao  Philippines - MBO',
            'Legaspi  Philippines - LGP',
            'Laoag  Philippines - LAO',
            'Lubang  Philippines - LBX',
            'Jolo  Philippines - JOL',
            'Kalibo  Philippines - KLO',
            'Iligan Maria Cristina Philippines - IGN',
            'Ipil  Philippines - IPE',
            'Ilo Ilo International Philippines - ILO',
            'Del Carmen Sayak Airport Philippines - IAO',
            'Sicogon Island  Philippines - ICO',
            'General Santos International Philippines - GES',
            'Catarman National Philippines - CRM',
            'Cuyo  Philippines - CYU',
            'Cauayan  Philippines - CYZ',
            'Calbayog  Philippines - CYP',
            'Culion  Philippines - CUJ',
            'Cagayan De Oro Lumbia Philippines - CGY',
            'Camiguin Mambajao Philippines - CGM',
            'Casiguran  Philippines - CGG',
            'Cagayan De Sulu  Philippines - CDY',
            'Cebu Mactan Intl Apt Philippines - CEB',
            'Cotabato Awang Philippines - CBO',
            'Dipolog  Philippines - DPL',
            'Dilasag  Philippines - DSG',
            'Daet Camarines Norte Philippines - DTE',
            'Davao Francisco Bangoy Intl Philippines - DVO',
            'Dumaguete  Philippines - DGT',
            'El Nido  Philippines - ENI',
            'Antique Evelio Javier Philippines - EUQ',
            'Bacolod Silay International Philippines - BCD',
            'Baganga  Philippines - BNQ',
            'Butuan  Philippines - BXU',
            'Basco  Philippines - BSO',
            'Bislig  Philippines - BPH',
            'Baler  Philippines - BQA',
            'Baguio Loakan Philippines - BAG',
            'Alah  Philippines - AAV',
            'Zamboanga  Philippines - ZAM',
            'Virac  Philippines - VRC',
            'Naga  Philippines - WNP',
            'Siocon  Philippines - XSO',
            'Coron  Philippines - XCN',
            'Maramag  Philippines - XMA',
            'Siasi  Philippines - SSV',
            'Surigao  Philippines - SUG',
            'Tandag  Philippines - TDG',
            'Tablas  Philippines - TBH',
            'Tacloban D Z Romualdez Philippines - TAC',
            'Tagbilaran  Philippines - TAG',
            'San Jose Mcguire Fld Philippines - SJI',
            'Busuanga  Philippines - USU',
            'Tawitawi  Philippines - TWT',
            'Tuguegarao  Philippines - TUG',
            'Tagbita  Philippines - TGB',
            'Sanga Sanga  Philippines - SGS',
            'Subic Bay Subic Bay Intl Philippines - SFS',
            'San Fernando  Philippines - SFE',
            'Taytay Sandoval Clr Airport Philippines - RZP',
            'Roxas City  Philippines - RXS',
            'Ozamis City Labo Philippines - OZC',
            'Pagadian  Philippines - PAG',
            'Puerto Princesa  Philippines - PPS',
            'Malabang  Philippines - MLP',
            'Manila Ninoy Aquino Intl Philippines - MNL',
            'Manila Sangley Point Nas Philippines - SGL',
            'Marinduque  Philippines - MRQ',
            'Caticlan Malay Philippines - MPH',
            'Mati  Philippines - MXI',
            'Luzon Is Ncp Luzon Is Philippines - CRK',
            'Luzon Is Ncp Cubi Pt N Philippines - NCP',
            'Sangley Point Naf Philippines - NSP',
            'Ormoc  Philippines - OMC',
            'Ormara  Pakistan - ORW',
            'Kohat  Pakistan - OHT',
            'Nushki  Pakistan - NHS',
            'Mianwali  Pakistan - MWD',
            'Multan  Pakistan - MUX',
            'Mirpur Khas  Pakistan - MPD',
            'Mohenjodaro  Pakistan - MJD',
            'Muzaffarabad  Pakistan - MFG',
            'Panjgur  Pakistan - PJG',
            'Pasni  Pakistan - PSI',
            'Para Chinar Pakistan - PAJ',
            'Peshawar  Pakistan - PEW',
            'Rahim Yar Khan  Pakistan - RYK',
            'Sawan  Pakistan - RZS',
            'Sibi  Pakistan - SBQ',
            'Sargodha  Pakistan - SGI',
            'Sargodha Bhagatanwala Pakistan - BHW',
            'Saidu Sharif  Pakistan - SDT',
            'Rawala Kot  Pakistan - RAZ',
            'Zhob  Pakistan - PZH',
            'Taftan  Pakistan - TFT',
            'Tarbela  Pakistan - TLB',
            'Turbat  Pakistan - TUK',
            'Quetta  Pakistan - UET',
            'Sialkot  Pakistan - SKT',
            'Sukkur  Pakistan - SKZ',
            'Sehwen Sharif  Pakistan - SYW',
            'Sui  Pakistan - SUL',
            'Shikarpur  Pakistan - SWV',
            'Sahiwal  Pakistan - SWN',
            'Nawabshah  Pakistan - WNS',
            'Wana  Pakistan - WAF',
            'Bahawalnagar  Pakistan - WGB',
            'Abbottabad  Pakistan - AAW',
            'Attock  Pakistan - ATG',
            'Bannu  Pakistan - BNP',
            'Badin Talhar Pakistan - BDN',
            'Bahawalpur  Pakistan - BHV',
            'Dadu  Pakistan - DDU',
            'Dera Ghazi Khan  Pakistan - DEA',
            'Dera Ismail Khan  Pakistan - DSK',
            'Chitral  Pakistan - CJL',
            'Chilas  Pakistan - CHB',
            'Campbellpore  Pakistan - CWP',
            'Dalbandin  Pakistan - DBA',
            'Gilgit  Pakistan - GIL',
            'Gwadar  Pakistan - GWD',
            'Hyderabad  Pakistan - HDD',
            'Gujrat  Pakistan - GRT',
            'Mansehra  Pakistan - HRA',
            'Islamabad Benazir Bhutto Intl Pakistan - ISB',
            'Jacobabad  Pakistan - JAG',
            'Jiwani  Pakistan - JIW',
            'Kalat  Pakistan - KBH',
            'Khuzdar  Pakistan - KDD',
            'Kadanwari  Pakistan - KCF',
            'Skardu  Pakistan - KDU',
            'Karachi Quaid-E-Azam Intl Pakistan - KHI',
            'Lahore  Pakistan - LHE',
            'Faisalabad  Pakistan - LYP',
            'Lora Lai  Pakistan - LRG',
            'Lodz Wladyslaw Reymont Poland - LCJ',
            'Krakow John Paul Ii Balice Poland - KRK',
            'Katowice Pyrzowice Poland - KTW',
            'Zielona Gora Babimost Poland - IEG',
            'Gdansk Lech Walesa Poland - GDN',
            'Czestochowa Rudniki Poland - CZW',
            'Bydgoszcz Ignacy Jan Paderewski Poland - BZG',
            'Warsaw F.Chopin Poland - WAW',
            'Wroclaw Nicolaus Copernicus Poland - WRO',
            'Elblag  Poland - ZBG',
            'Suwalki  Poland - ZWK',
            'Szczytno Szymany Poland - SZY',
            'Szczecin Goleniow Poland - SZZ',
            'Rzeszow Jasionka Poland - RZE',
            'Poznan Lawica Poland - POZ',
            'Koszalin Zegrze Pomorskie Ab Poland - OSZ',
            'Slupsk Redzikowo Poland - OSP',
            'Miquelon  St. Pierre And Miquelon - MQC',
            'Saint Pierre  St. Pierre And Miquelon - FSP',
            'Humacao Palmas Del Mar Puerto Rico - PPD',
            'Humacao Humacao Arpt Puerto Rico - HUC',
            'Mayaguez De Hostos Puerto Rico - MAZ',
            'Aguadilla Borinquen Puerto Rico - BQN',
            'Arecibo  Puerto Rico - ARE',
            'Culebra  Puerto Rico - CPX',
            'Dorado Dorado Beach Puerto Rico - DDP',
            'Fajardo  Puerto Rico - FAJ',
            'Roosevelt Roads Nas Puerto Rico - NRR',
            'Ponce Mercedita Puerto Rico - PSE',
            'San Juan Luis Munoz Marin Puerto Rico - SJU',
            'San Juan Isla Grande Puerto Rico - SIG',
            'Vieques  Puerto Rico - VQS',
            'Gaza City Yasser Arafat Intl Palestinian Occ. Territories - GZA',
            'Graciosa Island  Portugal - GRW',
            'Flores Island  Portugal - FLW',
            'Funchal Madeira Portugal - FNC',
            'Horta  Portugal - HOR',
            'Lizbon Airport Portugal - LIS',
            'Faro Airport Portugal - FAO',
            'Covilha  Portugal - COV',
            'Corvo Island  Portugal - CVU',
            'Chaves  Portugal - CHV',
            'Coimbra  Portugal - CBP',
            'Braga  Portugal - BGZ',
            'Braganca  Portugal - BGC',
            'Vila Real  Portugal - VRL',
            'Viseu  Portugal - VSE',
            'Setubal  Portugal - XSZ',
            'Sao Jorge Island  Portugal - SJZ',
            'Sines  Portugal - SIE',
            'Santa Maria Island  Portugal - SMA',
            'Terceira Island Lajes Portugal - TER',
            'Portimao  Portugal - PRM',
            'Porto Santo  Portugal - PXO',
            'Ponta Delgada Azores Joao Paulo Ii Portugal - PDL',
            'Pico Island  Portugal - PIX',
            'Ribeira Grande  Portugal - QEG',
            'Porto Francisco Sa Carneiro Portugal - OPO',
            'Koror Airai Palau Islands - ROR',
            'Pedro Juan Caball  Paraguay - PJC',
            'Pilar  Paraguay - PIL',
            'Puerto La Victoria  Paraguay - PCJ',
            'Puerto Leda  Paraguay - PBT',
            'Fuerte Olimpo  Paraguay - OLK',
            'Vallemi  Paraguay - VMI',
            'Bahia Negra  Paraguay - BFA',
            'Asuncion Silvio Pettirossi Paraguay - ASU',
            'Ayolas  Paraguay - AYO',
            'Ciudad Del Este Alejo Garci Paraguay - AGT',
            'Concepcion Mcal Lopez Paraguay - CIO',
            'Mariscal Estigarr  Paraguay - ESG',
            'Encarnacion Teniente Paraguay - ENO',
            'Filadelfia  Paraguay - FLM',
            'Doha Doha Free Zone Qatar - XOZ',
            'Doha  Qatar - DOH',
            'Saint Pierre Reunion Pierrefonds Reunion Island - ZSE',
            'Saint Denis Reunion Roland Garros Reunion Island - RUN',
            'Sibiu  Romania - SBZ',
            'Suceava Stefan Cel Mare Romania - SCV',
            'Oradea  Romania - OMR',
            'Tulcea Delta Dunarii Romania - TCE',
            'Satu Mare  Romania - SUJ',
            'Tirgu Mures  Romania - TGM',
            'Timisoara Traian Vuia Romania - TSR',
            'Deva  Romania - DVA',
            'Köstence - CND',
            'Cluj Napoca  Romania - CLJ',
            'Craiova  Romania - CRA',
            'Caransebes  Romania - CSB',
            'Baia Mare  Romania - BAY',
            'Arad  Romania - ARW',
            'Bacau  Romania - BCM',
            'Bükreş Baneasa Aurel Vlaicu Romania - BBU',
            'Bükreş Henri Coanda Romania - OTP',
            'Iasi  Romania - IAS',
            'Nis Konstantin Veliki Serbia - INI',
            'Belgrade Nikola Tesla Serbia - BEG',
            'Belgrad - BJY',
            'Uzice Ponikve Serbia - UZC',
            'Pristina Pristina Intl Serbia - PRN',
            'Kigali Kigali Int l Rwanda - KGL',
            'Kamembe  Rwanda - KME',
            'Gisenyi  Rwanda - GYI',
            'Butare  Rwanda - BTQ',
            'Ruhengeri  Rwanda - RHG',
            'Rafha  Saudi Arabia - RAH',
            'Arar  Saudi Arabia - RAE',
            'Riyadh King Khaled Intl Saudi Arabia - RUH',
            'Majma  Saudi Arabia - MJH',
            'Medine  Saudi Arabia - MED',
            'Sulayel  Saudi Arabia - SLF',
            'Sharurah  Saudi Arabia - SHW',
            'Alula Majeed Bin Abdulaziz Saudi Arabia - ULH',
            'Gurayat  Saudi Arabia - URY',
            'Tabuk  Saudi Arabia - TUU',
            'Turaif  Saudi Arabia - TUI',
            'Taif  Saudi Arabia - TIF',
            'Yanbu  Saudi Arabia - YNB',
            'Zilfi  Saudi Arabia - ZUL',
            'Wadi Ad Dawasir  Saudi Arabia - WAE',
            'Unayzah  Saudi Arabia - UZH',
            'Bisha  Saudi Arabia - BHH',
            'Al Baha Al Aqiq Saudi Arabia - ABT',
            'Abha  Saudi Arabia - AHB',
            'Al Kharj Prince Sultan Air Base Saudi Arabia - AKH',
            'Jouf  Saudi Arabia - AJF',
            'Qaisumah  Saudi Arabia - AQI',
            'Wedjh  Saudi Arabia - EJH',
            'Gassim  Saudi Arabia - ELQ',
            'Dammam King Fahad Intl Saudi Arabia - DMM',
            'Dawadmi  Saudi Arabia - DWD',
            'Nejran  Saudi Arabia - EAM',
            'Hafr Albatin  Saudi Arabia - HBT',
            'Hail  Saudi Arabia - HAS',
            'Jazan  Saudi Arabia - GIZ',
            'Alahsa  Saudi Arabia - HOF',
            'Jeddah King Abdulaziz Int Saudi Arabia - JED',
            'King Khalid Mil City King Khalid Military Saudi Arabia - KMC',
            'Khamis Mushait  Saudi Arabia - KMX',
            'Kukundu  Solomon Islands - KUE',
            'Kagau  Solomon Islands - KGE',
            'Jajao  Solomon Islands - JJA',
            'Mbambanakira  Solomon Islands - MBU',
            'Kwai Harbour  Solomon Islands - KWR',
            'Kwailabesi Aerodrome Solomon Islands - KWS',
            'Kirakira  Solomon Islands - IRA',
            'Honiara Henderson Intl Solomon Islands - HIR',
            'Gatokae Aerodrom Solomon Islands - GTA',
            'Guadalcanal  Solomon Islands - GSI',
            'Gizo  Solomon Islands - GZO',
            'Geva  Solomon Islands - GEF',
            'Fera Island  Solomon Islands - FRE',
            'Sege  Solomon Islands - EGM',
            'Choiseul Bay  Solomon Islands - CHY',
            'Atoifi  Solomon Islands - ATD',
            'Balalae  Solomon Islands - BAS',
            'Avu Avu  Solomon Islands - AVU',
            'Anuha Island Resort  Solomon Islands - ANH',
            'Auki Gwaunaru u Solomon Islands - AKS',
            'Afutara Afutara Aerodrome Solomon Islands - AFT',
            'Batuna Batuna Aerodrome Solomon Islands - BPF',
            'Bellona  Solomon Islands - BNY',
            'Suavanao Suavanao Airstrip Solomon Islands - VAO',
            'Barakoma  Solomon Islands - VEV',
            'Viru Viru Harbour Solomon Islands - VIU',
            'Yandina  Solomon Islands - XYA',
            'Tulagi Island  Solomon Islands - TLG',
            'Tarapaina  Solomon Islands - TAA',
            'Savo  Solomon Islands - SVY',
            'Mono  Solomon Islands - MNY',
            'Munda  Solomon Islands - MUA',
            'Star Harbour Nana Solomon Islands - NAZ',
            'Santa Ana  Solomon Islands - NNB',
            'Onepusu  Solomon Islands - ONE',
            'Marau Sound  Solomon Islands - RUS',
            'Santa Cruz Is  Solomon Islands - SCZ',
            'Ramata  Solomon Islands - RBV',
            'Ringi Cove  Solomon Islands - RIN',
            'Barora  Solomon Islands - RRI',
            'Rennell  Solomon Islands - RNL',
            'Arona Ulawa Solomon Islands - RNA',
            'Otong Java  Solomon Islands - OTV',
            'Parasi  Solomon Islands - PRS',
            'Praslin Island  Seychelles Islands - PRI',
            'Mahe Island Seychelles Intl Seychelles Islands - SEZ',
            'Bird Island  Seychelles Islands - BDI',
            'Desroches  Seychelles Islands - DES',
            'Denis Island  Seychelles Islands - DEI',
            'Fregate Is  Seychelles Islands - FRK',
            'Khashm El Girba  Sudan - GBU',
            'Gedaref  Sudan - GSU',
            'Malakal  Sudan - MAK',
            'Juba  Sudan - JUB',
            'Kadugli  Sudan - KDX',
            'Khartoum Civil Sudan - KRT',
            'Kassala  Sudan - KSL',
            'Kosti  Sudan - KST',
            'Kenana  Sudan - KJN',
            'Dinder Galegu Sudan - DNX',
            'Wad Medani  Sudan - DNI',
            'El Obeid  Sudan - EBD',
            'Dongola  Sudan - DOG',
            'Geneina  Sudan - EGN',
            'Eldebba  Sudan - EDB',
            'El Fasher  Sudan - ELF',
            'Baleela  Sudan - BJE',
            'Adareil  Sudan - AEE',
            'Ad Dabbah  Sudan - AAD',
            'Atbara  Sudan - ATB',
            'Roseires  Sudan - RSS',
            'Rumbek  Sudan - RBX',
            'Port Sudan  Sudan - PZU',
            'En Nahud  Sudan - NUD',
            'New Halfa  Sudan - NHF',
            'Merowe  Sudan - MWE',
            'Nyala  Sudan - UYL',
            'Wadi Halfa  Sudan - WHF',
            'Wau  Sudan - WUU',
            'Vastervik  Sweden - VVK',
            'Vaxjo Smaland Sweden - VXO',
            'Visby  Sweden - VBY',
            'Vilhelmina  Sweden - VHM',
            'Stockholm Bromma Sweden - BMA',
            'Stockholm Vasteras Sweden - VST',
            'Stockholm Arlanda Sweden - ARN',
            'Stockholm Skavsta Intl Sweden - NYO',
            'Soderhamn  Sweden - SOO',
            'Storuman  Sweden - SQO',
            'Trollhattan/Vanersborg Trollhattan Sweden - THN',
            'Torsby Torsby Apt Sweden - TYF',
            'Umea  Sweden - UME',
            'Mora Siljan Sweden - MXX',
            'Malmö  Sweden - MMX',
            'Norrkoping Kungsangen Sweden - NRK',
            'Ornskoldsvik  Sweden - OER',
            'Oskarshamn  Sweden - OSK',
            'Orebro Orebro Airport Sweden - ORB',
            'Ronneby/Karlskrona Kallinge Sweden - RNB',
            'Skelleftea  Sweden - SFT',
            'Sundsvall/Harnosand Midlanda Sweden - SDL',
            'Are/Ostersund Are Sweden - OSD',
            'Pajala  Sweden - PJA',
            'Angelholm/Helsingborg Angelholm Airport Sweden - AGH',
            'Arvidsjaur  Sweden - AJR',
            'Borlange/Falun Dala Airport Sweden - BLE',
            'Eskilstuna  Sweden - EKT',
            'Sveg  Sweden - EVG',
            'Kalmar  Sweden - KLR',
            'Karlskoga  Sweden - KSK',
            'Karlstad  Sweden - KSD',
            'Kiruna  Sweden - KRN',
            'Kramfors/Solleftea Kramfors Sweden - KRF',
            'Skovde  Sweden - KVB',
            'Kristianstad  Sweden - KID',
            'Jonkoping  Sweden - JKG',
            'Lycksele  Sweden - LYC',
            'Linkoping City Airport Sweden - LPI',
            'Lidkoping Hovby Sweden - LDK',
            'Lulea Kallax Sweden - LLA',
            'Göteborg City Airport Sweden - GSE',
            'Göteborg Landvetter Sweden - GOT',
            'Gavle Sandviken Sweden - GVX',
            'Halmstad  Sweden - HAD',
            'Gallivare  Sweden - GEV',
            'Hagfors  Sweden - HFS',
            'Hemavan/Tarnaby Hemavan Sweden - HMV',
            'Hultsfred/Vimmerby Hultsfred Sweden - HLF',
            'Idre  Sweden - IDB',
            'Hudiksvall  Sweden - HUV',
            'Singapore Seletar Singapore - XSP',
            'Singapore Paya Lebar Singapore - QPG',
            'Singapore Changi Singapore - SIN',
            'Georgetown Wideawake Field St. Helena Island - ASI',
            'Ljubljana Brnik Slovenia - LJU',
            'Maribor  Slovenia - MBX',
            'Portoroz  Slovenia - POW',
            'Presov  Slovakia - POV',
            'Piestany  Slovakia - PZY',
            'Sliac  Slovakia - SLD',
            'Poprad Tatry Slovakia - TAT',
            'Lucenec  Slovakia - LUE',
            'Kosice  Slovakia - KSC',
            'Zilina  Slovakia - ILZ',
            'Bratislava M R Stefanik Slovakia - BTS',
            'Bonthe  Sierra Leone - BTE',
            'Daru  Sierra Leone - DSL',
            'Gbangbatok  Sierra Leone - GBK',
            'Freetown Hastings Sierra Leone - HGS',
            'Freetown Lungi Intl Sierra Leone - FNA',
            'Kabala  Sierra Leone - KBA',
            'Kenema  Sierra Leone - KEN',
            'Sierra Leone  Sierra Leone - SRK',
            'Yengema  Sierra Leone - WYE',
            'San Marino  San Marino - SAI',
            'Richard Toll  Senegal - RDT',
            'Podor  Senegal - POD',
            'Niokolo Koba  Senegal - NIK',
            'Saint Louis  Senegal - XLS',
            'Ziguinchor  Senegal - ZIG',
            'Simenti  Senegal - SMY',
            'Tambacounda  Senegal - TUD',
            'Kolda  Senegal - KDA',
            'Kedougou  Senegal - KGG',
            'Kaolack  Senegal - KLC',
            'Matam  Senegal - MAX',
            'Dakar Yoff Senegal - DKR',
            'Cap Skirring  Senegal - CSK',
            'Bakel  Senegal - BXE',
            'Burao  Somalia - BUO',
            'Borama  Somalia - BXX',
            'Bardera  Somalia - BSY',
            'Bossaso  Somalia - BSA',
            'Baidoa  Somalia - BIB',
            'Berbera  Somalia - BBO',
            'Alula  Somalia - ALU',
            'Candala  Somalia - CXN',
            'Obbia  Somalia - CMO',
            'Scusciuban  Somalia - CMS',
            'Erigavo  Somalia - ERA',
            'Las Khoreh  Somalia - LKR',
            'Lugh Ganane  Somalia - LGX',
            'Kismayu  Somalia - KMU',
            'Garbaharey  Somalia - GBM',
            'Garoe  Somalia - GGR',
            'Eil  Somalia - HCM',
            'Gardo  Somalia - GSR',
            'Galcaio  Somalia - GLK',
            'Hargeisa  Somalia - HGA',
            'Mogadishu Mogadishu Intl Somalia - MGQ',
            'Moengo  Suriname - MOJ',
            'Paloemeu Vincent Fayks Suriname - OEM',
            'Paramaribo Zorg En Hoop Suriname - ORG',
            'Paramaribo Zanderij Intl Suriname - PBM',
            'Totness Coronie Suriname - TOT',
            'Stoelmans Eiland  Suriname - SMZ',
            'Washabo  Suriname - WSO',
            'Nieuw Nickerie  Suriname - ICK',
            'Kasikasima Tepoe Airstrip Suriname - KCB',
            'Ladouanie  Suriname - LDO',
            'Djoemoe  Suriname - DOE',
            'Drietabbetje  Suriname - DRJ',
            'Wageningen  Suriname - AGI',
            'Awaradam Cayana Airstrip Suriname - AAJ',
            'Albina  Suriname - ABN',
            'Botopasie  Suriname - BTO',
            'Sao Tome Is  Sao Tome And Principe Islands  - TMS',
            'Principe  Sao Tome And Principe Islands  - PCP',
            'Porto Alegre  Sao Tome And Principe Islands  - PGP',
            'San Salvador Comalapa Intl. El Salvador - SAL',
            'Palmyra  Syrian Arab Republic - PMS',
            'Al Thaurah  Syrian Arab Republic - SOR',
            'Aleppo Nejrab Syrian Arab Republic - ALP',
            'Deirezzor Al Syrian Arab Republic - DEZ',
            'Damascus Damascus Intl Syrian Arab Republic - DAM',
            'Latakia  Syrian Arab Republic - LTK',
            'Kameshli  Syrian Arab Republic - KAC',
            'Manzini Matsapha Intl Swaziland - MTS',
            'Middle Caicos  Turks And Caicos Islands - MDS',
            'North Caicos  Turks And Caicos Islands - NCA',
            'Providenciales  Turks And Caicos Islands - PLS',
            'Pine Cay  Turks And Caicos Islands - PIC',
            'Salt Cay  Turks And Caicos Islands - SLX',
            'South Caicos South Caicos Intl Turks And Caicos Islands - XSC',
            'Grand Turk Is  Turks And Caicos Islands - GDT',
            'Faya  Chad - FYT',
            'Lai  Chad - LTC',
            'Mao  Chad - AMO',
            'Am Timan  Chad - AMC',
            'Zakouma  Chad - AKM',
            'Abecher  Chad - AEH',
            'Ati  Chad - ATV',
            'Abou Deia  Chad - AOD',
            'Bokoro  Chad - BKR',
            'Sarh  Chad - SRH',
            'Oum Hadjer  Chad - OUM',
            'Bousso  Chad - OUT',
            'Bol  Chad - OTC',
            'Pala  Chad - PLF',
            'Ndjamena  Chad - NDJ',
            'Bongor  Chad - OGR',
            'Melfi  Chad - MEF',
            'Mongo  Chad - MVO',
            'Moundou  Chad - MQQ',
            'Lama Kara  Togo - LRL',
            'Lome  Togo - LFW',
            'Lampang  Thailand - LPT',
            'Loei  Thailand - LOE',
            'Mae Sot  Thailand - MAQ',
            'Krabi  Thailand - KBV',
            'Kamphangsaen  Thailand - KDT',
            'Nakhon Phanom  Thailand - KOP',
            'Lop Buri  Thailand - KKM',
            'Khon Kaen  Thailand - KKC',
            'Mae Hong Son  Thailand - HGN',
            'Hat Yai  Thailand - HDY',
            'Hua Hin Hua Hin Airport Thailand - HHQ',
            'Phuket Phuket Intl Thailand - HKT',
            'Bangkok Don Mueang Intl Thailand - DMK',
            'Bangkok Suvarnabhumi Intl Thailand - BKK',
            'Buri Ram  Thailand - BFV',
            'Ban Mak Khaen Udorn Thailand - BAO',
            'Chiang Mai Chiang Mai Intl Thailand - CNX',
            'Chumphon Chumphon Airport Thailand - CJM',
            'Chiang Rai  Thailand - CEI',
            'Nakhon Ratchasima  Thailand - NAK',
            'Narathiwat  Thailand - NAW',
            'Nakon Si Thammarat  Thailand - NST',
            'Nan  Thailand - NNT',
            'Phanom Sarakham  Thailand - PMM',
            'Phrae  Thailand - PRH',
            'Pattaya  Thailand - PYX',
            'Pai  Thailand - PYY',
            'Surin  Thailand - PXR',
            'Patong Beach  Thailand - PBS',
            'Pattani  Thailand - PAN',
            'Phetchabun Phetchabun Apt Thailand - PHY',
            'Phi Phi Island  Thailand - PHZ',
            'Phitsanulok  Thailand - PHS',
            'Songkhla  Thailand - SGZ',
            'Roi Et  Muang) Roi Et Airport Thailand - ROI',
            'Sakon Nakhon  Thailand - SNO',
            'Trat Trat Airport Thailand - TDX',
            'Trang  Thailand - TST',
            'Sukhothai  Thailand - THS',
            'Tak  Thailand - TKT',
            'Takhli  Thailand - TKH',
            'Ubon Ratchathani Ubon Ratchathani Intl Thailand - UBP',
            'Ranong  Thailand - UNN',
            'Koh Samui  Thailand - USM',
            'Surat Thani  Thailand - URT',
            'Utapao  Thailand - UTP',
            'Uttaradit  Thailand - UTR',
            'Udon Thani  Thailand - UTH',
            'Kulyab  Tajikistan - TJU',
            'Dushanbe  Tajikistan - DYU',
            'Qurghonteppa Kurgan Tube Tajikistan - KQT',
            'Khudzhand  Tajikistan - LBD',
            'Dili Comoro Timor Leste - DIL',
            'Baucau English Madeira Timor Leste - BCH',
            'Suai  Timor Leste - UAI',
            'Viqueque  Timor Leste - VIQ',
            'Ocussi  Timor Leste - OEC',
            'Maliana  Timor Leste - MPT',
            'Mary  Turkmenistan - MYP',
            'Dashoguz Turkmenistan - TAZ',
            'Aşkabat Türkmenistan Ashgabad Turkmenistan - ASB',
            'Turkmenabad Turkmenabad Airport Turkmenistan - CRZ',
            'Turkmanbashi  Turkmenistan - KRW',
            'Gabes Matmata Tunisia - GAE',
            'Gafsa Ksar Tunisia - GAF',
            'Djerba Zarzis Tunisia - DJE',
            'El Borma  Tunisia - EBM',
            'Tabarka 7 Novembre Tunisia - TBJ',
            'Tunis Carthage Tunisia - TUN',
            'Tozeur Nefta Tunisia - TOE',
            'Monastir Habib Bourguiba In Tunisia - MIR',
            'Enfidha Zine Elabidine Ben Ali Tunisia - NBE',
            'Sfax Thyna Tunisia - SFA',
            'Niuafo ou Mata aho Tonga - NFO',
            'Niuatoputapu Kuini Lavenia Tonga - NTT',
            'Tongatapu Fua amotu Intl Tonga - TBU',
            'Vava u Lupepau u Tonga - VAV',
            'Eua Kaufana Tonga - EUA',
            'Ha apai Salote Pilolevu Tonga - HPA',
            'Port Of Spain Piarco Trinidad And Tobago - POS',
            'Tobago  Trinidad And Tobago - TAB',
            'Funafuti Atol Funafuti Atol Intl Tuvalu - FUN',
            'Hengchun  Taiwan - HCN',
            'Green Island  Taiwan - GNI',
            'Hsinchu  Taiwan - HSZ',
            'Hualien  Taiwan - HUN',
            'Orchid Island  Taiwan - KYD',
            'Lishan  Taiwan - LHN',
            'Kaohsiung Kaohsiung Intl Taiwan - KHH',
            'Kinmen Shang Yi Taiwan - KNH',
            'Chi Mei  Taiwan - CMJ',
            'Chiayi  Taiwan - CYI',
            'Sun Moon Lake  Taiwan - SMT',
            'Taitung  Taiwan - TTT',
            'Taichung Ching Chuan Kang Apt Taiwan - RMQ',
            'Tainan  Taiwan - TNN',
            'Taipei Taiwan Taoyuan Intl Taiwan - TPE',
            'Taipei Sung Shan Taiwan - TSA',
            'Wonan  Taiwan - WOT',
            'Pingtung  Taiwan - PIF',
            'Matsu  Taiwan - MFK',
            'Makung  Taiwan - MZG',
            'Mtwara  Tanzania-United Republic - MYW',
            'Nachingwea  Tanzania-United Republic - NCH',
            'Mafia  Tanzania-United Republic - MFA',
            'Mwadui  Tanzania-United Republic - MWN',
            'Mwanza  Tanzania-United Republic - MWZ',
            'Musoma  Tanzania-United Republic - MUZ',
            'Pemba Wawi Tanzania-United Republic - PMA',
            'Songea  Tanzania-United Republic - SGX',
            'Seronera  Tanzania-United Republic - SEU',
            'Masasi  Tanzania-United Republic - XMI',
            'Zanzibar Kisauni Tanzania-United Republic - ZNZ',
            'Kigoma  Tanzania-United Republic - TKQ',
            'Tanga  Tanzania-United Republic - TGT',
            'Shinyanga  Tanzania-United Republic - SHY',
            'Tabora  Tanzania-United Republic - TBO',
            'Sumbawanga  Tanzania-United Republic - SUT',
            'Dar Es Salaam Dar Es Salaam Intl Tanzania-United Republic - DAR',
            'Dodoma  Tanzania-United Republic - DOD',
            'Bukoba  Tanzania-United Republic - BKZ',
            'Arusha  Tanzania-United Republic - ARK',
            'Kilwa  Tanzania-United Republic - KIY',
            'Njombe  Tanzania-United Republic - JOM',
            'Kilimanjaro  Tanzania-United Republic - JRO',
            'Lake Manyara  Tanzania-United Republic - LKY',
            'Lindi Kikwetu Tanzania-United Republic - LDI',
            'Mbeya  Tanzania-United Republic - MBI',
            'Lushoto  Tanzania-United Republic - LUY',
            'Iringa Nduli Tanzania-United Republic - IRI',
            'Geita  Tanzania-United Republic - GIT',
            'Moyo  Uganda - OYG',
            'Pakuba  Uganda - PAF',
            'Arua  Uganda - RUA',
            'Gulu  Uganda - ULU',
            'Tororo  Uganda - TRY',
            'Soroti  Uganda - SRT',
            'Entebbe  Uganda - EBB',
            'Kasese  Uganda - KSE',
            'Masindi  Uganda - KCU',
            'Jinja  Uganda - JIN',
            'Kabalega Falls  Uganda - KBG',
            'Mbarara  Uganda - MBQ',
            'Johnston Island  U.S. Minor Outlying Islands - JON',
            'Wake Island  U.S. Minor Outlying Islands - AWK',
            'Midway Island Sand Island U.S. Minor Outlying Islands - MDY',
            'Medfra  United States Of America - MDR',
            'Madison Jefferson Grd United States Of America - MDN',
            'Middleton Island Interm United States Of America - MDO',
            'Madras City County United States Of America - MDJ',
            'Carbondale Sth Illinois United States Of America - MDH',
            'Medford  United States Of America - MDF',
            'Mason City  United States Of America - MCW',
            'Minden Douglas County United States Of America - MEV',
            'Mesquite  United States Of America - MFH',
            'Marshfield Marshfield Mnpl United States Of America - MFI',
            'Mansfield Lahm Mncp United States Of America - MFD',
            'Mcallen Miller Intl United States Of America - MFE',
            'Meridian Key Field United States Of America - MEI',
            'Meadville  United States Of America - MEJ',
            'Manteo Dare County Reg United States Of America - MEO',
            'Memphis Nas United States Of America - NQA',
            'Memphis Memphis Intl United States Of America - MEM',
            'Medford Jackson County United States Of America - MFR',
            'Melfa Accomack County United States Of America - MFV',
            'Moultrie Thomasville United States Of America - MGR',
            'Moultrie Spence United States Of America - MUL',
            'Montgomery Dannelly Fld United States Of America - MGM',
            'Montgomery Gunter Afb United States Of America - GUN',
            'Montgomery Maxwell Afb United States Of America - MXF',
            'Matagorda Isl Matagorda United States Of America - MGI',
            'Montgomery Orange County United States Of America - MGJ',
            'Marietta Atlanta Nas United States Of America - NCQ',
            'Marietta Dobbins Afb United States Of America - MGE',
            'Michigan City Michigan United States Of America - MGC',
            'Mojave Kern County United States Of America - MHV',
            'Mount Shasta Rep United States Of America - MHS',
            'Manchester Manchester Boston Rgnl United States Of America - MHT',
            'Muncie Delaware County United States Of America - MIE',
            'Monahans Roy Hurd Mem United States Of America - MIF',
            'Miami Miami Intl United States Of America - MIA',
            'Miami Seaplane Base United States Of America - MPB',
            'Miami Tamiami United States Of America - TMB',
            'Miami Opa Locka United States Of America - OPF',
            'Miami Dade Collier United States Of America - TNT',
            'Morgantown  United States Of America - MGW',
            'Mitchell Mitchell Mnpl United States Of America - MHE',
            'Manhattan Manhattan Mnpl United States Of America - MHK',
            'Marshall Memorial Mncp United States Of America - MHL',
            'Minchumina Intermediate United States Of America - MHM',
            'Mullen  United States Of America - MHN',
            'Manley Hot Spring  United States Of America - MLY',
            'Miles City Miles City Mnpl United States Of America - MLS',
            'Millinocket  United States Of America - MLT',
            'Monroe Monroe Mnpl United States Of America - MLU',
            'Mammoth Lakes  United States Of America - MMH',
            'Athens Mcminn County United States Of America - MMI',
            'Moline Quad City United States Of America - MLI',
            'Milledgeville Baldwin C United States Of America - MLJ',
            'Malta  United States Of America - MLK',
            'Marshall  United States Of America - MLL',
            'Milford  United States Of America - MLF',
            'Melbourne Melbourne Intl United States Of America - MLB',
            'Mc Alester  United States Of America - MLC',
            'Malad City  United States Of America - MLD',
            'Marshall Marshall Mnpl United States Of America - MML',
            'Stow Minute Man Airfield United States Of America - MMN',
            'Marks Selfs United States Of America - MMS',
            'Morristown Morristown Mnpl United States Of America - MMU',
            'Menominee  United States Of America - MNM',
            'Marion Marion Mnpl United States Of America - MNN',
            'Minto  United States Of America - MNT',
            'Miami  United States Of America - MIO',
            'Shafter Kern County United States Of America - MIT',
            'Millville  United States Of America - MIV',
            'Marshalltown Mncp United States Of America - MIW',
            'Jackson  United States Of America - MJQ',
            'Kansas City Kansas City Intl United States Of America - MCI',
            'Kansas City Downtown United States Of America - MKC',
            'Kansas City Johnson Exec United States Of America - OJC',
            'Kansas City Johnson Ind United States Of America - JCI',
            'Milwaukee General Mitchell United States Of America - MKE',
            'Milwaukee Timmerman United States Of America - MWC',
            'Muskegon  United States Of America - MKG',
            'Muskogee Hatbox Field United States Of America - HAX',
            'Muskogee Davis Field United States Of America - MKO',
            'Hoolehua Molokai United States Of America - MKK',
            'Jackson Mckellar United States Of America - MKL',
            'Toms River R J Miller United States Of America - MJX',
            'Mankato Mankato Mnpl United States Of America - MKT',
            'Montpelier Edward F K State United States Of America - MPV',
            'Mount Pleasant Mount Pleasant Mnpl United States Of America - MPZ',
            'Macomb Macomb Mnpl United States Of America - MQB',
            'Quincy  United States Of America - MQI',
            'Mcpherson  United States Of America - MPR',
            'Mount Pleasant  United States Of America - MPS',
            'Mount Pocono  United States Of America - MPO',
            'Madison Griswold United States Of America - MPE',
            'Manassas  United States Of America - MNZ',
            'Mobile Mobile Municipal United States Of America - MOB',
            'Mobile Mob Aerospace United States Of America - BFM',
            'Modesto Modesto Mnpl United States Of America - MOD',
            'Morris Morris Mnpl United States Of America - MOX',
            'Mount Pleasant Mount Pleasant Mnpl United States Of America - MOP',
            'Morristown Moore Murrel United States Of America - MOR',
            'Moses Point Intermediate United States Of America - MOS',
            'Minot Minot Afb United States Of America - MIB',
            'Minot Minot Intl United States Of America - MOT',
            'Mountain Village  United States Of America - MOU',
            'Massena Richards Field United States Of America - MSS',
            'Monticello Sullivan Cnt United States Of America - MSV',
            'Mount Clemens Detroit Naf United States Of America - NFB',
            'Mount Clemens Selfridge Ang United States Of America - MTC',
            'New Orleans Nas United States Of America - NBG',
            'New Orleans Lakefront United States Of America - NEW',
            'New Orleans L Armstrong Intl United States Of America - MSY',
            'Mesa Falcon Field United States Of America - MSC',
            'Mount Pleasant  United States Of America - MSD',
            'Muscle Shoals  United States Of America - MSL',
            'Madison Dane Couty Regio United States Of America - MSN',
            'Missoula Johnson Bell F United States Of America - MSO',
            'Minneapolis Saint Paul Intl United States Of America - MSP',
            'Minneapolis Crystal United States Of America - MIC',
            'Minneapolis Flying Cloud United States Of America - FCM',
            'Mc Rae Telfair Wheeler United States Of America - MQW',
            'Martinsburg  United States Of America - MRB',
            'Columbia Maury County United States Of America - MRC',
            'Marfa Marfa Mnpl United States Of America - MRF',
            'Smyrna  United States Of America - MQY',
            'Monterey Fritzsche Aaf United States Of America - OAR',
            'Monterey Monterey Penins United States Of America - MRY',
            'Marco Island  United States Of America - MRK',
            'Morganton Lenoir United States Of America - MRN',
            'Marquette Sawyer Intl United States Of America - MQT',
            'Monticello Monticello Mnpl United States Of America - MXO',
            'Mccarthy  United States Of America - MXY',
            'Myrtle Beach Grd Strand United States Of America - CRE',
            'Myrtle Beach Myrtle Afb United States Of America - MYR',
            'Mekoryuk Ellis Field United States Of America - MYU',
            'Marysville Yuba County United States Of America - MYV',
            'Marysville Beale Afb United States Of America - BAB',
            'May Creek  United States Of America - MYK',
            'Mccall  United States Of America - MYL',
            'Marble Canyon  United States Of America - MYH',
            'Manila Manila Mnpl United States Of America - MXA',
            'Mount Wilson  United States Of America - MWS',
            'Monticello San Juan Cnt United States Of America - MXC',
            'Maxton  United States Of America - MXE',
            'Marlborough  United States Of America - MXG',
            'Middletown Hook Field United States Of America - MWO',
            'Mineral Wells Mineral Wells Arpt United States Of America - MWL',
            'Mineral Wells Fort Wolter United States Of America - CWO',
            'Windom Windom Mnpl United States Of America - MWM',
            'Marion Williamson Count United States Of America - MWA',
            'Moses Lake Larson Afb United States Of America - LRN',
            'Moses Lake Grant County United States Of America - MWH',
            'Muscatine  United States Of America - MUT',
            'Mount Union  United States Of America - MUU',
            'Mountain Home Afb United States Of America - MUO',
            'Monroeville Monroe Cnty United States Of America - MVC',
            'Montevideo Montevideo Mnpl United States Of America - MVE',
            'Stowe Morrisville Stowe United States Of America - MVL',
            'Kayenta Monument Valley United States Of America - MVM',
            'Mount Vernon Mount Vernon Outland United States Of America - MVN',
            'Marthas Vineyard  United States Of America - MVY',
            'Mount Vernon Skagit Reg United States Of America - MVW',
            'Metlakatla Spb United States Of America - MTM',
            'Mattoon Coles County Mem United States Of America - MTO',
            'Montauk Sky Portal United States Of America - MTP',
            'Montrose Montrose County United States Of America - MTJ',
            'Marathon Marathon Flight United States Of America - MTH',
            'Kamuela  United States Of America - MUE',
            'Fort Indiantown Muir Aaf United States Of America - MUI',
            'Manitowoc Manitowoc Mnpl United States Of America - MTW',
            'Oak Harbor  United States Of America - ODW',
            'Vincennes Oneal United States Of America - OEA',
            'Oakland Oakland Coliseum United States Of America - OBT',
            'Oakland  United States Of America - ODM',
            'Oceanside Oceanside Mnpl United States Of America - OCN',
            'Washington Warren Field United States Of America - OCW',
            'Oakdale  United States Of America - ODC',
            'Northbrook Sky Harbor United States Of America - OBK',
            'Ocean Reef  United States Of America - OCA',
            'Kobuk Kobuk Wien United States Of America - OBU',
            'Ocean City Ocean City Mnpl United States Of America - OCE',
            'Ocala Taylor Field United States Of America - OCF',
            'Nacogdoches Lufkin Angel United States Of America - LFK',
            'Nacogdoches  United States Of America - OCH',
            'Oceanic  United States Of America - OCI',
            'Osceola Osceola Mnpl United States Of America - OEO',
            'Norfolk Stefan Field United States Of America - OFK',
            'Kahului  United States Of America - OGG',
            'Ogallala Searle Field United States Of America - OGA',
            'Orangeburg Orangeburg Mnpl United States Of America - OGB',
            'Ogden Hill Afb United States Of America - HIF',
            'Ogden Ogden Mnpl United States Of America - OGD',
            'Ogdensburg  United States Of America - OGS',
            'Northeast Cape Afs United States Of America - OHC',
            'Nuiqsut  United States Of America - NUI',
            'Nulato  United States Of America - NUL',
            'Nunapitchuk  United States Of America - NUP',
            'Mountain View Moffett Fl United States Of America - NUQ',
            'Newport Parlin Field United States Of America - NWH',
            'Beckwourth Nervino United States Of America - NVN',
            'Nevada  United States Of America - NVD',
            'Whidbey Island Ault Fld United States Of America - NUW',
            'New York Marine Air United States Of America - QNY',
            'New York Battery Pk City United States Of America - NBP',
            'New York Wall Street Spb United States Of America - NWS',
            'New York La Guardia United States Of America - LGA',
            'New York John F Kennedy United States Of America - JFK',
            'New York Newark Liberty Intl United States Of America - EWR',
            'New York East 34St Landing United States Of America - NES',
            'Quantico Quantanico Nas United States Of America - NYG',
            'Willow Grove Willow Grov United States Of America - NXX',
            'Okeechobee County United States Of America - OBE',
            'South Weymouth  United States Of America - NZW',
            'Jacksonville A J Ellis United States Of America - OAJ',
            'Oakland Oakland Intl United States Of America - OAK',
            'Northway  United States Of America - ORT',
            'Noorvik Curtis Memorial United States Of America - ORV',
            'Osage Beach  United States Of America - OSB',
            'Oscoda Wurtsmith Afb United States Of America - OSC',
            'Oshkosh Wittman Field United States Of America - OSH',
            'Kosciusko Attala County United States Of America - OSX',
            'Opelousas Saint Landry United States Of America - OPL',
            'Orlando Herndon United States Of America - ORL',
            'Orlando Disney World United States Of America - DWS',
            'Orlando Orlando Sanford Intl United States Of America - SFB',
            'Orlando Orlando Intl United States Of America - MCO',
            'Norfolk Norfolk Intl United States Of America - ORF',
            'Norfolk Nas Chambers United States Of America - NGU',
            'Worcester  United States Of America - ORH',
            'Port Lions Port Lions Sp United States Of America - ORI',
            'Olney  United States Of America - ONY',
            'Oskaloosa Oskaloosa Mnpl United States Of America - OOA',
            'Toksook Bay  United States Of America - OOK',
            'Oneill Oneill Mnpl United States Of America - ONL',
            'Socorro  United States Of America - ONM',
            'Onion Bay  United States Of America - ONN',
            'Ontario  United States Of America - ONO',
            'Newport  United States Of America - ONP',
            'Ontario La United States Of America - ONT',
            'Oneonta Oneonta Mnpl United States Of America - ONH',
            'Winona Winona Mnpl United States Of America - ONA',
            'Omak Omak Mnpl United States Of America - OMK',
            'Olympia  United States Of America - OLM',
            'Nome  United States Of America - OME',
            'Nogales Nogales Intl United States Of America - OLS',
            'Columbus  United States Of America - OLU',
            'Olive Branch Olive Branc United States Of America - OLV',
            'Olney Olney Noble United States Of America - OLY',
            'Omaha Millard United States Of America - MIQ',
            'Omaha Eppley Airfield United States Of America - OMA',
            'Oshkosh  United States Of America - OKS',
            'Okmulgee  United States Of America - OKM',
            'Old Town  United States Of America - OLD',
            'Olean Olean Mnpl United States Of America - OLE',
            'Wolf Point Wolf Point Intl United States Of America - OLF',
            'Old Harbor Old Harbor Sp United States Of America - OLH',
            'Norwich Eaton United States Of America - OIC',
            'Oil City Splane Memorial United States Of America - OIL',
            'Kokomo  United States Of America - OKK',
            'Oklahoma City Tinker Afb United States Of America - TIK',
            'Oklahoma City Will Rogers World United States Of America - OKC',
            'Oklahoma City Wiley Post United States Of America - PWA',
            'Oklahoma City Downtown United States Of America - DWN',
            'Nightmute  United States Of America - NME',
            'Niles Jerry Tyler Memo United States Of America - NLE',
            'Nelson Lagoon  United States Of America - NLG',
            'Kneeland  United States Of America - NLN',
            'Naknek  United States Of America - NNK',
            'Nondalton  United States Of America - NNL',
            'Ninilchik  United States Of America - NIN',
            'Nikolai  United States Of America - NIB',
            'Niblack  United States Of America - NIE',
            'Beeville Chase Field Nas United States Of America - NIR',
            'Nichen Cove  United States Of America - NKV',
            'Lemoore Nas Reeves Field United States Of America - NLC',
            'Naukiti  United States Of America - NKI',
            'Oceana Nas United States Of America - NTU',
            'Port Hueneme Point Mugu United States Of America - NTD',
            'Manti Manti Ephraim United States Of America - NTJ',
            'Slayton Municipal United States Of America - NSL',
            'Imperial Beach Nas United States Of America - NRS',
            'Milton Whiting Field Nas United States Of America - NSE',
            'Shangri La  United States Of America - NRI',
            'Mayport Ns United States Of America - NRB',
            'Crows Landing Aux Field United States Of America - NRC',
            'Nakolik River  United States Of America - NOL',
            'Nephi  United States Of America - NPH',
            'Novato  United States Of America - NOT',
            'Newport State United States Of America - NPT',
            'Kingsville Nas United States Of America - NQI',
            'Glynco Nas United States Of America - NEA',
            'Lakehurst Naec United States Of America - NEL',
            'Whitehouse Olf Usn United States Of America - NEN',
            'Fallon Fallon Mnpl United States Of America - FLX',
            'Fallon Nas United States Of America - NFL',
            'Patuxent River Nas United States Of America - NHK',
            'Foley Barin Olf Osn United States Of America - NHX',
            'Brunswick Nas United States Of America - NHZ',
            'Alameda Nas United States Of America - NGZ',
            'Marana  United States Of America - MZJ',
            'Marion  United States Of America - MZZ',
            'Barbers Point  United States Of America - NAX',
            'Glenview Nas United States Of America - NBU',
            'New Chenega  United States Of America - NCN',
            'Quonset Point Nas United States Of America - NCO',
            'Ruidoso Ruidoso Mnpl United States Of America - RUI',
            'Raton Crews Field United States Of America - RTN',
            'Spirit Lake  United States Of America - RTL',
            'Rotunda  United States Of America - RTD',
            'Marguerite Bay  United States Of America - RTE',
            'Rochester Rochester Mnpl United States Of America - RST',
            'Rouses Point  United States Of America - RSX',
            'Russell  United States Of America - RSL',
            'Ruston  United States Of America - RSN',
            'Raspberry Strait  United States Of America - RSP',
            'Rosario Rosario Spb United States Of America - RSJ',
            'Rusyan Mission Rusyan United States Of America - RSH',
            'Rexburg Madison County United States Of America - RXE',
            'Rowan Bay  United States Of America - RWB',
            'Redwood Falls Redwood United States Of America - RWF',
            'Rocky Mount  United States Of America - RWI',
            'Rawlins  United States Of America - RWL',
            'Rutland  United States Of America - RUT',
            'Green River  United States Of America - RVR',
            'Savannah  United States Of America - SAV',
            'Savannah Hunter Aaf United States Of America - SVN',
            'Santa Barbara Saint Ba Mnpl United States Of America - SBA',
            'Santa Barbara Santa Cruz Island United States Of America - SZN',
            'Shelby  United States Of America - SBX',
            'Salisbury Wicomico Cnty United States Of America - SBY',
            'Steamboat Springs  United States Of America - SBS',
            'San Bernardino Norton Af United States Of America - SBD',
            'San Bernardino Tri City United States Of America - SBT',
            'Sheboygan Memorial United States Of America - SBM',
            'South Bend South Bend Regional United States Of America - SBN',
            'Salina  United States Of America - SBO',
            'Santa Fe  United States Of America - SAF',
            'Sagwon  United States Of America - SAG',
            'Roanoke Rapids Halifax United States Of America - RZZ',
            'Saratoga Shively United States Of America - SAA',
            'Sacramento Mcclellan Afb United States Of America - MCC',
            'Sacramento Mather Afb United States Of America - MHR',
            'Sacramento Executive United States Of America - SAC',
            'Sacramento Sacramento Intl United States Of America - SMF',
            'Sacramento Stockton United States Of America - SCK',
            'Safford  United States Of America - SAD',
            'San Diego Lindberg Fld United States Of America - SAN',
            'San Diego Miramar Nas United States Of America - NKX',
            'San Diego Brown Field United States Of America - SDM',
            'San Diego North Island Nas United States Of America - NZY',
            'San Diego Montgomery Fld United States Of America - MYF',
            'San Diego Gillespie United States Of America - SEE',
            'San Diego Mc Clellan Palomar United States Of America - CLD',
            'Sparta Sparta Community United States Of America - SAR',
            'Salton City  United States Of America - SAS',
            'San Antonio Kelly Afb United States Of America - SKF',
            'San Antonio San Antonio Intl United States Of America - SAT',
            'San Antonio Randolph Afb United States Of America - RND',
            'San Antonio Stinson Mun United States Of America - SSF',
            'San Antonio Martindale United States Of America - MDA',
            'Seymour Freeman Mncpl United States Of America - SER',
            'Selma Selfield United States Of America - SES',
            'Selma Craig Afb United States Of America - SEM',
            'Stephenville Clark Field United States Of America - SEP',
            'Sand Point Sand Point Mnpl United States Of America - SDP',
            'Sedona  United States Of America - SDX',
            'Sidney Richland Mncpl United States Of America - SDY',
            'Sebring Air Terminal United States Of America - SEF',
            'Selinsgrove Penn Valley United States Of America - SEG',
            'Seattle Boeing Fld Intl United States Of America - BFI',
            'Seattle Lake Union Spb United States Of America - LKE',
            'Seattle Seattle Tacoma United States Of America - SEA',
            'Louisville Intercont United States Of America - LJC',
            'Louisville Louisville Intl United States Of America - SDF',
            'Louisville Bowman Field United States Of America - LOU',
            'Scribner State United States Of America - SCB',
            'Prudhoe Bay Deadh  United States Of America - SCC',
            'State College University Park United States Of America - SCE',
            'Schenectady County United States Of America - SCH',
            'Scammon Bay Spb United States Of America - SCM',
            'Smith Cove  United States Of America - SCJ',
            'Skagway Skagway Mnpl United States Of America - SGY',
            'Staunton Shenandoah Val United States Of America - SHD',
            'Shelton Sanderson Field United States Of America - SHN',
            'Shungnak  United States Of America - SHG',
            'Shishmaref  United States Of America - SHH',
            'Springfield  United States Of America - SGH',
            'Stuttgart  United States Of America - SGT',
            'Saint George Saint George Municipal United States Of America - SGU',
            'Saginaw Bay  United States Of America - SGW',
            'Sugar Land Mncpl United States Of America - SGR',
            'San Fernando  United States Of America - SFR',
            'Springfield Branson Rg United States Of America - SGF',
            'Springfield Westover Metro United States Of America - CEF',
            'Springfield  United States Of America - SFY',
            'Smithfield North Central United States Of America - SFZ',
            'Sanford  United States Of America - SFM',
            'San Francisco San Francisco Intl United States Of America - SFO',
            'San Francisco Embarkader United States Of America - EMB',
            'Renton  United States Of America - RNT',
            'Rensselaer  United States Of America - RNZ',
            'Roanoke Roanoke Mnpl United States Of America - ROA',
            'Rochester Monroe County United States Of America - ROC',
            'Reno Tahoe Intl United States Of America - RNO',
            'Mcminnville Warren Cnty United States Of America - RNC',
            'Rangely  United States Of America - RNG',
            'New Richmond New Richmond Mnpl United States Of America - RNH',
            'Rampart  United States Of America - RMP',
            'Mariposa Mariposa-Yosemite United States Of America - RMY',
            'Rome Griffiss Afb United States Of America - RME',
            'Rome Richard B Russell United States Of America - RMG',
            'Merrill Merrill Mnpl United States Of America - RRL',
            'Warroad  United States Of America - RRT',
            'Roundup  United States Of America - RPX',
            'Roswell Industrial United States Of America - ROW',
            'Roseau Roseau Mnpl United States Of America - ROX',
            'Rogers  United States Of America - ROG',
            'Roosevelt  United States Of America - ROL',
            'Rifle Garfield County United States Of America - RIL',
            'Riverton  United States Of America - RIW',
            'Rockwood Rockwood Mnpl United States Of America - RKW',
            'Rolla National United States Of America - RLA',
            'Richland  United States Of America - RLD',
            'Bornite Bornite Upper United States Of America - RLU',
            'Yreka  United States Of America - RKC',
            'Rockland Knox County Reg United States Of America - RKD',
            'Rock Hill  United States Of America - RKH',
            'Rockport Aransas County United States Of America - RKP',
            'Poteau Robert S Kerr United States Of America - RKR',
            'Rock Springs Sweetwater United States Of America - RKS',
            'Rhinelander Oneida Coun United States Of America - RHI',
            'Richmond Richmond Intl United States Of America - RIC',
            'Richmond  United States Of America - RID',
            'Rice Lake  United States Of America - RIE',
            'Richfield Reynolds United States Of America - RIF',
            'Ranger Ranger Municipal United States Of America - RGR',
            'Refugio Rooke Field United States Of America - RFG',
            'Refugio Tom O connor United States Of America - VDU',
            'Anguilla Rollang Field United States Of America - RFK',
            'Raleigh Durham  United States Of America - RDU',
            'Red Devil  United States Of America - RDV',
            'Red River Grand Forks Af United States Of America - RDR',
            'Reading Reading Mnpl United States Of America - RDG',
            'Redmond Roberts Field United States Of America - RDM',
            'Reed City Miller Field United States Of America - RCT',
            'Redding Benton Field United States Of America - BZF',
            'Redding  United States Of America - RDD',
            'Red Dog  United States Of America - RDB',
            'Rome State United States Of America - REO',
            'Reedsville Mifflin Cnty United States Of America - RED',
            'Rehoboth Beach  United States Of America - REH',
            'Ruby  United States Of America - RBY',
            'Roche Harbor  United States Of America - RCE',
            'Walterboro Walterboro Mnpl United States Of America - RBW',
            'Cinder River  United States Of America - RCP',
            'Rockdale Coffield United States Of America - RCK',
            'Rochester Fulton County United States Of America - RCR',
            'Fort Jefferson  United States Of America - RBN',
            'Big Bear Big Bear City United States Of America - RBF',
            'Roseburg Roseburg Mnpl United States Of America - RBG',
            'Brooks Lodge  United States Of America - RBH',
            'Rancho French Valley United States Of America - RBK',
            'Red Bluff Red Bluff Fss United States Of America - RBL',
            'Montvale  United States Of America - QMV',
            'Racine Horlick United States Of America - RAC',
            'Winter Park Bus Station United States Of America - QWP',
            'Riverside  United States Of America - RAL',
            'Riverside March Afb United States Of America - RIV',
            'Riverside Fla Bob United States Of America - RIR',
            'Rapid City Ellsworth Afb United States Of America - RCA',
            'Rapid City Regional United States Of America - RAP',
            'Palmer Palmer Mnpl United States Of America - PAQ',
            'Pine Bluff Grider Field United States Of America - PBF',
            'Plattsburgh Plattsburgh Intl Apt United States Of America - PBG',
            'West Palm Beach County United States Of America - LNA',
            'West Palm Beach Pbeach I United States Of America - PBI',
            'Palo Alto  United States Of America - PAO',
            'Hanapepe Port Allen United States Of America - PAK',
            'Paducah Barkley Regional United States Of America - PAH',
            'Everett Snohomish County United States Of America - PAE',
            'Pack Creek  United States Of America - PBK',
            'Princeton  United States Of America - PCT',
            'Picayune Pearl River Cnt United States Of America - PCU',
            'Porcupine Creek  United States Of America - PCK',
            'Portage Creek  United States Of America - PCA',
            'Prairie Du Chien Mncpl United States Of America - PCD',
            'Painter Creek  United States Of America - PCE',
            'Yosemite Ntl Park  United States Of America - OYS',
            'Ozona  United States Of America - OZA',
            'Ozark Cairns Aaf United States Of America - OZR',
            'Owatonna  United States Of America - OWA',
            'Owensboro Daviess Count United States Of America - OWB',
            'Norwood Memorial United States Of America - OWD',
            'Oroville  United States Of America - OVE',
            'Oxford Waterbury Oxford United States Of America - OXC',
            'Oxford Miami University United States Of America - OXD',
            'Norridgewock Cntrl Maine United States Of America - OWK',
            'Oxnard  United States Of America - OXR',
            'Worthington  United States Of America - OTG',
            'North Bend  United States Of America - OTH',
            'Ottumwa Industrial United States Of America - OTM',
            'Oaktown Green United States Of America - OTN',
            'Otto Vor United States Of America - OTO',
            'Kotzebue  United States Of America - OTZ',
            'Tillamook  United States Of America - OTK',
            'Anacortes  United States Of America - OTS',
            'Norman Max Westheimer United States Of America - OUN',
            'Peoria Greater Peoria United States Of America - PIA',
            'Pine Mountain Harris Cnt United States Of America - PIM',
            'Pocatello  United States Of America - PIH',
            'Pilot Point Ugashik Bay United States Of America - UGB',
            'Pilot Point Pilot Point Arpt United States Of America - PIP',
            'Pierre  United States Of America - PIR',
            'Pittsburgh International United States Of America - PIT',
            'Pittsburgh Allegheny Cou United States Of America - AGC',
            'Payson  United States Of America - PJB',
            'Point Lay Dew Station United States Of America - PIZ',
            'Park Rapids  United States Of America - PKD',
            'Park Falls  United States Of America - PKF',
            'Napaskiak Spb United States Of America - PKA',
            'Parkersburg Mid Ohio Valley Apt United States Of America - PKB',
            'Port San Juan  United States Of America - PJS',
            'Paris Henry County United States Of America - PHT',
            'Phoenix Scottsdale Mncpl United States Of America - SCF',
            'Phoenix Sky Harbor Intl United States Of America - PHX',
            'Phoenix Luke Afb United States Of America - LUF',
            'Phoenix Williams Gateway Arpt United States Of America - AZA',
            'Phoenix Deer Valley United States Of America - DVT',
            'Port Huron Saint Clair Intl United States Of America - PHN',
            'Point Hope  United States Of America - PHO',
            'Philip  United States Of America - PHP',
            'Pagosa Springs Stevens F United States Of America - PGO',
            'New Philadelphia Harry United States Of America - PHD',
            'Newport News Hampton Langley Afb United States Of America - LFI',
            'Newport News Hampton  United States Of America - PHF',
            'Pahokee Palm Beach Glade United States Of America - PHK',
            'Philadelphia North United States Of America - PNE',
            'Philadelphia Spb United States Of America - PSQ',
            'Philadelphia Wings Field United States Of America - BBX',
            'Philadelphia Mustin Alf United States Of America - MUV',
            'Philadelphia Mercer County United States Of America - TTN',
            'Philadelphia Philadelphia Intl United States Of America - PHL',
            'Paragould Paragould Mnpl United States Of America - PGR',
            'Peach Springs  United States Of America - PGS',
            'Greenville Pitt Greenvi United States Of America - PGV',
            'Pascagoula Jackson Cnty United States Of America - PGL',
            'Port Graham  United States Of America - PGM',
            'Petersburg Grant County United States Of America - PGC',
            'Punta Gorda Charlotte C United States Of America - PGD',
            'Page  United States Of America - PGA',
            'Paf Warren  United States Of America - PFA',
            'Panama City Bay County United States Of America - PFN',
            'Panama City Tyndall Afb United States Of America - PAM',
            'Panama City Nw Florida Beaches Int United States Of America - ECP',
            'Pacific City State United States Of America - PFC',
            'Port Frederick  United States Of America - PFD',
            'Pelican Pelican Spb United States Of America - PEC',
            'Portland Portland Intl United States Of America - PDX',
            'Pecos City  United States Of America - PEQ',
            'Pedro Bay  United States Of America - PDB',
            'Pendleton  United States Of America - PDT',
            'Pembina Intermediate United States Of America - PMB',
            'Plymouth  United States Of America - PLY',
            'Palmdale La Palmdale Regional United States Of America - PMD',
            'Portsmouth Regional United States Of America - PMH',
            'Port Moller Afs United States Of America - PML',
            'Paimiut Spb United States Of America - PMU',
            'Palmer  United States Of America - PMX',
            'Peterson s Point  United States Of America - PNF',
            'Ponca City  United States Of America - PNC',
            'Plattsburgh Clinton Cnty United States Of America - PLB',
            'Pell City Saint Clair Cnty United States Of America - PLR',
            'Pellston Emmet County United States Of America - PLN',
            'Point Lookout M Graham Clark United States Of America - PLK',
            'Poughkeepsie Dutchess County Apt United States Of America - POU',
            'Powell  United States Of America - POY',
            'Pampa Perry Lefors Field United States Of America - PPA',
            'Prospect Creek  United States Of America - PPC',
            'Independence Tri City United States Of America - PPF',
            'Port Protection  United States Of America - PPV',
            'Pompano Beach  United States Of America - PPM',
            'Fort Polk Polk Aaf United States Of America - POE',
            'Poplar Bluff Earl Fields United States Of America - POF',
            'La Verne Brackett Field United States Of America - POC',
            'Sherman Denison Grayson United States Of America - PNX',
            'Pocahontas Pocahontas Mnpl United States Of America - POH',
            'Polk Inlet  United States Of America - POQ',
            'Princeton  United States Of America - PNN',
            'Panguitch  United States Of America - PNU',
            'Pensacola Saufley Nas United States Of America - NUN',
            'Pensacola Regional United States Of America - PNS',
            'Pensacola Ellyson Nas United States Of America - NDP',
            'Pensacola  United States Of America - NPA',
            'Polacca  United States Of America - PXL',
            'Port Walter  United States Of America - PWR',
            'Bremerton  United States Of America - PWT',
            'Pope Vanoy  United States Of America - PVY',
            'Painesville Casement United States Of America - PVZ',
            'Plentywood Sherwood United States Of America - PWD',
            'Portland Portland Intl United States Of America - PWM',
            'Perry Island Perry Spb United States Of America - PYL',
            'Plymouth  United States Of America - PYM',
            'Paradise Skypark United States Of America - PYS',
            'Provo  United States Of America - PVU',
            'Plainview Hale County United States Of America - PVW',
            'Placerville  United States Of America - PVF',
            'Provincetown  United States Of America - PVC',
            'Providence T F Green United States Of America - PVD',
            'Pullman Moscow Regional United States Of America - PUW',
            'Pueblo Memorial United States Of America - PUB',
            'Price Carbon County United States Of America - PUC',
            'Poulsbo  United States Of America - PUL',
            'Prudhoe Bay  United States Of America - PUO',
            'Perry Perry Mnpl United States Of America - PRO',
            'Presque Isle Presque Isle Mnpl United States Of America - PQI',
            'Pilot Station  United States Of America - PQS',
            'Port Johnson  United States Of America - PRF',
            'Paso Robles  United States Of America - PRB',
            'Prescott  United States Of America - PRC',
            'Port Oceanic  United States Of America - PRL',
            'Prentice  United States Of America - PRW',
            'Paris Cox Field United States Of America - PRX',
            'Pittsfield  United States Of America - PSF',
            'Petersburg Petersburg Mnpl United States Of America - PSG',
            'Prineville  United States Of America - PRZ',
            'Philipsburg Mid State United States Of America - PSB',
            'Pasco Tri Cities United States Of America - PSC',
            'Dublin New River Valley United States Of America - PSK',
            'Palestine  United States Of America - PSN',
            'Palm Springs Palm Springs Mnpl United States Of America - PSP',
            'Palm Springs Bermuda United States Of America - UDD',
            'Port Alsworth  United States Of America - PTA',
            'Petersburg Petersburg Mnpl United States Of America - PTB',
            'Petersburg Fort Lee Aaf United States Of America - FLE',
            'Port Alice  United States Of America - PTC',
            'Port Alexander  United States Of America - PTD',
            'Port Heiden  United States Of America - PTH',
            'Pleasant Harbour  United States Of America - PTR',
            'Pittsburg Pittsburg Mnpl United States Of America - PTS',
            'Pratt  United States Of America - PTT',
            'Platinum  United States Of America - PTU',
            'Porterville  United States Of America - PTV',
            'Pottstown  United States Of America - PTW',
            'Palacios  United States Of America - PSX',
            'Pontiac  United States Of America - PTK',
            'Port Armstrong  United States Of America - PTL',
            'Santa Cruz Skypark United States Of America - SRU',
            'Stony River  United States Of America - SRV',
            'Salisbury Rowan County United States Of America - SRW',
            'Sarasota Bradenton United States Of America - SRQ',
            'Sault Ste Marie Chippewa United States Of America - CIU',
            'Sault Ste Marie Kinchelo United States Of America - INR',
            'Brunswick Glynco Jetport United States Of America - BQK',
            'Brunswick Mckinnon United States Of America - SSI',
            'Sumter Shaw Afb United States Of America - SSC',
            'Sumter Sumter Mnpl United States Of America - SUM',
            'Sterling Rockfalls Whiteside Cnty United States Of America - SQI',
            'San Carlos  United States Of America - SQL',
            'Spencer Spencer Mnpl United States Of America - SPW',
            'Springdale Mncpl United States Of America - SPZ',
            'Santa Ynez  United States Of America - SQA',
            'Sequim Sequim Valley Apt United States Of America - SQV',
            'San Rafael Hamilton Fld United States Of America - SRF',
            'Searcy  United States Of America - SRC',
            'Saint Paul Island  United States Of America - SNP',
            'Salinas  United States Of America - SNS',
            'Snyder Winston Field United States Of America - SNK',
            'Shawnee Shawnee Mnpl United States Of America - SNL',
            'Sidney  United States Of America - SNY',
            'Southern Pines Pinehurst United States Of America - SOP',
            'Solomon  United States Of America - SOL',
            'Seldovia  United States Of America - SOV',
            'Show Low  United States Of America - SOW',
            'Springfield Capital United States Of America - SPI',
            'Spearfish Black Hills United States Of America - SPF',
            'Saint Petersburg Whitted United States Of America - SPG',
            'Wichita Falls Kickapoo United States Of America - KIP',
            'Wichita Falls Sheppard United States Of America - SPS',
            'San Pedro Catalina Spb United States Of America - SPQ',
            'Sikeston Memorial United States Of America - SIK',
            'Shageluk  United States Of America - SHX',
            'Sheridan  United States Of America - SHR',
            'Shreveport Downtown United States Of America - DTN',
            'Shreveport Barksdale Afb United States Of America - BAD',
            'Shreveport Regional United States Of America - SHV',
            'San Angelo Goodfellow Af United States Of America - GOF',
            'San Angelo Mathis Field United States Of America - SJT',
            'Montague Siskiyou County United States Of America - SIY',
            'Montague Yreka Rohrer Field United States Of America - ROF',
            'Sullivan County United States Of America - SIV',
            'Sitka  United States Of America - SIT',
            'Saint Johns Saint Johns Mnpl United States Of America - SJN',
            'San Jose San Jose Mnpl United States Of America - SJC',
            'San Jose Reid Hillview United States Of America - RHV',
            'Sheep Mountain  United States Of America - SMU',
            'Santa Ana John Wayne United States Of America - SNA',
            'Santa Maria Public United States Of America - SMX',
            'Saint Michael  United States Of America - SMK',
            'Salmon  United States Of America - SMN',
            'Santa Monica  United States Of America - SMO',
            'Sleetmute  United States Of America - SLQ',
            'Sulphur Springs  United States Of America - SLR',
            'Salida  United States Of America - SLT',
            'Somerset Pulaski County United States Of America - SME',
            'Salem Mcnary Field United States Of America - SLE',
            'Storm Lake Storm Lake Mnpl United States Of America - SLB',
            'Salt Lake City Salt Lake City Intl United States Of America - SLC',
            'Sandusky Griffing United States Of America - SKY',
            'Skwentna Intermediate United States Of America - SKW',
            'Siloam Springs Smith Fld United States Of America - SLG',
            'Saranac Lake Adirondack United States Of America - SLK',
            'Salina  United States Of America - SLN',
            'Salem Leckrone United States Of America - SLO',
            'Sitkinak Island Sitkinak United States Of America - SKJ',
            'Shaktoolik  United States Of America - SKK',
            'Fairfield Travis Afb United States Of America - SUU',
            'Savoonga  United States Of America - SVA',
            'Sioux City Sioux Gateway United States Of America - SUX',
            'Statesville Statesville Mnpl United States Of America - SVH',
            'Silver City Grant County United States Of America - SVC',
            'Susanville  United States Of America - SVE',
            'Hailey Sun Valley United States Of America - SUN',
            'Sun River  United States Of America - SUO',
            'Sundance Schloredt United States Of America - SUC',
            'Stroud  United States Of America - SUD',
            'Sturgeon Bay Door County United States Of America - SUE',
            'Stuart Witham Field United States Of America - SUA',
            'Stevens Point  United States Of America - STE',
            'Stuart Island  United States Of America - SSW',
            'White Sulphur Greenbrier United States Of America - SSU',
            'Saint George Island  United States Of America - STG',
            'Saint Cloud Saint Cloud Mnpl United States Of America - STC',
            'Saint Paul Downtown United States Of America - STP',
            'Saint Marys  United States Of America - STQ',
            'Saint Joseph Rosecrans Mem United States Of America - STJ',
            'Sterling Crosson Field United States Of America - STK',
            'Saint Louis Spirit Of United States Of America - SUS',
            'Saint Louis Bi State Park United States Of America - CPS',
            'Saint Louis Lambert United States Of America - STL',
            'Santa Rosa Sonoma County United States Of America - STS',
            'Shemya Shemya Afb United States Of America - SYA',
            'Seal Bay  United States Of America - SYB',
            'Sidney  United States Of America - SXY',
            'Syracuse Hancock Intl United States Of America - SYR',
            'Stanton Carleton United States Of America - SYN',
            'Shelbyville Bomar Fld United States Of America - SYI',
            'San Miguel Roberts Aaf United States Of America - SYL',
            'Sheldon Point Sheldon S United States Of America - SXP',
            'Soldotna  United States Of America - SXQ',
            'Sparrevohn Sparrevohn Af United States Of America - SVW',
            'Newburgh Newburgh Stewart Apt United States Of America - SWF',
            'Seward  United States Of America - SWD',
            'Stevens Village  United States Of America - SVS',
            'Sweetwater  United States Of America - SWW',
            'Stillwater Searcy Fld United States Of America - SWO',
            'Tuba City  United States Of America - TBC',
            'Fort Leonard Wood Forney United States Of America - TBN',
            'Trinidad Las Animas United States Of America - TAD',
            'Tanana Ralph Calhoun United States Of America - TAL',
            'Santa Paula  United States Of America - SZP',
            'Sylvester  United States Of America - SYV',
            'Warrensburg Whiteman Afb United States Of America - SZL',
            'Tatitlek  United States Of America - TEK',
            'Telluride  United States Of America - TEX',
            'Teterboro  United States Of America - TEB',
            'Tetlin  United States Of America - TEH',
            'Toledo Winlock United States Of America - TDO',
            'Statesboro Statesboro Mnpl United States Of America - TBR',
            'Tucumcari  United States Of America - TCC',
            'Truth Or Conseque Mncpl United States Of America - TCS',
            'Takotna  United States Of America - TCT',
            'Tuscaloosa Van De Graaf United States Of America - TCL',
            'Trenton Memorial United States Of America - TRX',
            'Terrell Terrell Field United States Of America - TRL',
            'Thermal  United States Of America - TRM',
            'Tremonton  United States Of America - TRT',
            'Tehachapi Kern County United States Of America - TSP',
            'Tanacross Intermediate United States Of America - TSG',
            'Taos  United States Of America - TSM',
            'Tonopah Test Range United States Of America - XSD',
            'Tonopah Tonopah Arpt United States Of America - TPH',
            'Tampa Saint Pete Clearwater United States Of America - PIE',
            'Tampa Tampa Intl United States Of America - TPA',
            'Tampa Peter O knight United States Of America - TPF',
            'Tampa Mac Dill Afb United States Of America - MCF',
            'Tampa Topp Of Tampa United States Of America - KYO',
            'Temple Draughon Miller United States Of America - TPL',
            'Tanalian Point  United States Of America - TPO',
            'Trona  United States Of America - TRH',
            'Bristol/Johnson City/Kin Tri Cities United States Of America - TRI',
            'Newton Newton Mnpl United States Of America - TNU',
            'Twentynine Palms  United States Of America - TNP',
            'Togiak Village  United States Of America - TOG',
            'Torrance  United States Of America - TOA',
            'Toccoa  United States Of America - TOC',
            'Troy Troy Mnpl United States Of America - TOI',
            'Toledo Express United States Of America - TOL',
            'Topeka Philip Billard United States Of America - TOP',
            'Topeka Forbes Afb United States Of America - FOE',
            'Torrington Torrington Mnpl United States Of America - TOR',
            'Tununak  United States Of America - TNK',
            'Tin City Tin City Afs United States Of America - TNC',
            'Tullahoma Arnold Afs United States Of America - TUH',
            'Tullahoma Northern United States Of America - THA',
            'Tuskegee Sharpe Field United States Of America - TGE',
            'York  United States Of America - THV',
            'Thermopolis Hot Springs United States Of America - THP',
            'Thompsonfield  United States Of America - THM',
            'Tokeen  United States Of America - TKI',
            'Tok  United States Of America - TKJ',
            'Talkeetna  United States Of America - TKA',
            'Tenakee Springs Spb United States Of America - TKE',
            'Truckee  United States Of America - TKF',
            'Tacoma Gray Aaf United States Of America - GRF',
            'Tacoma Mc Chord Afb United States Of America - TCM',
            'Tacoma Industrial United States Of America - TIW',
            'Titusville Space Center United States Of America - TIX',
            'Taku Lodge Taku Spb United States Of America - TKL',
            'Teller  United States Of America - TLA',
            'Tallahassee Tallahassee Mnpl United States Of America - TLH',
            'Tatalina Tatalina Afs United States Of America - TLJ',
            'Telida  United States Of America - TLF',
            'Tifton Henry Tift Myers United States Of America - TMA',
            'Tulare  United States Of America - TLR',
            'Tuluksak  United States Of America - TLT',
            'Summit  United States Of America - UMM',
            'Umnak Island North Shore United States Of America - UMB',
            'Umnak Island Umnak United States Of America - UNS',
            'Umiat  United States Of America - UMT',
            'Unalakleet  United States Of America - UNK',
            'Sewanee Franklin County United States Of America - UOS',
            'Oxford University Oxford United States Of America - UOX',
            'Quakertown Upper Bucks United States Of America - UKT',
            'Ukiah  United States Of America - UKI',
            'Waukon Waukon Mnpl United States Of America - UKN',
            'New Ulm  United States Of America - ULM',
            'Quillayute Quillayute St United States Of America - UIL',
            'Quincy Quincy Mnpl United States Of America - UIN',
            'Utica Berz Macomb United States Of America - UIZ',
            'Ugashik  United States Of America - UGS',
            'Saint Augustine  United States Of America - UST',
            'Tunica Tunica Municipal United States Of America - UTM',
            'Utopia Creek Indian Mnt United States Of America - UTO',
            'Kuparuk  United States Of America - UUK',
            'Uvalde Garner Fld United States Of America - UVA',
            'Ware  United States Of America - UWA',
            'Queen  United States Of America - UQE',
            'Upolu Point  United States Of America - UPP',
            'Juneau Dodge County United States Of America - UNU',
            'Waukesha  United States Of America - UES',
            'Uganik  United States Of America - UGI',
            'Waukegan Memorial United States Of America - UGN',
            'Union City Everett Stew United States Of America - UCY',
            'Columbus Lowndes County United States Of America - UBS',
            'Columbus Columbus Afb United States Of America - CBM',
            'Columbus Golden Triangle United States Of America - GTR',
            'Utica Oneida County United States Of America - UCA',
            'Yucca Flat  United States Of America - UCC',
            'Eunice  United States Of America - UCE',
            'Tyonek  United States Of America - TYE',
            'Taylor  United States Of America - TYZ',
            'Caro Tuscola Area United States Of America - TZC',
            'Tyler Pounds Field United States Of America - TYR',
            'Knoxville Mc Ghee Tyson United States Of America - TYS',
            'Texarkana Texarkana Mnpl United States Of America - TXK',
            'Port Townsend  United States Of America - TWD',
            'Taylor  United States Of America - TWE',
            'Twin Falls City County United States Of America - TWF',
            'Tucson Tucson Intl United States Of America - TUS',
            'Tucson Davis Monthan Afb United States Of America - DMA',
            'Tucson Marana Regional United States Of America - AVW',
            'Twin Hills  United States Of America - TWA',
            'Traverse City  United States Of America - TVC',
            'Thief River Falls Reg United States Of America - TVF',
            'Thomasville Thomasville Mnpl United States Of America - TVI',
            'Lake Tahoe South  United States Of America - TVL',
            'Britton Britton Mnpl United States Of America - TTO',
            'Troutdale  United States Of America - TTD',
            'Tupelo Lemons Municipal United States Of America - TUP',
            'Tulsa R Lloyd Jones United States Of America - RVS',
            'Tulsa Tulsa Intl United States Of America - TUL',
            'Kennewick Vista Field United States Of America - VSK',
            'Springfield State United States Of America - VSF',
            'Valentine Miller Field United States Of America - VTN',
            'Valparaiso Porter County United States Of America - VPZ',
            'Vero Beach Vero Beach Mnpl United States Of America - VRB',
            'Versailles  United States Of America - VRS',
            'Peru Illinois Valley Reg United States Of America - VYS',
            'Wales  United States Of America - WAA',
            'Wahpeton  United States Of America - WAH',
            'Chincoteague Wallops Flt United States Of America - WAL',
            'Washington Bolling Afb United States Of America - BOF',
            'Washington Baltimore United States Of America - BWI',
            'Washington R Reagan Nat United States Of America - DCA',
            'Washington Buzzards Pt S United States Of America - BZS',
            'Washington Dulles Intl United States Of America - IAD',
            'Washington Pentagon Army United States Of America - JPN',
            'Washington Baltimore Greenbelt United States Of America - GBO',
            'Washington Baltimore Glenn Martin United States Of America - MTN',
            'Hyder Spb United States Of America - WHD',
            'Wilbarger County United States Of America - WIB',
            'Wharton  United States Of America - WHT',
            'Winchester Winchester Mnpl United States Of America - WGO',
            'Frenchville  United States Of America - WFK',
            'Waynesburg Green County United States Of America - WAY',
            'Stebbins  United States Of America - WBB',
            'Beaver  United States Of America - WBQ',
            'Big Rapids  United States Of America - WBR',
            'Boulder Boulder Mnpl United States Of America - WBU',
            'Boulder Hilton Har H United States Of America - WHH',
            'Boulder Broker Inn United States Of America - WBI',
            'West Branch Community United States Of America - WBK',
            'Woburn Cummings Park United States Of America - WBN',
            'Deep Bay  United States Of America - WDB',
            'Enid Vance Afb United States Of America - END',
            'Enid Woodring Mncpl United States Of America - WDG',
            'Chandalar  United States Of America - WCR',
            'Waldron Island  United States Of America - WDN',
            'Winder  United States Of America - WDR',
            'Weatherford Parker Cnty United States Of America - WEA',
            'Visalia  United States Of America - VIS',
            'Vichy Rolla National United States Of America - VIH',
            'Kavik Airstrip United States Of America - VIK',
            'Abingdon Virginia Highla United States Of America - VJI',
            'West Kavik  United States Of America - VKW',
            'Vandalia  United States Of America - VLA',
            'Vicksburg  United States Of America - VKS',
            'Valdosta Regional United States Of America - VLD',
            'Valdosta Moody Afb United States Of America - VAD',
            'Valle J T Robidoux United States Of America - VLE',
            'Venice  United States Of America - VNC',
            'Camp Douglas Volk Field United States Of America - VOK',
            'Valparaiso Fort Walton Beach United States Of America - VPS',
            'Valparaiso Duke Field United States Of America - EGI',
            'Vallejo Stolport United States Of America - VLO',
            'Chevak  United States Of America - VAK',
            'Blue Mountain  United States Of America - VBM',
            'View Cove  United States Of America - VCB',
            'Van Horn Culberson Cnty United States Of America - VHN',
            'Tioga Tioga Mnpl United States Of America - VEX',
            'Vernal  United States Of America - VEL',
            'Vidalia Vidalia Mnpl United States Of America - VDI',
            'Valdez Valdez Mnpl United States Of America - VDZ',
            'Venetie  United States Of America - VEE',
            'Victoria County Foster United States Of America - VCT',
            'Victorville George Afb United States Of America - VCV',
            'Madison  United States Of America - XMD',
            'West Yellowstone Yellow United States Of America - WYS',
            'Yes Bay Spb United States Of America - WYB',
            'Lake Geneva Lake Geneva Mnpl United States Of America - XES',
            'Pine Ridge  United States Of America - XPR',
            'West Kuparuk  United States Of America - XPU',
            'Saint Marys  United States Of America - XSM',
            'Yakutat  United States Of America - YAK',
            'Willow  United States Of America - WOW',
            'Woodchopper  United States Of America - WOO',
            'Wood River  United States Of America - WOD',
            'White Mountain  United States Of America - WMO',
            'Mountain Home  United States Of America - WMH',
            'Meyers Chuck Spb United States Of America - WMK',
            'Napakiak Napakiak Spb United States Of America - WNA',
            'Tuxekan Isl Nichen Cove United States Of America - WNC',
            'Aleknagik  United States Of America - WKK',
            'Waikoloa Waikoloa Apt United States Of America - WKL',
            'Lancaster West J Fox United States Of America - WJF',
            'Lancaster Quartz Hill United States Of America - RZH',
            'Selawik  United States Of America - WLK',
            'Winfield Arkansas City United States Of America - WLD',
            'Labouchere Bay  United States Of America - WLB',
            'Willows Glenn County United States Of America - WLW',
            'Winnemucca  United States Of America - WMC',
            'Loring  United States Of America - WLR',
            'Waltham  United States Of America - WLM',
            'Little Naukati  United States Of America - WLN',
            'Westerly Westerly State United States Of America - WST',
            'Paonia North Frk Valley United States Of America - WPO',
            'Westsound  United States Of America - WSX',
            'Noatak  United States Of America - WTK',
            'Tuntutuliak  United States Of America - WTL',
            'Steamboat Bay Spb United States Of America - WSB',
            'White Sands Condron Aaf United States Of America - WSD',
            'Sarichef  United States Of America - WSF',
            'Washington County United States Of America - WSG',
            'Shirley Brookhaven United States Of America - WSH',
            'San Juan San Juan Spb United States Of America - WSJ',
            'Wiseman  United States Of America - WSM',
            'South Naknek  United States Of America - WSN',
            'Wrangell Wrangell Spb United States Of America - WRG',
            'Wrench Creek  United States Of America - WRH',
            'Fort Dix Mc Guire Afb United States Of America - WRI',
            'Worland  United States Of America - WRL',
            'White River  United States Of America - WTR',
            'Whale Pass  United States Of America - WWP',
            'Woodward West Woodward United States Of America - WWR',
            'Newtok  United States Of America - WWT',
            'Watsonville  United States Of America - WVI',
            'Waterville Robert Lafle United States Of America - WVL',
            'Wasilla  United States Of America - WWA',
            'Wildwood Cape May County United States Of America - WWD',
            'Zanesville  United States Of America - ZZV',
            'Zephyrhills  United States Of America - ZPH',
            'Nyac  United States Of America - ZNC',
            'Yuma Yuma Intl United States Of America - YUM',
            'Yuma Laguna Aaf United States Of America - LGF',
            'Youngstown Warren  United States Of America - YNG',
            'Yakima Firing Center Aaf United States Of America - FCT',
            'Yakima Air Terminal United States Of America - YKM',
            'Yankton Chan Gurney United States Of America - YKN',
            'West Memphis West Memphis Mnpl United States Of America - AWM',
            'Alexandria Bay  United States Of America - AXB',
            'Alexandria  United States Of America - AXN',
            'Algona  United States Of America - AXG',
            'Catalina Island Two Harbors United States Of America - TWH',
            'Catalina Island Apt In The Sky United States Of America - CIB',
            'Catalina Island Avalo Vor United States Of America - SXC',
            'Catalina Island Avalon Bay United States Of America - AVX',
            'Aurora Aurora Mnpl United States Of America - AUZ',
            'Asheville Asheville Regional Apt United States Of America - AVL',
            'Avon Park Avon Park Mnpl United States Of America - AVO',
            'Scranton Wyoming Val United States Of America - WBW',
            'Scranton Scranton Mnpl United States Of America - SCR',
            'Scranton Scranton Intl United States Of America - AVP',
            'Appleton Outagamie Cty United States Of America - ATW',
            'Watertown  United States Of America - ATY',
            'Augusta  United States Of America - AUG',
            'Alakanuk  United States Of America - AUK',
            'Austin  United States Of America - AUM',
            'Auburn  United States Of America - AUN',
            'Auburn Auburn Opelika United States Of America - AUO',
            'Wausau Wausau Mnpl United States Of America - AUW',
            'Wausau Central Wisconsin United States Of America - CWA',
            'Austin Bergstrom Intl United States Of America - AUS',
            'Waycross Ware County United States Of America - AYS',
            'Wapakoneta Neil Armstron United States Of America - AXV',
            'Angel Fire  United States Of America - AXX',
            'Westfield Barnes United States Of America - BAF',
            'Kalamazoo Battle Creek United States Of America - AZO',
            'Amityville Zahns United States Of America - AYZ',
            'Battle Mountain Lander C United States Of America - BAM',
            'Baker Island Baker Aaf United States Of America - BAR',
            'Burlington  United States Of America - BBF',
            'Benson Benson Mnpl United States Of America - BBB',
            'Bay City  United States Of America - BBC',
            'Brady Curtis Field United States Of America - BBD',
            'Walnut Ridge  United States Of America - ARG',
            'Asbury Park  United States Of America - ARX',
            'Minocqua Noble F Lee United States Of America - ARV',
            'Watertown  United States Of America - ART',
            'Nashua Boire Field United States Of America - ASH',
            'Aspen  United States Of America - ASE',
            'Marshall Harrison County United States Of America - ASL',
            'Talladega  United States Of America - ASN',
            'Astoria  United States Of America - AST',
            'Austin  United States Of America - ASQ',
            'Ashland  United States Of America - ASX',
            'Ashley  United States Of America - ASY',
            'Antlers  United States Of America - ATE',
            'Athens Ohio University United States Of America - ATO',
            'Artesia  United States Of America - ATS',
            'Atmautluak  United States Of America - ATT',
            'Attu Island Casco Cove United States Of America - ATU',
            'Atqasuk  United States Of America - ATK',
            'Atlanta Perimeter Mall United States Of America - JAJ',
            'Atlanta Hartsfield Jackson United States Of America - ATL',
            'Atlanta Galleria United States Of America - JGL',
            'Atlanta Fulton County United States Of America - FTY',
            'Atlanta De Kalb United States Of America - PDK',
            'Atlanta Beaver Ruin United States Of America - JAO',
            'Atlanta Technology Park United States Of America - JAE',
            'Annapolis Lee United States Of America - ANP',
            'Angola Tri State Steuben United States Of America - ANQ',
            'Annette Island  United States Of America - ANN',
            'Anthony  United States Of America - ANY',
            'Anvik  United States Of America - ANV',
            'Ainsworth  United States Of America - ANW',
            'Lima Allen County United States Of America - AOH',
            'Altoona  United States Of America - AOO',
            'Amook  United States Of America - AOS',
            'Napa Napa County United States Of America - APC',
            'Jasper Marion County United States Of America - APT',
            'Alyeska  United States Of America - AQY',
            'New Iberia Acadiana Rgnl United States Of America - ARA',
            'Ann Arbor Ann Arbor Mnpl United States Of America - ARB',
            'Arctic Village  United States Of America - ARC',
            'Apple Valley  United States Of America - APV',
            'Alpena County Regional United States Of America - APN',
            'Naples  United States Of America - APF',
            'Aberdeen Phillips Aaf United States Of America - APG',
            'Bowling Green Camp A P H United States Of America - APH',
            'Aliceville George Downer United States Of America - AIV',
            'Atlantic City Bader Fiel United States Of America - AIY',
            'Atlantic City Atlantic City Intl United States Of America - ACY',
            'Kaiser Lake Ozark Lee C Fine Memorial United States Of America - AIZ',
            'Wainwright  United States Of America - AIN',
            'Atlantic Atlantic Mnpl United States Of America - AIO',
            'King Salmon  United States Of America - AKN',
            'Akron Washington Co United States Of America - AKO',
            'Anaktuvuk  United States Of America - AKP',
            'Akiak  United States Of America - AKI',
            'Atka  United States Of America - AKB',
            'Herlong Amedee Aaf United States Of America - AHC',
            'Arapahoe Arapahoe Mnpl United States Of America - AHF',
            'Amery Amery Mnpl United States Of America - AHH',
            'Ashland Sumner Parker Field United States Of America - AHM',
            'Athens  United States Of America - AHN',
            'Angoon  United States Of America - AGN',
            'Magnolia Magnolia Mnpl United States Of America - AGO',
            'Anderson Anderson Mnpl United States Of America - AID',
            'Aiken Aiken Mnpl United States Of America - AIK',
            'Amchitka  United States Of America - AHT',
            'Alliance  United States Of America - AIA',
            'Anita Bay  United States Of America - AIB',
            'Alma Gratiot Community United States Of America - AMN',
            'Aniak  United States Of America - ANI',
            'Ames  United States Of America - AMW',
            'Anaheim  United States Of America - ANA',
            'Anniston County United States Of America - ANB',
            'Anchorage Merrill Field United States Of America - MRI',
            'Anchorage Anchorage Intl United States Of America - ANC',
            'Anchorage Elmendorf Afb United States Of America - EDF',
            'Anderson  United States Of America - AND',
            'Walla Walla  United States Of America - ALW',
            'Alexander City Tc Russel United States Of America - ALX',
            'Alitak Alitak Spb United States Of America - ALZ',
            'Amarillo Amarillo Intl United States Of America - AMA',
            'Amarillo Tradewind United States Of America - TDW',
            'Alamosa Alamosa Mnpl United States Of America - ALS',
            'Alice Alice Intl United States Of America - ALI',
            'Alamogordo Alamogordo Mnpl United States Of America - ALM',
            'Alamogordo Holloman Afb United States Of America - HMN',
            'Alton  United States Of America - ALN',
            'Waterloo  United States Of America - ALO',
            'Akhiok Akhiok Spb United States Of America - AKK',
            'Alpine  United States Of America - ALE',
            'Albany Albany Intl Apt United States Of America - ALB',
            'Adrian Lenawee County United States Of America - ADG',
            'Arcata Eureka United States Of America - ACV',
            'Arcata Eureka Murray Field United States Of America - EKA',
            'Kodiak Kodiak Fss United States Of America - WDY',
            'Kodiak Kodiak Airport United States Of America - ADQ',
            'Kodiak Kodiak Mnpl United States Of America - KDK',
            'Andrews  United States Of America - ADR',
            'Ada  United States Of America - ADT',
            'Aleneva  United States Of America - AED',
            'Camp Springs Andrews Naf United States Of America - NSF',
            'Camp Springs Andrews Afb United States Of America - ADW',
            'Adak Island  United States Of America - ADK',
            'Ardmore Municipal United States Of America - ADM',
            'Ardmore Downtown United States Of America - AHD',
            'Albert Lea  United States Of America - AEL',
            'Allakaket  United States Of America - AET',
            'Jaffrey Jaffrey Mnpl United States Of America - AFN',
            'Afton Afton Mnpl United States Of America - AFO',
            'Alexandria Esler Field United States Of America - ESF',
            'Alexandria Alexandria Intl United States Of America - AEX',
            'Augusta Bush Field United States Of America - AGS',
            'Augusta Daniel United States Of America - DNL',
            'Ambler  United States Of America - ABL',
            'Albuquerque Albuquerque Intl United States Of America - ABQ',
            'Aberdeen Aberdeen Mnpl United States Of America - ABR',
            'Bellaire Antrim County United States Of America - ACB',
            'Albany Dougherty County United States Of America - ABY',
            'Albany Albany Nas United States Of America - NAB',
            'Waco Waco Mnpl United States Of America - ACT',
            'Waco James Connall United States Of America - CNW',
            'Nantucket Memorial United States Of America - ACK',
            'Apalachicola Apalachicola Mnpl United States Of America - AAF',
            'Allentown Bthlehm  United States Of America - ABE',
            'Abilene Dyess Afb United States Of America - DYS',
            'Abilene Abilene Mnpl United States Of America - ABI',
            'Beckley  United States Of America - BKW',
            'Brookings  United States Of America - BKX',
            'Blackstone Blackstone Aa United States Of America - BKT',
            'Bluefield Mercer County United States Of America - BLF',
            'Blythe  United States Of America - BLH',
            'Bellingham  United States Of America - BLI',
            'Belmar Monmouth County United States Of America - BLM',
            'Blue Canyon  United States Of America - BLU',
            'Belleville Scott Afb United States Of America - BLV',
            'Waimanalo Bellows Field United States Of America - BLW',
            'Bloomington  United States Of America - BMG',
            'Brigham City  United States Of America - BMC',
            'Burns  United States Of America - BNO',
            'Barnwell Barnwell Cnty United States Of America - BNL',
            'Baranof Warm Spring Bay United States Of America - BNF',
            'Banning  United States Of America - BNG',
            'Bloomington Normal United States Of America - BMI',
            'Berlin  United States Of America - BML',
            'Nashville Nashville Intl Airport United States Of America - BNA',
            'Big Mountain  United States Of America - BMX',
            'Buckland  United States Of America - BKC',
            'Breckenridge Stephens C United States Of America - BKD',
            'Baker  United States Of America - BKE',
            'Brooks Lake  United States Of America - BKF',
            'Branson  United States Of America - BKG',
            'Kekaha Barking Sands United States Of America - BKH',
            'Bemidji Bemidji Apt United States Of America - BJI',
            'Wooster Wayne County United States Of America - BJJ',
            'Big Creek  United States Of America - BIC',
            'Block Island  United States Of America - BID',
            'Beatrice  United States Of America - BIE',
            'Big Delta Intermediate United States Of America - BIG',
            'Bishop  United States Of America - BIH',
            'Billings  United States Of America - BIL',
            'Broomfield Jeffco United States Of America - BJC',
            'Biloxi Keesler Afb United States Of America - BIX',
            'Bismarck  United States Of America - BIS',
            'Bridgeport I Sikorsky United States Of America - BDR',
            'Benton Harbor Ross Field United States Of America - BEH',
            'Broadus  United States Of America - BDX',
            'Bandon State United States Of America - BDY',
            'Bedford Hanscom Hanscom Field United States Of America - BED',
            'Bryce  United States Of America - BCE',
            'Baca Grande  United States Of America - BCJ',
            'Broken Bow  United States Of America - BBW',
            'Blacksburg Virginia Tech United States Of America - BCB',
            'Bear Creek  United States Of America - BCC',
            'Belle Chasse South Seaplane United States Of America - BCS',
            'Baudette  United States Of America - BDE',
            'Bradford Rinkenberger United States Of America - BDF',
            'Blanding  United States Of America - BDG',
            'Beaufort County United States Of America - BFT',
            'Bedford Virgil I Grissom United States Of America - BFR',
            'Scottsbluff Scotts Bluff United States Of America - BFF',
            'Bullfrog Basin  United States Of America - BFG',
            'Borger  United States Of America - BGD',
            'Bainbridge Decatur Cnty United States Of America - BGE',
            'Beaver Falls  United States Of America - BFP',
            'Blue Fox Bay  United States Of America - BFB',
            'Bradford  United States Of America - BFD',
            'Bakersfield Meadows Fld United States Of America - BFL',
            'Bethel City Landing United States Of America - JBT',
            'Bethel Bethel Airport United States Of America - BET',
            'Birmingham  United States Of America - BHM',
            'Bar Harbor  United States Of America - BHB',
            'Binghamton  United States Of America - BGM',
            'Big Lake  United States Of America - BGQ',
            'Bangor Bangor Intl United States Of America - BGR',
            'Bagdad  United States Of America - BGT',
            'Borrego Springs  United States Of America - BXS',
            'Boundary  United States Of America - BYA',
            'Blakely Island  United States Of America - BYW',
            'Fort Irwin Bicycle Lake United States Of America - BYS',
            'Buffalo Buffalo Mnpl United States Of America - BYG',
            'Blytheville Afb United States Of America - BYH',
            'Blytheville Blytheville Mnpl United States Of America - HKA',
            'Burley  United States Of America - BYI',
            'Bozeman Gallatin Field United States Of America - BZN',
            'Brazoria Hinkles Ferry United States Of America - BZT',
            'Cadillac  United States Of America - CAD',
            'Columbia Mc Entire Angb United States Of America - MMT',
            'Columbia Columbia Met United States Of America - CAE',
            'Columbia Owens Field United States Of America - CUB',
            'Canton Akron Akron Fulton United States Of America - AKC',
            'Canton Akron Akron United States Of America - CAK',
            'Caribou Caribou Mnpl United States Of America - CAR',
            'Clayton  United States Of America - CAO',
            'Burbank Bob Hope Apt United States Of America - BUR',
            'Buffalo Buffalo Niagara Intl United States Of America - BUF',
            'Butler  United States Of America - BUM',
            'Bartlesville  United States Of America - BVO',
            'Beaver Inlet Sea Port United States Of America - BVD',
            'Boxborough  United States Of America - BXC',
            'Buckeye  United States Of America - BXK',
            'Blaine  United States Of America - BWS',
            'Bogalusa George R Carr United States Of America - BXA',
            'Blackwell  United States Of America - BWL',
            'Bowman  United States Of America - BWM',
            'Bowling Green Warren Cnt United States Of America - BWG',
            'Brawley  United States Of America - BWC',
            'Brownwood  United States Of America - BWD',
            'Beluga  United States Of America - BVU',
            'Batesville Batesville Mnpl United States Of America - BVX',
            'Beverly  United States Of America - BVY',
            'Beatty  United States Of America - BTY',
            'Burwell Burwell Mnpl United States Of America - BUB',
            'Bettles  United States Of America - BTT',
            'Baton Rouge Ryan United States Of America - BTR',
            'Baton Rouge Downtown United States Of America - EBR',
            'Burlington Burlington Intl United States Of America - BTV',
            'Butler Graham Field United States Of America - BTP',
            'Barter Island  United States Of America - BTI',
            'Battle Creek Wk Kellogg United States Of America - BTL',
            'Butte  United States Of America - BTM',
            'Bennettsville  United States Of America - BTN',
            'Bartletts  United States Of America - BSZ',
            'Blaise Diagne International Airport Dakar Senegal - DSS',
            'Bountiful Salt Lake Sky United States Of America - BTF',
            'Bardstown Samuels Field United States Of America - BRY',
            'Brownsville South Padre United States Of America - BRO',
            'Barrow Will Rogers Memorial United States Of America - BRW',
            'Barrow Point Barrow United States Of America - PBA',
            'Bisbee Bisbee Municipal United States Of America - BSQ',
            'Boswell Bay  United States Of America - BSW',
            'Pohakuloa Bradshaw Aaf United States Of America - BSF',
            'Blairsville  United States Of America - BSI',
            'Boone  United States Of America - BNW',
            'Brookings Brookings Stat United States Of America - BOK',
            'Boise Air Term Gowen Fld United States Of America - BOI',
            'Bartow  United States Of America - BOW',
            'Bethpage Grumman United States Of America - BPA',
            'Boston Logan Intl United States Of America - BOS',
            'Boston Portsmouth Pease Intl United States Of America - PSM',
            'Big Piney Marbleton United States Of America - BPI',
            'Beaumont Jefferson Cnty United States Of America - BPT',
            'Beaumont Beaumont Mncpl United States Of America - BMT',
            'Whitesburg Whitesburg Mnpl United States Of America - BRG',
            'Brainerd Crow Wing Cnty United States Of America - BRD',
            'Burlington  United States Of America - BRL',
            'Wenatchee Pangborn Field United States Of America - EAT',
            'Eau Claire  United States Of America - EAU',
            'Wheatland Phifer Field United States Of America - EAN',
            'Kearney  United States Of America - EAR',
            'Eagle  United States Of America - EAA',
            'Webster City Webster City Mnpl United States Of America - EBS',
            'East Tawas Emmet County United States Of America - ECA',
            'Elizabeth City  United States Of America - ECG',
            'Newcastle Mondell United States Of America - ECS',
            'Edna Bay  United States Of America - EDA',
            'Doylestown  United States Of America - DYL',
            'Danbury  United States Of America - DXR',
            'Devils Lake  United States Of America - DVL',
            'Davenport  United States Of America - DVN',
            'Duncan Halliburton United States Of America - DUC',
            'Duke Pine Island Airport United States Of America - DUF',
            'Douglas Douglas Mnpl United States Of America - DGL',
            'Douglas Bisbee Douglas United States Of America - DUG',
            'Dubois Jefferson County United States Of America - DUJ',
            'Dutch Harbor Emergency United States Of America - DUT',
            'Dora Bay  United States Of America - DOF',
            'Dover Cheswold Dover Afb United States Of America - DOV',
            'Dugway Michael Aaf United States Of America - DPG',
            'Deer Park  United States Of America - DPK',
            'Mercury Desert Rock United States Of America - DRA',
            'Drummond Island  United States Of America - DRE',
            'Drift River  United States Of America - DRF',
            'Deering  United States Of America - DRG',
            'Des Moines  United States Of America - DSM',
            'Destin  United States Of America - DSI',
            'Dansville  United States Of America - DSV',
            'Delta  United States Of America - DTA',
            'Death Valley  United States Of America - DTH',
            'Detroit Lakes Detroit Lakes Mnpl United States Of America - DTL',
            'Decatur Island  United States Of America - DTR',
            'Detroit Detroit City United States Of America - DET',
            'Detroit Willow Run United States Of America - YIP',
            'Detroit Detroit Metro United States Of America - DTW',
            'Durant Eaker United States Of America - DUA',
            'De Ridder Beauregard Par United States Of America - DRI',
            'Durango La Plata United States Of America - DRO',
            'Durango Animas Airpark United States Of America - AMK',
            'Del Rio Laughlin Afb United States Of America - DLF',
            'Del Rio Del Rio Intl United States Of America - DRT',
            'Drummond  United States Of America - DRU',
            'Dalton Dalton Mnpl United States Of America - DNN',
            'Danville Vermilion Cnty United States Of America - DNV',
            'Denison Denison Mnpl United States Of America - DNS',
            'Deming  United States Of America - DMN',
            'Sedalia  United States Of America - DMO',
            'Dillon  United States Of America - DLN',
            'Dolomi  United States Of America - DLO',
            'The Dalles  United States Of America - DLS',
            'Dillon  United States Of America - DLL',
            'Diomede Island  United States Of America - DIO',
            'Dillingham Dillingham Mnpl United States Of America - DLG',
            'Duluth Duluth Intl United States Of America - DLH',
            'Duluth Richard I Bong United States Of America - SUW',
            'Duluth Lakeside Usaf United States Of America - LKI',
            'Dunkirk  United States Of America - DKK',
            'Delta Junction  United States Of America - DJN',
            'Dickinson  United States Of America - DIK',
            'Douglas Converse County United States Of America - DGW',
            'Deer Harbor  United States Of America - DHB',
            'Dalhart  United States Of America - DHT',
            'Dothan Dothan Regional Apt United States Of America - DHN',
            'Danger Bay  United States Of America - DGB',
            'Dahlgren Naf United States Of America - DGN',
            'Defiance Memorial United States Of America - DFI',
            'Denver Buckley Angb United States Of America - BFK',
            'Denver Denver Intl United States Of America - DEN',
            'Denver Arapahoe Co United States Of America - APA',
            'Dallas Redbird United States Of America - RBD',
            'Dallas Fort Worth Alliance United States Of America - AFW',
            'Dallas Carswell Afb United States Of America - FWH',
            'Dallas Love Field United States Of America - DAL',
            'Dallas Dallas North United States Of America - DNE',
            'Dallas Dallas Ft Worth United States Of America - DFW',
            'Dallas Meacham Field United States Of America - FTW',
            'Dallas Addison United States Of America - ADS',
            'Decorah Decorah Mnpl United States Of America - DEH',
            'Decatur Decatur Apt United States Of America - DEC',
            'Decatur Decatur Hi Way United States Of America - DCR',
            'Decatur Pyor United States Of America - DCU',
            'Dodge City Mncpl United States Of America - DDC',
            'Erie Erie Intl United States Of America - ERI',
            'Eldred Rock Coast Guard United States Of America - ERO',
            'Errol  United States Of America - ERR',
            'Keokuk  United States Of America - EOK',
            'Wendover  United States Of America - ENV',
            'Kenosha Kenosha Mnpl United States Of America - ENW',
            'Neosho  United States Of America - EOS',
            'Weeping Water Browns United States Of America - EPG',
            'Ephrata  United States Of America - EPH',
            'Elfin Cove Elfin Cove S United States Of America - ELV',
            'Ellamar  United States Of America - ELW',
            'Emmonak  United States Of America - EMK',
            'Kemerer  United States Of America - EMM',
            'Ely Yelland United States Of America - ELY',
            'Wellsville Wellsville Mnpl United States Of America - ELZ',
            'Centralia Centralia Mnpl United States Of America - ENL',
            'Nenana Nenana Mnpl United States Of America - ENN',
            'El Monte  United States Of America - EMT',
            'Emporia  United States Of America - EMP',
            'Kenai  United States Of America - ENA',
            'El Dorado  United States Of America - EDK',
            'Edenton Edenton Mnpl United States Of America - EDE',
            'Edgewood Weide Aaf United States Of America - EDG',
            'Newport  United States Of America - EFK',
            'East Fork  United States Of America - EFO',
            'Jefferson Jefferson Mnpl United States Of America - EFW',
            'Edwards Afb  United States Of America - EDW',
            'Needles  United States Of America - EED',
            'Eek  United States Of America - EEK',
            'Keene Dillant Hopkins United States Of America - EEN',
            'Eight Fathom Bigh  United States Of America - EFB',
            'Eagle Pass Maverick Co United States Of America - EGP',
            'Vail Eagle Eagle County United States Of America - EGE',
            'Cape Newenham  United States Of America - EHM',
            'East Hartford Rentschler United States Of America - EHT',
            'Eagle River  United States Of America - EGV',
            'Egegik  United States Of America - EGX',
            'Elizabethtown  United States Of America - EKX',
            'Eagle Lake  United States Of America - ELA',
            'Elkhart Elkhart Mnpl United States Of America - EKI',
            'Elkins  United States Of America - EKN',
            'Elko  United States Of America - EKO',
            'El Dorado Goodwin Field United States Of America - ELD',
            'Elk City Elk City Mnpl United States Of America - ELK',
            'Elim  United States Of America - ELI',
            'El Paso Biggs Aaf United States Of America - BIF',
            'El Paso El Paso Intl United States Of America - ELP',
            'Elmira  United States Of America - ELM',
            'Ellensburg Bowers Field United States Of America - ELN',
            'Fort Eustis Felker Aaf United States Of America - FAF',
            'Excursion Inlet Spb United States Of America - EXI',
            'Key West Key West Intl United States Of America - EYW',
            'Key West Nas United States Of America - NQX',
            'Yerington  United States Of America - EYR',
            'Eveleth  United States Of America - EVM',
            'Evadale Landing Strip United States Of America - EVA',
            'Newton City County United States Of America - EWK',
            'New Bern Craven County Regional United States Of America - EWN',
            'New Bedford  United States Of America - EWB',
            'Wildman Lake  United States Of America - EWD',
            'Evansville Dress Rgnl United States Of America - EVV',
            'Evanston  United States Of America - EVW',
            'Kerrville  United States Of America - ERV',
            'Escanaba Delta County United States Of America - ESC',
            'Eastsound Orcas Island United States Of America - ESD',
            'Easton  United States Of America - ESN',
            'Espanola  United States Of America - ESO',
            'East Stroudsburg Birchw United States Of America - ESP',
            'Eureka  United States Of America - EUE',
            'Eufaula Weedon Field United States Of America - EUF',
            'Eugene  United States Of America - EUG',
            'Easton State United States Of America - ESW',
            'West Bend  United States Of America - ETB',
            'Estherville Estherville Mnpl United States Of America - EST',
            'Eastland Eastland Mnpl United States Of America - ETN',
            'Enterprise Enterprise Mnpl United States Of America - ETS',
            'Fargo Hector Field United States Of America - FAR',
            'Fayetteville Pope Afb United States Of America - POB',
            'Fayetteville Fayetteville Mnpl United States Of America - FAY',
            'False Island  United States Of America - FAK',
            'Roma Falcon State United States Of America - FAL',
            'Farmington Regional United States Of America - FAM',
            'Fairbanks Phillips Fld United States Of America - PII',
            'Fairbanks Fairbanks Intl United States Of America - FAI',
            'Fairbanks Fort Wainwright United States Of America - FBK',
            'Fairbanks Eielson Afb United States Of America - EIL',
            'Fairbanks Metro Field United States Of America - MTX',
            'Forrest City Forrest City Mnpl United States Of America - FCY',
            'Fort Bridger  United States Of America - FBR',
            'Friday Harbor  United States Of America - FBS',
            'Fairbury Fairbury Mnpl United States Of America - FBY',
            'Kalispell Glacier Natio United States Of America - FCA',
            'Fresno Fresno Chandler United States Of America - FCH',
            'Fresno Fresno Yosemite Intl United States Of America - FAT',
            'Fort Bragg Simmons Aaf United States Of America - FBG',
            'Faribault Faribault Mnpl United States Of America - FBL',
            'Fire Cove  United States Of America - FIC',
            'Fishers Island Elizabet United States Of America - FID',
            'Fillmore Fillmore Mnpl United States Of America - FIL',
            'Fort Huachuca Libby Aaf United States Of America - FHU',
            'Fairfield Fairfield Mnpl United States Of America - FFL',
            'Fergus Falls  United States Of America - FFM',
            'Frankfort Capital City United States Of America - FFT',
            'Frederick Frederick Mnpl United States Of America - FDK',
            'Frederick Frederick Mnpl United States Of America - FDR',
            'Findlay  United States Of America - FDY',
            'Kill Devil Hills First United States Of America - FFA',
            'Fremont Fremont Mnpl United States Of America - FET',
            'Freeport Albertus United States Of America - FEP',
            'Central  United States Of America - CEM',
            'Crescent City Mc Namara United States Of America - CEC',
            'Cordova City United States Of America - CKU',
            'Cordova Mudhole Smith United States Of America - CDV',
            'Caldwell Caldwell Wright United States Of America - CDW',
            'Bryan Coulter Field United States Of America - CFD',
            'Clemson Oconee County United States Of America - CEU',
            'Connersville Mettle Fld United States Of America - CEV',
            'Crestview Bob Sikes United States Of America - CEW',
            'Chena Hot Springs  United States Of America - CEX',
            'Murray Calloway County United States Of America - CEY',
            'Cortez Montezuma County United States Of America - CEZ',
            'Coffee Point  United States Of America - CFA',
            'Cape Girardeau  United States Of America - CGI',
            'Cambridge  United States Of America - CGE',
            'Casa Grande Casa Grande Mnpl United States Of America - CGZ',
            'Chattanooga Lovell Field United States Of America - CHA',
            'College Park  United States Of America - CGS',
            'Coffeyville Coffeyville Mnpl United States Of America - CFV',
            'Craig Craig Spb United States Of America - CGA',
            'Clifton Morenci United States Of America - CFT',
            'Colby Colby Mnpl United States Of America - CBK',
            'Cabin Creek  United States Of America - CBZ',
            'Fort Chaffee Chaffee Afb United States Of America - CCA',
            'Upland Cable United States Of America - CCB',
            'Cumberland Wiley Ford United States Of America - CBE',
            'Council Bluffs Council Bluffs Mnpl United States Of America - CBF',
            'Corner Bay  United States Of America - CBA',
            'Cold Bay  United States Of America - CDB',
            'Cedar City  United States Of America - CDC',
            'Charles City Charles City Mnpl United States Of America - CCY',
            'Camden Harrell Fld United States Of America - CDH',
            'Chadron  United States Of America - CDR',
            'Childress  United States Of America - CDS',
            'Cedar Key Lewis United States Of America - CDK',
            'Candle  United States Of America - CDL',
            'Camden Woodward Fld United States Of America - CDN',
            'Crane Crane County Apt United States Of America - CCG',
            'Concord Buchanan Fld United States Of America - CCR',
            'Crooked Creek  United States Of America - CKD',
            'Clear Lake  United States Of America - CKE',
            'Cherokee Kegelman Af United States Of America - CKA',
            'Clarksburg Benedum United States Of America - CKB',
            'Cherokee  United States Of America - CKK',
            'El Cajon  United States Of America - CJN',
            'Carroll  United States Of America - CIN',
            'Chomley  United States Of America - CIV',
            'Cairo  United States Of America - CIR',
            'Chiloquin State United States Of America - CHZ',
            'Chico  United States Of America - CIC',
            'Cedar Rapids  United States Of America - CID',
            'Craig Craig Moffat United States Of America - CIG',
            'Chalkyitsik  United States Of America - CIK',
            'Council Melsing Creek United States Of America - CIL',
            'Chuathbaluk  United States Of America - CHU',
            'Charlottesville Albemarl United States Of America - CHO',
            'Circle Hot Spring  United States Of America - CHP',
            'Charleston  United States Of America - CHS',
            'Chickasha Chickasha Mnpl United States Of America - CHK',
            'Challis  United States Of America - CHL',
            'Chicago O hare Intl United States Of America - ORD',
            'Chicago Chicago Nas United States Of America - NOH',
            'Chicago Gary International United States Of America - GYY',
            'Chicago Merrill C Meigs United States Of America - CGX',
            'Chicago Dupage County United States Of America - DPA',
            'Chicago Chicago Rockford United States Of America - RFD',
            'Chicago Midway United States Of America - MDW',
            'Chicago Pal Waukee United States Of America - PWK',
            'Columbus Rickenbacker United States Of America - LCK',
            'Columbus Port Columbus United States Of America - CMH',
            'Columbus State Univ United States Of America - OSU',
            'Champaign Willard Unive United States Of America - CMI',
            'Chino  United States Of America - CNO',
            'Carlsbad  United States Of America - CNM',
            'Claremont Claremont Mnpl United States Of America - CNH',
            'Concordia Blosser Munic United States Of America - CNK',
            'Canon City  United States Of America - CNE',
            'Hancock Houghton County United States Of America - CMX',
            'Sparta Camp Mccoy Aaf United States Of America - CMY',
            'Clintonville  United States Of America - CLI',
            'Clearlake Metroport United States Of America - CLC',
            'Cleveland Cuyahoga United States Of America - CGF',
            'Cleveland Burke Lakefron United States Of America - BKL',
            'Cleveland Hopkins Int United States Of America - CLE',
            'Coalinga  United States Of America - CLG',
            'Clarksdale Fletcher Fld United States Of America - CKM',
            'Crookston Crookston Mnpl United States Of America - CKN',
            'Crane Island  United States Of America - CKR',
            'Clarksville Outlaw Fiel United States Of America - CKV',
            'Chicken  United States Of America - CKX',
            'College Station Easterw United States Of America - CLL',
            'Port Angeles Fairchild United States Of America - CLM',
            'Clarks Point  United States Of America - CLP',
            'Calipatria  United States Of America - CLR',
            'Chehalis Centralia United States Of America - CLS',
            'Charlotte Wilgrove Park United States Of America - QWG',
            'Charlotte Douglas United States Of America - CLT',
            'Columbus Columbus Mncpl United States Of America - CLU',
            'Clearwater Executive United States Of America - CLW',
            'Callaway Gardens  United States Of America - CWG',
            'Clinton  United States Of America - CWI',
            'Culver City Hughes United States Of America - CVR',
            'Center Island  United States Of America - CWS',
            'Willcox Cochise County United States Of America - CWX',
            'Crystal Lake  United States Of America - CYE',
            'Chefornak Chefornak Spb United States Of America - CYF',
            'Conroe Montgomery Co United States Of America - CXO',
            'Calexico Calexico Intl United States Of America - CXL',
            'Chitina Chitina Apt United States Of America - CXC',
            'Coldfoot  United States Of America - CXF',
            'Cushing Cushing Mnpl United States Of America - CUH',
            'Columbus Columbus Mnpl United States Of America - CUS',
            'Clovis Cannon Afb United States Of America - CVS',
            'Clovis Clovis Mnpl United States Of America - CVN',
            'Cube Cove  United States Of America - CUW',
            'Cincinnati Nth Kentucky United States Of America - CVG',
            'Cincinnati Cincinnati Mnpl United States Of America - LUK',
            'Dayton Wright Afb United States Of America - DWF',
            'Dayton James Cox Dayton United States Of America - DAY',
            'Dayton Patterson Afb United States Of America - FFO',
            'Dayton Wright Brothers United States Of America - MGY',
            'Danville Danville Mnpl United States Of America - DAN',
            'Dubuque Dubuque Mnpl United States Of America - DBQ',
            'Dubois  United States Of America - DBS',
            'Dahl Creek  United States Of America - DCK',
            'Dublin Dublin Mnpl United States Of America - DBN',
            'Cheyenne Warren Afb United States Of America - FEW',
            'Cheyenne  United States Of America - CYS',
            'Yakataga Intermediate United States Of America - CYT',
            'Chatham Chatham Spb United States Of America - CYM',
            'Copper Center  United States Of America - CZC',
            'Cascade Locks Cascade L United States Of America - CZK',
            'Cape Romanzof  United States Of America - CZF',
            'Carrizo Springs  United States Of America - CZT',
            'Chisana Chisana Field United States Of America - CZN',
            'Chistochina  United States Of America - CZO',
            'Cape Pole  United States Of America - CZP',
            'Daggett Barstow Daggett United States Of America - DAG',
            'Campo  United States Of America - CZZ',
            'Fort Belvoir Davison Aaf United States Of America - DAA',
            'Daytona Beach Regional United States Of America - DAB',
            'Charleston Yeager United States Of America - CRW',
            'Corinth Roscoe Turner United States Of America - CRX',
            'Corsicana  United States Of America - CRS',
            'Crossett Crossett Mnpl United States Of America - CRT',
            'Corcoran  United States Of America - CRO',
            'Corpus Christi Cuddihy United States Of America - CUX',
            'Corpus Christi Nas United States Of America - NGP',
            'Corpus Christi Corpus Christi Intl United States Of America - CRP',
            'Corpus Christi Cabaniss United States Of America - NGW',
            'San Luis Obispo O sullivan Aaf United States Of America - CSL',
            'San Luis Obispo County Apt United States Of America - SBP',
            'Clinton Sherman United States Of America - CSM',
            'Clinton Clinton Mnpl United States Of America - CLK',
            'Carson City  United States Of America - CSN',
            'Cape Spencer Coast Guard United States Of America - CSP',
            'Creston Creston Mnpl United States Of America - CSQ',
            'Columbus  United States Of America - CSG',
            'Columbus Mckenna Aaf United States Of America - MKF',
            'Columbus Lawson Aaf United States Of America - LSF',
            'Crested Butte  United States Of America - CSE',
            'Crossville Memorial United States Of America - CSV',
            'Cut Bank  United States Of America - CTB',
            'Calverton Peconic River United States Of America - CTO',
            'Coatesville Chestercount United States Of America - CTH',
            'Canton  United States Of America - CTK',
            'Cottonwood  United States Of America - CTW',
            'Cortland  United States Of America - CTX',
            'Cross City  United States Of America - CTY',
            'Clinton Sampson County United States Of America - CTZ',
            'Moab Canyonlands Field United States Of America - CNY',
            'Chanute Martin Johnson United States Of America - CNU',
            'Cocoa Merritt Island United States Of America - COI',
            'Cocoa Patrick Afb United States Of America - COF',
            'Columbia  United States Of America - COA',
            'Colorado Springs Colorado Springs Mnpl United States Of America - COS',
            'Colorado Springs Usaf Ac United States Of America - AFF',
            'Colorado Springs Butts United States Of America - FCS',
            'Cotulla  United States Of America - COT',
            'Columbia Columbia Rgnl United States Of America - COU',
            'Cody Yellowstone Rgnl United States Of America - COD',
            'Coeur D alene  United States Of America - COE',
            'Coleman  United States Of America - COM',
            'Concord  United States Of America - CON',
            'Cooperstown  United States Of America - COP',
            'Casper  United States Of America - CPR',
            'Compton  United States Of America - CPM',
            'Joliet Joliet Mnpl United States Of America - JOT',
            'Juneau Juneau Intl United States Of America - JNU',
            'Jamestown  United States Of America - JMS',
            'Jamestown  United States Of America - JHW',
            'Kapalua  United States Of America - JHM',
            'Jacksonville  United States Of America - JKV',
            'Cooper Lodge Quartz Creek United States Of America - JLA',
            'Arlington Heights Us Arm United States Of America - JLH',
            'Joplin  United States Of America - JLN',
            'Sausalito Marin County United States Of America - JMC',
            'Bell Island Hot Springs United States Of America - KBE',
            'Birch Creek  United States Of America - KBC',
            'Kake Spb United States Of America - KAE',
            'Kaltag  United States Of America - KAL',
            'Johnstown Cambria County United States Of America - JST',
            'Jackson Reynolds Mncpl United States Of America - JXN',
            'Manville Kupper United States Of America - JVI',
            'Janesville Rock County United States Of America - JVL',
            'Colorado Creek  United States Of America - KCR',
            'Chernofski Spb United States Of America - KCN',
            'Chignik Fisheries United States Of America - KCG',
            'Chignik Lagoon United States Of America - KCL',
            'Chignik Chignik Lake United States Of America - KCQ',
            'Chignik Chignik Bay United States Of America - KBW',
            'Coffman Cove Coffman Co United States Of America - KCC',
            'Klag Bay  United States Of America - KBK',
            'Ekwok  United States Of America - KEK',
            'Kenmore Air Harbo  United States Of America - KEH',
            'Nanwalek  United States Of America - KEB',
            'New Koliganek  United States Of America - KGK',
            'Grayling  United States Of America - KGX',
            'False Pass  United States Of America - KFP',
            'Kelly Bar  United States Of America - KEU',
            'Ivanof Bay Spb United States Of America - KIB',
            'King City Mesa Del Rey United States Of America - KIC',
            'Glacier Creek  United States Of America - KGZ',
            'Sandy River Federal No 1 United States Of America - KSR',
            'Saint Marys  United States Of America - KSM',
            'Port Williams P Williams United States Of America - KPR',
            'Kipnuk Kipnuk Spb United States Of America - KPN',
            'Jackpot  United States Of America - KPT',
            'Perryville Perryville S United States Of America - KPV',
            'Port Bailey  United States Of America - KPY',
            'Akutan  United States Of America - KQA',
            'Point Baker  United States Of America - KPB',
            'Port Clarence  United States Of America - KPC',
            'King Of PRusya  United States Of America - KPD',
            'Parks Parks Spb United States Of America - KPK',
            'Pauloff Harbor Pauloff United States Of America - KPH',
            'Waterfall Waterfall Spb United States Of America - KWF',
            'King Cove  United States Of America - KVC',
            'Kivalina  United States Of America - KVL',
            'Kugururok River  United States Of America - KUW',
            'Kasigluk  United States Of America - KUK',
            'Teller Mission Brevig M United States Of America - KTS',
            'Thorne Bay  United States Of America - KTB',
            'Tikchik Spb United States Of America - KTH',
            'Ketchikan Ketchikan Intl United States Of America - KTN',
            'Ketchikan Waterfront Spb United States Of America - WFB',
            'Kagvik Creek  United States Of America - KKF',
            'Koyuk  United States Of America - KKA',
            'Kitoi Bay Spb United States Of America - KKB',
            'Kalakaket Kalakaket Afs United States Of America - KKK',
            'Karluk Lake  United States Of America - KKL',
            'Kongiganak  United States Of America - KKH',
            'Akiachak Spb United States Of America - KKI',
            'Kalskag Kalskag Mnpl United States Of America - KLG',
            'Levelock  United States Of America - KLL',
            'Larsen Bay Larsen Spb United States Of America - KLN',
            'Kentland  United States Of America - KKT',
            'Ekuk  United States Of America - KKU',
            'Kelso Longview United States Of America - KLS',
            'Kelp Bay  United States Of America - KLP',
            'Klawock  United States Of America - KLW',
            'Kanab  United States Of America - KNB',
            'Kakhonak  United States Of America - KNK',
            'Moser Bay  United States Of America - KMY',
            'Manokotak Manokotak Spb United States Of America - KMO',
            'Kotlik  United States Of America - KOT',
            'Olga Bay Olga Bay Spb United States Of America - KOY',
            'Ouzinkie Ouzinkie Spb United States Of America - KOZ',
            'New Stuyahok  United States Of America - KNW',
            'Kona Keahole United States Of America - KOA',
            'Kennett Kennett Mnpl United States Of America - KNT',
            'Saginaw Tri City United States Of America - MBS',
            'Manistee Blacker United States Of America - MBL',
            'Mobridge  United States Of America - MBG',
            'Moberly  United States Of America - MBY',
            'Mccomb Pike County United States Of America - MCB',
            'Mackinac Island  United States Of America - MCD',
            'Merced Castle Afb United States Of America - MER',
            'Merced Macready Regional Apt United States Of America - MCE',
            'Mcgrath  United States Of America - MCG',
            'Mccook  United States Of America - MCK',
            'Mount Mckinley  United States Of America - MCL',
            'Macon Lewis B Wilson United States Of America - MCN',
            'Macon Robins Afb United States Of America - WRB',
            'Macon Smart United States Of America - MAC',
            'Malden  United States Of America - MAW',
            'Madera  United States Of America - MAE',
            'Midland Airpark United States Of America - MDD',
            'Midland Odessa United States Of America - MAF',
            'Lawrenceville Gwinnett County United States Of America - LZU',
            'Lewiston Nez Perce Cnt United States Of America - LWS',
            'Lewistown Lewistown Mnpl United States Of America - LWT',
            'Lawrenceville Lawrenceville Mnpl United States Of America - LWV',
            'Lexington  United States Of America - LXN',
            'Lyons Rice County Mncpl United States Of America - LYO',
            'Leadville  United States Of America - LXV',
            'Lynchburg Preston Glenn United States Of America - LYH',
            'Ely  United States Of America - LYU',
            'Cape Lisburne  United States Of America - LUR',
            'Laurel Hesler Noble Fld United States Of America - LUL',
            'Laurel Hattiesburg United States Of America - PIB',
            'Kalaupapa  United States Of America - LUP',
            'Lewisburg Greenbrier Valley United States Of America - LWB',
            'Lawrence  United States Of America - LWC',
            'Las Vegas  United States Of America - LVS',
            'Wells Harriet Field United States Of America - LWL',
            'Lawrence  United States Of America - LWM',
            'Livermore  United States Of America - LVK',
            'Lawrenceville  United States Of America - LVL',
            'Livingston Mission Fld United States Of America - LVM',
            'Lime Village  United States Of America - LVD',
            'Longview  United States Of America - LOG',
            'Lanai City  United States Of America - LNY',
            'Lone Rock Tri County United States Of America - LNR',
            'Lancaster  United States Of America - LNS',
            'Willoughby Lost Nation United States Of America - LNN',
            'Wise  United States Of America - LNP',
            'Lander Hunt Field United States Of America - LND',
            'Lincoln Lincoln Mnpl United States Of America - LNK',
            'Lonely Dew Station United States Of America - LNI',
            'Louisville Winston Cnty United States Of America - LMS',
            'Klamath Falls Klamath Falls Airport United States Of America - LMT',
            'Little Port Walte  United States Of America - LPW',
            'Laporte Laporte Mnpl United States Of America - LPO',
            'Lopez Island  United States Of America - LPS',
            'Lockport Lewis Lockport United States Of America - LOT',
            'Louisa  United States Of America - LOW',
            'London Corbin London United States Of America - LOZ',
            'Lompoc Lompoc Apt United States Of America - LPC',
            'Lompoc Vandenberg Afb United States Of America - VBG',
            'Lovelock Derby Field United States Of America - LOL',
            'Lathrop Sharpe Aaf United States Of America - LRO',
            'Lemars Lemars Mnpl United States Of America - LRJ',
            'Lincoln Rock Coast Guard United States Of America - LRK',
            'Pickens  United States Of America - LQK',
            'Laredo Laredo Intl United States Of America - LRD',
            'Jacksonville Little Rock United States Of America - LRF',
            'Lordsburg  United States Of America - LSB',
            'La Crosse La Crosse Mnpl United States Of America - LSE',
            'Las Cruces Las Cruces Mnpl United States Of America - LRU',
            'Lusk  United States Of America - LSK',
            'Los Banos  United States Of America - LSN',
            'Lost River  United States Of America - LSR',
            'Lathrop Wells  United States Of America - LTH',
            'Leonardtown Saint Marys Cnt United States Of America - LTW',
            'Altus Altus Afb United States Of America - LTS',
            'Altus Altus Mnpl United States Of America - AXS',
            'Linden  United States Of America - LDJ',
            'Ludington Mason County United States Of America - LDM',
            'Leesburg  United States Of America - LEE',
            'Latrobe Westmoreland Cnt United States Of America - LBE',
            'North Platte Lee Bird Fl United States Of America - LBF',
            'Lubbock Lubbock Intl United States Of America - LBB',
            'Lubbock Reese Afb United States Of America - REE',
            'Liberal Liberal Mnpl United States Of America - LBL',
            'Lumberton  United States Of America - LBT',
            'Lake Charles Lake Charles Mnpl United States Of America - LCH',
            'Lake Charles Chennault Intl United States Of America - CWF',
            'Laconia Laconia Mnpl United States Of America - LCI',
            'Koyukuk  United States Of America - KYU',
            'Karluk  United States Of America - KYK',
            'Key Largo Port Largo United States Of America - KYL',
            'Kwethluk  United States Of America - KWT',
            'Kasaan Kasaan Spb United States Of America - KXA',
            'West Point Village Spb United States Of America - KWP',
            'Quinhagak Kwinhagak United States Of America - KWN',
            'Kwigillingok  United States Of America - KWK',
            'Kizhuyak  United States Of America - KZH',
            'Zachar Bay Zachar Bay S United States Of America - KZB',
            'Lafayette Purdue Univer United States Of America - LAF',
            'Lamar Lamar Field United States Of America - LAA',
            'Lakeland Lakeland Mnpl United States Of America - LAL',
            'Los Alamos  United States Of America - LAM',
            'Lansing Capital City United States Of America - LAN',
            'Laramie General Brees United States Of America - LAR',
            'Las Vegas Mccarran Intl United States Of America - LAS',
            'Las Vegas Henderson Executive United States Of America - HSH',
            'Las Vegas Las Vegas Boulder Arpt United States Of America - BLD',
            'Las Vegas North Air Term United States Of America - VGT',
            'Las Vegas Nellis Afb United States Of America - LSV',
            'Lawton Lawton Mnpl United States Of America - LAW',
            'Los Angeles Whiteman United States Of America - WHP',
            'Los Angeles Van Nuys United States Of America - VNY',
            'Los Angeles Citicorp United States Of America - JCX',
            'Los Angeles Los Angeles Intl United States Of America - LAX',
            'Lakeside  United States Of America - LKS',
            'Lakeview Lake County United States Of America - LKV',
            'Lyndonville  United States Of America - LLX',
            'Mount Holly Burlington United States Of America - LLY',
            'Lake Minchumina  United States Of America - LMA',
            'Lake Jackson Brazoria C United States Of America - LJN',
            'Lake Placid  United States Of America - LKP',
            'Kulik Lake  United States Of America - LKK',
            'Little Rock Reg Apt United States Of America - LIT',
            'Livengood  United States Of America - LIV',
            'Hinesville Wright Aaf United States Of America - LIY',
            'Limestone Loring Afb United States Of America - LIZ',
            'Long Island  United States Of America - LIJ',
            'Kauai Island Princeville United States Of America - HPV',
            'Kauai Island Lihue United States Of America - LIH',
            'Lock Haven West T Piper Mem United States Of America - LHV',
            'Limon Limon Mnpl United States Of America - LIC',
            'Lost Harbor  United States Of America - LHB',
            'Lafayette Lafayette Rgnl United States Of America - LFT',
            'Logan Cache United States Of America - LGU',
            'Long Beach  United States Of America - LGB',
            'La Grange Calloway United States Of America - LGC',
            'La Grande  United States Of America - LGD',
            'Louisburg Franklin United States Of America - LFN',
            'Lewiston Auburn United States Of America - LEW',
            'Lexington Creech Aaf United States Of America - LSD',
            'Lexington Blue Grass United States Of America - LEX',
            'Lebanon Lebanon Rgnl United States Of America - LEB',
            'Lemmon  United States Of America - LEM',
            'Hoonah  United States Of America - HNH',
            'Honolulu Hickam Afb United States Of America - HIK',
            'Honolulu Honolulu Intl United States Of America - HNL',
            'Hana  United States Of America - HNM',
            'Homeshore  United States Of America - HMS',
            'Hemet Ryan Field United States Of America - HMT',
            'Huntingburg Huntingburg Mnpl United States Of America - HNB',
            'Hatteras  United States Of America - HNC',
            'Tahneta Pass Lodg Tahnet United States Of America - HNE',
            'Wheeling Ohio County United States Of America - HLG',
            'Hollister  United States Of America - HLI',
            'Holland Park Township United States Of America - HLM',
            'Helena  United States Of America - HLN',
            'Haines Haines Mnpl United States Of America - HNS',
            'Hanna  United States Of America - HNX',
            'Hobbs Industrial Airpark United States Of America - HBB',
            'Hobbs Lea County United States Of America - HOB',
            'Holikachu  United States Of America - HOL',
            'Homer  United States Of America - HOM',
            'Huron Howes United States Of America - HON',
            'Hot Springs Memorial Fld United States Of America - HOT',
            'Houston D W Hooks United States Of America - DWH',
            'Houston Ellington Field United States Of America - EFD',
            'Houston Hobby United States Of America - HOU',
            'Houston Spaceland United States Of America - SPX',
            'Houston G.Bush Intercont United States Of America - IAH',
            'Houston Andrau Airpark United States Of America - AAP',
            'Houston West Houston United States Of America - IWS',
            'Hawthorne  United States Of America - HHR',
            'Hibbing Chisholm United States Of America - HIB',
            'Whitefield Regional United States Of America - HIE',
            'Hillsboro Portland United States Of America - HIO',
            'Lake Havasu City Mncpl United States Of America - HII',
            'Healy Lake  United States Of America - HKB',
            'Kaanapali Maui  United States Of America - HKP',
            'Hickory  United States Of America - HKY',
            'Batesville Hillenbrand United States Of America - HLB',
            'Hill City  United States Of America - HLC',
            'Hartford Barnes United States Of America - BNH',
            'Hartford Brainard United States Of America - HFD',
            'Hartford Bradley Intl United States Of America - BDL',
            'Hermiston State United States Of America - HES',
            'Natchez Hardy Anders United States Of America - HEZ',
            'Hoffman Mackall Aaf United States Of America - HFF',
            'Hagerstown Wash County United States Of America - HGR',
            'Jolon Hunter Aaf United States Of America - HGT',
            'Hogatza  United States Of America - HGZ',
            'Hilton Head  United States Of America - HHH',
            'Wahiawa Wheeler Afb United States Of America - HHI',
            'Harlingen Valley Intl United States Of America - HRL',
            'Westchester County  United States Of America - HPN',
            'Hooper Bay  United States Of America - HPB',
            'Hopkinsville Campbell United States Of America - HOP',
            'Hampton Hampton Mnpl United States Of America - HPT',
            'Baytown  United States Of America - HPY',
            'Aberdeen  United States Of America - HQM',
            'Harrison Boone County United States Of America - HRO',
            'Harrisburg Raleigh United States Of America - HSB',
            'Hastings  United States Of America - HSI',
            'Huslia  United States Of America - HSL',
            'Homestead Afb United States Of America - HST',
            'Huntsville Huntsville Intl Apt United States Of America - HSV',
            'Huntsville Redstone Aaf United States Of America - HUA',
            'Hot Springs Ingalls Fld United States Of America - HSP',
            'Hawthorne  United States Of America - HTH',
            'Huntington Tri State United States Of America - HTS',
            'Huntsville  United States Of America - HTV',
            'Huntington  United States Of America - HTW',
            'East Hampton  United States Of America - HTO',
            'Houghton Roscommon Cnty United States Of America - HTL',
            'Terre Haute Hulman Field United States Of America - HUF',
            'Humboldt  United States Of America - HUD',
            'Hugo  United States Of America - HUJ',
            'Hughes Hughes Mnpl United States Of America - HUS',
            'Hutchinson  United States Of America - HUT',
            'Houlton Houlton Intl United States Of America - HUL',
            'Houma Terrebonne United States Of America - HUM',
            'Hanksville Intermediate United States Of America - HVE',
            'Hayward Air Terminal United States Of America - HWD',
            'Hawk Inlet Spb United States Of America - HWI',
            'New Haven  United States Of America - HVN',
            'Havre City County United States Of America - HVR',
            'Hartsville Hartsville Mnpl United States Of America - HVS',
            'Hydaburg Spb United States Of America - HYG',
            'Hollis Spb United States Of America - HYL',
            'Hyannis Barnstable United States Of America - HYA',
            'Hazleton  United States Of America - HZL',
            'Hollywood North Perry United States Of America - HWO',
            'Hayward Hayward Mnpl United States Of America - HYR',
            'Hays Hays Mnpl United States Of America - HYS',
            'Clarinda Clarinda Mnpl United States Of America - ICL',
            'Cascade  United States Of America - ICS',
            'Wichita Cessna Aircraft United States Of America - CEA',
            'Wichita Mid Continent United States Of America - ICT',
            'Wichita Beech United States Of America - BEC',
            'Wichita Mcconnell Afb United States Of America - IAB',
            'Icy Bay  United States Of America - ICY',
            'Idaho Falls Fanning Fld United States Of America - IDA',
            'Niagara Falls Niagara Falls Intl United States Of America - IAG',
            'Kiana Bob Barker Mem United States Of America - IAN',
            'Bullhead City Laughlin United States Of America - IFP',
            'Igiugig  United States Of America - IGG',
            'Kingman  United States Of America - IGM',
            'Iowa Falls  United States Of America - IFA',
            'Independence  United States Of America - IDP',
            'Ida Grove Ida Grove Mnpl United States Of America - IDG',
            'Grangeville Idaho County United States Of America - IDH',
            'Indiana  United States Of America - IDI',
            'Nikolski Nikolski Afs United States Of America - IKO',
            'Killeen Fort Hood Aaf United States Of America - HLR',
            'Killeen Gray Aaf United States Of America - GRK',
            'Killeen Killeen Mnpl United States Of America - ILE',
            'Willmar  United States Of America - ILL',
            'Wilmington New Hanover United States Of America - ILM',
            'Wilmington Clinton Field United States Of America - ILN',
            'Iliamna  United States Of America - ILI',
            'Wilmington Great Wilming United States Of America - ILG',
            'Kankakee Great Kankakee United States Of America - IKK',
            'Jacksonville Jacksonville Mnpl United States Of America - IJX',
            'Wilkesboro Wilkes Count United States Of America - IKB',
            'Imperial  United States Of America - IML',
            'Immokalee  United States Of America - IMM',
            'Iron Mountain Ford United States Of America - IMT',
            'Wink  United States Of America - INK',
            'International Falls  United States Of America - INL',
            'Indianapolis Indianapolis Intl United States Of America - IND',
            'Iowa City  United States Of America - IOW',
            'El Centro Imperial Cnty United States Of America - IPL',
            'El Centro Naf United States Of America - NJK',
            'Williamsport Williamsport Reg Apt United States Of America - IPT',
            'Winslow  United States Of America - INW',
            'Indian Springs Af Aux United States Of America - INS',
            'Winston Salem Smith Reynolds United States Of America - INT',
            'Iraan Iraan Mnpl United States Of America - IRB',
            'Circle Circle City United States Of America - IRC',
            'Kirksville Kirksville Mnpl United States Of America - IRK',
            'Sturgis Kirsch Mncpl United States Of America - IRS',
            'Isabel Pass  United States Of America - ISL',
            'Kissimmee Kissimmee Mnpl United States Of America - ISM',
            'Williston Sloulin Field United States Of America - ISN',
            'Kinston Stallings Field United States Of America - ISO',
            'Islip Long Island Macar United States Of America - ISP',
            'Manistique Schoolcraft United States Of America - ISQ',
            'Wiscasset  United States Of America - ISS',
            'Wisconsin Rapids Alexan United States Of America - ISW',
            'Ithaca Tompkins County United States Of America - ITH',
            'Hilo Hilo International United States Of America - ITO',
            'Ironwood Gogebic County United States Of America - IWD',
            'Ivishak  United States Of America - IVH',
            'Jackson Jackson Hole United States Of America - JAC',
            'Jasper County United States Of America - JAS',
            'Jackson Hawkins Field United States Of America - HKS',
            'Jackson Jackson Evers Intl United States Of America - JAN',
            'Inyokern Kern County United States Of America - IYK',
            'Jefferson City Memorial United States Of America - JEF',
            'Jefferson Ashtabula United States Of America - JFN',
            'Jonesboro  United States Of America - JBR',
            'Jacksonville Cecil Field United States Of America - NZC',
            'Jacksonville Nas United States Of America - NIP',
            'Jacksonville Craig Mncpl United States Of America - CRG',
            'Jacksonville Jacksonville Intl United States Of America - JAX',
            'Berkeley  United States Of America - JBK',
            'Jordan  United States Of America - JDN',
            'Junction Kimble County United States Of America - JCT',
            'Johnson  United States Of America - JCY',
            'John Day  United States Of America - JDA',
            'Grand Junction Walker Fl United States Of America - GJT',
            'Gatlinburg  United States Of America - GKT',
            'Gulkana  United States Of America - GKN',
            'Greenville  United States Of America - GLH',
            'Globe San Carlos Apache United States Of America - GLB',
            'Goodland Renner Field United States Of America - GLD',
            'Gainesville Gainesville Mnpl United States Of America - GLE',
            'Glennallen  United States Of America - GLQ',
            'Gaylord Otsego County United States Of America - GLR',
            'Galveston Scholes Field United States Of America - GLS',
            'Grants Milan United States Of America - GNT',
            'Goodnews Bay  United States Of America - GNU',
            'Gainesville Gainesville Regional United States Of America - GNV',
            'Quincy Gansner Field United States Of America - GNF',
            'Gooding  United States Of America - GNG',
            'Granite Mountain  United States Of America - GMT',
            'Monument Valley  United States Of America - GMV',
            'Golovin  United States Of America - GLV',
            'Glasgow Glasgow Mnpl United States Of America - GLW',
            'Groton Groton New London United States Of America - GON',
            'Guthrie  United States Of America - GOK',
            'Gold Beach State United States Of America - GOL',
            'Greenwood  United States Of America - GRD',
            'Greenville Greenville Mnpl United States Of America - GRE',
            'Green Bay Austin Field United States Of America - GRB',
            'Galion  United States Of America - GQQ',
            'Gulfport Biloxi Regional United States Of America - GPT',
            'Grand Rapids  United States Of America - GPZ',
            'Gustavus Bartlett Spb United States Of America - BQV',
            'Gustavus  United States Of America - GST',
            'Goshen  United States Of America - GSH',
            'Greensboro/High Point Piedmont Triad Intl United States Of America - GSO',
            'Greenville Downtown United States Of America - GMU',
            'Greenville Donaldson United States Of America - GDC',
            'Greenville Spartanburg United States Of America - GSP',
            'Greenville Downtown Memorial United States Of America - SPA',
            'Goldsboro Seymour Johns United States Of America - GSB',
            'Grand Island  United States Of America - GRI',
            'Grand Marais Devils Trck United States Of America - GRM',
            'Gordon  United States Of America - GRN',
            'Grand Rapids Gerald R Ford United States Of America - GRR',
            'Humboldt Humboldt Mnpl United States Of America - HBO',
            'Hobart  United States Of America - HBR',
            'Big Spring Howard County United States Of America - HCA',
            'Big Spring Webb Afb United States Of America - BGS',
            'Shoal Cove  United States Of America - HCB',
            'Hudson Columbia County United States Of America - HCC',
            'Holbrook Municipal United States Of America - HBK',
            'Hanus Bay  United States Of America - HBC',
            'Hattiesburg Bobby L Chai United States Of America - HBG',
            'Hobart Bay  United States Of America - HBH',
            'Holdrege Brewster Field United States Of America - HDE',
            'Holy Cross  United States Of America - HCR',
            'Cheraw  United States Of America - HCW',
            'Hidden Falls  United States Of America - HDA',
            'Herendeen  United States Of America - HED',
            'Helena Thompson Robbins United States Of America - HEE',
            'Hayden Yampa Valley United States Of America - HDN',
            'Oahu Dillingham Airfield United States Of America - HDH',
            'Goodyear Litchfield United States Of America - GYR',
            'Havasupai  United States Of America - HAE',
            'Half Moon Bay  United States Of America - HAF',
            'Hamilton Marion County United States Of America - HAB',
            'Haycock  United States Of America - HAY',
            'Harrisburg Harrisburg Intl United States Of America - MDT',
            'Harrisburg Skyport United States Of America - HAR',
            'Three Rivers Dr Haines United States Of America - HAI',
            'Hamilton  United States Of America - HAO',
            'Greeley Weld County United States Of America - GXY',
            'Greenwood Leflore United States Of America - GWO',
            'Glenwood Springs  United States Of America - GWS',
            'Glendale  United States Of America - GWV',
            'Greenville Majors Field United States Of America - GVT',
            'Grandview Richards Gebau United States Of America - GVW',
            'Gainesville Lee Gilmer United States Of America - GVL',
            'Gordonsville Gordonsville Mnpl United States Of America - GVE',
            'Guymon  United States Of America - GUY',
            'Peru Grissom Afb United States Of America - GUS',
            'Gulf Shores Edwards United States Of America - GUF',
            'Gallup Senator Clark United States Of America - GUP',
            'Great Falls Malmstrom United States Of America - GFA',
            'Great Falls Great Falls Intl United States Of America - GTF',
            'Grantsburg Grantsburg Mnpl United States Of America - GTG',
            'Gunnison  United States Of America - GUC',
            'Grants Pass  United States Of America - GTP',
            'Gettysburg  United States Of America - GTY',
            'Fullerton Fullerton Mnpl United States Of America - FUL',
            'Fort Yukon  United States Of America - FYU',
            'Fayetteville Nw Arkansas United States Of America - XNA',
            'Fort Wayne Smith Field United States Of America - SMD',
            'Fort Wayne Municipal United States Of America - FWA',
            'Farewell  United States Of America - FWL',
            'Flaxman Island  United States Of America - FXM',
            'Fort Smith Fort Smith Mnpl United States Of America - FSM',
            'Fort Sheridan Haley Aaf United States Of America - FSN',
            'Fort Stockton Pecos Cnty United States Of America - FST',
            'Fort Sumner  United States Of America - FSU',
            'Fort Knox Godman Aaf United States Of America - FTK',
            'Fortuna Ledge  United States Of America - FTL',
            'Fairmont  United States Of America - FRM',
            'Fort Richardson Bryant United States Of America - FRN',
            'Front Royal Warren Cnty United States Of America - FRR',
            'Fresh Water Bay  United States Of America - FRP',
            'Fryeburg  United States Of America - FRY',
            'Sioux Falls Regional United States Of America - FSD',
            'Fort Sill Henry Post Aaf United States Of America - FSI',
            'Fort Scott Fort Scott Mnpl United States Of America - FSK',
            'Farmingdale Republic Fld United States Of America - FRG',
            'French Lick French Lick Mnpl United States Of America - FRH',
            'Fort Riley Marshall Aaf United States Of America - FRI',
            'Fort Pierce Saint Lucie Cnt United States Of America - FPR',
            'Perry Perry Foley United States Of America - FPY',
            'Friday Harbor  United States Of America - FRD',
            'Westhampton Suffolk Cnty United States Of America - FOK',
            'Farmington Farmington Mnpl United States Of America - FMN',
            'Fort Madison Fort Madison Mnpl United States Of America - FMS',
            'Florence Municipal United States Of America - FMU',
            'Fort Myers Page Field United States Of America - FMY',
            'Fort Myers Sw Florida United States Of America - RSW',
            'Fin Creek  United States Of America - FNK',
            'Fort Collins Loveland Mncpl United States Of America - FNL',
            'Funter Bay Spb United States Of America - FNR',
            'Flint Bishop United States Of America - FNT',
            'Fort Bragg  United States Of America - FOB',
            'Fort Dodge  United States Of America - FOD',
            'Forest Park Morris Aaf United States Of America - FOP',
            'Fox  United States Of America - FOX',
            'Florence  United States Of America - FLO',
            'Flippin  United States Of America - FLP',
            'Falls Bay  United States Of America - FLJ',
            'Fort Lauderdale Executive United States Of America - FXE',
            'Fort Lauderdale Fll Intl United States Of America - FLL',
            'Flat  United States Of America - FLT',
            'Fort Leavenworth Sherman United States Of America - FLV',
            'Falmouth Otis Afb United States Of America - FMH',
            'Five Mile  United States Of America - FMC',
            'Fort Meade Tipton Aaf United States Of America - FME',
            'Five Finger  United States Of America - FIV',
            'Franklin Chess Lambertin United States Of America - FKL',
            'Franklin Franklin Mnpl United States Of America - FKN',
            'Fond Du Lac  United States Of America - FLD',
            'Gage  United States Of America - GAG',
            'Gaithersburg Montgomery United States Of America - GAI',
            'Gakona  United States Of America - GAK',
            'Galena  United States Of America - GAL',
            'Gambell  United States Of America - GAM',
            'Forest City Forest City Mnpl United States Of America - FXY',
            'Fayetteville Fayetteville Mnpl United States Of America - FYM',
            'Gadsden Gadsden Mnpl United States Of America - GAD',
            'Gabbs  United States Of America - GAB',
            'Great Bend  United States Of America - GBD',
            'Galesburg  United States Of America - GBG',
            'Galbraith Lake  United States Of America - GBH',
            'Great Barrington  United States Of America - GBR',
            'Golden Horn Spb United States Of America - GDH',
            'Grand Canyon West  United States Of America - GCW',
            'Greenville Greenville Mnpl United States Of America - GCY',
            'Grand Canyon Pulliam Field United States Of America - FLG',
            'Grand Canyon North Rim United States Of America - NGC',
            'Grand Canyon National United States Of America - GCN',
            'Garden City Garden City Kansas Rgl United States Of America - GCK',
            'Gillette Campbell County United States Of America - GCC',
            'Electric City Grand Coulee Dam United States Of America - GCD',
            'Glendive Dawson Communi United States Of America - GDV',
            'Gladwin  United States Of America - GDW',
            'Gardner Gardner Mnpl United States Of America - GDM',
            'Spokane Spokane Intl United States Of America - GEG',
            'Spokane Felts Field United States Of America - SFF',
            'Spokane Fairchild Afb United States Of America - SKA',
            'Ganes Creek  United States Of America - GEK',
            'Georgetown Sussex County United States Of America - GED',
            'Grand Forks  United States Of America - GFK',
            'Glens Falls Warren Cnty United States Of America - GFL',
            'Greybull South Big Horn United States Of America - GEY',
            'Togiak Fish  United States Of America - GFB',
            'Greenfield Pope Field United States Of America - GFD',
            'Glasgow Glasgow Intl United States Of America - GGW',
            'Georgetown  United States Of America - GGE',
            'Longview Gregg County United States Of America - GGG',
            'Winter Haven Gilbert Fld United States Of America - GIF',
            'Centerville Centerville Mnpl United States Of America - GHM',
            'Colonia  Uruguay - CYR',
            'Durazno  Uruguay - DZO',
            'Bella Union  Uruguay - BUV',
            'Artigas  Uruguay - ATI',
            'Vichadero  Uruguay - VCH',
            'Treinta Y Tres  Uruguay - TYT',
            'Tacuarembo  Uruguay - TAW',
            'Salto  Uruguay - STY',
            'Paysandu  Uruguay - PDU',
            'Punta Del Este  Uruguay - PDP',
            'Rivera  Uruguay - RVY',
            'Montevideo Carrasco Uruguay - MVD',
            'Melo  Uruguay - MLZ',
            'Nukus  Uzbekistan - NCU',
            'Namangan  Uzbekistan - NMA',
            'Navoi  Uzbekistan - NVI',
            'Taşkent Özbekistan Tashkent Vostohny Uzbekistan - TAS',
            'Samarkand  Uzbekistan - SKD',
            'Urgench  Uzbekistan - UGC',
            'Termez Uz  Uzbekistan - TMJ',
            'Andizhan  Uzbekistan - AZN',
            'Zarafshan  Uzbekistan - AFS',
            'Bukhara  Uzbekistan - BHK',
            'Fergana  Uzbekistan - FEG',
            'Karshi  Uzbekistan - KSQ',
            'Canouan Island  St. Vincent - CIW',
            'Port Elizabeth Bequila Apt St. Vincent - BQU',
            'Union Island  St. Vincent - UNI',
            'Saint Vincent  St. Vincent - SVD',
            'Mustique Island  St. Vincent - MQS',
            'Palm Island  St. Vincent - PLI',
            'Porlamar Delcaribe Gen S Venezuela - PMV',
            'Puerto Paez  Venezuela - PPZ',
            'Peraitepuy  Venezuela - PPH',
            'Palmarito  Venezuela - PTM',
            'Puerto Ayacucho  Venezuela - PYH',
            'Pedernales  Venezuela - PDZ',
            'Puerto Cabello  Venezuela - PBL',
            'Santa Barbara Ba  Venezuela - SBB',
            'San Fernando De Apure Flecheras Venezuela - SFD',
            'San Felix  Venezuela - SFX',
            'San Cristobal  Venezuela - SCI',
            'Puerto Ordaz  Venezuela - PZO',
            'Merida A Carnevalli Venezuela - MRD',
            'Maturin Quiriquire Venezuela - MUN',
            'Maracay  Venezuela - MYC',
            'Santo Domingo Mayo Guerrero Venezuela - STD',
            'Santa Barbara Ed L Delicias Venezuela - STB',
            'San Salvador De  Venezuela - SVV',
            'San Antonio  Venezuela - SVZ',
            'San Tome El Tigre Venezuela - SOM',
            'Santa Elena  Venezuela - SNV',
            'San Felipe  Venezuela - SNF',
            'Uriman  Venezuela - URM',
            'Tucupita  Venezuela - TUV',
            'Tumeremo  Venezuela - TMO',
            'Carora  Venezuela - VCR',
            'Valle De Pascua  Venezuela - VDP',
            'Valencia  Venezuela - VLN',
            'Valera Carvajal Venezuela - VLV',
            'El Vigia  Venezuela - VIG',
            'Wonken  Venezuela - WOK',
            'Barquisimeto  Venezuela - BRM',
            'Canaima  Venezuela - CAJ',
            'Barinas  Venezuela - BNS',
            'Barcelona General Ja Anzoategui Venezuela - BLA',
            'Anaco  Venezuela - AAO',
            'Acarigua  Venezuela - AGV',
            'Calabozo  Venezuela - CLZ',
            'Caracas Simon Bolivar Venezuela - CCS',
            'Cabimas Oro Negro Venezuela - CBS',
            'Ciudad Bolivar  Venezuela - CBL',
            'Ciudad Guayana  Venezuela - CGU',
            'Coro  Venezuela - CZE',
            'Casigua  Venezuela - CUV',
            'Carupano  Venezuela - CUP',
            'Cumana  Venezuela - CUM',
            'Caicara De Oro  Venezuela - CXA',
            'El Tigre  Venezuela - ELX',
            'Elorza  Venezuela - EOZ',
            'El Dorado  Venezuela - EOR',
            'Kamarata  Venezuela - KTV',
            'Kavanayen  Venezuela - KAV',
            'La Fria  Venezuela - LFR',
            'Lagunillas  Venezuela - LGY',
            'La Guaira  Venezuela - LAG',
            'Las Piedras Josefa Camejo Venezuela - LSP',
            'Los Roques  Venezuela - LRV',
            'Pijiguaos  Venezuela - LPJ',
            'Maracaibo La Chinita Venezuela - MAR',
            'Guasdualito Vare Maria Venezuela - GDO',
            'Guanare  Venezuela - GUQ',
            'Guiria  Venezuela - GUI',
            'Icabaru  Venezuela - ICA',
            'Beef Island  Virgin Islands-British - EIS',
            'Virgin Gorda  Virgin Islands-British - VIJ',
            'Tortola Road Town Virgin Islands-British - RAD',
            'Tortola West End Spb Virgin Islands-British - TOV',
            'Anegada  Virgin Islands-British - NGD',
            'Saint John Island  Virgin Islands-United States - SJF',
            'Saint Thomas Island Sea Plane Base Virgin Islands-United States - SPB',
            'Saint Thomas Island  Virgin Islands-United States - STT',
            'Saint Croix Island Spb Virgin Islands-United States - SSB',
            'Saint Croix Island Henry E Rohlsen Virgin Islands-United States - STX',
            'Tuy Hoa  Vietnam - TBB',
            'Soc Trang  Vietnam - SOA',
            'Son La Na San Vietnam - SQH',
            'Tamky  Vietnam - TMK',
            'Tamky Chulai Vietnam - VCL',
            'Qui Nhon  Vietnam - UIH',
            'Vinh City  Vietnam - VII',
            'Rach Gia  Vietnam - VKG',
            'Con Dao Coong Vietnam - VCS',
            'Dong Hoi  Vietnam - VDH',
            'Can Tho  Vietnam - VCA',
            'Vung Tau  Vietnam - VTG',
            'Phuoclong  Vietnam - VSO',
            'Vinh Long  Vietnam - XVL',
            'Quang Ngai  Vietnam - XNG',
            'Long Xuyen  Vietnam - XLO',
            'Nha Trang  Vietnam - NHA',
            'Nha Trang Cam Ranh Vietnam - CXR',
            'Ho Chi Minh City Tan Son Nhat Vietnam - SGN',
            'Phan Rang  Vietnam - PHA',
            'Phan Thiet  Vietnam - PHH',
            'Phu Vinh  Vietnam - PHU',
            'Pleiku  Vietnam - PXU',
            'Phu Quoc Duong Dang Vietnam - PQC',
            'Dien Bien Phu Dien Bien Airport Vietnam - DIN',
            'Dalat Lienkhang Vietnam - DLI',
            'Da Nang  Vietnam - DAD',
            'Cape St Jacques  Vietnam - CSJ',
            'Banmethuot Phung Duc Vietnam - BMV',
            'Ca Mau  Vietnam - CAH',
            'Hue Phu Bai Vietnam - HUI',
            'Haiphong Catbi Vietnam - HPH',
            'Quanduc Nhon Co Vietnam - HOO',
            'Hanoi and Kuzey Hanoi Vietnam - HAN',
            'Phu Bon  Vietnam - HBN',
            'Kontum  Vietnam - KON',
            'Lamap  Vanuatu - LPM',
            'Lamen Bay  Vanuatu - LNB',
            'Lonorore  Vanuatu - LNE',
            'Longana  Vanuatu - LOD',
            'Big Bay  Vanuatu - GBA',
            'Futuna Island Futuna Apt Vanuatu - FTA',
            'Ipota  Vanuatu - IPA',
            'Aneityum  Vanuatu - AUY',
            'Aniwa  Vanuatu - AWD',
            'Craig Cove  Vanuatu - CCV',
            'Dillons Bay  Vanuatu - DLY',
            'Emae  Vanuatu - EAE',
            'Epi  Vanuatu - EPI',
            'Paama  Vanuatu - PBJ',
            'Redcliffe  Vanuatu - RCL',
            'Norsup  Vanuatu - NUS',
            'Olpoi  Vanuatu - OLJ',
            'Maewo  Vanuatu - MWF',
            'Mota Lava  Vanuatu - MTV',
            'Walaha  Vanuatu - WLH',
            'Valesdir  Vanuatu - VLS',
            'Port Vila Bauerfield Vanuatu - VLI',
            'Gaua  Vanuatu - ZGU',
            'Quine Hill  Vanuatu - UIQ',
            'Ulei  Vanuatu - ULB',
            'Torres Torres Airstrip Vanuatu - TOH',
            'Tongoa  Vanuatu - TGH',
            'Sara  Vanuatu - SSR',
            'Espiritu Santo Pekoa Vanuatu - SON',
            'Sola  Vanuatu - SLH',
            'Tanna  Vanuatu - TAH',
            'South West Bay  Vanuatu - SWJ',
            'Wallis Island  Wallis And Futuna Islands - WLS',
            'Futuna Island  Wallis And Futuna Islands - FUT',
            'Lalomalava  Samoa-Independent State Of - LAV',
            'Apia Faleolo Samoa-Independent State Of - APW',
            'Apia Fagali I Samoa-Independent State Of - FGI',
            'Asau  Samoa-Independent State Of - AAU',
            'Maota Savaii Is  Samoa-Independent State Of - MXS',
            'Mareb  Yemen Republic - MYN',
            'Mukalla  Yemen Republic - MKX',
            'Mayfa ah  Yemen Republic - MFY',
            'Riyan Mukalla  Yemen Republic - RIY',
            'Socotra  Yemen Republic - SCT',
            'Sanaa Sanaa Intl Yemen Republic - SAH',
            'Raudha  Yemen Republic - RXA',
            'Wadi Ain  Yemen Republic - WDA',
            'Sadah  Yemen Republic - SYE',
            'Taiz Al Janad Yemen Republic - TAI',
            'Mukeiras  Yemen Republic - UKR',
            'Al Ghaydah  Yemen Republic - AAY',
            'Aden Aden Intl Yemen Republic - ADE',
            'Aljouf  Yemen Republic - AJO',
            'Ataq  Yemen Republic - AXK',
            'Beidah  Yemen Republic - BYD',
            'Albuq  Yemen Republic - BUK',
            'Beihan  Yemen Republic - BHN',
            'Abbse  Yemen Republic - EAB',
            'Dhamar  Yemen Republic - DMR',
            'Dhala  Yemen Republic - DHL',
            'Dathina  Yemen Republic - DAH',
            'Lodar  Yemen Republic - LDR',
            'Kamaran Is  Yemen Republic - KAM',
            'Seiyun  Yemen Republic - GXF',
            'Qishn  Yemen Republic - IHN',
            'Hodeidah  Yemen Republic - HOD',
            'Dzaoudzi  Mayotte - DZA',
            'Durban King Shaka Intl South Africa - DUR',
            'Durban Virginia South Africa - VIR',
            'Dukuduk  South Africa - DUK',
            'East London  South Africa - ELS',
            'Empangeni  South Africa - EMG',
            'Ellisras  South Africa - ELL',
            'Ficksburg Ficksburg Sentra South Africa - FCB',
            'Cape Town Cape Town Intl South Africa - CPT',
            'Cradock  South Africa - CDO',
            'Bloemfontein Bloemfontein Intl South Africa - BFN',
            'Bisho  South Africa - BIY',
            'Aggeneys  South Africa - AGZ',
            'Alexander Bay Kortdoorn South Africa - ALJ',
            'Alldays  South Africa - ADY',
            'Port Alfred  South Africa - AFD',
            'Mala Mala  South Africa - AAM',
            'Hluhluwe  South Africa - HLW',
            'Hoedspruit Hoedspruit Airport South Africa - HDS',
            'Harrismith  South Africa - HRS',
            'Hazyview  South Africa - HZV',
            'Inyati  South Africa - INY',
            'George  South Africa - GRJ',
            'Sabi Sabi  South Africa - GSS',
            'Giyani  South Africa - GIY',
            'Johannesburg Lanseria Intl Apt South Africa - HLA',
            'Johannesburg O.R. Tambo Intl South Africa - JNB',
            'Johannesburg Grand Central South Africa - GCJ',
            'Johannesburg Randgermiston South Africa - QRA',
            'Port Saint Johns  South Africa - JOH',
            'Khoka Moya  South Africa - KHO',
            'Koinghaas  South Africa - KIG',
            'Kimberley  South Africa - KIM',
            'Komatipoort  South Africa - KOF',
            'Kleinzee  South Africa - KLZ',
            'Kuruman  South Africa - KMH',
            'Londolozi  South Africa - LDZ',
            'Louis Trichardt  South Africa - LCD',
            'Ladysmith  South Africa - LAY',
            'Klerksdorp  South Africa - KXE',
            'Lime Acres  South Africa - LMR',
            'Malelane  South Africa - LLE',
            'Tzaneen Letaba South Africa - LTA',
            'Mmabatho Mmabatho Intl South Africa - MBD',
            'Mkambati  South Africa - MBM',
            'Lusikisiki  South Africa - LUJ',
            'Ulundi  South Africa - ULD',
            'Ulusaba  South Africa - ULX',
            'Umtata  South Africa - UTT',
            'Queenstown  South Africa - UTW',
            'Upington Upington Mnpl South Africa - UTN',
            'Butterworth  South Africa - UTE',
            'Thohoyandou  South Africa - THY',
            'Tshipise  South Africa - TSD',
            'Skukuza  South Africa - SZK',
            'Thaba Nchu  South Africa - TCU',
            'Tanda Tula  South Africa - TDT',
            'Sishen  South Africa - SIS',
            'Welkom  South Africa - WEL',
            'Vryburg  South Africa - VRU',
            'Vredendal  South Africa - VRE',
            'Vryheid  South Africa - VYD',
            'Waterkloof  South Africa - WKF',
            'Secunda  South Africa - ZEC',
            'Reivilo  South Africa - RVO',
            'Springbok  South Africa - SBU',
            'Saldanha Bay Langebaanweg South Africa - SDB',
            'Robertson  South Africa - ROD',
            'Richards Bay  South Africa - RCB',
            'Pietermaritzburg  South Africa - PZB',
            'Plettenberg Bay  South Africa - PBZ',
            'Oudtshoorn  South Africa - OUH',
            'Overberg  South Africa - OVG',
            'Phalaborwa H Van Eck South Africa - PHW',
            'Port Elizabeth  South Africa - PLZ',
            'Polokwane  South Africa - PTG',
            'Pretoria Wonderboom South Africa - PRY',
            'Prieska  South Africa - PRK',
            'Margate  South Africa - MGH',
            'Messina  South Africa - MEZ',
            'Motswari  South Africa - MWR',
            'Sun City Pilansberg South Africa - NTY',
            'Ngala Ngala Airfield South Africa - NGL',
            'Newcastle  South Africa - NCS',
            'Mossel Bay  South Africa - MZY',
            'Mkuze  South Africa - MZQ',
            'Mzamba Wild Coast Sun  South Africa - MZF',
            'Nelspruit  South Africa - NLP',
            'Nelspruit Kruger Mpumalanga South Africa - MQP',
            'Ndola  Zambia - NLA',
            'Mfuwe  Zambia - MFU',
            'Mongu  Zambia - MNR',
            'Mansa  Zambia - MNS',
            'Mbala  Zambia - MMQ',
            'Ngoma  Zambia - ZGM',
            'Kasaba Bay  Zambia - ZKB',
            'Kasompe  Zambia - ZKP',
            'Sesheke  Zambia - SJQ',
            'Solwezi  Zambia - SLI',
            'Senanga  Zambia - SXG',
            'Lusaka  Zambia - LUN',
            'Livingstone  Zambia - LVI',
            'Lukulu  Zambia - LXU',
            'Kalabo  Zambia - KLB',
            'Kitwe Southdowns Zambia - KIW',
            'Kaoma  Zambia - KMZ',
            'Kasama  Zambia - KAA',
            'Zambezi  Zambia - BBZ',
            'Chingola  Zambia - CGJ',
            'Chipata  Zambia - CIP',
            'Chipinge  Zimbabwe - CHJ',
            'Buffalo Range  Zimbabwe - BFO',
            'Bulawayo  Zimbabwe - BUQ',
            'Bumi Hills Bumi Hills Airfield Zimbabwe - BZH',
            'Kariba  Zimbabwe - KAB',
            'Gweru  Zimbabwe - GWE',
            'Hwange Nat Park  Zimbabwe - HWN',
            'Harare  Zimbabwe - HRE',
            'Mutare  Zimbabwe - UTA',
            'Hwange  Zimbabwe - WKI',
            'Wankie Rhodesia  Zimbabwe - WKM',
            'Victoria Falls  Zimbabwe - VFA',
            'Mahenye Mahenye Airfield Zimbabwe - MJW',
            'Masvingo  Zimbabwe - MVZ',
            'Pseudo City Code  Fictitious Points - OWZ',
            'Fictitious Point  Fictitious Points - QMX',
            'Fictitious Point  Fictitious Points - QMY',
            'Fictitious Point  Fictitious Points - QPX',
            'Fictitious Point  Fictitious Points - QPY',
            'Fictitious Point  Fictitious Points - QXL',
            'Fictitious Point  Fictitious Points - QXM',
            'Fictitious Point  Fictitious Points - QZW',
            'Fictitious Point Utc Fictitious Point Fictitious Points - QZX',
            'Fictitious Point  Fictitious Points - QZY',
            'Fictitious Point  Fictitious Points - QUK',
            'Fictitious Point  Fictitious Points - QTV',
            'Fictitious Point  Fictitious Points - XCA',
            'Fictitious Point  Fictitious Points - XXX',
            'Iata Traffic Serv  Fictitious Points - IAT',
            'Headquarters  Fictitious Points - HDQ',
            'Pseudo City Code  Fictitious Points - EHD'
        ];

    },

    cabins() {
        return [
            {
                name: 'Economy',
                value: 'Economy'
            },
            {
                name: 'Business',
                value: 'Business'
            },
            {
                name: 'Premium',
                value: 'Premium'
            },
            {
                name: 'First',
                value: 'First'
            },

        ]
    }


}